import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Built-in scalar representing an amount of time */
  Duration: { input: any; output: any; }
  /** Built-in scalar representing an instant in time */
  Instant: { input: string; output: string; }
  /** Built-in scalar representing a local date */
  LocalDate: { input: string; output: string; }
  /** Built-in scalar representing a local date-time */
  LocalDateTime: { input: any; output: any; }
  /** Built-in scalar representing a local time */
  LocalTime: { input: string; output: string; }
  /** UUID String */
  UUID: { input: any; output: any; }
};

export const Acceptance = {
  Accepted: 'ACCEPTED',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Reordered: 'REORDERED'
} as const;

export type Acceptance = typeof Acceptance[keyof typeof Acceptance];
export const AcceptsWalkIns = {
  AcceptsWalkInsGuestDirect: 'ACCEPTS_WALK_INS_GUEST_DIRECT',
  AcceptsWalkInsGuestDirectRequiresGeoCheck: 'ACCEPTS_WALK_INS_GUEST_DIRECT_REQUIRES_GEO_CHECK',
  AcceptsWalkInsHostMediated: 'ACCEPTS_WALK_INS_HOST_MEDIATED',
  AcceptsWalkInsOff: 'ACCEPTS_WALK_INS_OFF'
} as const;

export type AcceptsWalkIns = typeof AcceptsWalkIns[keyof typeof AcceptsWalkIns];
export const AccoladeType = {
  AccoladeBonAppetitMagazine: 'ACCOLADE_BON_APPETIT_MAGAZINE',
  AccoladeCanada_100BestRestaurants: 'ACCOLADE_CANADA_100_BEST_RESTAURANTS',
  AccoladeChicagoTribune: 'ACCOLADE_CHICAGO_TRIBUNE',
  AccoladeChicagoTribuneReviewed: 'ACCOLADE_CHICAGO_TRIBUNE_REVIEWED',
  AccoladeFoodWineMagazine: 'ACCOLADE_FOOD_WINE_MAGAZINE',
  AccoladeGeneric: 'ACCOLADE_GENERIC',
  AccoladeJamesBeardFoundation: 'ACCOLADE_JAMES_BEARD_FOUNDATION',
  AccoladeMichelinGuide: 'ACCOLADE_MICHELIN_GUIDE',
  AccoladeSanFranciscoChronicle: 'ACCOLADE_SAN_FRANCISCO_CHRONICLE',
  AccoladeTheBostonGlobe: 'ACCOLADE_THE_BOSTON_GLOBE',
  AccoladeTheNewYorkTimes: 'ACCOLADE_THE_NEW_YORK_TIMES',
  AccoladeTheWashingtonPost: 'ACCOLADE_THE_WASHINGTON_POST',
  AccoladeWineSpectator: 'ACCOLADE_WINE_SPECTATOR',
  AccoladeWorlds_50BestRestaurants: 'ACCOLADE_WORLDS_50_BEST_RESTAURANTS',
  AccoladeWorlds_50BestRestaurantsNorthAmerica: 'ACCOLADE_WORLDS_50_BEST_RESTAURANTS_NORTH_AMERICA'
} as const;

export type AccoladeType = typeof AccoladeType[keyof typeof AccoladeType];
export type AccoladeTypeEntity = {
  __typename?: 'AccoladeTypeEntity';
  /** AccoladeTypeEntity_Generated::getAccoladeTypeRating */
  accoladeTypeRating?: Maybe<AccoladeTypeRatingEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** AccoladeTypeEntity_Generated::getDefaultAchievement */
  defaultAchievement?: Maybe<Scalars['String']['output']>;
  /** AccoladeTypeEntity_Generated::getDisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** AccoladeTypeEntity_Generated::getHasAchievement */
  hasAchievement: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getHasCritic */
  hasCritic: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getHasLink */
  hasLink: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getIconImgLink */
  iconImgLink?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** AccoladeTypeEntity_Generated::getIsActive */
  isActive: Scalars['Boolean']['output'];
  /** AccoladeTypeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** AccoladeTypeEntity_Generated::getOrgLink */
  orgLink?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type AccoladeTypeInfo = {
  __typename?: 'AccoladeTypeInfo';
  /** AccoladeTypeInfo::accoladeTypeEntity */
  accoladeTypeEntity?: Maybe<AccoladeTypeEntity>;
  /** AccoladeTypeInfo::businessEntitiesWithAccoladeType */
  businessEntitiesWithAccoladeType: Array<BusinessEntity>;
  /** AccoladeTypeInfo::businessesWithAccoladeType */
  businessesWithAccoladeType: Array<Scalars['String']['output']>;
  /** AccoladeTypeInfo::totalNumBusinessAccolades */
  totalNumBusinessAccolades: Scalars['Int']['output'];
};

export type AccoladeTypeInput = {
  accoladeTypeRating?: InputMaybe<AccoladeTypeRatingInput>;
  defaultAchievement?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasAchievement: Scalars['Boolean']['input'];
  hasCritic: Scalars['Boolean']['input'];
  hasLink: Scalars['Boolean']['input'];
  iconImgLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  orgLink?: InputMaybe<Scalars['String']['input']>;
};

export type AccoladeTypeRatingEntity = {
  __typename?: 'AccoladeTypeRatingEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getIsHalfPoints */
  isHalfPoints: Scalars['Boolean']['output'];
  /** AccoladeTypeRatingEntity_Generated::getMaxValue */
  maxValue: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getMinValue */
  minValue: Scalars['Int']['output'];
  /** AccoladeTypeRatingEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** AccoladeTypeRatingEntity_Generated::getSystemType */
  systemType: System;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type AccoladeTypeRatingInfo = {
  __typename?: 'AccoladeTypeRatingInfo';
  /** AccoladeTypeRatingInfo::accoladeTypeRatingEntity */
  accoladeTypeRatingEntity?: Maybe<AccoladeTypeRatingEntity>;
  /** AccoladeTypeRatingInfo::accoladeTypesWithRating */
  accoladeTypesWithRating: Array<Scalars['String']['output']>;
  /** AccoladeTypeRatingInfo::totalNumAccoladesUsingRating */
  totalNumAccoladesUsingRating: Scalars['Int']['output'];
};

export type AccoladeTypeRatingInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isHalfPoints?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  systemType?: InputMaybe<System>;
};

export const ActiveMode = {
  Active: 'ACTIVE',
  All: 'ALL',
  Inactive: 'INACTIVE'
} as const;

export type ActiveMode = typeof ActiveMode[keyof typeof ActiveMode];
export type AddEntitlementToEntitlementSetsInput = {
  entitlementId: Scalars['Int']['input'];
  entitlementSetIds: Array<Scalars['Int']['input']>;
};

export type AddEntitlementToEntitlementSetsPayload = {
  __typename?: 'AddEntitlementToEntitlementSetsPayload';
  /** AddEntitlementToEntitlementSetsPayload::entitlementSetFeatures */
  entitlementSetFeatures: Array<EntitlementSetFeatureEntity>;
  /** AddEntitlementToEntitlementSetsPayload::error */
  error?: Maybe<ErrorResult>;
};

export type AddPatronAddressInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  googlePlacesId: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<PatronPhoneInput>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  /** Address::address */
  address?: Maybe<Scalars['String']['output']>;
  /** Address::address2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Address::city */
  city?: Maybe<Scalars['String']['output']>;
  /** Address::googlePlacesId */
  googlePlacesId?: Maybe<Scalars['String']['output']>;
  /** Address::latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Address::longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Address::neighborhood */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Address::state */
  state?: Maybe<Scalars['String']['output']>;
  /** Address::zipCode */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressProfileInput = {
  address?: InputMaybe<AddressInput>;
  contactPhone?: InputMaybe<ContactPhoneInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type AdminPatronNotifySummary = {
  __typename?: 'AdminPatronNotifySummary';
  /** AdminPatronNotifySummary::createdAt */
  createdAt: Scalars['String']['output'];
  /** AdminPatronNotifySummary::notifyDates */
  notifyDates: Array<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::partySize */
  partySize: Scalars['Int']['output'];
  /** AdminPatronNotifySummary::preferredEndTime */
  preferredEndTime?: Maybe<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::preferredStartTime */
  preferredStartTime?: Maybe<Scalars['String']['output']>;
  /** AdminPatronNotifySummary::status */
  status: Scalars['String']['output'];
  /** AdminPatronNotifySummary::venueName */
  venueName: Scalars['String']['output'];
};

export type AdminPatronPurchaseSummary = {
  __typename?: 'AdminPatronPurchaseSummary';
  /** AdminPatronPurchaseSummary::partySize */
  partySize: Scalars['Int']['output'];
  /** AdminPatronPurchaseSummary::startDateTime */
  startDateTime: Scalars['String']['output'];
  /** AdminPatronPurchaseSummary::status */
  status: Scalars['String']['output'];
  /** AdminPatronPurchaseSummary::venueName */
  venueName: Scalars['String']['output'];
};

export type AffiliatedVenue = {
  __typename?: 'AffiliatedVenue';
  /** AffiliatedVenue::fullLink */
  fullLink: Scalars['String']['output'];
  /** AffiliatedVenue::location */
  location: Scalars['String']['output'];
  /** AffiliatedVenue::name */
  name: Scalars['String']['output'];
  /** AffiliatedVenue::priceRange */
  priceRange?: Maybe<PriceRange>;
  /** AffiliatedVenue::ratings */
  ratings?: Maybe<Scalars['Float']['output']>;
  /** AffiliatedVenue::ratingsCount */
  ratingsCount?: Maybe<Scalars['Int']['output']>;
  /** AffiliatedVenue::simpleCuisine */
  simpleCuisine: Scalars['String']['output'];
  /** AffiliatedVenue::uploadedImage */
  uploadedImage: UploadedImageEntity;
};

export const AlertOwnerTeam = {
  Foh: 'FOH',
  Guest: 'GUEST',
  Integrations: 'INTEGRATIONS',
  Payments: 'PAYMENTS'
} as const;

export type AlertOwnerTeam = typeof AlertOwnerTeam[keyof typeof AlertOwnerTeam];
export type Announcement = {
  __typename?: 'Announcement';
  /** Announcement::infoBoxLink */
  infoBoxLink?: Maybe<Scalars['String']['output']>;
  /** Announcement::infoBoxText */
  infoBoxText?: Maybe<Scalars['String']['output']>;
};

export type Availability = {
  __typename?: 'Availability';
  /** The actions we suggest for the user. (Availability::getActions) */
  actions: Array<AvailabilityAction>;
  /** The high-level status of the business's availability. (Availability::getStatus) */
  status: AvailabilityStatus;
};

export type AvailabilityAction = {
  /** AvailabilityAction::type */
  type: AvailabilityActionType;
};

export const AvailabilityActionType = {
  Critical: 'CRITICAL',
  Recommended: 'RECOMMENDED'
} as const;

export type AvailabilityActionType = typeof AvailabilityActionType[keyof typeof AvailabilityActionType];
export type AvailabilityCriticalAction = AvailabilityAction & {
  __typename?: 'AvailabilityCriticalAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityOffAction = AvailabilityAction & {
  __typename?: 'AvailabilityOffAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityRecommendedAction = AvailabilityAction & {
  __typename?: 'AvailabilityRecommendedAction';
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export const AvailabilityState = {
  Danger: 'DANGER',
  IneligibleForAvailability: 'INELIGIBLE_FOR_AVAILABILITY',
  Success: 'SUCCESS',
  Warning: 'WARNING'
} as const;

export type AvailabilityState = typeof AvailabilityState[keyof typeof AvailabilityState];
export type AvailabilityStatus = {
  __typename?: 'AvailabilityStatus';
  /** The end date of the current business's global availability window (AvailabilityStatus::globalEndDate) */
  globalEndDate: Scalars['LocalDate']['output'];
  /** AvailabilityStatus::state */
  state: AvailabilityState;
};

export type AvailabilityWindowEndingAction = AvailabilityAction & {
  __typename?: 'AvailabilityWindowEndingAction';
  /** AvailabilityWindowEndingAction::endingDate */
  endingDate: Scalars['LocalDate']['output'];
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type AvailabilityWindowInPastAction = AvailabilityAction & {
  __typename?: 'AvailabilityWindowInPastAction';
  /** AvailabilityWindowInPastAction::endDate */
  endDate: Scalars['LocalDate']['output'];
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type Available = DateTimeRange & Node & TableStateRange & {
  __typename?: 'Available';
  /** Available::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** Available::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** Available::offering */
  offering: Array<Offering>;
  /** Available::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Available::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** Available::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Available::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type AvailableCommunalSlot = Slot & {
  __typename?: 'AvailableCommunalSlot';
  /** AvailableCommunalSlot::availableSize */
  availableSize: Scalars['Int']['output'];
  /** AvailableCommunalSlot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** AvailableCommunalSlot::exclusivity */
  exclusivity: Exclusivity;
  /** AvailableCommunalSlot::isHidden */
  hidden: Scalars['Boolean']['output'];
  /** AvailableCommunalSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** AvailableCommunalSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** AvailableCommunalSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type AvailableOptions = {
  __typename?: 'AvailableOptions';
  /** AvailableOptions::options */
  options: Array<Option>;
  /** AvailableOptions::optionsType */
  optionsType?: Maybe<OptionsType>;
};

export type AvailableSlot = Slot & {
  __typename?: 'AvailableSlot';
  /** AvailableSlot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** AvailableSlot::exclusivity */
  exclusivity: Exclusivity;
  /** AvailableSlot::isHidden */
  hidden: Scalars['Boolean']['output'];
  /** AvailableSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** AvailableSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** AvailableSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type AvailableTimelineExportDetails = {
  __typename?: 'AvailableTimelineExportDetails';
  /** AvailableTimelineExportDetails::getFileDescriptors */
  fileDescriptors: Array<ExportFileDescriptor>;
};

export type AvalaraTax = PurchasableTax & Tax & {
  __typename?: 'AvalaraTax';
  /** AvalaraTax::getFlatTaxCents */
  flatTaxCents?: Maybe<Scalars['Int']['output']>;
  /** AvalaraTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** AvalaraTax::getJurisdictionName */
  jurisdictionName: Scalars['String']['output'];
  /** AvalaraTax::getJurisdictionType */
  jurisdictionType: JurisdictionType;
  /** AvalaraTax::getName */
  name: Scalars['String']['output'];
  /** AvalaraTax::getTaxApplicationType */
  taxApplicationType?: Maybe<TaxApplicationType>;
  /** AvalaraTax::getTaxRate */
  taxRate: Percent;
  /** AvalaraTax::getTaxSource */
  taxSource: TaxSource;
  /** AvalaraTax::getTaxType */
  taxType: Scalars['String']['output'];
  /** AvalaraTax::getUsState */
  usState?: Maybe<UsState>;
};

export const AvalaraTaxParameterKey = {
  EatingFacilityProvisions: 'EatingFacilityProvisions',
  FoodAndBeverageSales: 'FoodAndBeverageSales',
  IsServiceChargeTaxed: 'IsServiceChargeTaxed',
  PlaceOfConsumption: 'PlaceOfConsumption',
  SellerClassification: 'SellerClassification'
} as const;

export type AvalaraTaxParameterKey = typeof AvalaraTaxParameterKey[keyof typeof AvalaraTaxParameterKey];
export type Award = {
  __typename?: 'Award';
  /** Award::accoladeType */
  accoladeType?: Maybe<AccoladeType>;
  /** Award::achievement */
  achievement?: Maybe<Scalars['String']['output']>;
  /** Award::name */
  name?: Maybe<Scalars['String']['output']>;
  /** Award::yearDisplay */
  yearDisplay?: Maybe<Scalars['String']['output']>;
};

export const BackingMode = {
  MenuItem: 'MENU_ITEM',
  MenuModifier: 'MENU_MODIFIER',
  TicketOption: 'TICKET_OPTION'
} as const;

export type BackingMode = typeof BackingMode[keyof typeof BackingMode];
export const BackingType = {
  Db: 'DB',
  Enum: 'ENUM'
} as const;

export type BackingType = typeof BackingType[keyof typeof BackingType];
export const BankAccountType = {
  Checking: 'CHECKING',
  Savings: 'SAVINGS'
} as const;

export type BankAccountType = typeof BankAccountType[keyof typeof BankAccountType];
export type BaseStateEntity = {
  __typename?: 'BaseStateEntity';
  /** BaseStateEntity::getBaseState */
  baseState: Scalars['String']['output'];
  /** Returns the byte[] baseState as a human-readable JSON string. (BaseStateEntity::getBaseStateJson) */
  baseStateJson: Scalars['String']['output'];
  /** BaseStateEntity::getBusinessId */
  businessId: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseStateEntity::getEventId */
  eventId: Scalars['Int']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseStateEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseStateEntity::getServiceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type Block = DateTimeRange & Node & TableStateRange & {
  __typename?: 'Block';
  /** Block::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** Block::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type BookableTable = {
  __typename?: 'BookableTable';
  /** BookableTable::assignmentPriorityLevel */
  assignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** BookableTable::blockedLocalTimes */
  blockedLocalTimes: Array<Scalars['LocalTime']['output']>;
  /** BookableTable::maxSize */
  maxSize: Scalars['Int']['output'];
  /** BookableTable::minSize */
  minSize: Scalars['Int']['output'];
  /** BookableTable::name */
  name: Scalars['String']['output'];
  /** BookableTable::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** BookableTable::supportedExperiences */
  supportedExperiences: Array<Experience>;
};

export type Booking = {
  __typename?: 'Booking';
  /** Booking::assignedToSlot */
  assignedToSlot: Scalars['Boolean']['output'];
  /** Booking::date */
  date: Scalars['LocalDate']['output'];
  /** Booking::endLocalTime */
  endLocalTime: Scalars['LocalTime']['output'];
  /** Booking::experience */
  experience: Experience;
  /** Booking::partyName */
  partyName: Scalars['String']['output'];
  /** Booking::partySize */
  partySize: Scalars['Int']['output'];
  /** Booking::pinTicketGroup */
  pinTicketGroup: Scalars['Boolean']['output'];
  /** Booking::pinned */
  pinned: Scalars['Boolean']['output'];
  /** Booking::startLocalTime */
  startLocalTime: Scalars['LocalTime']['output'];
  /** Booking::getUniqueIdentifier */
  uniqueIdentifier: Scalars['String']['output'];
};

export type BookingBase = {
  /** BookingBase::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** BookingBase::id */
  id: Scalars['ID']['output'];
  /** BookingBase::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** BookingBase::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** BookingBase::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
};

export type BookingNoteEntity = {
  __typename?: 'BookingNoteEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BookingNoteEntity_Generated::getNote */
  note?: Maybe<Scalars['String']['output']>;
  /** BookingNoteEntity_Generated::getNoteType */
  noteType?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BookingPolicy = {
  __typename?: 'BookingPolicy';
  /** BookingPolicy::editOrCancelRestriction */
  editOrCancelRestriction?: Maybe<ModificationRestriction>;
  /** BookingPolicy::explanation */
  explanation: Array<Scalars['String']['output']>;
  /** BookingPolicy::rescheduleRestriction */
  rescheduleRestriction?: Maybe<ModificationRestriction>;
  /** BookingPolicy::transferRestriction */
  transferRestriction?: Maybe<ModificationRestriction>;
};

export type BookingReleaseEntity = {
  __typename?: 'BookingReleaseEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BookingRequestForPriceSheetInput = {
  partySize: Scalars['Int']['input'];
  requestedDateTime: Scalars['LocalDateTime']['input'];
};

export type BookingRequestForTurnTimesInput = {
  partySize: Scalars['Int']['input'];
  requestedDateTime: Scalars['LocalDateTime']['input'];
};

export type BookingToTables = {
  __typename?: 'BookingToTables';
  /** BookingToTables::bookableTables */
  bookableTables: Array<BookableTable>;
  /** BookingToTables::booking */
  booking: Booking;
};

export type BulkAdminPatronActionPayload = {
  __typename?: 'BulkAdminPatronActionPayload';
  /** BulkAdminPatronActionPayload::errors */
  errors: Array<ErrorResult>;
  /** BulkAdminPatronActionPayload::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** BulkAdminPatronActionPayload::successCount */
  successCount: Scalars['Int']['output'];
};

export type BulkPatronActionWorkflowStatus = {
  __typename?: 'BulkPatronActionWorkflowStatus';
  /** BulkPatronActionWorkflowStatus::attachedToExistingRun */
  attachedToExistingRun: Scalars['Boolean']['output'];
  /** BulkPatronActionWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** BulkPatronActionWorkflowStatus::errors */
  errors: Array<Scalars['String']['output']>;
  /** BulkPatronActionWorkflowStatus::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** BulkPatronActionWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numProcessed */
  numProcessed: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
  /** BulkPatronActionWorkflowStatus::numTruncatedErrors */
  numTruncatedErrors: Scalars['Int']['output'];
};

export type BusinessAccoladeEntity = {
  __typename?: 'BusinessAccoladeEntity';
  /** BusinessAccoladeEntity_Generated::getAccolade */
  accolade?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getAccoladeType */
  accoladeType?: Maybe<AccoladeTypeEntity>;
  /** BusinessAccoladeEntity_Generated::getAchievement */
  achievement?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getAuthor */
  author?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessAccoladeEntity_Generated::getIsArchived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessAccoladeEntity_Generated::getLink */
  link?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getOrdering */
  ordering?: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeEntity_Generated::getOrganization */
  organization?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getRatingNumber */
  ratingNumber?: Maybe<Scalars['Float']['output']>;
  /** BusinessAccoladeEntity_Generated::getRatingString */
  ratingString?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessAccoladeEntity_Generated::getYear */
  year?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeEntity_Generated::getYearEndInclusive */
  yearEndInclusive?: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeEntity_Generated::getYearStartInclusive */
  yearStartInclusive: Scalars['Int']['output'];
};

export type BusinessAccoladeInput = {
  accolade?: InputMaybe<Scalars['String']['input']>;
  accoladeType?: InputMaybe<AccoladeTypeInput>;
  accoladeTypeId?: InputMaybe<Scalars['Int']['input']>;
  achievement?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  businessId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  ratingNumber?: InputMaybe<Scalars['Int']['input']>;
  ratingNumberNew?: InputMaybe<Scalars['Float']['input']>;
  ratingString?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  yearEndInclusive?: InputMaybe<Scalars['Int']['input']>;
  yearStartInclusive?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessAccoladeOutput = {
  __typename?: 'BusinessAccoladeOutput';
  /** BusinessAccoladeOutput::accoladeType */
  accoladeType?: Maybe<AccoladeTypeEntity>;
  /** BusinessAccoladeOutput::accoladeTypeName */
  accoladeTypeName?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::achievement */
  achievement?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::isArchived */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessAccoladeOutput::author */
  author?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::business */
  business?: Maybe<BusinessEntity>;
  /** BusinessAccoladeOutput::id */
  id: Scalars['Int']['output'];
  /** BusinessAccoladeOutput::link */
  link?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::ordering */
  ordering?: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeOutput::organization */
  organization?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::ratingNumber */
  ratingNumber?: Maybe<Scalars['Float']['output']>;
  /** BusinessAccoladeOutput::ratingString */
  ratingString?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::year */
  year?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::yearDisplay */
  yearDisplay?: Maybe<Scalars['String']['output']>;
  /** BusinessAccoladeOutput::yearEndInclusive */
  yearEndInclusive?: Maybe<Scalars['Int']['output']>;
  /** BusinessAccoladeOutput::yearStartInclusive */
  yearStartInclusive: Scalars['Int']['output'];
};

export type BusinessAvalaraTaxParameterEntity = {
  __typename?: 'BusinessAvalaraTaxParameterEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessAvalaraTaxParameterEntity::getParameterKey */
  parameterKey: AvalaraTaxParameterKey;
  /** BusinessAvalaraTaxParameterEntity::getParameterValue */
  parameterValue: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessBankAccountEntity = {
  __typename?: 'BusinessBankAccountEntity';
  /** BusinessBankAccountEntityBase::getBankAccountType */
  bankAccountType?: Maybe<BankAccountType>;
  /** BusinessBankAccountEntityBase::getBankName */
  bankName?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessBankAccountEntityBase::getDepositedCents1 */
  depositedCents1?: Maybe<Scalars['Int']['output']>;
  /** BusinessBankAccountEntityBase::getDepositsPayout */
  depositsPayout?: Maybe<PayoutEntity>;
  /** BusinessBankAccountEntityBase::getDepositsSent */
  depositsSent?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessBankAccountEntityBase::getDepositsSentDate */
  depositsSentDate?: Maybe<Scalars['LocalDate']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FinanceBusinessResolvers::maskedAccountNumber */
  maskedAccountNumber?: Maybe<Scalars['String']['output']>;
  /** BusinessBankAccountEntityBase::getTockVerified */
  tockVerified?: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessBankAccountEntityBase::getVerificationDepositsRequired */
  verificationDepositsRequired?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessBankAccountEntityBase::getVerificationStatus */
  verificationStatus?: Maybe<VerificationStatus>;
  /** BusinessBankAccountEntityBase::getVerified */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessBillingInvoiceEntity = {
  __typename?: 'BusinessBillingInvoiceEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessClosedDayEntity = {
  __typename?: 'BusinessClosedDayEntity';
  /** BusinessClosedDayEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessClosedDayEntity_Generated::getDate */
  date: Scalars['LocalDate']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessClosedDayEntity_Generated::getPatron */
  patron?: Maybe<PatronEntity>;
  /** BusinessClosedDayEntity_Generated::getReason */
  reason?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessContent = {
  __typename?: 'BusinessContent';
  /** BusinessContent::needToKnow */
  needToKnow?: Maybe<Scalars['String']['output']>;
  /** BusinessContent::whyWeLikeIt */
  whyWeLikeIt?: Maybe<Scalars['String']['output']>;
};

export type BusinessContentEntity = {
  __typename?: 'BusinessContentEntity';
  /** BusinessContentEntity_Generated::getBusinessId */
  businessId?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessContentEntity_Generated::getNeedToKnow */
  needToKnow?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessContentEntity_Generated::getVenueId */
  venueId?: Maybe<Scalars['Int']['output']>;
  /** BusinessContentEntity_Generated::getWhyWeLikeIt */
  whyWeLikeIt?: Maybe<Scalars['String']['output']>;
};

export type BusinessDetailsEntity = {
  __typename?: 'BusinessDetailsEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessDetailsEntity_Generated::getDistinguishLargeParties */
  distinguishLargeParties: Scalars['Boolean']['output'];
  /** BusinessDetailsEntity_Generated::getEmail */
  email?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessDetailsEntity_Generated::getMinLargePartySize */
  minLargePartySize?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessEntitlementSetEntity = Node & {
  __typename?: 'BusinessEntitlementSetEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessEntitlementSetEntity_Generated::getEntitlementSet */
  entitlementSet: EntitlementSetEntity;
  /** BusinessEntitlementSetEntity::getId */
  id: Scalars['ID']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessEntitlementSetEntity_Generated::getSource */
  source: BusinessEntitlementSetSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const BusinessEntitlementSetSource = {
  Addon: 'ADDON',
  Manual: 'MANUAL',
  Plan: 'PLAN'
} as const;

export type BusinessEntitlementSetSource = typeof BusinessEntitlementSetSource[keyof typeof BusinessEntitlementSetSource];
export type BusinessEntity = {
  __typename?: 'BusinessEntity';
  /** BusinessEntity::getIANATimeZone */
  IANATimeZone?: Maybe<Scalars['String']['output']>;
  /** BusinessEntity_Generated::getAccolades */
  accolades: Array<BusinessAccoladeEntity>;
  /** Get available experiences for a business (BusinessResolvers::getActivePublicExperiences) */
  activePublicExperiences: Array<TicketTypeSlim>;
  /** All active tables that are bookable at some point in the future. (BusinessResolvers::getAllActiveFutureTables) */
  allActiveFutureTables: Array<TableEntity>;
  /** Get all active tables for a business (BusinessEntity::getAllActiveTables) */
  allActiveTables: Array<TableEntity>;
  /** Events for a business on a given date (AllEventsResolvers::allEvents) */
  allEvents: Array<EventEntity>;
  /** Business-level availability data (BusinessResolvers::availability) */
  availability?: Maybe<Availability>;
  /** List timeline exports available in GCS for a business taken on a given date (InternalRebalanceToolingResolvers::availableTimelineExports) */
  availableTimelineExports?: Maybe<AvailableTimelineExportDetails>;
  /** BusinessEntity_Generated::getAvalaraTaxParameters */
  avalaraTaxParameters: Array<BusinessAvalaraTaxParameterEntity>;
  /** BusinessEntity::getBankAccount */
  bankAccount?: Maybe<BusinessBankAccountEntity>;
  /** Base state for a business on a given date (BaseStateResolvers::baseState) */
  baseState: BaseStateEntity;
  /** BusinessResolvers::bookingReleases */
  bookingReleases: Array<BookingReleaseEntity>;
  /** BusinessEntity_Generated::getBookingsDisabled */
  bookingsDisabled?: Maybe<Scalars['Boolean']['output']>;
  /** All business accolades for a business (BusinessAccoladeResolvers::businessAccolades) */
  businessAccolades: Array<BusinessAccoladeEntity>;
  /** All business accolades for a business (BusinessAccoladeResolvers::businessAccoladesList) */
  businessAccoladesList: Array<BusinessAccoladeOutput>;
  /** BusinessEntity_Generated::getBusinessBillingInvoices */
  businessBillingInvoices: Array<BusinessBillingInvoiceEntity>;
  /** BusinessEntity_Generated::getBusinessDetails */
  businessDetails?: Maybe<BusinessDetailsEntity>;
  /** BusinessEntity_Generated::getBusinessEntitlementSets */
  businessEntitlementSets: Array<BusinessEntitlementSetEntity>;
  /** BusinessEntity_Generated::getBusinessFaqs */
  businessFaqs: Array<BusinessFaqEntity>;
  /** BusinessEntity_Generated::getBusinessGroup */
  businessGroup: BusinessGroupEntity;
  /** Get a tag by business and ID (BusinessGroupTagResolvers::businessGroupTag) */
  businessGroupTag?: Maybe<BusinessGroupTagPayload>;
  /** BusinessEntity_Generated::getBusinessTags */
  businessTags: Array<BusinessTagEntity>;
  /** BusinessEntity_Generated::getBusinessWaitlistPriorityFactors */
  businessWaitlistPriorityFactors: Array<BusinessWaitlistPriorityFactorEntity>;
  /** Business calendar data (BusinessResolvers::calendar) */
  calendar?: Maybe<CalendarDateQuery>;
  /** BusinessEntity_Generated::getClosedDays */
  closedDays: Array<BusinessClosedDayEntity>;
  /** Load a timeline dumped to GCS and compare the plan from another rebalancer (InternalRebalanceToolingResolvers::compareRebalancePlans) */
  compareRebalancePlans?: Maybe<RebalancePlanComparison>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessEntity_Generated::getCurrencyCode */
  currencyCode: Scalars['String']['output'];
  /** BusinessEntity::getCustomerFacingEmail */
  customerFacingEmail?: Maybe<Scalars['String']['output']>;
  /** BusinessEntity::getCustomerFacingPhone */
  customerFacingPhone?: Maybe<Scalars['String']['output']>;
  /** BusinessEntity_Generated::getCutoffDaysBefore */
  cutoffDaysBefore?: Maybe<Scalars['Int']['output']>;
  /** BusinessEntity_Generated::getCutoffMinutesBefore */
  cutoffMinutesBefore?: Maybe<Scalars['Int']['output']>;
  /** BusinessEntity_Generated::getCutoffTime */
  cutoffTime?: Maybe<Scalars['LocalTime']['output']>;
  /** RebalanceResolvers::defaultMediumScoreOptions */
  defaultMediumScoreOptions: MediumScoreOptions;
  /** The main type of offering for this business. This is a way to separate Events-only and TTG-only businesses from standard dine-in businesses. (BusinessResolvers::defaultOfferingType) */
  defaultOfferingType: OfferingType;
  /** RebalanceResolvers::defaultSoftScoreOptions */
  defaultSoftScoreOptions: SoftScoreOptions;
  /** BusinessEntity_Generated::getDomainName */
  domainName?: Maybe<Scalars['String']['output']>;
  /** BusinessResolvers::getEmailLogoUrl */
  emailLogoUrl?: Maybe<Scalars['String']['output']>;
  /** EventTemplateResolvers::eventTemplates */
  eventTemplates: Array<EventTemplate>;
  /** BusinessEntity_Generated::getExclusivityPrograms */
  exclusivityPrograms: Array<BusinessExclusivityProgramEntity>;
  /** TurnTimeResolvers::getExpectedWalkInTurnTimeMinutes */
  expectedWalkInTurnTimeMinutes?: Maybe<Scalars['Int']['output']>;
  /** Gets the fallback tax category for a business. (TaxResolvers::fallbackTaxCategory) */
  fallbackTaxCategory: TaxCategoryEntity;
  /** BusinessEntity_Generated::getGiftCardProvider */
  giftCardProvider?: Maybe<GiftCardProvider>;
  /** Get guest profile (GuestProfileResolvers::guestProfileByPatronIds) */
  guestProfileByPatronIds: Array<GuestProfileEntity>;
  /** BusinessEntity::getFirstProfileImageUrl */
  heroImageUrl?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** All images in the business's image collection. These images may or may not be displayed publicly. (BusinessResolvers::getImages) */
  images: Array<BusinessImage>;
  /** BusinessEntity_Generated::getImportRecords */
  importRecords: Array<ImportEntity>;
  /** BusinessResolvers::inventorySchedules */
  inventorySchedules: Array<BusinessInventoryScheduleEntity>;
  /** BusinessEntity_Generated::getInvoices */
  invoices: Array<InvoiceEntity>;
  /** BusinessEntity::isActive */
  isActive: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getIsAuthorizedByTock */
  isAuthorizedByTock: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getIsDeleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Returns True if there is no item owned by this business with the provided name. (WineItemsResolvers::isItemNameUniqueForBusiness) */
  itemNameUniqueForBusiness?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessEntity_Generated::getLanguageTag */
  locale: Scalars['String']['output'];
  /** BusinessResolvers::getLocation */
  location: BusinessLocation;
  /** BusinessEntity_Generated::getMenuItems */
  menuItems: Array<MenuItemEntity>;
  /** BusinessEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessEntity_Generated::getPaymentProcessorType */
  paymentProcessorType?: Maybe<PaymentProcessorType>;
  /** BusinessEntity::getPaymentSubscription */
  paymentSubscription?: Maybe<PaymentSubscriptionEntity>;
  /** BusinessEntity_Generated::getPayoutConfigs */
  payoutConfigs: Array<BusinessPayoutConfigEntity>;
  /** FinanceBusinessResolvers::getPayoutSummarys */
  payoutSummarys: Array<BusinessPayoutSummaryEntity>;
  /** The Google Place ID for this business (BusinessEntity::placeId) */
  placeId?: Maybe<Scalars['String']['output']>;
  /** Entitlement changes given a business, plan, and list of add-ons (EntitlementSetResolvers::previewEntitlementChanges) */
  previewEntitlementChanges?: Maybe<EntitlementChangePreview>;
  /** Images shown on the business's profile page. (BusinessResolvers::getProfileImages) */
  profileImages: Array<BusinessImage>;
  /** PublicMenuResolvers::publicMenu */
  publicMenu?: Maybe<Menu>;
  /** PublicMenuResolvers::publicMenus */
  publicMenus: Array<Menu>;
  /** Bookings made for the business. (BusinessResolvers::getPurchases) */
  purchases: Array<PurchaseEntity>;
  /** BusinessEntity::isResyCreditEligible */
  resyCreditEligible: Scalars['Boolean']['output'];
  /** BusinessEntity_Generated::getSearchAttributes */
  searchAttributes: Array<SearchAttributeEntity>;
  /** Gets all Seating Areas for the current business. (SeatingAreaResolvers::seatingAreas) */
  seatingAreas: Array<SeatingAreaOutput>;
  /** Provides a means to get the shipping configuration for a business. (BusinessEntity::getShippingConfiguration) */
  shippingConfiguration?: Maybe<ShippingConfigurationEntity>;
  /** Get Shop Brands for this Business, optionally including archived ones. (ShopBrandResolvers::getShopBrands) */
  shopBrands: Array<ShopBrandEntity>;
  /** BusinessEntity::getShopBusiness */
  shopBusiness?: Maybe<ShopBusinessEntity>;
  /** BusinessEntity_Generated::getShopBusinesss */
  shopBusinesss: Array<ShopBusinessEntity>;
  /** BusinessEntity_Generated::getShopConfigOnboardingStates */
  shopConfigOnboardingStates: Array<ShopConfigOnboardingStateEntity>;
  /** Get business shop items (BusinessResolvers::getShopItems) */
  shopItems: Array<ShopItem>;
  /** Gets a single order shipment by the order id (ShopOrderResolvers::shopOrder) */
  shopOrder?: Maybe<FormattedWineShopOrder>;
  /** Gets all Shop Orders for this business. (ShopOrderResolvers::shopOrders) */
  shopOrders: Array<OrderEntity>;
  /** Gets shop orders for a business with optional name filter and pagination (ShopOrderResolvers::shopOrdersPaginated) */
  shopOrdersPaginated?: Maybe<OrderEntityConnection>;
  /** BusinessResolvers::getShouldDisplayAddress */
  shouldDisplayAddress: Scalars['Boolean']['output'];
  /** BusinessResolvers::getShowCovidSafetyMeasures */
  showCovidSafetyMeasures: Scalars['Boolean']['output'];
  /** Get tax categories enabled for a business, as well as disabled/inactive tax categories associated with an optional list of purchasable ids. (TaxResolvers::taxCategoryEntities) */
  taxCategoryEntities: Array<TaxCategoryEntity>;
  /** TicketGroupResolvers::ticketGroup */
  ticketGroup?: Maybe<TicketGroupEntity>;
  /** TicketGroupResolvers::ticketGroups */
  ticketGroups: Array<TicketGroupEntity>;
  /** BusinessResolvers::getTicketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** BusinessEntity::getTicketTypes */
  ticketTypes: Array<TicketTypeEntity>;
  /** TicketTypeResolvers::ticketTypesList */
  ticketTypesList: Array<TicketTypeOutput>;
  /** BusinessResolvers::ticketsAvailableUntil */
  ticketsAvailableUntil?: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessResolvers::getTimeZone */
  timeZone?: Maybe<Scalars['String']['output']>;
  /** BusinessEntity::getTockContact */
  tockContact?: Maybe<BusinessTockContactEntity>;
  /** TockTenResolvers::tockTenConfigs */
  tockTenConfigs: Array<TockTenConfigEntity>;
  /** Returns unassigned reservations and their last table assignment, priority, seating area, experience, guest name, and party size (UnassignedReportResolvers::unassignedReservations) */
  unassignedReservations: Array<UnassignedReservations>;
  /** BusinessEntity::isUnlisted */
  unlisted: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** Validates a Brand Key and SKU with ShipCompliant. Returns a ShipCompliantItemValidation if the item is validated and throws an exception if not. (ShipCompliantItemValidationResolvers::validateShipCompliantItem) */
  validateShipCompliantItem?: Maybe<ShipCompliantItemValidation>;
  /** Visit feedback for the business. (VisitFeedbackResolvers::getVisitFeedbackReport) */
  visitFeedbackReport?: Maybe<VisitFeedbackReportPayload>;
  /** BusinessEntity::isWaitingForReview */
  waitingForReview: Scalars['Boolean']['output'];
  /** WaitlistResolvers::waitlist */
  waitlist?: Maybe<WaitlistEntity>;
  /** The publicly accessible URL guests can visit to make reservations to this business (BusinessEntity::webUrl) */
  webUrl?: Maybe<Scalars['String']['output']>;
  /** Fetch all Tock webhook endpoints for a business (TockWebhookResolvers::webhookEndpoints) */
  webhookEndpoints: Array<WebhookEndpointEntity>;
};


export type BusinessEntityAllEventsArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityAvailableTimelineExportsArgs = {
  env: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
};


export type BusinessEntityBaseStateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityBusinessGroupTagArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityCompareRebalancePlansArgs = {
  env: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
  filename: Scalars['String']['input'];
  service: Scalars['String']['input'];
  serviceDate: Scalars['LocalDate']['input'];
  timeLimitMillis: Scalars['Int']['input'];
};


export type BusinessEntityEventTemplatesArgs = {
  ticketTypeIds: Array<Scalars['Int']['input']>;
};


export type BusinessEntityExpectedWalkInTurnTimeMinutesArgs = {
  bookingRequest: BookingRequestForTurnTimesInput;
};


export type BusinessEntityGuestProfileByPatronIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type BusinessEntityImagesArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};


export type BusinessEntityItemNameUniqueForBusinessArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


export type BusinessEntityPreviewEntitlementChangesArgs = {
  paymentSubscriptionPlanAddonIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentSubscriptionPlanId?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessEntityPublicMenuArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityPurchasesArgs = {
  purchaseFilter: PurchaseFilterInput;
};


export type BusinessEntityShopBrandsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BusinessEntityShopItemsArgs = {
  filter: ShopItemFilterInput;
};


export type BusinessEntityShopOrderArgs = {
  confirmationCode: Scalars['String']['input'];
};


export type BusinessEntityShopOrdersPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  search?: InputMaybe<ShopOrderSearchParamsInput>;
  sortDirection?: InputMaybe<SortDirection>;
  sortProperty?: InputMaybe<ShopOrderSortProperties>;
};


export type BusinessEntityTaxCategoryEntitiesArgs = {
  purchasableIds?: InputMaybe<Array<PurchasableIdInput>>;
};


export type BusinessEntityTicketGroupArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityTicketGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type BusinessEntityTicketTypeArgs = {
  id: Scalars['Int']['input'];
};


export type BusinessEntityTicketTypesArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  varieties?: InputMaybe<Array<TicketTypeVariety>>;
};


export type BusinessEntityTicketTypesListArgs = {
  future?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  varieties?: InputMaybe<Array<TicketTypeVariety>>;
};


export type BusinessEntityUnassignedReservationsArgs = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};


export type BusinessEntityValidateShipCompliantItemArgs = {
  brandKey?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
};


export type BusinessEntityVisitFeedbackReportArgs = {
  purchaseFilter: PurchaseFilterInput;
};


export type BusinessEntityWaitlistArgs = {
  waitlistId: Scalars['Int']['input'];
};

/** A connection to a list of items. */
export type BusinessEntityConnection = {
  __typename?: 'BusinessEntityConnection';
  /** a list of edges */
  edges?: Maybe<Array<Maybe<BusinessEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type BusinessEntityEdge = {
  __typename?: 'BusinessEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BusinessEntity>;
};

export type BusinessExclusivityProgramEntity = {
  __typename?: 'BusinessExclusivityProgramEntity';
  /** BusinessExclusivityProgramEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessExclusivityProgramEntity_Generated::getDefaultTableReleaseDaysBefore */
  defaultTableReleaseDaysBefore?: Maybe<Scalars['Int']['output']>;
  /** BusinessExclusivityProgramEntity_Generated::getExclusivityProgram */
  exclusivityProgram: Exclusivity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessFaqEntity = {
  __typename?: 'BusinessFaqEntity';
  /** BusinessFaqEntity_Generated::getAnswer */
  answer?: Maybe<Scalars['String']['output']>;
  /** BusinessFaqEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessFaqEntity_Generated::getOrderingIndex */
  orderingIndex: Scalars['Int']['output'];
  /** BusinessFaqEntity_Generated::getQuestion */
  question?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessFaqInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type BusinessFeatureEntity = {
  __typename?: 'BusinessFeatureEntity';
  /** BusinessFeatureEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessFeatureEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BusinessFeatureEntity_Generated::getHistorys */
  historys: Array<BusinessFeatureHistoryEntity>;
  /** BusinessFeatureEntity_Generated::getId */
  id?: Maybe<Scalars['Int']['output']>;
  /** BusinessFeatureEntity_Generated::getLastEditedByPatron */
  lastEditedByPatron?: Maybe<PatronEntity>;
  /** BusinessFeatureEntity_Generated::getState */
  state: BusinessFeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type BusinessFeatureHistoryEntity = {
  __typename?: 'BusinessFeatureHistoryEntity';
  /** BusinessFeatureHistoryEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BusinessFeatureHistoryEntity_Generated::getBusinessFeature */
  businessFeature?: Maybe<BusinessFeatureEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessFeatureHistoryEntity_Generated::getEditedByPatron */
  editedByPatron?: Maybe<PatronEntity>;
  /** BusinessFeatureHistoryEntity_Generated::getState */
  state: BusinessFeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export const BusinessFeatureState = {
  Launched: 'LAUNCHED',
  Unlaunched: 'UNLAUNCHED'
} as const;

export type BusinessFeatureState = typeof BusinessFeatureState[keyof typeof BusinessFeatureState];
export type BusinessGroupEntity = {
  __typename?: 'BusinessGroupEntity';
  /** BusinessGroupEntity_Generated::getBusinesss */
  businesses: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessGroupEntity_Generated::getGroupLevelTags */
  groupLevelTags?: Maybe<Scalars['Boolean']['output']>;
  /** BusinessGroupEntity_Generated::getGroupUrlPageTitle */
  groupUrlPageTitle?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessGroupEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessGroupEntity_Generated::getSlug */
  slug?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

/** A connection to a list of items. */
export type BusinessGroupEntityConnection = {
  __typename?: 'BusinessGroupEntityConnection';
  /** a list of edges */
  edges?: Maybe<Array<Maybe<BusinessGroupEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type BusinessGroupEntityEdge = {
  __typename?: 'BusinessGroupEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BusinessGroupEntity>;
};

export type BusinessGroupInfo = {
  __typename?: 'BusinessGroupInfo';
  /** BusinessGroupInfo::businesses */
  businesses: Array<BusinessEntity>;
  /** BusinessGroupInfo::id */
  id: Scalars['Int']['output'];
  /** BusinessGroupInfo::name */
  name: Scalars['String']['output'];
  /** BusinessGroupInfo::slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** BusinessGroupInfo::uploadedImage */
  uploadedImage?: Maybe<UploadedImageEntity>;
};

export type BusinessGroupInput = {
  groupLevelTags?: InputMaybe<Scalars['Boolean']['input']>;
  groupUrlPageTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessGroupTagEntity = {
  __typename?: 'BusinessGroupTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessGroupTagEntity_Generated::getIcon */
  icon?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessGroupTagEntity_Generated::getTag */
  tag?: Maybe<Scalars['String']['output']>;
  /** BusinessGroupTagEntity::getTagTypeAsString */
  tagTypeAsString?: Maybe<Scalars['String']['output']>;
  /** BusinessGroupTagEntity_Generated::getTicketTypeQuestionOptions */
  ticketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessGroupTagPayload = {
  __typename?: 'BusinessGroupTagPayload';
  /** BusinessGroupTagPayload::businessGroupTag */
  businessGroupTag?: Maybe<BusinessGroupTagEntity>;
  /** BusinessGroupTagPayload::businessGroupTagUsage */
  businessGroupTagUsage?: Maybe<BusinessGroupTagUsage>;
  /** BusinessGroupTagPayload::error */
  error?: Maybe<ErrorResult>;
};

export type BusinessGroupTagUsage = {
  __typename?: 'BusinessGroupTagUsage';
  /** BusinessGroupTagUsage::archivedTicketTypeQuestionOptions */
  archivedTicketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BusinessGroupTagUsage::getBusinessWaitlistPriorityFactors */
  businessWaitlistPriorityFactors: Array<BusinessWaitlistPriorityFactorEntity>;
  /** BusinessGroupTagUsage::isInArchivedUse */
  inArchivedUse: Scalars['Boolean']['output'];
  /** BusinessGroupTagUsage::isInUse */
  inUse: Scalars['Boolean']['output'];
  /** BusinessGroupTagUsage::ticketTypeQuestionOptions */
  ticketTypeQuestionOptions: Array<TicketTypeQuestionOptionEntity>;
  /** BusinessGroupTagUsage::getTicketTypeQuestions */
  ticketTypeQuestions: Array<TicketTypeQuestionEntity>;
};

export type BusinessImage = UploadedImageEntityInterface & {
  __typename?: 'BusinessImage';
  /** BusinessImage::getAltText */
  altText?: Maybe<Scalars['String']['output']>;
  /** Google Cloud Storage path to the image. Not intended for public use. Edit: Required to generate Imgix URLs from Consumer (BusinessImage::getBackingUrl) */
  backingUrl?: Maybe<Scalars['String']['output']>;
  /** BusinessImage::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BusinessImage::getDominantColor */
  dominantColor?: Maybe<Scalars['String']['output']>;
  /** BusinessImage::getId */
  id: Scalars['Int']['output'];
  /** BusinessImage::getImageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type BusinessInventoryScheduleEntity = {
  __typename?: 'BusinessInventoryScheduleEntity';
  /** BusinessInventoryScheduleEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getEndDate */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessInventoryScheduleEntity_Generated::getFloorplan */
  floorplan: FloorplanEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getIsSpecialDay */
  isSpecialDay: Scalars['Boolean']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getBusinessInventoryScheduleSeatingTemplates */
  seatingTemplates: Array<BusinessInventoryScheduleSeatingTemplateEntity>;
  /** BusinessInventoryScheduleEntity_Generated::getStartDate */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  /** BusinessInventoryScheduleEntity_Generated::getState */
  state: BusinessInventoryScheduleState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessInventoryScheduleEntity_Generated::getUpdatedBy */
  updatedBy?: Maybe<PatronEntity>;
};

export type BusinessInventoryScheduleSeatingTemplateEntity = {
  __typename?: 'BusinessInventoryScheduleSeatingTemplateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const BusinessInventoryScheduleState = {
  Archived: 'ARCHIVED',
  Draft: 'DRAFT',
  Published: 'PUBLISHED'
} as const;

export type BusinessInventoryScheduleState = typeof BusinessInventoryScheduleState[keyof typeof BusinessInventoryScheduleState];
export type BusinessLocation = {
  __typename?: 'BusinessLocation';
  /** BusinessLocation::getAddress */
  address?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getAddress2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getAddressLat */
  addressLat?: Maybe<Scalars['Float']['output']>;
  /** BusinessLocation::getAddressLng */
  addressLng?: Maybe<Scalars['Float']['output']>;
  /** BusinessLocation::getCity */
  city?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getCountry */
  country?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getGooglePlacesId */
  googlePlacesId?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getState */
  state?: Maybe<Scalars['String']['output']>;
  /** BusinessLocation::getZipCode */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BusinessPayoutConfigEntity = {
  __typename?: 'BusinessPayoutConfigEntity';
  /** BusinessPayoutConfigEntity_Generated::getAllowDebits */
  allowDebits: Scalars['Boolean']['output'];
  /** BusinessPayoutConfigEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessPayoutConfigEntity_Generated::getDisablePayout */
  disablePayout?: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutConfigEntity_Generated::getNegativeBalanceAdjustmentCents */
  negativeBalanceAdjustmentCents?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigEntity_Generated::getNote */
  note?: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigEntity_Generated::getOrderPayoutParameters */
  orderPayoutParameters?: Maybe<BusinessPayoutConfigParametersEntity>;
  /** BusinessPayoutConfigEntity_Generated::getPayoutMonthly */
  payoutMonthly: Scalars['Boolean']['output'];
  /** BusinessPayoutConfigEntity_Generated::getPurchasePayoutParameters */
  purchasePayoutParameters: BusinessPayoutConfigParametersEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessPayoutConfigInput = {
  allowDebits: Scalars['Boolean']['input'];
  disablePayout: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  negativeBalanceAdjustmentCents?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessPayoutConfigParametersEntity = {
  __typename?: 'BusinessPayoutConfigParametersEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getFirstPostServiceDays */
  firstPostServiceDays?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getFirstPostServicePercentage */
  firstPostServicePercentage?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getNote */
  note?: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigParametersEntity::getPayoutDescriptionString */
  payoutDescriptionString?: Maybe<Scalars['String']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getPostPaymentDays */
  postPaymentDays?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getPostPaymentPercentage */
  postPaymentPercentage?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getRollingDays */
  rollingDays: Scalars['Int']['output'];
  /** BusinessPayoutConfigParametersEntity_Generated::getSecondPostServiceDays */
  secondPostServiceDays?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getSecondPostServicePercentage */
  secondPostServicePercentage?: Maybe<Scalars['Int']['output']>;
  /** BusinessPayoutConfigParametersEntity_Generated::getType */
  type: ConfigType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessPayoutSummaryEntity = {
  __typename?: 'BusinessPayoutSummaryEntity';
  /** BusinessPayoutSummaryEntity_Generated::getAmountCents */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessPayoutSummaryEntity::getPayoutId */
  payoutId?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BusinessPayoutSummaryEntity_Generated::getWasRejected */
  wasRejected?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessRebalancerDefaultSettingsEntity = {
  __typename?: 'BusinessRebalancerDefaultSettingsEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const BusinessRole = {
  AccountOwner: 'ACCOUNT_OWNER',
  Admin: 'ADMIN',
  Driver: 'DRIVER',
  Employee: 'EMPLOYEE',
  Host: 'HOST'
} as const;

export type BusinessRole = typeof BusinessRole[keyof typeof BusinessRole];
export type BusinessServerEntity = {
  __typename?: 'BusinessServerEntity';
  /** BusinessServerEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BusinessServerEntity_Generated::getColor */
  color?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessServerEntity_Generated::getExcludeFromRotation */
  excludeFromRotation: Scalars['Boolean']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessServerEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTagEntity = {
  __typename?: 'BusinessTagEntity';
  /** BusinessTagEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessTagEntity_Generated::getMetaTag */
  metaTag: MetaTagEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTaxEntity = PurchasableTax & Tax & {
  __typename?: 'BusinessTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessTaxEntity::getFlatTaxCents */
  flatTaxCents?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BusinessTaxEntity::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** BusinessTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BusinessTaxEntity::getTaxApplicationType */
  taxApplicationType?: Maybe<TaxApplicationType>;
  /** BusinessTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** BusinessTaxEntity::getTaxSource */
  taxSource: TaxSource;
  /** BusinessTaxEntity::getTaxType */
  taxType: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessTaxMigration = {
  __typename?: 'BusinessTaxMigration';
  /** BusinessTaxMigration::businessId */
  businessId: Scalars['Int']['output'];
  /** BusinessTaxMigration::businessName */
  businessName?: Maybe<Scalars['String']['output']>;
  /** BusinessTaxMigration::taxRate */
  taxRate?: Maybe<Percent>;
  /** BusinessTaxMigration::taxableTicketTypesWithTaxableAddons */
  taxableTicketTypesWithTaxableAddons: Array<TaxableTicketTypesWithTaxableAddons>;
};

export type BusinessTaxMigrationPayload = {
  __typename?: 'BusinessTaxMigrationPayload';
  /** BusinessTaxMigrationPayload::error */
  error?: Maybe<ErrorResult>;
  /** BusinessTaxMigrationPayload::success */
  success: Scalars['Boolean']['output'];
};

export type BusinessTockContactEntity = {
  __typename?: 'BusinessTockContactEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BusinessTockContactEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** BusinessTockContactEntity_Generated::getEmail */
  email?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessTockContactEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** BusinessTockContactEntity_Generated::getPhone */
  phone?: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessWaitlistPriorityFactorEntity = {
  __typename?: 'BusinessWaitlistPriorityFactorEntity';
  /** BusinessWaitlistPriorityFactorEntity_Generated::getBusinessGroupTags */
  businessGroupTags: Array<BusinessWaitlistPriorityFactorTagEntity>;
  /** BusinessWaitlistPriorityFactorEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BusinessWaitlistPriorityFactorEntity_Generated::getOrdering */
  ordering: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type BusinessWaitlistPriorityFactorTagEntity = {
  __typename?: 'BusinessWaitlistPriorityFactorTagEntity';
  /** BusinessWaitlistPriorityFactorTagEntity_Generated::getBusinessGroupTag */
  businessGroupTag: BusinessGroupTagEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type CalendarDateBookingsAggregation = {
  __typename?: 'CalendarDateBookingsAggregation';
  /** CalendarDateBookingsAggregation::available */
  available: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::date */
  date?: Maybe<Scalars['String']['output']>;
  /** CalendarDateBookingsAggregation::dayNotePresent */
  dayNotePresent: Scalars['Boolean']['output'];
  /** CalendarDateBookingsAggregation::forfeited */
  forfeited: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::hasInventory */
  hasInventory: Scalars['Boolean']['output'];
  /** CalendarDateBookingsAggregation::held */
  held: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::locked */
  locked: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::noShow */
  noShow: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::sold */
  sold: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::unassigned */
  unassigned: Scalars['Int']['output'];
  /** CalendarDateBookingsAggregation::walkin */
  walkin: Scalars['Int']['output'];
};

export type CalendarDateQuery = {
  __typename?: 'CalendarDateQuery';
  /** Business has any bookings ever (CalendarDateQuery::businessHasBookings) */
  businessHasBookings: Scalars['Boolean']['output'];
  /** Summary Data for Calendar (CalendarDateQuery::summary) */
  summary?: Maybe<CalendarDateSummary>;
};

export type CalendarDateSummary = {
  __typename?: 'CalendarDateSummary';
  /** Bookings aggregated by date  (CalendarDateSummary::dateBookings) */
  dateBookings: Array<CalendarDateBookingsAggregation>;
};


export type CalendarDateSummaryDateBookingsArgs = {
  edited?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['String']['input'];
  guestTags?: InputMaybe<Array<Scalars['String']['input']>>;
  isUnansweredFilterOn?: InputMaybe<Scalars['Boolean']['input']>;
  partySizes?: InputMaybe<Array<Scalars['Int']['input']>>;
  purchaseStates?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  ticketOptions?: InputMaybe<Array<Scalars['Int']['input']>>;
  ticketTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  visitTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CalendarTable = {
  __typename?: 'CalendarTable';
  /** CalendarTable::getId */
  id: Scalars['Int']['output'];
  /** CalendarTable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** CalendarTable::isAutoReleaseTable */
  isAutoReleaseTable: Scalars['Boolean']['output'];
  /** CalendarTable::seatingArea */
  seatingArea?: Maybe<SeatingAreaOutput>;
  /** CalendarTable::getSectionLabel */
  sectionLabel: Scalars['String']['output'];
  /** CalendarTable::getServiceInfo */
  serviceInfo: Array<PerServiceInfo>;
  /** CalendarTable::getTable */
  table: TableEntity;
  /** CalendarTable::getTableStateRanges */
  tableStateRanges: Array<TableStateRange>;
  /** CalendarTable::getTicketTypeIds */
  ticketTypeIds: Array<Scalars['Int']['output']>;
};

export type CancelBookingsInputInput = {
  businessId: Scalars['Int']['input'];
  emailCancellationMessage?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  numPurchases: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
  sendEmails: Scalars['Boolean']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  ticketTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CancelBookingsOutput = {
  __typename?: 'CancelBookingsOutput';
  /** CancelBookingsOutput::purchaseCount */
  purchaseCount: Scalars['Int']['output'];
  /** CancelBookingsOutput::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
  /** CancelBookingsOutput::ticketTypeName */
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

export type CancelBookingsWorkflowStatus = {
  __typename?: 'CancelBookingsWorkflowStatus';
  /** CancelBookingsWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** CancelBookingsWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
  /** CancelBookingsWorkflowStatus::workflowRunId */
  workflowRunId: Scalars['String']['output'];
};

export const Category = {
  Draft: 'DRAFT',
  Flag: 'FLAG',
  FutureEffectiveDate: 'FUTURE_EFFECTIVE_DATE'
} as const;

export type Category = typeof Category[keyof typeof Category];
export const ChangeAction = {
  Added: 'ADDED',
  Removed: 'REMOVED'
} as const;

export type ChangeAction = typeof ChangeAction[keyof typeof ChangeAction];
export type CheckoutCartShippingOption = {
  __typename?: 'CheckoutCartShippingOption';
  /** CheckoutCartShippingOption::estimatedPriceCents */
  estimatedPriceCents: Scalars['Int']['output'];
  /** CheckoutCartShippingOption::maxUnitsInclusive */
  maxUnitsInclusive: Scalars['Int']['output'];
  /** CheckoutCartShippingOption::shippingZoneOption */
  shippingZoneOption: ShippingZoneOptionEntity;
  /** CheckoutCartShippingOption::shippingZoneOptionRate */
  shippingZoneOptionRate: ShippingZoneOptionRateEntity;
};

export const Classification = {
  Application: 'APPLICATION',
  Permanent: 'PERMANENT',
  Transient: 'TRANSIENT'
} as const;

export type Classification = typeof Classification[keyof typeof Classification];
export type CollectionForVenueRequestInput = {
  resyVenueId?: InputMaybe<Scalars['Int']['input']>;
  tockVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompsAndDiscountsPurchasedTaxable = Taxable & {
  __typename?: 'CompsAndDiscountsPurchasedTaxable';
  /** CompsAndDiscountsPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** CompsAndDiscountsPurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export const ConfigType = {
  PercentagePostPaymentAndService: 'PERCENTAGE_POST_PAYMENT_AND_SERVICE',
  PercentagePostService: 'PERCENTAGE_POST_SERVICE',
  RollingAfterServiceDate: 'ROLLING_AFTER_SERVICE_DATE',
  RollingFromPaymentDate: 'ROLLING_FROM_PAYMENT_DATE'
} as const;

export type ConfigType = typeof ConfigType[keyof typeof ConfigType];
export type ConfirmationCode = {
  __typename?: 'ConfirmationCode';
  /** ConfirmationCode::toString */
  code?: Maybe<Scalars['String']['output']>;
  /** ConfirmationCode::getType */
  type?: Maybe<ConfirmationCodeType>;
};

export const ConfirmationCodeType = {
  Legacy: 'LEGACY',
  Reservation: 'RESERVATION',
  Ticket: 'TICKET',
  Togo: 'TOGO'
} as const;

export type ConfirmationCodeType = typeof ConfirmationCodeType[keyof typeof ConfirmationCodeType];
export type ConsumerPurchase = {
  __typename?: 'ConsumerPurchase';
  /** ConsumerPurchase::getAmountDueCents */
  amountDueCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getAmountRefundedCents */
  amountRefundedCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getBookingPolicy */
  bookingPolicy?: Maybe<BookingPolicy>;
  /** ConsumerPurchase::getBusiness */
  business: BusinessEntity;
  /** ConsumerPurchase::isCancelledOrRefunded */
  cancelledOrRefunded: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getCompAmountCents */
  compAmountCents?: Maybe<Scalars['Int']['output']>;
  /** ConsumerPurchase::getConfirmationCode */
  confirmationCode: Scalars['String']['output'];
  /** ConsumerPurchase::getCustomBookingPolicyText */
  customBookingPolicyText?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getCustomFeeCents */
  customFeeCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getCustomFeeName */
  customFeeName?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getCustomFeeRate */
  customFeeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getDinerPatron */
  dinerPatron: PatronEntity;
  /** ConsumerPurchase::getDiscounts */
  discounts: Array<DiscountEntity>;
  /** ConsumerPurchase::isEligibleForFeedback */
  eligibleForFeedback: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getEventFeeCents */
  eventFeeCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getEventFeeRate */
  eventFeeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getFees */
  fees: Array<PurchasedFeeEntity>;
  /** ConsumerPurchase::getFirstTransferredTo */
  firstTransferredTo?: Maybe<PatronEntity>;
  /** ConsumerPurchase::getGratuityCents */
  gratuityCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getId */
  id: Scalars['Int']['output'];
  /** ConsumerPurchase::getMobileTicket */
  mobileTicket?: Maybe<MobileTicket>;
  /** ConsumerPurchase::getNetAmountPaidCents */
  netAmountPaidCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getOwnerPatron */
  ownerPatron: PatronEntity;
  /** ConsumerPurchase::getPaymentCardHold */
  paymentCardHold?: Maybe<PaymentCardHold>;
  /** ConsumerPurchase::getPaymentTransactions */
  paymentTransactions: Array<PaymentTransaction>;
  /** ConsumerPurchase::getPurchasedCustomCharges */
  purchasedCustomCharges: Array<PurchasedCustomChargeEntity>;
  /** ConsumerPurchase::getPurchasedOptions */
  purchasedOptions: Array<PurchasedOption>;
  /** ConsumerPurchase::getReservationQuestionnaire */
  reservationQuestionnaire?: Maybe<ReservationQuestionnaire>;
  /** ConsumerPurchase::getSeatingAreaName */
  seatingAreaName?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getSelectedGratuityRate */
  selectedGratuityRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getServiceChargeAmountCents */
  serviceChargeAmountCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getServiceChargeName */
  serviceChargeName?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getServiceChargeRate */
  serviceChargeRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getStartDateTime */
  startDateTime: Scalars['String']['output'];
  /** ConsumerPurchase::getSubtotalCents */
  subtotalCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getTaxRate */
  taxRate: Scalars['Float']['output'];
  /** ConsumerPurchase::getTaxTotalCents */
  taxTotalCents: Scalars['Int']['output'];
  /** ConsumerPurchase::getTicketCount */
  ticketCount: Scalars['Int']['output'];
  /** ConsumerPurchase::getTicketPriceInformation */
  ticketPriceInformation?: Maybe<TicketPriceInformation>;
  /** ConsumerPurchase::getTicketType */
  ticketType: TicketTypeEntity;
  /** ConsumerPurchase::getTotalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** ConsumerPurchase::isTransferInProgress */
  transferInProgress: Scalars['Boolean']['output'];
  /** ConsumerPurchase::getTransferredFromEmail */
  transferredFromEmail?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getTransferredToEmail */
  transferredToEmail?: Maybe<Scalars['String']['output']>;
  /** ConsumerPurchase::getVisitFiveStarRating */
  visitFiveStarRating?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerPurchaseSummary = {
  __typename?: 'ConsumerPurchaseSummary';
  /** ConsumerPurchaseSummary::business */
  business: BusinessEntity;
  /** ConsumerPurchaseSummary::cancellationPolicyDescription */
  cancellationPolicyDescription: Array<Scalars['String']['output']>;
  /** ConsumerPurchaseSummary::isCancelledOrRefunded */
  cancelledOrRefunded: Scalars['Boolean']['output'];
  /** ConsumerPurchaseSummary::city */
  city: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::confirmationCode */
  confirmationCode: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::confirmationText */
  confirmationText: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::country */
  country: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::dinerPatron */
  dinerPatron: PatronEntity;
  /** ConsumerPurchaseSummary::isEligibleForFeedback */
  eligibleForFeedback: Scalars['Boolean']['output'];
  /** ConsumerPurchaseSummary::firstTransferredTo */
  firstTransferredTo?: Maybe<PatronEntity>;
  /** ConsumerPurchaseSummary::id */
  id: Scalars['Int']['output'];
  /** ConsumerPurchaseSummary::ownerPatron */
  ownerPatron: PatronEntity;
  /** ConsumerPurchaseSummary::seatingArea */
  seatingArea?: Maybe<SeatingAreaEntity>;
  /** ConsumerPurchaseSummary::seatingAreaName */
  seatingAreaName: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::ticketCount */
  ticketCount: Scalars['Int']['output'];
  /** ConsumerPurchaseSummary::ticketDateTime */
  ticketDateTime: Scalars['String']['output'];
  /** ConsumerPurchaseSummary::ticketType */
  ticketType: TicketTypeEntity;
  /** ConsumerPurchaseSummary::visitFiveStarRating */
  visitFiveStarRating?: Maybe<Scalars['Int']['output']>;
};

export type ConsumerPurchaseWithCount = {
  __typename?: 'ConsumerPurchaseWithCount';
  /** ConsumerPurchaseWithCount::purchases */
  purchases: Array<ConsumerPurchase>;
  /** ConsumerPurchaseWithCount::totalCount */
  totalCount: Scalars['Int']['output'];
};

export type ContactInfoEntity = {
  __typename?: 'ContactInfoEntity';
  /** ContactInfoEntity_Generated::getAddressLocation */
  addressLocation: LocationEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ContactInfoEntity_Generated::getDateOfBirth */
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  /** ContactInfoEntity_Generated::getEmail */
  email?: Maybe<Scalars['String']['output']>;
  /** ContactInfoEntity_Generated::getFirstName */
  firstName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ContactInfoEntity_Generated::getLastName */
  lastName: Scalars['String']['output'];
  /** ContactInfoEntity_Generated::getPhone */
  phone?: Maybe<PhoneEntity>;
  /** ContactInfoEntity::getPhoneId */
  phoneId?: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ContactPhoneInput = {
  countryCode: Scalars['String']['input'];
  isoRegionCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type CreateBusinessEntitlementSetsInput = {
  businessId: Scalars['ID']['input'];
  entitlementSetIds: Array<Scalars['Int']['input']>;
  source: BusinessEntitlementSetSource;
};

export type CreateBusinessEntitlementSetsPayload = {
  __typename?: 'CreateBusinessEntitlementSetsPayload';
  /** CreateBusinessEntitlementSetsPayload::businessEntitlementSets */
  businessEntitlementSets: Array<BusinessEntitlementSetEntity>;
  /** CreateBusinessEntitlementSetsPayload::error */
  error?: Maybe<ErrorResult>;
};

export type CreateEntitlementSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entitlementIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEntitlementSetPayload = {
  __typename?: 'CreateEntitlementSetPayload';
  /** CreateEntitlementSetPayload::entitlementSet */
  entitlementSet?: Maybe<EntitlementSetEntity>;
  /** CreateEntitlementSetPayload::error */
  error?: Maybe<ErrorResult>;
};

export type CreatePaymentSubscriptionPlanAddonInput = {
  amountCents: Scalars['Int']['input'];
  canonicalType: SubscriptionAddonCanonicalType;
  currencyCode: Scalars['String']['input'];
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePaymentSubscriptionPlanAddonPayload = {
  __typename?: 'CreatePaymentSubscriptionPlanAddonPayload';
  /** CreatePaymentSubscriptionPlanAddonPayload::error */
  error?: Maybe<ErrorResult>;
  /** CreatePaymentSubscriptionPlanAddonPayload::paymentSubscriptionPlanAddon */
  paymentSubscriptionPlanAddon?: Maybe<PaymentSubscriptionPlanAddonEntity>;
};

export type CreatePaymentSubscriptionPlanInput = {
  canonicalName: SubscriptionCanonicalName;
  currencyCode: Scalars['String']['input'];
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  monthlyPerTicketBaseFee: Scalars['Int']['input'];
  monthlyPerTicketFee: Scalars['Int']['input'];
  monthlySmsFee?: InputMaybe<Scalars['Int']['input']>;
  monthlySubscriptionFee: Scalars['Int']['input'];
  purchaseProcessingFeePercentage: Scalars['Float']['input'];
  subscriptionPlanName: Scalars['String']['input'];
  toGoFeePercentage: Scalars['Float']['input'];
};

export type CreatePaymentSubscriptionPlanPayload = {
  __typename?: 'CreatePaymentSubscriptionPlanPayload';
  /** CreatePaymentSubscriptionPlanPayload::error */
  error?: Maybe<ErrorResult>;
  /** CreatePaymentSubscriptionPlanPayload::paymentSubscriptionPlan */
  paymentSubscriptionPlan?: Maybe<PaymentSubscriptionPlanEntity>;
};

export type CreateWaitlistResponse = {
  __typename?: 'CreateWaitlistResponse';
  /** CreateWaitlistResponse::success */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Cuisine = {
  __typename?: 'Cuisine';
  /** Cuisine::isCustomCuisine */
  customCuisine: Scalars['Boolean']['output'];
  /** Cuisine::name */
  name: Scalars['String']['output'];
};

export type CustomAndEventFeesPurchasedTaxable = Taxable & {
  __typename?: 'CustomAndEventFeesPurchasedTaxable';
  /** CustomAndEventFeesPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** CustomAndEventFeesPurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type CustomChargeEntity = Taxable & {
  __typename?: 'CustomChargeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** CustomChargeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** CustomChargeEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const DateFilterType = {
  CreatedAt: 'CREATED_AT',
  DeliveredAt: 'DELIVERED_AT'
} as const;

export type DateFilterType = typeof DateFilterType[keyof typeof DateFilterType];
export type DateRangeInput = {
  /** End of the range (inclusive). */
  endDate: Scalars['LocalDate']['input'];
  /** Start of the range (inclusive). */
  startDate: Scalars['LocalDate']['input'];
};

export type DateStat = {
  __typename?: 'DateStat';
  /** DateStat::bookedCovers */
  bookedCovers: Scalars['Int']['output'];
  /** DateStat::coversExcludedFromPacing */
  coversExcludedFromPacing: Scalars['Int']['output'];
  /** DateStat::diningPartiesExcludedFromPacing */
  diningPartiesExcludedFromPacing: Scalars['Int']['output'];
  /** DateStat::occupancy */
  occupancy: Scalars['Int']['output'];
  /** DateStat::occupancyAsPercentOfPeak */
  occupancyAsPercentOfPeak: Scalars['Float']['output'];
  /** DateStat::soldCovers */
  soldCovers: Scalars['Int']['output'];
};

export type DateTimeRange = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type DateTimeStats = {
  __typename?: 'DateTimeStats';
  /** DateTimeStats::stats */
  stats?: Maybe<DateStat>;
  /** DateTimeStats::time */
  time: Scalars['String']['output'];
};

export type DayTail = DateTimeRange & Node & TableStateRange & {
  __typename?: 'DayTail';
  /** DayTail::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** DayTail::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** DayTail::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** DayTail::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
};

export const DeleteReason = {
  NoResponse: 'NO_RESPONSE',
  Privacy: 'PRIVACY',
  SanctionedCountry: 'SANCTIONED_COUNTRY',
  Temporary: 'TEMPORARY',
  Useless: 'USELESS'
} as const;

export type DeleteReason = typeof DeleteReason[keyof typeof DeleteReason];
export type DeliveryAddressInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  googlePlacesId: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type DeliveryInfoInput = {
  billingAddress?: InputMaybe<AddressProfileInput>;
  destinationAddress?: InputMaybe<AddressProfileInput>;
  giftNote?: InputMaybe<Scalars['String']['input']>;
  recipientDOB?: InputMaybe<Scalars['LocalDate']['input']>;
  shippingZoneOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryServiceFeePurchasedTaxable = Taxable & {
  __typename?: 'DeliveryServiceFeePurchasedTaxable';
  /** DeliveryServiceFeePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** DeliveryServiceFeePurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export const DeliveryServiceProvider = {
  Doordash: 'DOORDASH',
  Internal: 'INTERNAL',
  Postmates: 'POSTMATES'
} as const;

export type DeliveryServiceProvider = typeof DeliveryServiceProvider[keyof typeof DeliveryServiceProvider];
export type DeliveryServiceabilityCheckInput = {
  address?: InputMaybe<DeliveryAddressInput>;
  deliveryDateTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  ticketTypeId: Scalars['Int']['input'];
};

export const DeliveryServiceabilityValidationResult = {
  NotServiceableByDeliveryServiceProvider: 'NOT_SERVICEABLE_BY_DELIVERY_SERVICE_PROVIDER',
  TaxProviderInvalidAddress: 'TAX_PROVIDER_INVALID_ADDRESS',
  UberDeliveryNotWithin_30DayRange: 'UBER_DELIVERY_NOT_WITHIN_30_DAY_RANGE',
  Valid: 'VALID'
} as const;

export type DeliveryServiceabilityValidationResult = typeof DeliveryServiceabilityValidationResult[keyof typeof DeliveryServiceabilityValidationResult];
export type Description = {
  __typename?: 'Description';
  /** Description::laterAbility */
  laterAbility?: Maybe<DurationDependentModificationAbility>;
  /** Description::modificationAbility */
  modificationAbility?: Maybe<ModificationAbility>;
};

export type DescriptionInput = {
  laterAbility?: InputMaybe<DurationDependentModificationAbilityInput>;
  modificationAbility?: InputMaybe<ModificationAbility>;
};

export const DescriptiveVariety = {
  TogoALaCarte: 'TOGO_A_LA_CARTE',
  TogoPackage: 'TOGO_PACKAGE',
  TogoPrixFixe: 'TOGO_PRIX_FIXE'
} as const;

export type DescriptiveVariety = typeof DescriptiveVariety[keyof typeof DescriptiveVariety];
export type DiscountEntity = {
  __typename?: 'DiscountEntity';
  /** DiscountEntity_Generated::getAmountCents */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** DiscountEntity::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** DiscountEntity_Generated::getDiscountType */
  discountType?: Maybe<DiscountType>;
  /** DiscountEntity_Generated::getGiftCard */
  giftCard?: Maybe<GiftCardEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** DiscountEntity_Generated::getPromoCode */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const DiscountType = {
  Credit: 'CREDIT',
  PostTotalAdminComp: 'POST_TOTAL_ADMIN_COMP',
  PostTotalRefund: 'POST_TOTAL_REFUND',
  SubtotalComp: 'SUBTOTAL_COMP'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];
export type DurationDependentModificationAbility = {
  __typename?: 'DurationDependentModificationAbility';
  /** DurationDependentModificationAbility::duration */
  duration?: Maybe<Scalars['Duration']['output']>;
  /** DurationDependentModificationAbility::modificationAbility */
  modificationAbility?: Maybe<ModificationAbility>;
};

export type DurationDependentModificationAbilityInput = {
  duration?: InputMaybe<Scalars['Duration']['input']>;
  modificationAbility?: InputMaybe<ModificationAbility>;
};

export const EmailBehavior = {
  NoConfirmation: 'NO_CONFIRMATION',
  SendConfirmation: 'SEND_CONFIRMATION'
} as const;

export type EmailBehavior = typeof EmailBehavior[keyof typeof EmailBehavior];
export const EnablementState = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED',
  EnabledForTockEmployeesOnly: 'ENABLED_FOR_TOCK_EMPLOYEES_ONLY'
} as const;

export type EnablementState = typeof EnablementState[keyof typeof EnablementState];
export const EnablementType = {
  Business: 'BUSINESS',
  Region: 'REGION'
} as const;

export type EnablementType = typeof EnablementType[keyof typeof EnablementType];
export const EndpointType = {
  GuestProfile: 'GUEST_PROFILE',
  Reservation: 'RESERVATION',
  WalkIns: 'WALK_INS'
} as const;

export type EndpointType = typeof EndpointType[keyof typeof EndpointType];
export type EntitlementChange = {
  __typename?: 'EntitlementChange';
  /** EntitlementChange::action */
  action?: Maybe<ChangeAction>;
  /** EntitlementChange::entitlement */
  entitlement: FeatureEntity;
};

export type EntitlementChangePreview = {
  __typename?: 'EntitlementChangePreview';
  /** EntitlementChangePreview::entitlementSetsAfter */
  entitlementSetsAfter: Array<EntitlementSetChange>;
  /** EntitlementChangePreview::entitlementSetsBefore */
  entitlementSetsBefore: Array<EntitlementSetChange>;
  /** EntitlementChangePreview::entitlementsAfter */
  entitlementsAfter: Array<EntitlementChange>;
  /** EntitlementChangePreview::entitlementsBefore */
  entitlementsBefore: Array<EntitlementChange>;
};

export type EntitlementSetChange = {
  __typename?: 'EntitlementSetChange';
  /** EntitlementSetChange::action */
  action?: Maybe<ChangeAction>;
  /** EntitlementSetChange::entitlementSet */
  entitlementSet: EntitlementSetEntity;
};

export type EntitlementSetEntity = {
  __typename?: 'EntitlementSetEntity';
  /** EntitlementSetEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EntitlementSetEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** EntitlementSetEntity_Generated::getEntitlementSetFeatures */
  entitlementSetFeatures: Array<EntitlementSetFeatureEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** EntitlementSetEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EntitlementSetFeatureEntity = {
  __typename?: 'EntitlementSetFeatureEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EntitlementSetFeatureEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  /** ErrorMessage::getClassification */
  classification?: Maybe<Classification>;
  /** ErrorMessage::getDebug */
  debug?: Maybe<Scalars['String']['output']>;
  /** ErrorMessage::getErrorCode */
  errorCode: Scalars['Int']['output'];
  /** ErrorMessage::getHttpStatusCode */
  httpStatusCode: Scalars['Int']['output'];
  /** ErrorMessage::getMessage */
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorResult = {
  __typename?: 'ErrorResult';
  /** ErrorResult::displayMessage */
  displayMessage: Scalars['String']['output'];
  /** ErrorResult::internalMessage */
  internalMessage: Scalars['String']['output'];
};

export type EventAddress = {
  __typename?: 'EventAddress';
  /** EventAddress::address */
  address?: Maybe<Scalars['String']['output']>;
  /** EventAddress::address2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** EventAddress::city */
  city?: Maybe<Scalars['String']['output']>;
  /** EventAddress::country */
  country?: Maybe<Scalars['String']['output']>;
  /** EventAddress::googlePlacesId */
  googlePlacesId?: Maybe<Scalars['String']['output']>;
  /** EventAddress::latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** EventAddress::longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** EventAddress::neighborhood */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** EventAddress::state */
  state?: Maybe<Scalars['String']['output']>;
  /** EventAddress::zipCode */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type EventEntity = {
  __typename?: 'EventEntity';
  /** EventEntityBase::getAcceptance */
  acceptance: Acceptance;
  /** EventEntityBase::getClientDisplayName */
  clientDisplayName: Scalars['String']['output'];
  /** EventEntityBase::getClientGuid */
  clientGuid?: Maybe<Scalars['String']['output']>;
  /** EventEntityBase::getClientMessageId */
  clientMessageId?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EventEntityBase::getEvent */
  event: Scalars['String']['output'];
  /** Returns the event byte[] as a human-readable JSON string. (EventEntity::getEventJson) */
  eventJson: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** EventEntityBase::getLastKnownEvent */
  lastKnownEvent?: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getNextAcceptedEventId */
  nextAcceptedEventId?: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getPatronId */
  patronId?: Maybe<Scalars['Int']['output']>;
  /** EventEntityBase::getProcessedByPipelineAt */
  processedByPipelineAt?: Maybe<Scalars['Instant']['output']>;
  /** EventEntityBase::getServiceDate */
  serviceDate?: Maybe<Scalars['LocalDate']['output']>;
  /** EventEntityBase::getTmiVersion */
  tmiVersion: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EventInfo = {
  __typename?: 'EventInfo';
  /** EventInfo::address */
  address?: Maybe<EventAddress>;
  /** EventInfo::date */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** EventInfo::description */
  description: Scalars['String']['output'];
  /** EventInfo::hasMultipleTimes */
  hasMultipleTimes?: Maybe<Scalars['Boolean']['output']>;
  /** EventInfo::id */
  id: Scalars['String']['output'];
  /** EventInfo::name */
  name: Scalars['String']['output'];
  /** EventInfo::needToKnow */
  needToKnow?: Maybe<Scalars['String']['output']>;
  /** EventInfo::otherUpcomingEvents */
  otherUpcomingEvents: Array<UpcomingEvent>;
  /** EventInfo::repetitionSchedule */
  repetitionSchedule?: Maybe<EventRepetitionSchedule>;
  /** EventInfo::startTime */
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  /** EventInfo::uploadedImages */
  uploadedImages: Array<Image>;
  /** EventInfo::venue */
  venue?: Maybe<EventVenueInfo>;
};

export type EventRepetitionSchedule = {
  __typename?: 'EventRepetitionSchedule';
  /** EventRepetitionSchedule::endDate */
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  /** EventRepetitionSchedule::scheduleCadence */
  scheduleCadence?: Maybe<Scalars['String']['output']>;
  /** EventRepetitionSchedule::startDate */
  startDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type EventTemplate = {
  __typename?: 'EventTemplate';
  /** EventTemplate::eventTemplateSlotConfig */
  eventTemplateSlotConfig: Array<EventTemplateSlotConfigEntity>;
  /** EventTemplate::id */
  id: Scalars['Int']['output'];
  /** EventTemplate::nextDate */
  nextDate?: Maybe<Scalars['LocalDate']['output']>;
  /** EventTemplate::omissionSchedule */
  omissionSchedule?: Maybe<Schedule>;
  /** EventTemplate::schedule */
  schedule?: Maybe<Schedule>;
  /** EventTemplate::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type EventTemplateSlotConfigEntity = {
  __typename?: 'EventTemplateSlotConfigEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** EventTemplateSlotConfigEntity_Generated::getEndTime */
  endTime?: Maybe<Scalars['LocalTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** EventTemplateSlotConfigEntity_Generated::getIsEvensOnly */
  isEvensOnly?: Maybe<Scalars['Boolean']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMaxPurchaseSize */
  maxPurchaseSize?: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMaxSize */
  maxSize?: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getMinPurchaseSize */
  minPurchaseSize?: Maybe<Scalars['Int']['output']>;
  /** EventTemplateSlotConfigEntity_Generated::getStartTime */
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type EventVenueInfo = {
  __typename?: 'EventVenueInfo';
  /** EventVenueInfo::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** EventVenueInfo::name */
  name?: Maybe<Scalars['String']['output']>;
  /** EventVenueInfo::url */
  url?: Maybe<Scalars['String']['output']>;
};

export const Exclusivity = {
  ChasePay: 'CHASE_PAY',
  None: 'NONE',
  Reserve: 'RESERVE',
  Sapphire: 'SAPPHIRE'
} as const;

export type Exclusivity = typeof Exclusivity[keyof typeof Exclusivity];
export type Experience = {
  __typename?: 'Experience';
  /** Experience::name */
  name: Scalars['String']['output'];
  /** Experience::shortCode */
  shortCode: Scalars['String']['output'];
};

export type ExperimentEntity = {
  __typename?: 'ExperimentEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ExperimentEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** ExperimentEntity_Generated::getExperimentVariants */
  experimentVariants: Array<ExperimentVariantEntity>;
  /** ExperimentEntity_Generated::getForceVariant */
  forceVariant?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ExperimentEntity_Generated::getIsActive */
  isActive: Scalars['Boolean']['output'];
  /** ExperimentEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ExperimentEntity_Generated::getOptimizeId */
  optimizeId: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ExperimentVariantEntity = {
  __typename?: 'ExperimentVariantEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ExperimentVariantEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** ExperimentVariantEntity_Generated::getExperiment */
  experiment: ExperimentEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ExperimentVariantEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ExperimentVariantEntity_Generated::getTrafficAllocation */
  trafficAllocation: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ExperimentVariantEntity_Generated::getVariant */
  variant: Scalars['Int']['output'];
};

export type ExperimentVariantInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  trafficAllocation: Scalars['Int']['input'];
  variant: Scalars['Int']['input'];
};

export type ExportFileDescriptor = {
  __typename?: 'ExportFileDescriptor';
  /** ExportFileDescriptor::getExportType */
  exportType: TimelineExportType;
  /** ExportFileDescriptor::getId */
  id: Scalars['String']['output'];
  /** ExportFileDescriptor::getLabel */
  label: Scalars['String']['output'];
};

export const ExternalSystemType = {
  AcornSquirrel: 'ACORN_SQUIRREL',
  Activ8: 'ACTIV8',
  Aloha: 'ALOHA',
  AmexEwp: 'AMEX_EWP',
  Annexcloud: 'ANNEXCLOUD',
  BloomIntelligence: 'BLOOM_INTELLIGENCE',
  Bloyal: 'BLOYAL',
  Commerce7: 'COMMERCE7',
  Dynamics_365: 'DYNAMICS_365',
  Ecellar: 'ECELLAR',
  GoogleAnalyticsWebProperty: 'GOOGLE_ANALYTICS_WEB_PROPERTY',
  GoogleAnalyticsWebProperty_4: 'GOOGLE_ANALYTICS_WEB_PROPERTY_4',
  Iterable: 'ITERABLE',
  JceGdus: 'JCE_GDUS',
  Lightspeed: 'LIGHTSPEED',
  Micros: 'MICROS',
  Micros_3700: 'MICROS_3700',
  Orderport: 'ORDERPORT',
  Paytronix: 'PAYTRONIX',
  Podium: 'PODIUM',
  Positouch: 'POSITOUCH',
  Redchirp: 'REDCHIRP',
  Resy: 'RESY',
  Rooam: 'ROOAM',
  Salesforce: 'SALESFORCE',
  Shipcompliant: 'SHIPCOMPLIANT',
  SquarePos: 'SQUARE_POS',
  TheCustomerConnection: 'THE_CUSTOMER_CONNECTION',
  Toast: 'TOAST',
  TripleseatEvents: 'TRIPLESEAT_EVENTS',
  TripleseatLeads: 'TRIPLESEAT_LEADS',
  Untill: 'UNTILL',
  Vinespring: 'VINESPRING',
  Volante: 'VOLANTE',
  Winedirect: 'WINEDIRECT',
  WinedirectClassic: 'WINEDIRECT_CLASSIC'
} as const;

export type ExternalSystemType = typeof ExternalSystemType[keyof typeof ExternalSystemType];
export type ExtraChargeDetailsInput = {
  extraChargeType: ExtraChargeType;
  gratuityOptionOne: Scalars['Int']['input'];
  gratuityOptionThree: Scalars['Int']['input'];
  gratuityOptionTwo: Scalars['Int']['input'];
  serviceChargeName: Scalars['String']['input'];
  serviceChargeRate: Scalars['Float']['input'];
  serviceChargeTaxed: Scalars['Boolean']['input'];
};

export const ExtraChargeType = {
  Gratuity: 'GRATUITY',
  None: 'NONE',
  ServiceCharge: 'SERVICE_CHARGE'
} as const;

export type ExtraChargeType = typeof ExtraChargeType[keyof typeof ExtraChargeType];
export type Faq = {
  __typename?: 'FAQ';
  /** FAQ::answer */
  answer: Scalars['String']['output'];
  /** FAQ::question */
  question: Scalars['String']['output'];
};

export type FakePurchaseWorkflowStatus = {
  __typename?: 'FakePurchaseWorkflowStatus';
  /** FakePurchaseWorkflowStatus::done */
  done: Scalars['Boolean']['output'];
  /** FakePurchaseWorkflowStatus::numFailed */
  numFailed: Scalars['Int']['output'];
  /** FakePurchaseWorkflowStatus::numSuccess */
  numSuccess: Scalars['Int']['output'];
  /** FakePurchaseWorkflowStatus::numTotal */
  numTotal: Scalars['Int']['output'];
};

export type FakePurchasesInputInput = {
  apiServerUrlBase?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  numPurchases: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type FeatureEntity = {
  __typename?: 'FeatureEntity';
  /** Get the business-specific states of this feature flag (FeatureEntity::getBusinessFeatures) */
  businessFeatures: Array<BusinessFeatureEntity>;
  /** FeatureEntity_Generated::getCanonicalType */
  canonicalType: FeatureType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** FeatureEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** FeatureEntity::getEntitlementSets */
  entitlementSets: Array<EntitlementSetEntity>;
  /** FeatureEntity_Generated::getHistorys */
  historys: Array<FeatureHistoryEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeatureEntity_Generated::getLastEditedByPatron */
  lastEditedByPatron?: Maybe<PatronEntity>;
  /** FeatureEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** Count how many businesses have a state that differs from this flag's global state (FeatureEntity::getOverridesCount) */
  overridesCount: Scalars['Int']['output'];
  /** FeatureEntity_Generated::getState */
  state: FeatureState;
  /** Specifies whether this flag is unused in the codebase (FeatureEntity::isUnused) */
  unused: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type FeatureEntityBusinessFeaturesArgs = {
  onlyOverrides?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureHistoryEntity = {
  __typename?: 'FeatureHistoryEntity';
  /** FeatureHistoryEntity_Generated::getCanonicalType */
  canonicalType: FeatureType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** FeatureHistoryEntity_Generated::getEditedByPatron */
  editedByPatron?: Maybe<PatronEntity>;
  /** FeatureHistoryEntity_Generated::getFeature */
  feature: FeatureEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeatureHistoryEntity_Generated::getState */
  state: FeatureState;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const FeatureState = {
  Kill: 'KILL',
  Launched: 'LAUNCHED',
  Unlaunched: 'UNLAUNCHED'
} as const;

export type FeatureState = typeof FeatureState[keyof typeof FeatureState];
export const FeatureType = {
  Default: 'DEFAULT',
  Entitlement: 'ENTITLEMENT'
} as const;

export type FeatureType = typeof FeatureType[keyof typeof FeatureType];
export type FeeEntity = Taxable & {
  __typename?: 'FeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** FeeEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** FeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** FeeEntity_Generated::getPriceCents */
  priceCents?: Maybe<Scalars['Int']['output']>;
  /** FeeEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type FeedbackFilterInput = {
  /** If present, only include feedback that has one of the specified five point star ratings. By convention, an emptyset matches everything rather than nothing. */
  fivePointStarRatings?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, only include feedback items that have a written feedback section. */
  mustHaveFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** If present, only include feedback that has one of the specified ratings. By convention, an emptyset matches everything rather than nothing. */
  ratings?: InputMaybe<Array<Rating>>;
};

export type FilterInput = {
  since?: InputMaybe<Scalars['Instant']['input']>;
  statuses: Array<Status>;
};

export type FlavorTagInfo = {
  __typename?: 'FlavorTagInfo';
  /** FlavorTagInfo::color */
  color?: Maybe<Scalars['String']['output']>;
  /** FlavorTagInfo::name */
  name?: Maybe<Scalars['String']['output']>;
};

export type FloorplanEntity = {
  __typename?: 'FloorplanEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type FormattedWineShopOrder = {
  __typename?: 'FormattedWineShopOrder';
  /** FormattedWineShopOrder::id */
  id: Scalars['Int']['output'];
  /** FormattedWineShopOrder::items */
  items: Array<OrderWineItem>;
  /** FormattedWineShopOrder::order */
  order: OrderEntity;
};

export type FreeFormQuestion = ReservationQuestion & {
  __typename?: 'FreeFormQuestion';
  /** FreeFormQuestion::name */
  name?: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::question */
  question?: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::response */
  response?: Maybe<Scalars['String']['output']>;
  /** FreeFormQuestion::textType */
  textType?: Maybe<TextType>;
};

export const FulfillmentWarehouse = {
  AbbeyWineWarehouse: 'ABBEY_WINE_WAREHOUSE',
  AeroPacking: 'AERO_PACKING',
  AlexanderValleyCellars: 'ALEXANDER_VALLEY_CELLARS',
  Amedeo: 'AMEDEO',
  BigRedNapa: 'BIG_RED_NAPA',
  BigRedWineShipping: 'BIG_RED_WINE_SHIPPING',
  BodegaShipping: 'BODEGA_SHIPPING',
  ConciergePackageService: 'CONCIERGE_PACKAGE_SERVICE',
  CopperPeakLogistics: 'COPPER_PEAK_LOGISTICS',
  CrownWineShipping: 'CROWN_WINE_SHIPPING',
  EagleRockFulfillment: 'EAGLE_ROCK_FULFILLMENT',
  EliteWineShipping: 'ELITE_WINE_SHIPPING',
  ExpressWineDelivery: 'EXPRESS_WINE_DELIVERY',
  FederalFulfillment: 'FEDERAL_FULFILLMENT',
  FoleyFulfillment: 'FOLEY_FULFILLMENT',
  Fortship: 'FORTSHIP',
  FortExchange: 'FORT_EXCHANGE',
  G3Chicago: 'G3CHICAGO',
  G3AmericanCanyon: 'G3_AMERICAN_CANYON',
  Groskopf: 'GROSKOPF',
  IlsInc: 'ILS_INC',
  InHouse: 'IN_HOUSE',
  InHouseFedex: 'IN_HOUSE_FEDEX',
  InHouseGso: 'IN_HOUSE_GSO',
  InHouseUps: 'IN_HOUSE_UPS',
  M7WineSolutions: 'M7_WINE_SOLUTIONS',
  MichaelDusiLogisticsWarehouse: 'MICHAEL_DUSI_LOGISTICS_WAREHOUSE',
  NvwwDirect: 'NVWW_DIRECT',
  OregonWineServices: 'OREGON_WINE_SERVICES',
  OutOfTheBox: 'OUT_OF_THE_BOX',
  PackNShipDirect: 'PACK_N_SHIP_DIRECT',
  PackNShipDirectAlt: 'PACK_N_SHIP_DIRECT_ALT',
  PasoWineStorage: 'PASO_WINE_STORAGE',
  PremiumWineDelivery: 'PREMIUM_WINE_DELIVERY',
  RedHillsCellarsLlc: 'RED_HILLS_CELLARS_LLC',
  SaddleCreek: 'SADDLE_CREEK',
  SafeHaven: 'SAFE_HAVEN',
  SherwinWineServices: 'SHERWIN_WINE_SERVICES',
  ShipWa: 'SHIP_WA',
  TownGreen: 'TOWN_GREEN',
  Vindelivery: 'VINDELIVERY',
  VineVault: 'VINE_VAULT',
  Vinfillment: 'VINFILLMENT',
  VintnersDirect: 'VINTNERS_DIRECT',
  Vinum_55: 'VINUM_55',
  VinGo: 'VIN_GO',
  VinLux: 'VIN_LUX',
  WccFulfillment: 'WCC_FULFILLMENT',
  WinecareLogistics: 'WINECARE_LOGISTICS',
  Winecub: 'WINECUB',
  WineryFulfillmentServices: 'WINERY_FULFILLMENT_SERVICES',
  WineCountryGiftBaskets: 'WINE_COUNTRY_GIFT_BASKETS',
  WineCountryPackAndShip: 'WINE_COUNTRY_PACK_AND_SHIP',
  WineCountryShipping: 'WINE_COUNTRY_SHIPPING',
  WineCoLlc: 'WINE_CO_LLC',
  WineDirect: 'WINE_DIRECT',
  WineShipping: 'WINE_SHIPPING',
  WineShippingSantaMaria: 'WINE_SHIPPING_SANTA_MARIA',
  WscDirect: 'WSC_DIRECT'
} as const;

export type FulfillmentWarehouse = typeof FulfillmentWarehouse[keyof typeof FulfillmentWarehouse];
export type FulfillmentWarehouseWrapper = {
  __typename?: 'FulfillmentWarehouseWrapper';
  /** FulfillmentWarehouseWrapper::getEnumName */
  enumName: Scalars['String']['output'];
  /** FulfillmentWarehouseWrapper::getName */
  name: Scalars['String']['output'];
};

export type GiftCardEntity = {
  __typename?: 'GiftCardEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const GiftCardProvider = {
  Paytronix: 'PAYTRONIX',
  Stub: 'STUB',
  Tcc: 'TCC',
  Tock: 'TOCK'
} as const;

export type GiftCardProvider = typeof GiftCardProvider[keyof typeof GiftCardProvider];
export const GlobalRole = {
  Eng: 'ENG',
  Finance: 'FINANCE',
  Hospitality: 'HOSPITALITY',
  Patron: 'PATRON'
} as const;

export type GlobalRole = typeof GlobalRole[keyof typeof GlobalRole];
export type GoogleSettingsEntity = {
  __typename?: 'GoogleSettingsEntity';
  /** GoogleSettingsEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableOrderFeed */
  disableOrderFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableOrderFeedUpdatedAt */
  disableOrderFeedUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReservationFeed */
  disableReservationFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReservationFeedUpdatedAt */
  disableReservationFeedUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReserveWithGoogle */
  disableReserveWithGoogle: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableReserveWithGoogleUpdatedAt */
  disableReserveWithGoogleUpdatedAt: Scalars['Instant']['output'];
  /** GoogleSettingsEntity_Generated::getDisableServiceFeed */
  disableServiceFeed: Scalars['Boolean']['output'];
  /** GoogleSettingsEntity_Generated::getDisableServiceFeedUpdatedAt */
  disableServiceFeedUpdatedAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GraphQluuid = {
  __typename?: 'GraphQLUUID';
  /** GraphQLUUID::asString */
  asString?: Maybe<Scalars['String']['output']>;
};

export type GratuityPurchasedTaxable = Taxable & {
  __typename?: 'GratuityPurchasedTaxable';
  /** GratuityPurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** GratuityPurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type GuestLock = DateTimeRange & Lock & Node & TableStateRange & {
  __typename?: 'GuestLock';
  /** GuestLock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** GuestLock::partySize */
  partySize: Scalars['Int']['output'];
  /** GuestLock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** GuestLock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** GuestLock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type GuestProfileEntity = {
  __typename?: 'GuestProfileEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Guest profile spend (GuestProfileResolvers::getSpend) */
  spend?: Maybe<GuestProfileSpend>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GuestProfileGroupEntity = {
  __typename?: 'GuestProfileGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type GuestProfileSpend = {
  __typename?: 'GuestProfileSpend';
  /** Get guest profile average check per visit (GuestProfileSpend::avg_check_per_visit) */
  avg_check_per_visit: Scalars['Float']['output'];
  /** Get guest profile total spend on a business (GuestProfileSpend::total) */
  total: Scalars['Int']['output'];
  /** Get guest profile total spend on a business group (GuestProfileSpend::total_group) */
  total_group: Scalars['Int']['output'];
  /** Get guest profile last 12 months spend on a business (GuestProfileSpend::ttm) */
  ttm: Scalars['Int']['output'];
  /** Get guest profile last 12 months spend on a business group (GuestProfileSpend::ttm_group) */
  ttm_group: Scalars['Int']['output'];
};

export type GuestProfileTagCount = {
  __typename?: 'GuestProfileTagCount';
  /** GuestProfileTagCount::archivedTagCount */
  archivedTagCount: Scalars['Int']['output'];
  /** GuestProfileTagCount::business */
  business: BusinessEntity;
  /** GuestProfileTagCount::tag */
  tag: Scalars['String']['output'];
  /** GuestProfileTagCount::unarchivedTagCount */
  unarchivedTagCount: Scalars['Int']['output'];
};

export type GuestProfileTagEntity = {
  __typename?: 'GuestProfileTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** GuestProfileTagEntity_Generated::getTag */
  tag?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type HeldCommunalSlot = Slot & {
  __typename?: 'HeldCommunalSlot';
  /** HeldCommunalSlot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** HeldCommunalSlot::heldCoversCount */
  heldCoversCount: Scalars['Int']['output'];
  /** HeldCommunalSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** HeldCommunalSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** HeldCommunalSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type HeldSlot = Slot & {
  __typename?: 'HeldSlot';
  /** HeldSlot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** HeldSlot::heldForGuest */
  heldForGuest?: Maybe<PatronEntity>;
  /** HeldSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** HeldSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** HeldSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type HelpMenuDisplayItem = {
  __typename?: 'HelpMenuDisplayItem';
  /** HelpMenuDisplayItem::bodyText */
  bodyText: Scalars['String']['output'];
  /** HelpMenuDisplayItem::effectiveDate */
  effectiveDate: Scalars['LocalDate']['output'];
  /** HelpMenuDisplayItem::headline */
  headline: Scalars['String']['output'];
  /** HelpMenuDisplayItem::helpCenterUrl */
  helpCenterUrl?: Maybe<Scalars['String']['output']>;
  /** HelpMenuDisplayItem::id */
  id: Scalars['Int']['output'];
  /** HelpMenuDisplayItem::imageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** HelpMenuDisplayItem::isPublic */
  public: Scalars['Boolean']['output'];
  /** HelpMenuDisplayItem::tooltipRationales */
  tooltipRationales: Array<TooltipRationale>;
};

export type HelpMenuEntryEntity = {
  __typename?: 'HelpMenuEntryEntity';
  /** HelpMenuEntryEntity_Generated::getBodyText */
  bodyText: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** HelpMenuEntryEntity_Generated::getEffectiveDate */
  effectiveDate: Scalars['LocalDate']['output'];
  /** HelpMenuEntryEntity_Generated::getFeatures */
  features: Array<FeatureEntity>;
  /** HelpMenuEntryEntity_Generated::getHeadline */
  headline: Scalars['String']['output'];
  /** HelpMenuEntryEntity_Generated::getHelpCenterUrl */
  helpCenterUrl?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** HelpMenuEntryEntity_Generated::getImage */
  image?: Maybe<UploadedImageEntity>;
  /** HelpMenuEntryEntity_Generated::getPublicationStatus */
  publicationStatus: PublicationStatus;
  /** HelpMenuEntryEntity_Generated::getRelevantInventoryType */
  relevantInventoryType: RelevantInventoryType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type HiddenExperienceAction = AvailabilityAction & {
  __typename?: 'HiddenExperienceAction';
  /** HiddenExperienceAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type Hold = {
  __typename?: 'Hold';
  /** Hold::endLocalTime */
  endLocalTime: Scalars['LocalTime']['output'];
  /** Hold::experience */
  experience: Experience;
  /** Hold::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** Hold::startLocalTime */
  startLocalTime: Scalars['LocalTime']['output'];
};

export type HoldToTables = {
  __typename?: 'HoldToTables';
  /** HoldToTables::bookableTables */
  bookableTables: Array<BookableTable>;
  /** HoldToTables::hold */
  hold: Hold;
};

export type IMetaTag = {
  /** IMetaTag::getKey */
  key: MetaTagKey;
  /** IMetaTag::getName */
  name: Scalars['String']['output'];
  /** IMetaTag::getType */
  type: TagType;
};

export type Image = {
  __typename?: 'Image';
  /** Image::altText */
  altText?: Maybe<Scalars['String']['output']>;
  /** Image::dominantColor */
  dominantColor?: Maybe<Scalars['String']['output']>;
  /** Image::imageBackingUrl */
  imageBackingUrl?: Maybe<Scalars['String']['output']>;
  /** Image::imageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** Image::orderingIndex */
  orderingIndex?: Maybe<Scalars['Int']['output']>;
};

export type Impl = Tax & {
  __typename?: 'Impl';
  /** Impl::getAmountCents */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** Impl::getIsMarketplaceTax */
  isMarketplaceTax?: Maybe<Scalars['Boolean']['output']>;
  /** Impl::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Impl::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Impl::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** Impl::getName */
  name: Scalars['String']['output'];
  /** Impl::getNetTaxableAmountCents */
  netTaxableAmountCents?: Maybe<Scalars['Int']['output']>;
  /** Impl::getTaxRate */
  taxRate: Percent;
  /** Impl::getTaxSource */
  taxSource: TaxSource;
  /** Impl::getTaxSourceUniqueId */
  taxSourceUniqueId?: Maybe<Scalars['String']['output']>;
};

export type ImportEntity = {
  __typename?: 'ImportEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ImportEntity_Generated::getStatus */
  status?: Maybe<ImportStatus>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ImportResponse = {
  __typename?: 'ImportResponse';
  /** ImportResponse::assignmentWarnings */
  assignmentWarnings: Array<Scalars['String']['output']>;
  /** ImportResponse::businessName */
  businessName?: Maybe<Scalars['String']['output']>;
  /** ImportResponse::currentStage */
  currentStage?: Maybe<ImportStage>;
  /** ImportResponse::currentStageDisplayName */
  currentStageDisplayName?: Maybe<Scalars['String']['output']>;
  /** ImportResponse::errorMessage */
  errorMessage?: Maybe<ErrorMessage>;
  /** ImportResponse::importId */
  importId: Scalars['Int']['output'];
  /** ImportResponse::importUuid */
  importUuid?: Maybe<Scalars['UUID']['output']>;
  /** ImportResponse::longestRunningChunk */
  longestRunningChunk: Scalars['Int']['output'];
  /** ImportResponse::longestRunningChunkTimeSeconds */
  longestRunningChunkTimeSeconds: Scalars['Int']['output'];
  /** ImportResponse::message */
  message?: Maybe<Scalars['String']['output']>;
  /** ImportResponse::numberOfChunksUploaded */
  numberOfChunksUploaded: Scalars['Int']['output'];
  /** ImportResponse::patrons */
  patrons: Scalars['Int']['output'];
  /** ImportResponse::paused */
  paused: Scalars['Boolean']['output'];
  /** ImportResponse::rebalancingExecuted */
  rebalancingExecuted: Scalars['Boolean']['output'];
  /** ImportResponse::reservations */
  reservations: Scalars['Int']['output'];
  /** ImportResponse::runTime */
  runTime: Scalars['Int']['output'];
  /** ImportResponse::startedAt */
  startedAt?: Maybe<Scalars['Instant']['output']>;
  /** ImportResponse::succeeded */
  succeeded: Scalars['Boolean']['output'];
  /** ImportResponse::totalChunks */
  totalChunks: Scalars['Int']['output'];
  /** ImportResponse::waitlistEntries */
  waitlistEntries: Scalars['Int']['output'];
  /** ImportResponse::workflowIdentifier */
  workflowIdentifier?: Maybe<WorkflowIdentifier>;
};

export const ImportStage = {
  Completed: 'COMPLETED',
  Initializing: 'INITIALIZING',
  ParsingData: 'PARSING_DATA',
  PostImportProcessing: 'POST_IMPORT_PROCESSING',
  WritingToEntitiesDb: 'WRITING_TO_ENTITIES_DB'
} as const;

export type ImportStage = typeof ImportStage[keyof typeof ImportStage];
export const ImportStatus = {
  ImportFailed: 'IMPORT_FAILED',
  ImportInProgress: 'IMPORT_IN_PROGRESS',
  ImportNotStarted: 'IMPORT_NOT_STARTED',
  ImportSucceeded: 'IMPORT_SUCCEEDED',
  ImportUndone: 'IMPORT_UNDONE'
} as const;

export type ImportStatus = typeof ImportStatus[keyof typeof ImportStatus];
export type ImportUndoConfigurationDeletionResult = {
  __typename?: 'ImportUndoConfigurationDeletionResult';
  /** ImportUndoConfigurationDeletionResult::countDeletedTicketGroups */
  countDeletedTicketGroups: Scalars['Int']['output'];
  /** ImportUndoConfigurationDeletionResult::countDeletedTicketTypes */
  countDeletedTicketTypes: Scalars['Int']['output'];
};

export type ImportUndoDeletionResult = {
  __typename?: 'ImportUndoDeletionResult';
  /** ImportUndoDeletionResult::countDeleted */
  countDeleted: Scalars['Int']['output'];
};

export type ImportUndoResponse = {
  __typename?: 'ImportUndoResponse';
  /** ImportUndoResponse::businessId */
  businessId: Scalars['Int']['output'];
  /** ImportUndoResponse::completed */
  completed: Scalars['Boolean']['output'];
  /** ImportUndoResponse::configurationDeletionResult */
  configurationDeletionResult?: Maybe<ImportUndoConfigurationDeletionResult>;
  /** ImportUndoResponse::errorMessage */
  errorMessage?: Maybe<ErrorMessage>;
  /** ImportUndoResponse::guestDeletionResult */
  guestDeletionResult?: Maybe<ImportUndoDeletionResult>;
  /** ImportUndoResponse::reservationDeletionResult */
  reservationDeletionResult?: Maybe<ImportUndoDeletionResult>;
  /** ImportUndoResponse::runTime */
  runTime: Scalars['Int']['output'];
  /** ImportUndoResponse::startedAt */
  startedAt?: Maybe<Scalars['Instant']['output']>;
  /** ImportUndoResponse::waitlistDeletionResult */
  waitlistDeletionResult?: Maybe<ImportUndoDeletionResult>;
};

export type ImportUndoStartResponse = {
  __typename?: 'ImportUndoStartResponse';
  /** ImportUndoStartResponse::started */
  started: Scalars['Boolean']['output'];
};

export type InactiveTimeBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'InactiveTimeBlock';
  /** InactiveTimeBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** InactiveTimeBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type InferredPurchasedTaxable = Taxable & {
  __typename?: 'InferredPurchasedTaxable';
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export const InitiatedFrom = {
  Consumer: 'CONSUMER',
  Dashboard: 'DASHBOARD'
} as const;

export type InitiatedFrom = typeof InitiatedFrom[keyof typeof InitiatedFrom];
export type InviteLock = DateTimeRange & Lock & Node & TableStateRange & {
  __typename?: 'InviteLock';
  /** InviteLock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** InviteLock::initiatedFrom */
  initiatedFrom: InitiatedFrom;
  /** InviteLock::partySize */
  partySize: Scalars['Int']['output'];
  /** InviteLock::purchaseVerifyType */
  purchaseVerifyType: PurchaseVerifyType;
  /** InviteLock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** InviteLock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** InviteLock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type InvoiceEntity = {
  __typename?: 'InvoiceEntity';
  /** InvoiceEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** InvoiceEntity_Generated::getCustomEmailText */
  customEmailText?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** InvoiceEntity_Generated::getPeriodEndDate */
  periodEndDate: Scalars['LocalDate']['output'];
  /** InvoiceEntity_Generated::getPeriodStartDate */
  periodStartDate: Scalars['LocalDate']['output'];
  /** InvoiceEntity_Generated::getProcessorType */
  processorType: PaymentProcessorType;
  /** InvoiceEntity::getTotalAmountCents */
  totalAmountCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type InvoiceInput = {
  businessId: Scalars['Int']['input'];
  invoiceItems: Array<InvoiceItemInput>;
};

export type InvoiceItemInput = {
  amountUsdCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  periodEndDate: Scalars['LocalDate']['input'];
  periodStartDate: Scalars['LocalDate']['input'];
};

export type ItemBasicTypeEntity = Purchasable & Taxable & {
  __typename?: 'ItemBasicTypeEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image?: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory?: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory?: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents?: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge?: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity_Generated::getSku */
  sku?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

export type ItemContextEntity = {
  __typename?: 'ItemContextEntity';
  /** ItemContextEntity_Generated::getContextType */
  contextType: ItemContextType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemContextShopBrandEntity = {
  __typename?: 'ItemContextShopBrandEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextShopBrandEntity_Generated::getIsArchived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** ItemContextShopBrandEntity_Generated::getItemContext */
  itemContext: ItemContextEntity;
  /** ItemContextShopBrandEntity_Generated::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const ItemContextType = {
  Menu: 'MENU',
  WineShop: 'WINE_SHOP'
} as const;

export type ItemContextType = typeof ItemContextType[keyof typeof ItemContextType];
export type ItemContextWineShopEntity = {
  __typename?: 'ItemContextWineShopEntity';
  /** ItemContextWineShopEntity::isActive */
  active: Scalars['Boolean']['output'];
  /** ItemContextEntity_Generated::getContextType */
  contextType: ItemContextType;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemContextEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ItemContextWineShopEntity::getItemContextShopBrandEntities */
  itemContextShopBrandEntities: Array<ItemContextShopBrandEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemMetaTagEntity = {
  __typename?: 'ItemMetaTagEntity';
  /** ItemMetaTagEntity::getBackingTag */
  backingTag: IMetaTag;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemRegionEntity = {
  __typename?: 'ItemRegionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemRegionEntity_Generated::getItem */
  item: ItemWineEntity;
  /** ItemRegionResolvers::getRegion */
  region?: Maybe<RegionTagWrapper>;
  /** ItemRegionEntity_Generated::getTag */
  tag: RegionTag;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ItemScaleTagEntity = {
  __typename?: 'ItemScaleTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WineItemsResolvers::getScaleTag */
  scaleTag?: Maybe<ScaleTag>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ItemScaleTagEntity_Generated::getValue */
  value: Scalars['Int']['output'];
};

export type ItemShipCompliantEntity = {
  __typename?: 'ItemShipCompliantEntity';
  /** ItemShipCompliantEntity_Generated::getBrandProperty */
  brandProperty?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemShipCompliantEntity_Generated::getShipCompliantId */
  shipCompliantId: Scalars['String']['output'];
  /** ItemShipCompliantEntity_Generated::getShipCompliantItemType */
  shipCompliantItemType?: Maybe<ProductType>;
  /** ItemShipCompliantEntity_Generated::getStatus */
  status: ShipCompliantStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const ItemType = {
  Base: 'BASE',
  Wine: 'WINE'
} as const;

export type ItemType = typeof ItemType[keyof typeof ItemType];
export type ItemWineEntity = {
  __typename?: 'ItemWineEntity';
  /** ItemWineEntity_Generated::getAlcoholByVolumePercent */
  alcoholByVolumePercent: Scalars['Float']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ItemWineEntity_Generated::getFullDescription */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ItemWineEntity_Generated::getItemRegions */
  itemRegions: Array<ItemRegionEntity>;
  /** ItemWineEntity_Generated::getTockDisregardStructureTags */
  tockDisregardStructureTags?: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ItemWineEntity_Generated::getVintage */
  vintage?: Maybe<Scalars['Int']['output']>;
  /** ItemWineEntity_Generated::getVolumeMl */
  volumeMl: Scalars['Int']['output'];
  /** ItemWineEntity_Generated::getWeightLb */
  weightLb: Scalars['Float']['output'];
};

export type ItemWineTypeEntity = Purchasable & Taxable & {
  __typename?: 'ItemWineTypeEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image?: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory?: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ItemWineTypeEntity::getItemContextWineShop */
  itemContextWineShop?: Maybe<ItemContextWineShopEntity>;
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** ItemWineTypeEntity::getItemWine */
  itemWine?: Maybe<ItemWineEntity>;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory?: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents?: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge?: Maybe<Scalars['Int']['output']>;
  /** Get ShipCompliant info for this Wine Item. Returns null if there is no info. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::shipCompliantInfo) */
  shipCompliantInfo?: Maybe<ItemShipCompliantEntity>;
  /** MenuItemEntity_Generated::getSku */
  sku?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

/** A connection to a list of items. */
export type ItemWineTypeEntityConnection = {
  __typename?: 'ItemWineTypeEntityConnection';
  /** a list of edges */
  edges?: Maybe<Array<Maybe<ItemWineTypeEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type ItemWineTypeEntityEdge = {
  __typename?: 'ItemWineTypeEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ItemWineTypeEntity>;
};

export type JceHomepageGeographyEntity = {
  __typename?: 'JceHomepageGeographyEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** JceHomepageGeographyEntity_Generated::getHomepageGeographyEntrys */
  homepageGeographyEntrys: Array<JceHomepageOrderingEntryEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceHomepageGeographyEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** JceHomepageGeographyEntity_Generated::getPriorityWithinTier */
  priorityWithinTier?: Maybe<Scalars['Int']['output']>;
  /** JceHomepageGeographyEntity_Generated::getResyBlogKey */
  resyBlogKey?: Maybe<Scalars['String']['output']>;
  /** JceHomepageGeographyEntity_Generated::getTier */
  tier?: Maybe<JceHomepageGeographyTier>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** JceHomepageGeographyEntity_Generated::getUrlSlug */
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type JceHomepageGeographyInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  priorityWithinTier?: InputMaybe<Scalars['Int']['input']>;
  resyBlogKey: Scalars['String']['input'];
  tier?: InputMaybe<JceHomepageGeographyTier>;
  urlSlug: Scalars['String']['input'];
};

export const JceHomepageGeographyTier = {
  TierOne: 'TIER_ONE',
  TierThree: 'TIER_THREE',
  TierTwo: 'TIER_TWO',
  TierUnspecified: 'TIER_UNSPECIFIED',
  TierWineRegion: 'TIER_WINE_REGION'
} as const;

export type JceHomepageGeographyTier = typeof JceHomepageGeographyTier[keyof typeof JceHomepageGeographyTier];
export type JceHomepageOrderingEntryEntity = {
  __typename?: 'JceHomepageOrderingEntryEntity';
  /** JceHomepageOrderingEntryEntity_Generated::getCollection */
  collection?: Maybe<JceVenueCollectionEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getIsDesignatedForLeaderboard */
  isDesignatedForLeaderboard: Scalars['Boolean']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getPosition */
  position: Scalars['Int']['output'];
  /** JceHomepageOrderingEntryEntity_Generated::getSpecialCollection */
  specialCollection?: Maybe<JceVenueSpecialCollection>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type JceHomepageOrderingEntryInput = {
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  existingId?: InputMaybe<Scalars['Int']['input']>;
  geographyId: Scalars['Int']['input'];
  isDesignatedForLeaderboard?: InputMaybe<Scalars['Boolean']['input']>;
  specialCollection?: InputMaybe<JceVenueSpecialCollection>;
};

export type JceVenueCollectionEntity = {
  __typename?: 'JceVenueCollectionEntity';
  /** JceVenueCollectionEntity_Generated::getCollectionEntrys */
  collectionEntrys: Array<JceVenueCollectionEntryEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** JceVenueCollectionEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** JceVenueCollectionEntity_Generated::getIconIndicator */
  iconIndicator?: Maybe<JceVenueCollectionIconIndicator>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceVenueCollectionEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** JceVenueCollectionEntity_Generated::getStatus */
  status?: Maybe<JceVenueCollectionStatus>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** JceVenueCollectionEntity_Generated::getUrlSlug */
  urlSlug?: Maybe<Scalars['String']['output']>;
};

export type JceVenueCollectionEntryEntity = {
  __typename?: 'JceVenueCollectionEntryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** JceVenueCollectionEntryEntity_Generated::getPosition */
  position?: Maybe<Scalars['Int']['output']>;
  /** JceVenueCollectionEntryEntity_Generated::getResyVenueId */
  resyVenueId?: Maybe<Scalars['Int']['output']>;
  /** JceVenueCollectionEntryEntity_Generated::getTockVenueId */
  tockVenueId?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type JceVenueCollectionEntryInput = {
  resyVenueId?: InputMaybe<Scalars['Int']['input']>;
  tockVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export const JceVenueCollectionIconIndicator = {
  IconArt: 'ICON_ART',
  IconAward: 'ICON_AWARD',
  IconBakedGoods: 'ICON_BAKED_GOODS',
  IconBlackOwned: 'ICON_BLACK_OWNED',
  IconBookTonight: 'ICON_BOOK_TONIGHT',
  IconBowtie: 'ICON_BOWTIE',
  IconBurger: 'ICON_BURGER',
  IconChecklist: 'ICON_CHECKLIST',
  IconChefPicks: 'ICON_CHEF_PICKS',
  IconClassic: 'ICON_CLASSIC',
  IconClimbing: 'ICON_CLIMBING',
  IconCocktail: 'ICON_COCKTAIL',
  IconCoffee: 'ICON_COFFEE',
  IconDateNight: 'ICON_DATE_NIGHT',
  IconDessert: 'ICON_DESSERT',
  IconDineIn: 'ICON_DINE_IN',
  IconDonut: 'ICON_DONUT',
  IconDumplings: 'ICON_DUMPLINGS',
  IconEggs: 'ICON_EGGS',
  IconEvents: 'ICON_EVENTS',
  IconFall: 'ICON_FALL',
  IconGda: 'ICON_GDA',
  IconGroups: 'ICON_GROUPS',
  IconHealthy: 'ICON_HEALTHY',
  IconHoliday: 'ICON_HOLIDAY',
  IconIconic: 'ICON_ICONIC',
  IconIndustryHangs: 'ICON_INDUSTRY_HANGS',
  IconLunarNewYear: 'ICON_LUNAR_NEW_YEAR',
  IconMapPin: 'ICON_MAP_PIN',
  IconMichelin: 'ICON_MICHELIN',
  IconNaturalWine: 'ICON_NATURAL_WINE',
  IconNew: 'ICON_NEW',
  IconOutdoorDining: 'ICON_OUTDOOR_DINING',
  IconPasta: 'ICON_PASTA',
  IconPastry: 'ICON_PASTRY',
  IconPickUpTonight: 'ICON_PICK_UP_TONIGHT',
  IconPizza: 'ICON_PIZZA',
  IconRecommendedForYou: 'ICON_RECOMMENDED_FOR_YOU',
  IconRestaurateurPicks: 'ICON_RESTAURATEUR_PICKS',
  IconSeafood: 'ICON_SEAFOOD',
  IconSpecial: 'ICON_SPECIAL',
  IconSpring: 'ICON_SPRING',
  IconStaffPicks: 'ICON_STAFF_PICKS',
  IconSummer: 'ICON_SUMMER',
  IconSushi: 'ICON_SUSHI',
  IconSustainability: 'ICON_SUSTAINABILITY',
  IconTacos: 'ICON_TACOS',
  IconTopRated: 'ICON_TOP_RATED',
  IconToGo: 'ICON_TO_GO',
  IconTravel: 'ICON_TRAVEL',
  IconUnknown: 'ICON_UNKNOWN',
  IconValentines: 'ICON_VALENTINES',
  IconWine: 'ICON_WINE',
  IconWinter: 'ICON_WINTER',
  IconWomen: 'ICON_WOMEN'
} as const;

export type JceVenueCollectionIconIndicator = typeof JceVenueCollectionIconIndicator[keyof typeof JceVenueCollectionIconIndicator];
export type JceVenueCollectionInput = {
  description: Scalars['String']['input'];
  iconIndicator: JceVenueCollectionIconIndicator;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status: JceVenueCollectionStatus;
  urlSlug?: InputMaybe<Scalars['String']['input']>;
};

export const JceVenueCollectionStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  Draft: 'DRAFT'
} as const;

export type JceVenueCollectionStatus = typeof JceVenueCollectionStatus[keyof typeof JceVenueCollectionStatus];
export const JceVenueSpecialCollection = {
  BookTonight: 'BOOK_TONIGHT',
  Gda: 'GDA',
  RecommendedForYou: 'RECOMMENDED_FOR_YOU',
  SpecialCollectionUnspecified: 'SPECIAL_COLLECTION_UNSPECIFIED'
} as const;

export type JceVenueSpecialCollection = typeof JceVenueSpecialCollection[keyof typeof JceVenueSpecialCollection];
export const JurisdictionType = {
  City: 'City',
  Country: 'Country',
  County: 'County',
  Special: 'Special',
  State: 'State'
} as const;

export type JurisdictionType = typeof JurisdictionType[keyof typeof JurisdictionType];
export const KeyType = {
  ApiKey: 'API_KEY',
  Business: 'BUSINESS',
  BusinessGroup: 'BUSINESS_GROUP',
  ExternalIntegration: 'EXTERNAL_INTEGRATION'
} as const;

export type KeyType = typeof KeyType[keyof typeof KeyType];
export type LastAssignedTableInfo = {
  __typename?: 'LastAssignedTableInfo';
  /** LastAssignedTableInfo::isInTableCombo */
  inTableCombo: Scalars['Boolean']['output'];
  /** LastAssignedTableInfo::tableName */
  tableName: Scalars['String']['output'];
  /** LastAssignedTableInfo::tablePriority */
  tablePriority?: Maybe<Scalars['String']['output']>;
};

export type LocationEntity = {
  __typename?: 'LocationEntity';
  /** LocationEntity_Generated::getAddress */
  address?: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getAddress2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getCity */
  city?: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getCountry */
  country?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** LocationEntity_Generated::getGooglePlacesId */
  googlePlacesId?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** LocationEntity_Generated::getLat */
  lat?: Maybe<Scalars['Float']['output']>;
  /** LocationEntity_Generated::getLng */
  lng?: Maybe<Scalars['Float']['output']>;
  /** LocationEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** LocationEntity_Generated::getState */
  state?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** LocationEntity_Generated::getZipCode */
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Lock = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::id */
  id: Scalars['ID']['output'];
  /** Lock::partySize */
  partySize: Scalars['Int']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Lock::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** Lock::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type LockedSlot = Slot & {
  __typename?: 'LockedSlot';
  /** LockedSlot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** LockedSlot::initiatedFrom */
  initiatedFrom?: Maybe<InitiatedFrom>;
  /** LockedSlot::lockedCoversCount */
  lockedCoversCount: Scalars['Int']['output'];
  /** LockedSlot::purchaseVerifyType */
  purchaseVerifyType?: Maybe<PurchaseVerifyType>;
  /** LockedSlot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** LockedSlot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** LockedSlot::ticketSubsetId */
  ticketSubsetId: Scalars['Int']['output'];
  /** LockedSlot::ticketType */
  ticketType: TicketTypeEntity;
};

export type ManageTockWebhookRequestInput = {
  authHeaders: Array<Array<Scalars['String']['input']>>;
  businessGroupId: Scalars['Int']['input'];
  endpointUrl: Scalars['String']['input'];
  webhookEndpointId: Scalars['Int']['input'];
  webhookRequestAction: WebhookRequestAction;
  webhookType: WebhookType;
};

export type ManualInvoiceRequestInput = {
  customEmailText?: InputMaybe<Scalars['String']['input']>;
  invoice: InvoiceInput;
};

export type MediumScoreOptions = {
  __typename?: 'MediumScoreOptions';
  /** MediumScoreOptions::penalizeExperienceMismatches */
  penalizeExperienceMismatches: Scalars['Boolean']['output'];
  /** MediumScoreOptions::penalizeInHouseTableAssignments */
  penalizeInHouseTableAssignments: Scalars['Boolean']['output'];
  /** MediumScoreOptions::penalizeSeatingAreaAssignment */
  penalizeSeatingAreaAssignment?: Maybe<Scalars['Boolean']['output']>;
};

export type MediumScoreOptionsInput = {
  penalizeExperienceMismatches: Scalars['Boolean']['input'];
  penalizeInHouseTableAssignments: Scalars['Boolean']['input'];
  penalizeSeatingAreaAssignment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Menu = {
  __typename?: 'Menu';
  /** Menu::id */
  id: Scalars['Int']['output'];
  /** Menu::name */
  name?: Maybe<Scalars['String']['output']>;
  /** Menu::sections */
  sections: Array<MenuSection>;
};

export type MenuCategoryEntity = {
  __typename?: 'MenuCategoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  /** MenuItem::description */
  description?: Maybe<Scalars['String']['output']>;
  /** MenuItem::imageUrl */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** MenuItem::name */
  name?: Maybe<Scalars['String']['output']>;
  /** MenuItem::price */
  price?: Maybe<MoneyCents>;
};

export type MenuItemEntity = Purchasable & Taxable & {
  __typename?: 'MenuItemEntity';
  /** MenuItemEntity_Generated::getChitName */
  chitName?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** MenuItemEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayName */
  displayName?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity_Generated::getDisplayPriceCents */
  displayPriceCents?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuItemEntity_Generated::getImage */
  image?: Maybe<UploadedImageEntity>;
  /** MenuItemEntity_Generated::getInventory */
  inventory?: Maybe<TicketOptionInventoryEntity>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuItemEntity_Generated::getItemMetaTags */
  itemMetaTags: Array<ItemMetaTagEntity>;
  /** MenuItemEntity_Generated::getItemScaleTags */
  itemScaleTags: Array<ItemScaleTagEntity>;
  /** MenuItemEntity_Generated::getItemType */
  itemType: ItemType;
  /** MenuItemEntity_Generated::getMenuCategory */
  menuCategory?: Maybe<MenuCategoryEntity>;
  /** MenuItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MenuItemEntity_Generated::getPriceCents */
  priceCents?: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuItemEntity_Generated::getRequiredAge */
  requiredAge?: Maybe<Scalars['Int']['output']>;
  /** MenuItemEntity_Generated::getSku */
  sku?: Maybe<Scalars['String']['output']>;
  /** MenuItemEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** MenuItemEntity::viewBusinessTaxes */
  viewBusinessTaxes: Array<BusinessTaxEntity>;
};

export type MenuModifierGroupEntity = {
  __typename?: 'MenuModifierGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuModifierGroupOptionEntity = Purchasable & Taxable & {
  __typename?: 'MenuModifierGroupOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MenuModifierGroupOptionEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** MenuModifierGroupOptionEntity_Generated::getMenuModifierGroup */
  menuModifierGroup: MenuModifierGroupEntity;
  /** MenuModifierGroupOptionEntity::getName */
  name: Scalars['String']['output'];
  /** MenuModifierGroupOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** MenuModifierGroupOptionEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  /** MenuSection::items */
  items: Array<MenuItem>;
  /** MenuSection::name */
  name?: Maybe<Scalars['String']['output']>;
};

export const MetaTagDecorated = {
  Biodynamic: 'BIODYNAMIC',
  IndoorSeating: 'INDOOR_SEATING',
  LowSulfite: 'LOW_SULFITE',
  Natural: 'NATURAL',
  Organic: 'ORGANIC',
  OutdoorSeating: 'OUTDOOR_SEATING',
  Sustainable: 'SUSTAINABLE',
  Vegan: 'VEGAN',
  WineAcacia: 'WINE_ACACIA',
  WineAgiorgitiko: 'WINE_AGIORGITIKO',
  WineAglianico: 'WINE_AGLIANICO',
  WineAiren: 'WINE_AIREN',
  WineAleatico: 'WINE_ALEATICO',
  WineAlicanteBouschet: 'WINE_ALICANTE_BOUSCHET',
  WineAligote: 'WINE_ALIGOTE',
  WineAllspice: 'WINE_ALLSPICE',
  WineAlvarinho: 'WINE_ALVARINHO',
  WineAnise: 'WINE_ANISE',
  WineApple: 'WINE_APPLE',
  WineApricot: 'WINE_APRICOT',
  WineArinto: 'WINE_ARINTO',
  WineArneis: 'WINE_ARNEIS',
  WineAssyrtiko: 'WINE_ASSYRTIKO',
  WineAurore: 'WINE_AURORE',
  WineAuxerrois: 'WINE_AUXERROIS',
  WineBacchus: 'WINE_BACCHUS',
  WineBacoBlanc: 'WINE_BACO_BLANC',
  WineBacoNoir: 'WINE_BACO_NOIR',
  WineBakingSpices: 'WINE_BAKING_SPICES',
  WineBarbera: 'WINE_BARBERA',
  WineBeeswax: 'WINE_BEESWAX',
  WineBellPepper: 'WINE_BELL_PEPPER',
  WineBitterAlmond: 'WINE_BITTER_ALMOND',
  WineBlackberry: 'WINE_BLACKBERRY',
  WineBlackCherry: 'WINE_BLACK_CHERRY',
  WineBlackCurrant: 'WINE_BLACK_CURRANT',
  WineBlackPepper: 'WINE_BLACK_PEPPER',
  WineBlackTea: 'WINE_BLACK_TEA',
  WineBlancDuBois: 'WINE_BLANC_DU_BOIS',
  WineBlaufrankisch: 'WINE_BLAUFRANKISCH',
  WineBlueberry: 'WINE_BLUEBERRY',
  WineBobal: 'WINE_BOBAL',
  WineBonarda: 'WINE_BONARDA',
  WineBoysenberry: 'WINE_BOYSENBERRY',
  WineBrachetto: 'WINE_BRACHETTO',
  WineBramble: 'WINE_BRAMBLE',
  WineBrioche: 'WINE_BRIOCHE',
  WineBrownSugar: 'WINE_BROWN_SUGAR',
  WineBubblegum: 'WINE_BUBBLEGUM',
  WineBurger: 'WINE_BURGER',
  WineButter: 'WINE_BUTTER',
  WineButterscotch: 'WINE_BUTTERSCOTCH',
  WineCabernetDore: 'WINE_CABERNET_DORE',
  WineCabernetFranc: 'WINE_CABERNET_FRANC',
  WineCabernetPfeffer: 'WINE_CABERNET_PFEFFER',
  WineCabernetSauvignon: 'WINE_CABERNET_SAUVIGNON',
  WineCanaiolo: 'WINE_CANAIOLO',
  WineCaramel: 'WINE_CARAMEL',
  WineCarignan: 'WINE_CARIGNAN',
  WineCarmenere: 'WINE_CARMENERE',
  WineCascade: 'WINE_CASCADE',
  WineCassis: 'WINE_CASSIS',
  WineCastelao: 'WINE_CASTELAO',
  WineCatarratto: 'WINE_CATARRATTO',
  WineCatawba: 'WINE_CATAWBA',
  WineCayugaWhite: 'WINE_CAYUGA_WHITE',
  WineCenturion: 'WINE_CENTURION',
  WineChambourcin: 'WINE_CHAMBOURCIN',
  WineChamomile: 'WINE_CHAMOMILE',
  WineChancellor: 'WINE_CHANCELLOR',
  WineCharbono: 'WINE_CHARBONO',
  WineChardonel: 'WINE_CHARDONEL',
  WineChardonnay: 'WINE_CHARDONNAY',
  WineChasselasDore: 'WINE_CHASSELAS_DORE',
  WineCheninBlanc: 'WINE_CHENIN_BLANC',
  WineCherry: 'WINE_CHERRY',
  WineChocolate: 'WINE_CHOCOLATE',
  WineCigarBox: 'WINE_CIGAR_BOX',
  WineCinnamon: 'WINE_CINNAMON',
  WineCinsault: 'WINE_CINSAULT',
  WineCitrus: 'WINE_CITRUS',
  WineClairetteBlanche: 'WINE_CLAIRETTE_BLANCHE',
  WineClayPot: 'WINE_CLAY_POT',
  WineClinton: 'WINE_CLINTON',
  WineClove: 'WINE_CLOVE',
  WineCocoa: 'WINE_COCOA',
  WineCocoaPowder: 'WINE_COCOA_POWDER',
  WineCoconut: 'WINE_COCONUT',
  WineCoffee: 'WINE_COFFEE',
  WineColombard: 'WINE_COLOMBARD',
  WineConcord: 'WINE_CONCORD',
  WineCorotNoir: 'WINE_COROT_NOIR',
  WineCortese: 'WINE_CORTESE',
  WineCorvina: 'WINE_CORVINA',
  WineCoudercNoir: 'WINE_COUDERC_NOIR',
  WineCounoise: 'WINE_COUNOISE',
  WineCranberry: 'WINE_CRANBERRY',
  WineCream: 'WINE_CREAM',
  WineCrimsonCabernet: 'WINE_CRIMSON_CABERNET',
  WineCustard: 'WINE_CUSTARD',
  WineDarkChocolate: 'WINE_DARK_CHOCOLATE',
  WineDate: 'WINE_DATE',
  WineDelaware: 'WINE_DELAWARE',
  WineDessert: 'WINE_DESSERT',
  WineDeChaunac: 'WINE_DE_CHAUNAC',
  WineDill: 'WINE_DILL',
  WineDolcetto: 'WINE_DOLCETTO',
  WineDornfelder: 'WINE_DORNFELDER',
  WineDriedFruit: 'WINE_DRIED_FRUIT',
  WineDulcet: 'WINE_DULCET',
  WineDutchess: 'WINE_DUTCHESS',
  WineElderflower: 'WINE_ELDERFLOWER',
  WineElvira: 'WINE_ELVIRA',
  WineErbaluce: 'WINE_ERBALUCE',
  WineEucalyptus: 'WINE_EUCALYPTUS',
  WineExclusive: 'WINE_EXCLUSIVE',
  WineFalanghina: 'WINE_FALANGHINA',
  WineFavorite: 'WINE_FAVORITE',
  WineFennel: 'WINE_FENNEL',
  WineFiano: 'WINE_FIANO',
  WineFig: 'WINE_FIG',
  WineFiveSpice: 'WINE_FIVE_SPICE',
  WineFlower: 'WINE_FLOWER',
  WineFolleBlanche: 'WINE_FOLLE_BLANCHE',
  WineFrappato: 'WINE_FRAPPATO',
  WineFredonia: 'WINE_FREDONIA',
  WineFresia: 'WINE_FRESIA',
  WineFriulano: 'WINE_FRIULANO',
  WineFruitcake: 'WINE_FRUITCAKE',
  WineFurmint: 'WINE_FURMINT',
  WineGaglioppo: 'WINE_GAGLIOPPO',
  WineGamay: 'WINE_GAMAY',
  WineGamayNoir: 'WINE_GAMAY_NOIR',
  WineGarganega: 'WINE_GARGANEGA',
  WineGewurztraminer: 'WINE_GEWURZTRAMINER',
  WineGinger: 'WINE_GINGER',
  WineGodello: 'WINE_GODELLO',
  WineGooseberry: 'WINE_GOOSEBERRY',
  WineGraciano: 'WINE_GRACIANO',
  WineGrapefruit: 'WINE_GRAPEFRUIT',
  WineGrass: 'WINE_GRASS',
  WineGrechetto: 'WINE_GRECHETTO',
  WineGreenTea: 'WINE_GREEN_TEA',
  WineGrenache: 'WINE_GRENACHE',
  WineGrenacheBlanc: 'WINE_GRENACHE_BLANC',
  WineGrignolino: 'WINE_GRIGNOLINO',
  WineGrillo: 'WINE_GRILLO',
  WineGrunerVeltliner: 'WINE_GRUNER_VELTLINER',
  WineGuava: 'WINE_GUAVA',
  WineHazelnut: 'WINE_HAZELNUT',
  WineHibiscus: 'WINE_HIBISCUS',
  WineHoney: 'WINE_HONEY',
  WineHoneysuckle: 'WINE_HONEYSUCKLE',
  WineIris: 'WINE_IRIS',
  WineIsabella: 'WINE_ISABELLA',
  WineJalapeno: 'WINE_JALAPENO',
  WineJasmine: 'WINE_JASMINE',
  WineLager: 'WINE_LAGER',
  WineLagrein: 'WINE_LAGREIN',
  WineLambrusco: 'WINE_LAMBRUSCO',
  WineLavender: 'WINE_LAVENDER',
  WineLeather: 'WINE_LEATHER',
  WineLemon: 'WINE_LEMON',
  WineLemongrass: 'WINE_LEMONGRASS',
  WineLicorice: 'WINE_LICORICE',
  WineLilac: 'WINE_LILAC',
  WineLime: 'WINE_LIME',
  WineLimestone: 'WINE_LIMESTONE',
  WineListanNegro: 'WINE_LISTAN_NEGRO',
  WineLoureiro: 'WINE_LOUREIRO',
  WineLychee: 'WINE_LYCHEE',
  WineMalbec: 'WINE_MALBEC',
  WineMalvasiaBianca: 'WINE_MALVASIA_BIANCA',
  WineMalvasiaFina: 'WINE_MALVASIA_FINA',
  WineMango: 'WINE_MANGO',
  WineMarmalade: 'WINE_MARMALADE',
  WineMarsanne: 'WINE_MARSANNE',
  WineMelon: 'WINE_MELON',
  WineMelonDeBourgogne: 'WINE_MELON_DE_BOURGOGNE',
  WineMencia: 'WINE_MENCIA',
  WineMerlot: 'WINE_MERLOT',
  WineMineral: 'WINE_MINERAL',
  WineMint: 'WINE_MINT',
  WineMission: 'WINE_MISSION',
  WineMocha: 'WINE_MOCHA',
  WineMontepulciano: 'WINE_MONTEPULCIANO',
  WineMoschofilero: 'WINE_MOSCHOFILERO',
  WineMourvedre: 'WINE_MOURVEDRE',
  WineMullerThurgau: 'WINE_MULLER_THURGAU',
  WineMuscadelle: 'WINE_MUSCADELLE',
  WineMuscadine: 'WINE_MUSCADINE',
  WineMuscat: 'WINE_MUSCAT',
  WineMuscatBlanc: 'WINE_MUSCAT_BLANC',
  WineMuscatOfAlexandria: 'WINE_MUSCAT_OF_ALEXANDRIA',
  WineMuscatOttonel: 'WINE_MUSCAT_OTTONEL',
  WineMushroom: 'WINE_MUSHROOM',
  WineNebbiolo: 'WINE_NEBBIOLO',
  WineNectarine: 'WINE_NECTARINE',
  WineNegrette: 'WINE_NEGRETTE',
  WineNegroamaro: 'WINE_NEGROAMARO',
  WineNerelloMascalese: 'WINE_NERELLO_MASCALESE',
  WineNeroDavola: 'WINE_NERO_DAVOLA',
  WineNewYorkMuscat: 'WINE_NEW_YORK_MUSCAT',
  WineNiagara: 'WINE_NIAGARA',
  WineNorton: 'WINE_NORTON',
  WineNutmeg: 'WINE_NUTMEG',
  WineNuttyFlavors: 'WINE_NUTTY_FLAVORS',
  WineOak: 'WINE_OAK',
  WineOlive: 'WINE_OLIVE',
  WineOntario: 'WINE_ONTARIO',
  WineOrange: 'WINE_ORANGE',
  WineOrangeBlossom: 'WINE_ORANGE_BLOSSOM',
  WineOrangeMuscat: 'WINE_ORANGE_MUSCAT',
  WinePais: 'WINE_PAIS',
  WinePalomino: 'WINE_PALOMINO',
  WinePalominoFino: 'WINE_PALOMINO_FINO',
  WinePassionFruit: 'WINE_PASSION_FRUIT',
  WinePeach: 'WINE_PEACH',
  WinePear: 'WINE_PEAR',
  WinePedroXimenez: 'WINE_PEDRO_XIMENEZ',
  WinePeony: 'WINE_PEONY',
  WinePersimmon: 'WINE_PERSIMMON',
  WinePetiteSirah: 'WINE_PETITE_SIRAH',
  WinePetitBouschet: 'WINE_PETIT_BOUSCHET',
  WinePetitManseng: 'WINE_PETIT_MANSENG',
  WinePetitVerdot: 'WINE_PETIT_VERDOT',
  WinePetrol: 'WINE_PETROL',
  WinePicpoul: 'WINE_PICPOUL',
  WinePineapple: 'WINE_PINEAPPLE',
  WinePinotage: 'WINE_PINOTAGE',
  WinePinotBlanc: 'WINE_PINOT_BLANC',
  WinePinotGris: 'WINE_PINOT_GRIS',
  WinePinotMeunier: 'WINE_PINOT_MEUNIER',
  WinePinotNoir: 'WINE_PINOT_NOIR',
  WinePlum: 'WINE_PLUM',
  WinePomegranate: 'WINE_POMEGRANATE',
  WinePotpourri: 'WINE_POTPOURRI',
  WinePottingSoil: 'WINE_POTTING_SOIL',
  WinePrimitivo: 'WINE_PRIMITIVO',
  WineQuince: 'WINE_QUINCE',
  WineRaisin: 'WINE_RAISIN',
  WineRaspberry: 'WINE_RASPBERRY',
  WineRed: 'WINE_RED',
  WineRedBeet: 'WINE_RED_BEET',
  WineRedPepper: 'WINE_RED_PEPPER',
  WineRedPlum: 'WINE_RED_PLUM',
  WineRibollaGialla: 'WINE_RIBOLLA_GIALLA',
  WineRiesling: 'WINE_RIESLING',
  WineRkatsiteli: 'WINE_RKATSITELI',
  WineRoastedGame: 'WINE_ROASTED_GAME',
  WineRondinella: 'WINE_RONDINELLA',
  WineRose: 'WINE_ROSE',
  WineRoseFlavor: 'WINE_ROSE_FLAVOR',
  WineRoussanne: 'WINE_ROUSSANNE',
  WineSagrantino: 'WINE_SAGRANTINO',
  WineSalt: 'WINE_SALT',
  WineSangiovese: 'WINE_SANGIOVESE',
  WineSauvignonBlanc: 'WINE_SAUVIGNON_BLANC',
  WineSauvignonGris: 'WINE_SAUVIGNON_GRIS',
  WineSavatiano: 'WINE_SAVATIANO',
  WineScheurebe: 'WINE_SCHEUREBE',
  WineSchiava: 'WINE_SCHIAVA',
  WineSemillon: 'WINE_SEMILLON',
  WineSeyvalBlanc: 'WINE_SEYVAL_BLANC',
  WineSilvaner: 'WINE_SILVANER',
  WineSlate: 'WINE_SLATE',
  WineSmoke: 'WINE_SMOKE',
  WineSourdough: 'WINE_SOURDOUGH',
  WineSourCherry: 'WINE_SOUR_CHERRY',
  WineSparkling: 'WINE_SPARKLING',
  WineStarFruit: 'WINE_STAR_FRUIT',
  WineStrawberry: 'WINE_STRAWBERRY',
  WineStLaurent: 'WINE_ST_LAURENT',
  WineSunDriedTomato: 'WINE_SUN_DRIED_TOMATO',
  WineSweetSpice: 'WINE_SWEET_SPICE',
  WineSyrah: 'WINE_SYRAH',
  WineTangerine: 'WINE_TANGERINE',
  WineTannat: 'WINE_TANNAT',
  WineTempranillo: 'WINE_TEMPRANILLO',
  WineTeroldego: 'WINE_TEROLDEGO',
  WineThyme: 'WINE_THYME',
  WineTintoCao: 'WINE_TINTO_CAO',
  WineTobacco: 'WINE_TOBACCO',
  WineTocaiFriulano: 'WINE_TOCAI_FRIULANO',
  WineTomato: 'WINE_TOMATO',
  WineTomatoLeaf: 'WINE_TOMATO_LEAF',
  WineTorrontes: 'WINE_TORRONTES',
  WineTouriga: 'WINE_TOURIGA',
  WineTourigaFranca: 'WINE_TOURIGA_FRANCA',
  WineTourigaNacional: 'WINE_TOURIGA_NACIONAL',
  WineTraminer: 'WINE_TRAMINER',
  WineTrebbiano: 'WINE_TREBBIANO',
  WineTrebbianoToscano: 'WINE_TREBBIANO_TOSCANO',
  WineTrousseau: 'WINE_TROUSSEAU',
  WineTrousseauGris: 'WINE_TROUSSEAU_GRIS',
  WineTruffle: 'WINE_TRUFFLE',
  WineValdiguie: 'WINE_VALDIGUIE',
  WineVanilla: 'WINE_VANILLA',
  WineVentura: 'WINE_VENTURA',
  WineVerdejo: 'WINE_VERDEJO',
  WineVerdelho: 'WINE_VERDELHO',
  WineVerdicchio: 'WINE_VERDICCHIO',
  WineVermentino: 'WINE_VERMENTINO',
  WineVidalBlanc: 'WINE_VIDAL_BLANC',
  WineVillardBlanc: 'WINE_VILLARD_BLANC',
  WineVillardNoir: 'WINE_VILLARD_NOIR',
  WineViognier: 'WINE_VIOGNIER',
  WineViolet: 'WINE_VIOLET',
  WineViura: 'WINE_VIURA',
  WineVolcanicRocks: 'WINE_VOLCANIC_ROCKS',
  WineWatermelon: 'WINE_WATERMELON',
  WineWelschRizling: 'WINE_WELSCH_RIZLING',
  WineWetGravel: 'WINE_WET_GRAVEL',
  WineWhite: 'WINE_WHITE',
  WineWhiteFlower: 'WINE_WHITE_FLOWER',
  WineWhitePepper: 'WINE_WHITE_PEPPER',
  WineXarelLo: 'WINE_XAREL_LO',
  WineXinomavro: 'WINE_XINOMAVRO',
  WineZinfandel: 'WINE_ZINFANDEL',
  WineZweigelt: 'WINE_ZWEIGELT'
} as const;

export type MetaTagDecorated = typeof MetaTagDecorated[keyof typeof MetaTagDecorated];
export type MetaTagEntity = IMetaTag & {
  __typename?: 'MetaTagEntity';
  /** MetaTagEntity_Generated::getBusinessTags */
  businessTags: Array<BusinessTagEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MetaTagEntity_Generated::getIsActive */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** MetaTagEntity_Generated::getIsInternal */
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** MetaTagEntity::getKey */
  key: MetaTagKey;
  /** MetaTagEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** MetaTagEntity_Generated::getTicketTypeTags */
  ticketTypeTags: Array<TicketTypeTagEntity>;
  /** MetaTagEntity_Generated::getType */
  type: TagType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type MetaTagKey = {
  __typename?: 'MetaTagKey';
  /** MetaTagKey::backingType */
  backingType?: Maybe<BackingType>;
  /** MetaTagKey::enumValue */
  enumValue?: Maybe<Scalars['String']['output']>;
  /** MetaTagKey::metaTagId */
  metaTagId?: Maybe<Scalars['Int']['output']>;
};

export type MetaTagWrapper = IMetaTag & {
  __typename?: 'MetaTagWrapper';
  /** MetaTagWrapper::getKey */
  key: MetaTagKey;
  /** MetaTagWrapper::getName */
  name: Scalars['String']['output'];
  /** MetaTagWrapper::getType */
  type: TagType;
};

export type MetroAreaEntity = {
  __typename?: 'MetroAreaEntity';
  /** Businesses that list the given metro area as their nearest metro (MetroAreaResolvers::businesses) */
  businesses: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** MetroAreaEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type MetroAreaEntityBusinessesArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};

export type MfaEmailFactor = {
  __typename?: 'MfaEmailFactor';
  /** MfaEmailFactor::emailAddress */
  emailAddress?: Maybe<Scalars['String']['output']>;
};

export type MfaFactor = MfaEmailFactor | MfaPhoneFactor;

export type MfaPhoneFactor = {
  __typename?: 'MfaPhoneFactor';
  /** MfaPhoneFactor::phoneNumber */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type MobileTicket = {
  __typename?: 'MobileTicket';
  /** MobileTicket::mobileTicketUrl */
  mobileTicketUrl?: Maybe<Scalars['String']['output']>;
};

export type MockTaxable = Taxable & {
  __typename?: 'MockTaxable';
  /** MockTaxable::getName */
  name: Scalars['String']['output'];
  /** MockTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export const ModificationAbility = {
  Allowed: 'ALLOWED',
  Disallowed: 'DISALLOWED'
} as const;

export type ModificationAbility = typeof ModificationAbility[keyof typeof ModificationAbility];
export type ModificationRestriction = {
  __typename?: 'ModificationRestriction';
  /** ModificationRestriction::description */
  description?: Maybe<Description>;
};

export type MoneyCents = {
  __typename?: 'MoneyCents';
  /** MoneyCents::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** MoneyCents::getAmountDollar */
  amountDollar: Scalars['Float']['output'];
  /** MoneyCents::getCurrencyCode */
  currencyCode?: Maybe<Scalars['String']['output']>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  /** Add business exclusivity program details if not present (BusinessResolvers::addBusinessExclusivityProgram) */
  addBusinessExclusivityProgram: BusinessEntity;
  /** Add business tags if not present (BusinessResolvers::addBusinessTagsIfNotPresent) */
  addBusinessTagsIfNotPresent: BusinessEntity;
  /** Add an entitlement to an entitlement set (EntitlementSetResolvers::addEntitlementToEntitlementSets) */
  addEntitlementToEntitlementSets?: Maybe<AddEntitlementToEntitlementSetsPayload>;
  /** Add a new entry to a venue collection (JceHomepageResolvers::addJceVenueCollectionEntry) */
  addJceVenueCollectionEntry?: Maybe<JceVenueCollectionEntryEntity>;
  /** Adds or updates ShipCompliant information for a Wine Item. Throws an error if the Wine Item doesn't belong to this business. (WineItemsResolvers::addShipCompliantInfoToWineItem) */
  addShipCompliantInfoToWineItem?: Maybe<ItemWineTypeEntity>;
  /** SsoLoginDomainResolvers::addSsoLoginDomain */
  addSsoLoginDomain: Scalars['Boolean']['output'];
  /** SsoLoginDomainResolvers::addSsoLoginDomainsToBusiness */
  addSsoLoginDomainsToBusiness: Scalars['Boolean']['output'];
  /** Creates a new ShopBrandStory and associates it with a ShopBrand (ShopBrandResolvers::addStoryToShopBrand) */
  addStoryToShopBrand?: Maybe<ShopBrandStoryEntity>;
  /** Add new ticket price information to an experience (TicketTypeResolvers::addTicketPriceInformation) */
  addTicketPriceInformation?: Maybe<TicketTypeEntity>;
  /** Adds or switches a Wine Item to the specified Brand. Throws an error if either the Wine Item or Brand don't belong to this business. (WineItemsResolvers::addWineItemToBrand) */
  addWineItemToBrand?: Maybe<ItemWineTypeEntity>;
  /** Approve temporary business access (PermissionResolvers::approveBusinessAccess) */
  approveBusinessAccess: Scalars['Boolean']['output'];
  /** Approves a business for permission to sign the service agreement before billing details (FinanceBusinessResolvers::approveSpecialSigningPermission) */
  approveSpecialSigningPermission: Scalars['Boolean']['output'];
  /** Archives a business entitlement set (BusinessEntitlementSetResolvers::archiveBusinessEntitlementSet) */
  archiveBusinessEntitlementSet?: Maybe<UpdateBusinessEntitlementSetPayload>;
  /** Archives an existing PatronAddressEntity. (PatronResolvers::archivePatronAddress) */
  archivePatronAddress?: Maybe<PatronAddressEntity>;
  /** Archives one or more Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::archiveShippingZones) */
  archiveShippingZones: Array<ShippingZoneEntity>;
  /** Archives the Brand with the specified ID. Throws an error if the Brand doesn't belong to this business. (ShopBrandResolvers::archiveShopBrand) */
  archiveShopBrand?: Maybe<ShopBrandEntity>;
  /** Archives the Shop Business with the specified ID. Throws an error if the Shop Business is null. (ShopBusinessResolvers::archiveShopBusiness) */
  archiveShopBusiness?: Maybe<ShopBusinessEntity>;
  /** Archives the wine item with the specified ID. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::archiveWineItem) */
  archiveWineItem?: Maybe<ItemWineTypeEntity>;
  /** Archives a wine item and the relationship to its brand(s), if any. (WineItemsResolvers::archiveWineItemAndBrandRelation) */
  archiveWineItemAndBrandRelation?: Maybe<ItemWineTypeEntity>;
  /** Set a Wine Item -- Brand link to archived. Throws an error if either the Wine Item or Brand don't belong to this business. (WineItemsResolvers::archiveWineItemToBrand) */
  archiveWineItemToBrand?: Maybe<ItemWineTypeEntity>;
  /** Remove several business feature flag overrides at once (FeatureResolvers::batchDeleteBusinessFeature) */
  batchDeleteBusinessFeature: Scalars['Boolean']['output'];
  /** Update the state of a feature flag for many businesses (FeatureResolvers::batchUpdateBusinessFeature) */
  batchUpdateBusinessFeature: Array<BusinessFeatureEntity>;
  /** OrderResolvers::beta_initiateMultipleOrderExecution_v2 */
  beta_initiateMultipleOrderExecution_v2: Array<WorkflowIdentifier>;
  /** OrderResolvers::beta_initiateOrderCancellation */
  beta_initiateOrderCancellation?: Maybe<WorkflowIdentifier>;
  /** OrderResolvers::beta_initiateOrderExecution_v2 */
  beta_initiateOrderExecution_v2?: Maybe<WorkflowIdentifier>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::beta_updateShippingZone) */
  beta_updateShippingZone?: Maybe<UpsertShippingZoneResult>;
  /** Bulk delete patrons from Tock. Deprecated: use the bulkDeletePatronAccounts GraphQL subscription instead. (PatronResolvers::bulkDeletePatronAccounts) */
  bulkDeletePatronAccounts?: Maybe<BulkAdminPatronActionPayload>;
  /** Same as resetCompromisedAccount, but performs bulk action. (PatronResolvers::bulkResetCompromisedAccount) */
  bulkResetCompromisedAccount?: Maybe<ResetCompromisedAccountPayload>;
  /** Same as resetCompromisedAccount, but performs bulk action. Deprecated: use the bulkResetCompromisedAccounts GraphQL subscription instead. (PatronResolvers::bulkResetCompromisedAccountV2) */
  bulkResetCompromisedAccountV2?: Maybe<BulkAdminPatronActionPayload>;
  /** Change publication status to a help menu entry (HelpMenuEntryResolvers::changeHelpMenuEntryPublicationStatus) */
  changeHelpMenuEntryPublicationStatus?: Maybe<HelpMenuEntryEntity>;
  /** DeliveryServiceabilityCheckResolvers::checkDeliveryServiceability */
  checkDeliveryServiceability: DeliveryServiceabilityValidationResult;
  /** BusinessTaxParameterResolvers::clearAvalaraTaxParameter */
  clearAvalaraTaxParameter: Scalars['Boolean']['output'];
  /** Clear patron's gift card balance. (PatronResolvers::clearTockGiftCardBalance) */
  clearTockGiftCardBalance: Scalars['Boolean']['output'];
  /** Clear patron's gift card balance. (PatronResolvers::clearTockGiftCardBalanceV2) */
  clearTockGiftCardBalanceV2?: Maybe<PatronEntity>;
  /** Collect meter data from client to view in Grafana. See https://metrics.dropwizard.io/4.2.0/getting-started.html#meters (MetricsResolvers::collectMeterData) */
  collectMeterData: Scalars['Boolean']['output'];
  /** Collect timer data from client to send to Prometheus and view in Grafana. (MetricsResolvers::collectTimerData) */
  collectTimerData: Scalars['Boolean']['output'];
  /** Create a new accolade type (AccoladeTypeResolvers::createAccoladeType) */
  createAccoladeType?: Maybe<AccoladeTypeEntity>;
  /** Create a new accolade type rating (AccoladeTypeResolvers::createAccoladeTypeRating) */
  createAccoladeTypeRating?: Maybe<AccoladeTypeRatingEntity>;
  /** Create business accolade (BusinessAccoladeResolvers::createBusinessAccolade) */
  createBusinessAccolade?: Maybe<BusinessAccoladeEntity>;
  /** Update the business's content (BusinessContentResolvers::createBusinessContent) */
  createBusinessContent?: Maybe<BusinessContentEntity>;
  /** Create business content entries in bulk (BusinessContentResolvers::createBusinessContentBulk) */
  createBusinessContentBulk: Array<BusinessContentEntity>;
  /** Creates multiple business entitlement sets (BusinessEntitlementSetResolvers::createBusinessEntitlementSets) */
  createBusinessEntitlementSets?: Maybe<CreateBusinessEntitlementSetsPayload>;
  /** Create multiple new business FAQs (BusinessFaqResolvers::createBusinessFaqs) */
  createBusinessFaqs: Array<BusinessFaqEntity>;
  /** Create a new business group (BusinessGroupResolvers::createBusinessGroup) */
  createBusinessGroup?: Maybe<BusinessGroupEntity>;
  /** Create an entitlement set (EntitlementSetResolvers::createEntitlementSet) */
  createEntitlementSet?: Maybe<CreateEntitlementSetPayload>;
  /** Create a new experiment (ExperimentResolvers::createExperiment) */
  createExperiment?: Maybe<ExperimentEntity>;
  /** Create a new feature flag (FeatureResolvers::createFeature) */
  createFeature?: Maybe<FeatureEntity>;
  /** Creates a new friendly Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createFriendlyShippingZone) */
  createFriendlyShippingZone?: Maybe<UpsertShippingZoneResult>;
  /** Create a time range hold for a flex table (TableResolvers::createHold) */
  createHold: Scalars['Boolean']['output'];
  /** Create a new geography (JceHomepageResolvers::createJceHomepageGeography) */
  createJceHomepageGeography?: Maybe<JceHomepageGeographyEntity>;
  /** Create a new homepage ordering entry; it is added to the bottom of the list (JceHomepageResolvers::createJceHomepageOrderingEntry) */
  createJceHomepageOrderingEntry?: Maybe<JceHomepageOrderingEntryEntity>;
  /** Create a new collection within the given geography (JceHomepageResolvers::createJceVenueCollection) */
  createJceVenueCollection?: Maybe<JceVenueCollectionEntity>;
  /** Create a new meta tag (MetaTagResolvers::createMetaTag) */
  createMetaTag?: Maybe<MetaTagEntity>;
  /** Creates and persists a PatronAddressEntity for use as, e.g., a shipping or delivery address, so long as an identical address does not already exist for the patron (PatronResolvers::createPatronAddress) */
  createPatronAddress?: Maybe<PatronAddressEntity>;
  /** Obtain a new payment intent for the purpose of saving a payment card using a payment card element (PaymentCardIntentResolver::createPaymentCardSetupIntent) */
  createPaymentCardSetupIntent?: Maybe<PaymentCardSetupIntent>;
  /** Create a payment subscription plan (PaymentSubscriptionPlanResolvers::createPaymentSubscriptionPlan) */
  createPaymentSubscriptionPlan?: Maybe<CreatePaymentSubscriptionPlanPayload>;
  /** Create a payment subscription plan add-on (PaymentSubscriptionPlanAddonResolvers::createPaymentSubscriptionPlanAddon) */
  createPaymentSubscriptionPlanAddon?: Maybe<CreatePaymentSubscriptionPlanAddonPayload>;
  /** Provides a means to create a new Shipping Configuration for a business. (ShippingConfigurationResolvers::createShippingConfiguration) */
  createShippingConfiguration?: Maybe<ShippingConfigurationEntity>;
  /** Creates a new Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createShippingZone) */
  createShippingZone?: Maybe<ShippingZoneEntity>;
  /** Creates multiple new Shipping Zone for the associated business including associated Shipping States, Options, and Rates. (ShippingZoneResolvers::createShippingZones) */
  createShippingZones: Array<ShippingZoneEntity>;
  /** Add a new Brand for this Shop Business. (ShopBrandResolvers::createShopBrand) */
  createShopBrand?: Maybe<ShopBrandEntity>;
  /** Add a new Shop Business for this business. (ShopBusinessResolvers::createShopBusiness) */
  createShopBusiness?: Maybe<ShopBusinessEntity>;
  /** Creates one or more TaxCategoryEntity. Returns the created entities. (TaxCategoryMutationResolvers::createTaxCategoryEntities) */
  createTaxCategoryEntities: Array<TaxCategoryEntity>;
  /** Generate a new api key for Tock endpoints (TockApiKeyResolvers::createTockApiKey) */
  createTockApiKey?: Maybe<Scalars['String']['output']>;
  /** Creates a new Tock 10 record (TockTenResolvers::createTockTenList) */
  createTockTenList?: Maybe<Scalars['Int']['output']>;
  /** Create a waitlist request for a patron. (WaitlistResolvers::createWaitlist) */
  createWaitlist?: Maybe<CreateWaitlistResponse>;
  /** Create a new wine item owned by this business. (WineItemsResolvers::createWineItem) */
  createWineItem?: Maybe<ItemWineTypeEntity>;
  /** Delete an accolade type (AccoladeTypeResolvers::deleteAccoladeType) */
  deleteAccoladeType: Scalars['Boolean']['output'];
  /** Delete an accolade type rating (AccoladeTypeResolvers::deleteAccoladeTypeRating) */
  deleteAccoladeTypeRating: Scalars['Boolean']['output'];
  /** Delete business accolade (BusinessAccoladeResolvers::deleteBusinessAccolade) */
  deleteBusinessAccolade: Scalars['Boolean']['output'];
  /** Delete business exclusivity program details if present (BusinessResolvers::deleteBusinessExclusivityProgram) */
  deleteBusinessExclusivityProgram: BusinessEntity;
  /** Delete a business FAQ (BusinessFaqResolvers::deleteBusinessFaq) */
  deleteBusinessFaq: Scalars['Boolean']['output'];
  /** Delete an experiment. This cannot be undone. (ExperimentResolvers::deleteExperiment) */
  deleteExperiment: Scalars['Boolean']['output'];
  /** Delete a feature flag. This cannot be undone. (FeatureResolvers::deleteFeature) */
  deleteFeature: Scalars['Boolean']['output'];
  /** Delete patron's waitlist specific request. (WaitlistResolvers::deleteWaitlistRequest) */
  deleteWaitlistRequest: Scalars['Boolean']['output'];
  /** Delete patron's waitlist requests. (WaitlistResolvers::deleteWaitlistRequests) */
  deleteWaitlistRequests: Scalars['Boolean']['output'];
  /** *** Note this is development code and should not be used *** Do internal onboarding for a Shop Business (InternalWineShopOnboardingResolvers::doShopBusinessOnboarding) */
  doShopBusinessOnboarding: Scalars['Boolean']['output'];
  /** Create a new wine item owned by this business, add ShipCompliant information to it, and add it to the specified Brand. Throws an error if the Brand doesn't belong to this business. (WineItemsResolvers::fullyCreateWineItem) */
  fullyCreateWineItem?: Maybe<ItemWineTypeEntity>;
  /** OrderResolvers::hostCancelOrder */
  hostCancelOrder?: Maybe<WorkflowIdentifier>;
  /** Issues a manual invoice for the given business (FinanceBusinessResolvers::issueManualInvoice) */
  issueManualInvoice: Scalars['Boolean']['output'];
  /** Generate a new api key for Tock endpoints (TockWebhookResolvers::manageTockWebhook) */
  manageTockWebhook: Scalars['Boolean']['output'];
  /** Marks a particular invoice as being paid outside of the product (FinanceBusinessResolvers::markInvoiceAsPaidByCheck) */
  markInvoiceAsPaidByCheck: Scalars['Boolean']['output'];
  /** PatronMfaMethodsResolver::mfaInitiateDisablement */
  mfaInitiateDisablement?: Maybe<GraphQluuid>;
  /** PatronMfaMethodsResolver::mfaInitiateSetup */
  mfaInitiateSetup?: Maybe<GraphQluuid>;
  /** PatronMfaMethodsResolver::mfaVerifyDisablement */
  mfaVerifyDisablement?: Maybe<Scalars['Boolean']['output']>;
  /** PatronMfaMethodsResolver::mfaVerifySetup */
  mfaVerifySetup?: Maybe<MfaFactor>;
  /** Pauses a workflow if the pause parameter is true, unpauses if false (ImportResolvers::pauseOrContinueWorkflow) */
  pauseOrContinueWorkflow?: Maybe<ImportResponse>;
  /** Predict estimated wait time based on incoming features and computed values (WaitlistResolvers::predictEstimatedWaitTime) */
  predictEstimatedWaitTime: Scalars['Int']['output'];
  /** RebalanceResolvers::rebalance */
  rebalance?: Maybe<RebalanceExecutionResult>;
  /** Fire a recompute event for every step (ShopOnboardingStateSubscriptionResolvers::recomputeState) */
  recomputeState: Scalars['Boolean']['output'];
  /** Records live waitlist training data for training estimated-wait-time machine learning models (WaitlistResolvers::recordWaitlistFeatureItem) */
  recordWaitlistFeatureItem?: Maybe<WalkInEstimationCompleteFeatures>;
  /** Register a get started click event (ShopOnboardingStateSubscriptionResolvers::registerGetStartedEvent) */
  registerGetStartedEvent: Scalars['Boolean']['output'];
  /** Makes a charge from a Tock credit card to a connected Stripe account for use in reimbursement (FinanceBusinessResolvers::reimburseBusinessThroughStripe) */
  reimburseBusinessThroughStripe?: Maybe<Scalars['String']['output']>;
  /** Remove business tags if present (BusinessResolvers::removeBusinessTagsIfPresent) */
  removeBusinessTagsIfPresent: BusinessEntity;
  /** Removes a communication policy from a ticket type (TicketTypeResolvers::removeCommunicationPolicyFromTicketType) */
  removeCommunicationPolicyFromTicketType?: Maybe<TicketTypeEntity>;
  /** Remove holds from flex table (TableResolvers::removeHolds) */
  removeHolds: Scalars['Boolean']['output'];
  /** Reorder business accolade (BusinessAccoladeResolvers::reorderBusinessAccolades) */
  reorderBusinessAccolades: Array<BusinessAccoladeEntity>;
  /** Request temporary business access (PermissionResolvers::requestBusinessAccess) */
  requestBusinessAccess: Scalars['Boolean']['output'];
  /** Requests permission for a business to sign the service agreement before billing details (FinanceBusinessResolvers::requestSpecialSigningPermission) */
  requestSpecialSigningPermission: Scalars['Boolean']['output'];
  /** Clears the value indicating that verification deposits have been sent so that they will be resent (FinanceBusinessResolvers::resendBankVerificationDeposits) */
  resendBankVerificationDeposits: Scalars['Boolean']['output'];
  /** Resets an account deemed compromised by AMEX security and enables MFA. (PatronResolvers::resetCompromisedAccount) */
  resetCompromisedAccount?: Maybe<ResetCompromisedAccountPayload>;
  /** Resets an account deemed compromised by AMEX security and enables MFA. (PatronResolvers::resetCompromisedAccountV2) */
  resetCompromisedAccountV2?: Maybe<BulkAdminPatronActionPayload>;
  /** Restores table assignments from just before or just after a schedule publish. (RestoreTableAssignmentsResolvers::restoreTablesFromScheduleHistory) */
  restoreTablesFromScheduleHistory: Scalars['Boolean']['output'];
  /** Reverses the given business from the given payout record (FinanceBusinessResolvers::reverseBusinessPayout) */
  reverseBusinessPayout: Scalars['Boolean']['output'];
  /** Voids the invoice for the given id, removing the associated payout entities as well if forcePayoutRemoval is true (FinanceBusinessResolvers::reverseInvoice) */
  reverseInvoice: Scalars['Boolean']['output'];
  /** Send a string to pubsub. Used for debugging (DevNonSubscriptionResolvers::sendString) */
  sendString?: Maybe<Scalars['String']['output']>;
  /** BusinessTaxParameterResolvers::setAvalaraTaxParameter */
  setAvalaraTaxParameter: Scalars['Boolean']['output'];
  /** Sets a bookingpolicy for a tickettype (BookingPolicyResolvers::setBookingPolicyDescriptions) */
  setBookingPolicyDescriptions?: Maybe<TicketTypeEntity>;
  /** RebalanceResolvers::setDefaultMediumScoreOptions */
  setDefaultMediumScoreOptions?: Maybe<BusinessRebalancerDefaultSettingsEntity>;
  /** RebalanceResolvers::setDefaultSoftScoreOptions */
  setDefaultSoftScoreOptions?: Maybe<BusinessRebalancerDefaultSettingsEntity>;
  /** Updates reservation business bcc email eligibility by tag (GuestProfileTagResolvers::setEnabledTagBccReminderEmails) */
  setEnabledTagBccReminderEmails?: Maybe<BusinessEntity>;
  /** Update the ticket types enabled for business bcc'd reminder emails (TicketTypeResolvers::setEnabledTicketTypeBusinessBccReminderEmails) */
  setEnabledTicketTypeBusinessBccReminderEmails?: Maybe<BusinessEntity>;
  /** Set all homepage ordering entries for a given geography, updating, creating, and reordering as needed (JceHomepageResolvers::setJceHomepageOrderingEntriesForGeography) */
  setJceHomepageOrderingEntriesForGeography: Array<JceHomepageOrderingEntryEntity>;
  /** Set all entries for a venue collection. It simply updates any existing rows associated with a collection, deleting any extra (JceHomepageResolvers::setJceVenueCollectionEntriesForCollection) */
  setJceVenueCollectionEntriesForCollection: Array<JceVenueCollectionEntryEntity>;
  /** Sets the tags for Priority Notify, limit 10 (WaitlistResolvers::setNotifyPriorityFactorTags) */
  setNotifyPriorityFactorTags?: Maybe<BusinessWaitlistPriorityFactorEntity>;
  /** Sets the visibility of a Brand (ShopBrandResolvers::setShopBrandVisibility) */
  setShopBrandVisibility?: Maybe<ShopBrandEntity>;
  /** Sets the contact email address for this Shop Business. This is visible to shoppers and is used in emails as a reply-to address. (ShopBusinessResolvers::setShopBusinessEmail) */
  setShopBusinessEmail?: Maybe<ShopBusinessEntity>;
  /** Sets the comma-separated list of email addresses for email notifications for this Shop Business. (ShopBusinessResolvers::setShopBusinessNotificationEmails) */
  setShopBusinessNotificationEmails?: Maybe<ShopBusinessEntity>;
  /** Sets the current subscription for a business to be paid outside of the product (FinanceBusinessResolvers::setSubscriptionToPaidByCheck) */
  setSubscriptionToPaidByCheck: Scalars['Boolean']['output'];
  /** Start a workflow to delete all data associated with the business's last import. Returns the initial status (ImportResolvers::startImportUndo) */
  startImportUndo?: Maybe<ImportUndoStartResponse>;
  /** Send business to the Account Management team so they can approve and activate the business (BusinessResolvers::submitBusinessForApproval) */
  submitBusinessForApproval: BusinessEntity;
  /** Update an accolade type (AccoladeTypeResolvers::updateAccoladeType) */
  updateAccoladeType?: Maybe<AccoladeTypeEntity>;
  /** Update an accolade type rating (AccoladeTypeResolvers::updateAccoladeTypeRating) */
  updateAccoladeTypeRating?: Maybe<AccoladeTypeRatingEntity>;
  /** Internal field used by Finance and Hteam to track additional state of bank verification (FinanceBusinessResolvers::updateBankVerificationStatus) */
  updateBankVerificationStatus: Scalars['Boolean']['output'];
  /** Update basic information about a business (BusinessResolvers::updateBusiness) */
  updateBusiness?: Maybe<BusinessEntity>;
  /** Update business accolade (BusinessAccoladeResolvers::updateBusinessAccolade) */
  updateBusinessAccolade: Array<BusinessAccoladeEntity>;
  /** Update business accolade status (BusinessAccoladeResolvers::updateBusinessAccoladeStatus) */
  updateBusinessAccoladeStatus: Scalars['Boolean']['output'];
  /** Update the city or state for the business (BusinessResolvers::updateBusinessCityState) */
  updateBusinessCityState: BusinessEntity;
  /** Update the business's content (BusinessContentResolvers::updateBusinessContent) */
  updateBusinessContent?: Maybe<BusinessContentEntity>;
  /** Update business exclusivity program details if present (BusinessResolvers::updateBusinessExclusivityProgram) */
  updateBusinessExclusivityProgram: BusinessEntity;
  /** Update multiple business FAQs (BusinessFaqResolvers::updateBusinessFaqs) */
  updateBusinessFaqs: Array<BusinessFaqEntity>;
  /** Update the state of a feature flag for a specific business (FeatureResolvers::updateBusinessFeature) */
  updateBusinessFeature?: Maybe<BusinessFeatureEntity>;
  /** Update the state of a feature flag for a random set of businesses (FeatureResolvers::updateBusinessFeatureRandom) */
  updateBusinessFeatureRandom: Array<BusinessFeatureEntity>;
  /** Update business should filter notification emails by experience (BusinessResolvers::updateBusinessFilterExperienceNotificationEmails) */
  updateBusinessFilterExperienceNotificationEmails?: Maybe<BusinessEntity>;
  /** Update a new business group (BusinessGroupResolvers::updateBusinessGroup) */
  updateBusinessGroup?: Maybe<BusinessGroupEntity>;
  /** Update the location and related fields of the current business (BusinessResolvers::updateBusinessLocation) */
  updateBusinessLocation: BusinessEntity;
  /** Updates a given business payout config (FinanceBusinessResolvers::updateBusinessPayoutConfig) */
  updateBusinessPayoutConfig?: Maybe<BusinessPayoutConfigEntity>;
  /** Migrates single taxes businesses to tax library (BusinessTaxMigratorResolvers::updateBusinessToTaxLibrary) */
  updateBusinessToTaxLibrary?: Maybe<BusinessTaxMigrationPayload>;
  /** Update Currency Code (BusinessResolvers::updateCurrencyCode) */
  updateCurrencyCode: BusinessEntity;
  /** Update an entitlement set (EntitlementSetResolvers::updateEntitlementSet) */
  updateEntitlementSet?: Maybe<UpdateEntitlementSetPayload>;
  /** Internal finance tool used to update the exclusivity of purchase. (FinanceBusinessResolvers::updateExclusivity) */
  updateExclusivity: Scalars['Int']['output'];
  /** Launch or un-launch an experiment (ExperimentResolvers::updateExperimentIsActive) */
  updateExperimentIsActive?: Maybe<ExperimentEntity>;
  /** Update the variant configurations of an existing experiment (ExperimentResolvers::updateExperimentVariants) */
  updateExperimentVariants?: Maybe<ExperimentEntity>;
  /** Globally update the state of an existing feature flag (FeatureResolvers::updateFeature) */
  updateFeature?: Maybe<FeatureEntity>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. All ShippingZoneOptions within the ShippingZone must be a configType FRIENDLY variant. (ShippingZoneResolvers::updateFriendlyShippingZone) */
  updateFriendlyShippingZone?: Maybe<UpsertShippingZoneResult>;
  /** Update Gift Card Provider (BusinessResolvers::updateGiftCardProvider) */
  updateGiftCardProvider: BusinessEntity;
  /** Updates the Google settings for the business in scope noting also the timestamp of any changes (GoogleSettingsResolvers::updateGoogleSettings) */
  updateGoogleSettings?: Maybe<GoogleSettingsEntity>;
  /** Archives all guest profiles with this tag for business (GuestProfileTagResolvers::updateGuestProfileTags) */
  updateGuestProfileTags: Scalars['Boolean']['output'];
  /** Update import status for the given business (BusinessImportResolvers::updateImportStatus) */
  updateImportStatus: Scalars['Boolean']['output'];
  /** Update an existing geography (JceHomepageResolvers::updateJceHomepageGeography) */
  updateJceHomepageGeography?: Maybe<JceHomepageGeographyEntity>;
  /** Update an existing venue collection (JceHomepageResolvers::updateJceVenueCollection) */
  updateJceVenueCollection?: Maybe<JceVenueCollectionEntity>;
  /** TockApiKeyResolvers::updateKeyStatus */
  updateKeyStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Update checkout lock duration minutes for a business (BusinessResolvers::updateLockDuration) */
  updateLockDuration: BusinessEntity;
  /** Update a meta tag (MetaTagResolvers::updateMetaTag) */
  updateMetaTag?: Maybe<MetaTagEntity>;
  /** Updates an existing PatronAddressEntity, so long as the intended updated address does not match an existing address for the patron. (PatronResolvers::updatePatronAddress) */
  updatePatronAddress?: Maybe<PatronAddressEntity>;
  /** Updates the patron's communications opt in with the listed businesses, identified by business id (PatronResolvers::updatePatronCommunicationsOptIn) */
  updatePatronCommunicationsOptIn?: Maybe<PatronEntity>;
  /** Mark patron as eligible for self-onboarding by email address (PatronResolvers::updatePatronSelfOnboardingEligibility) */
  updatePatronSelfOnboardingEligibility: PatronEntity;
  /** Update a payment subscription plan (PaymentSubscriptionPlanResolvers::updatePaymentSubscriptionPlan) */
  updatePaymentSubscriptionPlan?: Maybe<UpdatePaymentSubscriptionPlanPayload>;
  /** Update a payment subscription plan add-on (PaymentSubscriptionPlanAddonResolvers::updatePaymentSubscriptionPlanAddon) */
  updatePaymentSubscriptionPlanAddon?: Maybe<UpdatePaymentSubscriptionPlanAddonPayload>;
  /** Allows Finance to update the payout structure for a business. (FinanceBusinessResolvers::updatePayoutConfigParams) */
  updatePayoutConfigParams?: Maybe<BusinessPayoutConfigParametersEntity>;
  /** Update the tax category for purchasables (TaxPurchasablesResolvers::updatePurchasableTaxCategories) */
  updatePurchasableTaxCategories: Array<Purchasable>;
  /** Update search attribute for a business (BusinessResolvers::updateSearchAttribute) */
  updateSearchAttribute: Scalars['Boolean']['output'];
  /** Updates a shipment to the given status (OrderShipmentResolvers::updateShipmentStatus) */
  updateShipmentStatus?: Maybe<OrderShipmentUpdateEntity>;
  /** Updates a shipment tracking number (OrderShipmentResolvers::updateShipmentTracking) */
  updateShipmentTracking: Array<TrackingInfo>;
  /** Provides a means to update a business's Shipping Configuration. (ShippingConfigurationResolvers::updateShippingConfiguration) */
  updateShippingConfiguration?: Maybe<ShippingConfigurationEntity>;
  /** Updates a Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::updateShippingZone) */
  updateShippingZone?: Maybe<ShippingZoneEntity>;
  /** Updates one or more Shipping Zone and associated States, Options, and Rates. (ShippingZoneResolvers::updateShippingZones) */
  updateShippingZones: Array<ShippingZoneEntity>;
  /** Updates an existing Brand for this business. Throws an error if the Brand doesn't belong to this business. (ShopBrandResolvers::updateShopBrand) */
  updateShopBrand?: Maybe<ShopBrandEntity>;
  /** Updates the properties of an existing ShopBrandStory (ShopBrandResolvers::updateShopBrandStory) */
  updateShopBrandStory?: Maybe<ShopBrandStoryEntity>;
  /** Updates an existing Shop Business for this business. Throws an error if the Shop Business is null, or if it doesn't belong to this business. (ShopBusinessResolvers::updateShopBusiness) */
  updateShopBusiness?: Maybe<ShopBusinessEntity>;
  /** Update boolean status of showCovidSafetyMeasures (BusinessResolvers::updateShowCovidSafetyMeasures) */
  updateShowCovidSafetyMeasures: BusinessEntity;
  /** Updates a set of TaxCategoryEntity. Returns the updated entities. (TaxCategoryMutationResolvers::updateTaxCategoryEntities) */
  updateTaxCategoryEntities: Array<TaxCategoryEntity>;
  /** TockTenResolvers::updateTockTenList */
  updateTockTenList: Scalars['Boolean']['output'];
  /** Update tos signed date (BusinessResolvers::updateTosSignedDate) */
  updateTosSignedDate: Scalars['Boolean']['output'];
  /** Update a waitlist request for a patron. (WaitlistResolvers::updateWaitlist) */
  updateWaitlist?: Maybe<UpdateWaitlistResponse>;
  /** Updates an existing wine item for this business. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::updateWineItem) */
  updateWineItem?: Maybe<ItemWineTypeEntity>;
  /** Upserts a help menu entry (HelpMenuEntryResolvers::upsertHelpMenuEntry) */
  upsertHelpMenuEntry?: Maybe<HelpMenuEntryEntity>;
  /** Update Tock Contact Information (BusinessResolvers::upsertTockContact) */
  upsertTockContact?: Maybe<BusinessTockContactEntity>;
};


/** Mutation root */
export type MutationAddBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
};


/** Mutation root */
export type MutationAddBusinessTagsIfNotPresentArgs = {
  metaTagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationAddEntitlementToEntitlementSetsArgs = {
  input: AddEntitlementToEntitlementSetsInput;
};


/** Mutation root */
export type MutationAddJceVenueCollectionEntryArgs = {
  collectionId: Scalars['Int']['input'];
  entry: JceVenueCollectionEntryInput;
};


/** Mutation root */
export type MutationAddShipCompliantInfoToWineItemArgs = {
  shipCompliantBrandKey?: InputMaybe<Scalars['String']['input']>;
  shipCompliantProductType: ProductType;
  shipCompliantSku: Scalars['String']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationAddSsoLoginDomainArgs = {
  businessGroupId: Scalars['Int']['input'];
  domain: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationAddSsoLoginDomainsToBusinessArgs = {
  businessId: Scalars['Int']['input'];
  domains: Array<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationAddStoryToShopBrandArgs = {
  brandId: Scalars['Int']['input'];
  story: ShopBrandStoryInput;
};


/** Mutation root */
export type MutationAddTicketPriceInformationArgs = {
  partyRangeTicketPriceInformation: Array<PartyRangeTicketPriceInformationPartitionInput>;
  ticketTypeCharges?: InputMaybe<TicketTypeChargesInput>;
  ticketTypeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationAddWineItemToBrandArgs = {
  shopBrandId: Scalars['Int']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationApproveBusinessAccessArgs = {
  approved: Scalars['Boolean']['input'];
  requestId: Scalars['String']['input'];
};


/** Mutation root */
export type MutationApproveSpecialSigningPermissionArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveBusinessEntitlementSetArgs = {
  id: Scalars['ID']['input'];
};


/** Mutation root */
export type MutationArchivePatronAddressArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationArchiveShopBrandArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveShopBusinessArgs = {
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemAndBrandRelationArgs = {
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationArchiveWineItemToBrandArgs = {
  shopBrandId: Scalars['Int']['input'];
  wineItemId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBatchDeleteBusinessFeatureArgs = {
  businessIds: Array<Scalars['Int']['input']>;
  featureId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBatchUpdateBusinessFeatureArgs = {
  businessIds: Array<Scalars['Int']['input']>;
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationBeta_InitiateMultipleOrderExecution_V2Args = {
  inputs: Array<OrderExecutionRequestInput>;
};


/** Mutation root */
export type MutationBeta_InitiateOrderCancellationArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationBeta_InitiateOrderExecution_V2Args = {
  input: OrderExecutionRequestInput;
};


/** Mutation root */
export type MutationBeta_UpdateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationBulkDeletePatronAccountsArgs = {
  deleteReason: DeleteReason;
  emailBehavior: EmailBehavior;
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationBulkResetCompromisedAccountArgs = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationBulkResetCompromisedAccountV2Args = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationChangeHelpMenuEntryPublicationStatusArgs = {
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['Int']['input'];
  publicationStatus: PublicationStatus;
};


/** Mutation root */
export type MutationCheckDeliveryServiceabilityArgs = {
  input: DeliveryServiceabilityCheckInput;
};


/** Mutation root */
export type MutationClearAvalaraTaxParameterArgs = {
  key: AvalaraTaxParameterKey;
};


/** Mutation root */
export type MutationClearTockGiftCardBalanceArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationClearTockGiftCardBalanceV2Args = {
  patronId: Scalars['Int']['input'];
  tockGiftCardBalance: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCollectMeterDataArgs = {
  metricName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCollectTimerDataArgs = {
  durationSeconds: Scalars['Float']['input'];
  metricName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateAccoladeTypeArgs = {
  accoladeType: AccoladeTypeInput;
};


/** Mutation root */
export type MutationCreateAccoladeTypeRatingArgs = {
  accoladeTypeRating: AccoladeTypeRatingInput;
};


/** Mutation root */
export type MutationCreateBusinessAccoladeArgs = {
  businessAccolade: BusinessAccoladeInput;
};


/** Mutation root */
export type MutationCreateBusinessContentArgs = {
  businessContent?: InputMaybe<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationCreateBusinessContentBulkArgs = {
  businessContents: Array<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationCreateBusinessEntitlementSetsArgs = {
  input: CreateBusinessEntitlementSetsInput;
};


/** Mutation root */
export type MutationCreateBusinessFaqsArgs = {
  faqs: Array<BusinessFaqInput>;
};


/** Mutation root */
export type MutationCreateBusinessGroupArgs = {
  businessGroup: BusinessGroupInput;
};


/** Mutation root */
export type MutationCreateEntitlementSetArgs = {
  input: CreateEntitlementSetInput;
};


/** Mutation root */
export type MutationCreateExperimentArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** Mutation root */
export type MutationCreateFeatureArgs = {
  canonicalType?: InputMaybe<FeatureType>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state: FeatureState;
};


/** Mutation root */
export type MutationCreateFriendlyShippingZoneArgs = {
  input: ShippingZoneInfoInput;
};


/** Mutation root */
export type MutationCreateHoldArgs = {
  endDateTime: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  tableId: Scalars['Int']['input'];
  ticketGroupId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCreateJceHomepageGeographyArgs = {
  geography: JceHomepageGeographyInput;
};


/** Mutation root */
export type MutationCreateJceHomepageOrderingEntryArgs = {
  homepageOrderingEntry: JceHomepageOrderingEntryInput;
};


/** Mutation root */
export type MutationCreateJceVenueCollectionArgs = {
  collection: JceVenueCollectionInput;
  geographyId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationCreateMetaTagArgs = {
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  tagBusinesses: Array<Scalars['Int']['input']>;
  tagExperiences: Array<Scalars['Int']['input']>;
  type: TagType;
};


/** Mutation root */
export type MutationCreatePatronAddressArgs = {
  input: AddPatronAddressInput;
};


/** Mutation root */
export type MutationCreatePaymentSubscriptionPlanArgs = {
  input: CreatePaymentSubscriptionPlanInput;
};


/** Mutation root */
export type MutationCreatePaymentSubscriptionPlanAddonArgs = {
  input: CreatePaymentSubscriptionPlanAddonInput;
};


/** Mutation root */
export type MutationCreateShippingConfigurationArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfiguration: ShippingConfigurationInput;
};


/** Mutation root */
export type MutationCreateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationCreateShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationCreateShopBrandArgs = {
  businessId: Scalars['Int']['input'];
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationCreateShopBusinessArgs = {
  businessId: Scalars['Int']['input'];
  shopBusiness: ShopBusinessInput;
};


/** Mutation root */
export type MutationCreateTaxCategoryEntitiesArgs = {
  taxCategories: Array<TaxCategoryInput>;
};


/** Mutation root */
export type MutationCreateTockApiKeyArgs = {
  tockApiKeyGenerationRequest: TockApiKeyGenerationRequestInput;
};


/** Mutation root */
export type MutationCreateTockTenListArgs = {
  tockTen: TockTenInput;
};


/** Mutation root */
export type MutationCreateWaitlistArgs = {
  desiredSize: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  guestNote: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  ticketTypeId?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationCreateWineItemArgs = {
  details: WineItemDetailsInput;
};


/** Mutation root */
export type MutationDeleteAccoladeTypeArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteAccoladeTypeRatingArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteBusinessAccoladeArgs = {
  businessAccoladeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
};


/** Mutation root */
export type MutationDeleteBusinessFaqArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteExperimentArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteFeatureArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDeleteWaitlistRequestArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationDoShopBusinessOnboardingArgs = {
  businessId: Scalars['Int']['input'];
  overwritePreviousOnboarding: Scalars['Boolean']['input'];
  shipCompliantItems: Array<ShipCompliantItemInput>;
  shippingConfiguration: ShippingConfigurationInput;
  shippingZones: Array<ShippingZoneInput>;
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationFullyCreateWineItemArgs = {
  fullWineItemDetails: WineItemFullDetailsInput;
};


/** Mutation root */
export type MutationHostCancelOrderArgs = {
  amountToRefundCents?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  request: OrderPriceCalculationRequestInput;
};


/** Mutation root */
export type MutationIssueManualInvoiceArgs = {
  manualInvoiceRequest: ManualInvoiceRequestInput;
};


/** Mutation root */
export type MutationManageTockWebhookArgs = {
  manageTockWebhookRequest?: InputMaybe<ManageTockWebhookRequestInput>;
};


/** Mutation root */
export type MutationMarkInvoiceAsPaidByCheckArgs = {
  invoiceId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationMfaVerifyDisablementArgs = {
  mfaCode: Scalars['String']['input'];
  otpSessionUuid: Scalars['UUID']['input'];
};


/** Mutation root */
export type MutationMfaVerifySetupArgs = {
  mfaCode: Scalars['String']['input'];
  otpSessionUuid: Scalars['UUID']['input'];
};


/** Mutation root */
export type MutationPauseOrContinueWorkflowArgs = {
  businessId: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationPredictEstimatedWaitTimeArgs = {
  item: WalkinPredictIncomingFeaturesInput;
};


/** Mutation root */
export type MutationRebalanceArgs = {
  rebalanceRequest: RebalanceRequestInput;
};


/** Mutation root */
export type MutationRecordWaitlistFeatureItemArgs = {
  item: WalkInEstimationIncomingFeaturesInput;
};


/** Mutation root */
export type MutationReimburseBusinessThroughStripeArgs = {
  amountCents: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  creditCardId: Scalars['String']['input'];
  description: Scalars['String']['input'];
};


/** Mutation root */
export type MutationRemoveBusinessTagsIfPresentArgs = {
  metaTagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationRemoveCommunicationPolicyFromTicketTypeArgs = {
  ticketTypeId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationRemoveHoldsArgs = {
  serviceDate: Scalars['String']['input'];
  tableId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationReorderBusinessAccoladesArgs = {
  businessAccolades: Array<BusinessAccoladeInput>;
};


/** Mutation root */
export type MutationRequestBusinessAccessArgs = {
  business: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
  role: BusinessRole;
};


/** Mutation root */
export type MutationRequestSpecialSigningPermissionArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResendBankVerificationDepositsArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResetCompromisedAccountArgs = {
  patronId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationResetCompromisedAccountV2Args = {
  patronId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation root */
export type MutationRestoreTablesFromScheduleHistoryArgs = {
  fromBefore: Scalars['Boolean']['input'];
  historyId: Scalars['Int']['input'];
  restoreToday: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationReverseBusinessPayoutArgs = {
  businessId: Scalars['Int']['input'];
  payoutId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationReverseInvoiceArgs = {
  forcePayoutRemoval: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSendStringArgs = {
  str: Scalars['String']['input'];
  topic: Scalars['String']['input'];
};


/** Mutation root */
export type MutationSetAvalaraTaxParameterArgs = {
  key: AvalaraTaxParameterKey;
  value: Scalars['String']['input'];
};


/** Mutation root */
export type MutationSetBookingPolicyDescriptionsArgs = {
  customPolicyText?: InputMaybe<Scalars['String']['input']>;
  editOrCancelDescription: DescriptionInput;
  rescheduleDescription: DescriptionInput;
  ticketTypeId: Scalars['Int']['input'];
  transferDescription: DescriptionInput;
  useBusinessDefault: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationSetDefaultMediumScoreOptionsArgs = {
  mediumScoreOptions: MediumScoreOptionsInput;
};


/** Mutation root */
export type MutationSetDefaultSoftScoreOptionsArgs = {
  softScoreOptions: SoftScoreOptionsInput;
};


/** Mutation root */
export type MutationSetEnabledTagBccReminderEmailsArgs = {
  tagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetEnabledTicketTypeBusinessBccReminderEmailsArgs = {
  ticketTypeIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetJceHomepageOrderingEntriesForGeographyArgs = {
  geographyId: Scalars['Int']['input'];
  orderingEntries: Array<JceHomepageOrderingEntryInput>;
};


/** Mutation root */
export type MutationSetJceVenueCollectionEntriesForCollectionArgs = {
  collectionId: Scalars['Int']['input'];
  entries: Array<JceVenueCollectionEntryInput>;
};


/** Mutation root */
export type MutationSetNotifyPriorityFactorTagsArgs = {
  tagIds: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetShopBrandVisibilityArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  isVisible: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationSetShopBusinessEmailArgs = {
  emailAddress: Scalars['String']['input'];
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSetShopBusinessNotificationEmailsArgs = {
  emailAddresses: Scalars['String']['input'];
  shopBusinessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationSetSubscriptionToPaidByCheckArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationStartImportUndoArgs = {
  businessId: Scalars['Int']['input'];
  importUuid: Scalars['UUID']['input'];
  maxConcurrentTasks?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateAccoladeTypeArgs = {
  accoladeType: AccoladeTypeInput;
};


/** Mutation root */
export type MutationUpdateAccoladeTypeRatingArgs = {
  accoladeTypeRating: AccoladeTypeRatingInput;
};


/** Mutation root */
export type MutationUpdateBankVerificationStatusArgs = {
  bankVerificationStatus?: InputMaybe<VerificationStatus>;
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessArgs = {
  input: UpdateBusinessInput;
};


/** Mutation root */
export type MutationUpdateBusinessAccoladeArgs = {
  businessAccolade: BusinessAccoladeInput;
};


/** Mutation root */
export type MutationUpdateBusinessAccoladeStatusArgs = {
  businessAccoladeId: Scalars['Int']['input'];
  ordering: Scalars['Int']['input'];
  status: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessCityStateArgs = {
  businessId: Scalars['Int']['input'];
  input: UpdateBusinessLocationInput;
};


/** Mutation root */
export type MutationUpdateBusinessContentArgs = {
  businessContent?: InputMaybe<UpdateBusinessContentInput>;
};


/** Mutation root */
export type MutationUpdateBusinessExclusivityProgramArgs = {
  businessId: Scalars['Int']['input'];
  exclusivity: Exclusivity;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdateBusinessFaqsArgs = {
  faqs: Array<UpdateBusinessFaqInput>;
};


/** Mutation root */
export type MutationUpdateBusinessFeatureArgs = {
  businessId: Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationUpdateBusinessFeatureRandomArgs = {
  count: Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
};


/** Mutation root */
export type MutationUpdateBusinessFilterExperienceNotificationEmailsArgs = {
  shouldFilterByExperience: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateBusinessGroupArgs = {
  businessGroup: BusinessGroupInput;
};


/** Mutation root */
export type MutationUpdateBusinessLocationArgs = {
  input: UpdateBusinessLocationInput;
};


/** Mutation root */
export type MutationUpdateBusinessPayoutConfigArgs = {
  businessPayoutConfig: BusinessPayoutConfigInput;
};


/** Mutation root */
export type MutationUpdateBusinessToTaxLibraryArgs = {
  businessId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateCurrencyCodeArgs = {
  businessId: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateEntitlementSetArgs = {
  input: UpdateEntitlementSetInput;
};


/** Mutation root */
export type MutationUpdateExclusivityArgs = {
  exclusivity: Exclusivity;
  purchaseConfirmationCodes: Array<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationUpdateExperimentIsActiveArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateExperimentVariantsArgs = {
  experimentVariants: Array<ExperimentVariantInput>;
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateFeatureArgs = {
  clearOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  state: FeatureState;
};


/** Mutation root */
export type MutationUpdateFriendlyShippingZoneArgs = {
  input: ShippingZoneInfoInput;
};


/** Mutation root */
export type MutationUpdateGiftCardProviderArgs = {
  businessId: Scalars['Int']['input'];
  giftCardProvider: GiftCardProvider;
};


/** Mutation root */
export type MutationUpdateGoogleSettingsArgs = {
  googleSettings: UpdateGoogleSettingsInput;
};


/** Mutation root */
export type MutationUpdateGuestProfileTagsArgs = {
  businessId: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateImportStatusArgs = {
  id: Scalars['Int']['input'];
  importStatus: ImportStatus;
};


/** Mutation root */
export type MutationUpdateJceHomepageGeographyArgs = {
  geography: JceHomepageGeographyInput;
};


/** Mutation root */
export type MutationUpdateJceVenueCollectionArgs = {
  collection: JceVenueCollectionInput;
};


/** Mutation root */
export type MutationUpdateKeyStatusArgs = {
  isEnabled: Scalars['Boolean']['input'];
  keyUUID: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdateLockDurationArgs = {
  businessId: Scalars['Int']['input'];
  lockDuration: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateMetaTagArgs = {
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  removeExperiences: Array<Scalars['Int']['input']>;
  removeTagBusinesses: Array<Scalars['Int']['input']>;
  tagBusinesses: Array<Scalars['Int']['input']>;
  tagExperiences: Array<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationUpdatePatronAddressArgs = {
  input: UpdatePatronAddressInput;
};


/** Mutation root */
export type MutationUpdatePatronCommunicationsOptInArgs = {
  input: UpdatePatronCommunicationsOptInInput;
};


/** Mutation root */
export type MutationUpdatePatronSelfOnboardingEligibilityArgs = {
  eligibilityStatus: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
};


/** Mutation root */
export type MutationUpdatePaymentSubscriptionPlanArgs = {
  input: UpdatePaymentSubscriptionPlanInput;
};


/** Mutation root */
export type MutationUpdatePaymentSubscriptionPlanAddonArgs = {
  input: UpdatePaymentSubscriptionPlanAddonInput;
};


/** Mutation root */
export type MutationUpdatePayoutConfigParamsArgs = {
  businessId: Scalars['Int']['input'];
  updatePayoutConfigParams: UpdatePayoutConfigParamsInput;
};


/** Mutation root */
export type MutationUpdatePurchasableTaxCategoriesArgs = {
  purchasableIds: Array<PurchasableIdInput>;
  taxCategoryId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateSearchAttributeArgs = {
  businessId: Scalars['Int']['input'];
  searchAttribute: SearchAttributeInput;
};


/** Mutation root */
export type MutationUpdateShipmentStatusArgs = {
  sendStatusUpdateEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shipmentId: Scalars['Int']['input'];
  status: TockShipmentStatus;
  trackingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Mutation root */
export type MutationUpdateShipmentTrackingArgs = {
  shipmentId: Scalars['Int']['input'];
  trackingNumbers: Array<Scalars['String']['input']>;
};


/** Mutation root */
export type MutationUpdateShippingConfigurationArgs = {
  businessId: Scalars['Int']['input'];
  shippingConfiguration: ShippingConfigurationInput;
};


/** Mutation root */
export type MutationUpdateShippingZoneArgs = {
  businessId: Scalars['Int']['input'];
  shippingZone: ShippingZoneInput;
};


/** Mutation root */
export type MutationUpdateShippingZonesArgs = {
  businessId: Scalars['Int']['input'];
  shippingZones: Array<ShippingZoneInput>;
};


/** Mutation root */
export type MutationUpdateShopBrandArgs = {
  businessId: Scalars['Int']['input'];
  shopBrand: ShopBrandInput;
};


/** Mutation root */
export type MutationUpdateShopBrandStoryArgs = {
  brandId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  story: ShopBrandStoryInput;
};


/** Mutation root */
export type MutationUpdateShopBusinessArgs = {
  businessId: Scalars['Int']['input'];
  shopBusiness: ShopBusinessInput;
};


/** Mutation root */
export type MutationUpdateShowCovidSafetyMeasuresArgs = {
  status: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateTaxCategoryEntitiesArgs = {
  taxCategories: Array<TaxCategoryInput>;
};


/** Mutation root */
export type MutationUpdateTockTenListArgs = {
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
  isDeleted: Scalars['Boolean']['input'];
};


/** Mutation root */
export type MutationUpdateTosSignedDateArgs = {
  businessId: Scalars['Int']['input'];
  tosSignedDate: Scalars['LocalDate']['input'];
};


/** Mutation root */
export type MutationUpdateWaitlistArgs = {
  desiredSize: Scalars['Int']['input'];
  endDateTime: Scalars['String']['input'];
  guestNote: Scalars['String']['input'];
  startDateTime: Scalars['String']['input'];
  ticketTypeId?: InputMaybe<Scalars['Int']['input']>;
  waitlistId: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpdateWineItemArgs = {
  details: WineItemDetailsInput;
  id: Scalars['Int']['input'];
};


/** Mutation root */
export type MutationUpsertHelpMenuEntryArgs = {
  entry: UpsertHelpMenuInput;
};


/** Mutation root */
export type MutationUpsertTockContactArgs = {
  tockContact: UpsertTockContactInput;
};

export type NoOfferingsAction = AvailabilityAction & {
  __typename?: 'NoOfferingsAction';
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

/** An object with an ID */
export type Node = {
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

export const NoteType = {
  Dietary: 'DIETARY',
  General: 'GENERAL'
} as const;

export type NoteType = typeof NoteType[keyof typeof NoteType];
export type NotifyPartyDetails = {
  __typename?: 'NotifyPartyDetails';
  /** NotifyPartyDetails::createdAt */
  createdAt?: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::dates */
  dates: Array<Scalars['LocalDate']['output']>;
  /** NotifyPartyDetails::desiredPartySize */
  desiredPartySize?: Maybe<Scalars['Int']['output']>;
  /** NotifyPartyDetails::endTime */
  endTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::eventHistory */
  eventHistory: Array<WaitlistEvent>;
  /** NotifyPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** NotifyPartyDetails::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** NotifyPartyDetails::patron */
  patron?: Maybe<PatronEntity>;
  /** NotifyPartyDetails::startTime */
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** NotifyPartyDetails::state */
  state?: Maybe<State>;
  /** NotifyPartyDetails::ticketType */
  ticketType?: Maybe<TicketTypeEntity>;
};

export type NthWeekday = {
  __typename?: 'NthWeekday';
  /** NthWeekday::nthOccurrence */
  nthOccurrence: Scalars['Int']['output'];
  /** NthWeekday::weekday */
  weekday?: Maybe<Weekday>;
};

export type Offering = {
  __typename?: 'Offering';
  /** Offering::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Offering::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export const OfferingType = {
  DineIn: 'DINE_IN',
  Event: 'EVENT',
  ToG0: 'TO_G0'
} as const;

export type OfferingType = typeof OfferingType[keyof typeof OfferingType];
export const OnboardingState = {
  Completed: 'COMPLETED',
  Invalid: 'INVALID',
  NotStarted: 'NOT_STARTED'
} as const;

export type OnboardingState = typeof OnboardingState[keyof typeof OnboardingState];
export const OnboardingStep = {
  BrandCreated: 'BRAND_CREATED',
  GetStarted: 'GET_STARTED',
  ItemCreated: 'ITEM_CREATED',
  Published: 'PUBLISHED',
  ScConnected: 'SC_CONNECTED',
  ShippingSet: 'SHIPPING_SET',
  TosSigned: 'TOS_SIGNED'
} as const;

export type OnboardingStep = typeof OnboardingStep[keyof typeof OnboardingStep];
export type Option = {
  __typename?: 'Option';
  /** Option::id */
  id: Scalars['Int']['output'];
  /** Option::value */
  value?: Maybe<Scalars['String']['output']>;
};

export type OptionsQuestion = ReservationQuestion & {
  __typename?: 'OptionsQuestion';
  /** OptionsQuestion::additionalQuestion */
  additionalQuestion?: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::additionalResponse */
  additionalResponse?: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::availableOptions */
  availableOptions?: Maybe<AvailableOptions>;
  /** OptionsQuestion::name */
  name?: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::question */
  question?: Maybe<Scalars['String']['output']>;
  /** OptionsQuestion::responses */
  responses: Array<Scalars['String']['output']>;
};

export const OptionsType = {
  Checkboxes: 'CHECKBOXES',
  RadioButton: 'RADIO_BUTTON'
} as const;

export type OptionsType = typeof OptionsType[keyof typeof OptionsType];
export type OrderCartDiscountInput = {
  amountCents: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCartInput = {
  businessId: Scalars['Int']['input'];
  discounts?: InputMaybe<Array<OrderCartDiscountInput>>;
  items?: InputMaybe<Array<OrderCartItemInput>>;
};

export type OrderCartItemInput = {
  itemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderDiscountEntity = {
  __typename?: 'OrderDiscountEntity';
  /** OrderDiscountEntity_Generated::getAmountCents */
  amountCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderDiscountEntity_Generated::getDescription */
  description: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderEntity = {
  __typename?: 'OrderEntity';
  /** OrderEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** OrderEntity_Generated::getBuyerPatron */
  buyerPatron: PatronEntity;
  /** OrderEntity_Generated::getComplianceOwnerContactInfo */
  complianceOwnerContactInfo?: Maybe<ContactInfoEntity>;
  /** OrderEntity_Generated::getConfirmationCode */
  confirmationCode?: Maybe<Scalars['String']['output']>;
  /** OrderEntity::getConfirmationCodeWithFallback */
  confirmationCodeWithFallback: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderEntity::getFirstPayment */
  firstPayment: PaymentEntity;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderEntity_Generated::getIsCancelled */
  isCancelled: Scalars['Boolean']['output'];
  /** Returns the shipping address related to the order. (OrderShipmentResolvers::getOrderDeliveryLocation) */
  orderDeliveryLocation?: Maybe<LocationEntity>;
  /** OrderEntity_Generated::getOrderDiscounts */
  orderDiscounts: Array<OrderDiscountEntity>;
  /** Returns the payment methods related to the order. (OrderDetailsResolvers::getOrderPayments) */
  orderPayments: Array<PaymentEntity>;
  /** OrderEntity_Generated::getOrderedItems */
  orderedItems: Array<OrderItemEntity>;
  /** OrderEntity_Generated::getPayments */
  payments: Array<PaymentEntity>;
  /** Returns the receipt lines related to the order. (OrderDetailsResolvers::getReceiptLines) */
  receiptLines: Array<Array<OrderReceiptLine>>;
  /** OrderEntity_Generated::getShipmentFees */
  shipmentFees: Array<OrderShipmentFeeEntity>;
  /** OrderEntity::getShipments */
  shipments: Array<OrderShipmentEntity>;
  /** Returns the TockShipmentStatus related to the order. (OrderShipmentResolvers::getStatus) */
  status?: Maybe<TockShipmentStatus>;
  /** OrderEntity_Generated::getSubtotalCents */
  subtotalCents: Scalars['Int']['output'];
  /** OrderEntity_Generated::getTotalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** Returns a list of tracking information objects (containing tracking number and URL) for the shipment related to the order. (OrderShipmentResolvers::getTracking) */
  tracking: Array<TrackingInfo>;
  /** Returns a list of tracking numbers for the shipment related to the order. (OrderShipmentResolvers::getTrackingInfo) */
  trackingInfo: Array<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

/** A connection to a list of items. */
export type OrderEntityConnection = {
  __typename?: 'OrderEntityConnection';
  /** a list of edges */
  edges?: Maybe<Array<Maybe<OrderEntityEdge>>>;
  /** The total number of pages (PaginatedResponse::getPageCount) */
  pageCount: Scalars['Int']['output'];
  /** The current page, 0-indexed (PaginatedResponse::getPageIndex) */
  pageIndex: Scalars['Int']['output'];
  /** details about this specific page */
  pageInfo: PageInfo;
  /** The human-readable page number, 1-indexed. Useful for showing 'Page 2 of 15'. (PaginatedResponse::getPageNumber) */
  pageNumber: Scalars['Int']['output'];
  /** The total number of items across all pages (PaginatedResponse::getTotalCount) */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection */
export type OrderEntityEdge = {
  __typename?: 'OrderEntityEdge';
  /** cursor marks a unique position or index into the connection */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OrderEntity>;
};

export type OrderExecutionRequestInput = {
  lastSeenPriceCents: Scalars['Int']['input'];
  paymentCardId?: InputMaybe<Scalars['Int']['input']>;
  paymentSelections?: InputMaybe<PaymentSelectionsInput>;
  priceCalculationRequest?: InputMaybe<OrderPriceCalculationRequestInput>;
};

export type OrderExecutionResponse = {
  __typename?: 'OrderExecutionResponse';
  /** OrderExecutionResponse::orderEntity */
  orderEntity?: Maybe<OrderEntity>;
  /** OrderExecutionResponse::result */
  result: ResultType;
};

export type OrderItemEntity = Taxable & {
  __typename?: 'OrderItemEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderItemEntity_Generated::getItem */
  item: MenuItemEntity;
  /** OrderItemEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderItemEntity_Generated::getPerUnitPriceCents */
  perUnitPriceCents: Scalars['Int']['output'];
  /** OrderItemEntity_Generated::getQuantityPurchased */
  quantityPurchased: Scalars['Int']['output'];
  /** OrderDetailsResolvers::getShopItem */
  shopItem?: Maybe<ShopItem>;
  /** OrderItemEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderItemTaxEntity = Tax & {
  __typename?: 'OrderItemTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export type OrderPriceCalculationRequestInput = {
  buyerPatronId?: InputMaybe<Scalars['Int']['input']>;
  cart?: InputMaybe<OrderCartInput>;
  deliveryInfo?: InputMaybe<DeliveryInfoInput>;
  previousOrderId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderPriceCalculationResponse = {
  __typename?: 'OrderPriceCalculationResponse';
  /** OrderPriceCalculationResponse::businessId */
  businessId: Scalars['Int']['output'];
  /** OrderPriceCalculationResponse::receiptLines */
  receiptLines: Array<Array<OrderReceiptLine>>;
  /** OrderPriceCalculationResponse::totalPriceCents */
  totalPriceCents: Scalars['Int']['output'];
  /** OrderPriceCalculationResponse::validationWarnings */
  validationWarnings: Array<OrderPriceCalculationValidationWarning>;
};

export type OrderPriceCalculationValidationWarning = {
  __typename?: 'OrderPriceCalculationValidationWarning';
  /** OrderPriceCalculationValidationWarning::message */
  message: Scalars['String']['output'];
  /** OrderPriceCalculationValidationWarning::type */
  type: OrderPriceCalculationValidationWarningType;
};

export const OrderPriceCalculationValidationWarningType = {
  IncompleteDestinationAddress: 'INCOMPLETE_DESTINATION_ADDRESS',
  IncompleteRecipientName: 'INCOMPLETE_RECIPIENT_NAME',
  ItemInventoryLimitExceeded: 'ITEM_INVENTORY_LIMIT_EXCEEDED',
  MissingRecipientDob: 'MISSING_RECIPIENT_DOB',
  MissingShippingOption: 'MISSING_SHIPPING_OPTION',
  ShippingDestinationNotAllowed: 'SHIPPING_DESTINATION_NOT_ALLOWED',
  ThirdPartyShippingValidation: 'THIRD_PARTY_SHIPPING_VALIDATION'
} as const;

export type OrderPriceCalculationValidationWarningType = typeof OrderPriceCalculationValidationWarningType[keyof typeof OrderPriceCalculationValidationWarningType];
export type OrderReceiptLine = {
  __typename?: 'OrderReceiptLine';
  /** OrderReceiptLine::lineItemName */
  lineItemName?: Maybe<Scalars['String']['output']>;
  /** OrderReceiptLine::priceCents */
  priceCents: Scalars['Int']['output'];
  /** OrderReceiptLine::status */
  status?: Maybe<OrderReceiptLineStatus>;
};

export const OrderReceiptLineStatus = {
  Bold: 'BOLD',
  Default: 'DEFAULT',
  Success: 'SUCCESS'
} as const;

export type OrderReceiptLineStatus = typeof OrderReceiptLineStatus[keyof typeof OrderReceiptLineStatus];
export type OrderShipmentEntity = {
  __typename?: 'OrderShipmentEntity';
  /** OrderShipmentEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentEntity_Generated::getCurrentOrder */
  currentOrder: OrderEntity;
  /** OrderShipmentEntity::getEstimatedDeliveryDate */
  estimatedDeliveryDate?: Maybe<Scalars['Instant']['output']>;
  /** OrderShipmentEntity_Generated::getGiftNote */
  giftNote?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentEntity_Generated::getLocation */
  location: LocationEntity;
  /** OrderShipmentEntity_Generated::getOriginalOrder */
  originalOrder: OrderEntity;
  /** OrderShipmentEntity_Generated::getRecipientContactInfo */
  recipientContactInfo?: Maybe<ContactInfoEntity>;
  /** OrderShipmentEntity_Generated::getShipmentUpdates */
  shipmentUpdates: Array<OrderShipmentUpdateEntity>;
  /** OrderShipmentEntity::isShippingCommunicationEnabled */
  shippingCommunicationEnabled: Scalars['Boolean']['output'];
  /** OrderShipmentEntity_Generated::getOrderShipmentShippingZoneOption */
  shippingZoneOption?: Maybe<OrderShipmentShippingZoneOptionEntity>;
  /** OrderShipmentEntity_Generated::getShippingZoneOptionName */
  shippingZoneOptionName?: Maybe<Scalars['String']['output']>;
  /** OrderShipmentEntity_Generated::getThirdPartyKey */
  thirdPartyKey: Scalars['String']['output'];
  /** OrderShipmentEntity_Generated::getThirdPartyProvider */
  thirdPartyProvider: ThirdPartyOrderProvider;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderShipmentFeeEntity = Taxable & {
  __typename?: 'OrderShipmentFeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentFeeEntity_Generated::getFeeCents */
  feeCents: Scalars['Int']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentFeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderShipmentFeeEntity_Generated::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderShipmentFeeTaxEntity = Tax & {
  __typename?: 'OrderShipmentFeeTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export type OrderShipmentShippingZoneOptionEntity = {
  __typename?: 'OrderShipmentShippingZoneOptionEntity';
  /** OrderShipmentShippingZoneOptionEntity_Generated::getCarrier */
  carrier: Scalars['String']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getCode */
  code: Scalars['String']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getEstimatedShippingDays */
  estimatedShippingDays?: Maybe<Scalars['Int']['output']>;
  /** OrderShipmentShippingZoneOptionEntity_Generated::getFulfillmentAccount */
  fulfillmentAccount?: Maybe<Scalars['String']['output']>;
  /** OrderShipmentShippingZoneOptionEntity_Generated::getFulfillmentWarehouse */
  fulfillmentWarehouse: FulfillmentWarehouse;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderShipmentShippingZoneOptionEntity_Generated::getService */
  service: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderShipmentShippingZoneOptionEntity::getWarehouseLabel */
  warehouseLabel?: Maybe<Scalars['String']['output']>;
};

export type OrderShipmentUpdateEntity = {
  __typename?: 'OrderShipmentUpdateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** OrderShipmentUpdateEntity::getFormattedStatus */
  formattedStatus?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderShipmentUpdateEntity_Generated::getOrderShipment */
  orderShipment: OrderShipmentEntity;
  /** OrderShipmentUpdateEntity_Generated::getStatus */
  status: TockShipmentStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type OrderTaxEntity = Tax & {
  __typename?: 'OrderTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** OrderTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** OrderTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** OrderTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** OrderTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** OrderTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** OrderTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export type OrderWineItem = {
  __typename?: 'OrderWineItem';
  /** OrderWineItem::item */
  item: ItemWineTypeEntity;
  /** OrderWineItem::orderItemTaxes */
  orderItemTaxes: Array<OrderItemTaxEntity>;
  /** OrderWineItem::perUnitPriceCents */
  perUnitPriceCents: Scalars['Int']['output'];
  /** OrderWineItem::quantityPurchased */
  quantityPurchased: Scalars['Int']['output'];
};

export type OrderingEntriesAndUnorderedCollections = {
  __typename?: 'OrderingEntriesAndUnorderedCollections';
  /** OrderingEntriesAndUnorderedCollections::orderingEntries */
  orderingEntries: Array<JceHomepageOrderingEntryEntity>;
  /** OrderingEntriesAndUnorderedCollections::unorderedCollections */
  unorderedCollections: Array<JceVenueCollectionEntity>;
};

export const OriginatedAt = {
  AnswerQuestionAdmin: 'ANSWER_QUESTION_ADMIN',
  ChangeDinerAdmin: 'CHANGE_DINER_ADMIN',
  Consumer: 'CONSUMER',
  ConsumerChaseUr: 'CONSUMER_CHASE_UR',
  ConsumerPackage: 'CONSUMER_PACKAGE',
  ConsumerReserveWithGoogleRedirect: 'CONSUMER_RESERVE_WITH_GOOGLE_REDIRECT',
  ConsumerResyRedirect: 'CONSUMER_RESY_REDIRECT',
  DeliveryService: 'DELIVERY_SERVICE',
  EditQuestionAdmin: 'EDIT_QUESTION_ADMIN',
  ExecuteHold: 'EXECUTE_HOLD',
  HandsellAdmin: 'HANDSELL_ADMIN',
  HandsellEmail: 'HANDSELL_EMAIL',
  HandsellEmailConcierge: 'HANDSELL_EMAIL_CONCIERGE',
  HandsellSms: 'HANDSELL_SMS',
  Import: 'IMPORT',
  QuestionSubmit: 'QUESTION_SUBMIT',
  RescheduleAdmin: 'RESCHEDULE_ADMIN',
  RescheduleConsumer: 'RESCHEDULE_CONSUMER',
  ReserveWithGoogle: 'RESERVE_WITH_GOOGLE',
  Transfer: 'TRANSFER',
  TransferAdmin: 'TRANSFER_ADMIN',
  TripleseatEvent: 'TRIPLESEAT_EVENT',
  VisitEdit: 'VISIT_EDIT',
  VisitEditDashboard: 'VISIT_EDIT_DASHBOARD'
} as const;

export type OriginatedAt = typeof OriginatedAt[keyof typeof OriginatedAt];
export type PacingBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'PacingBlock';
  /** PacingBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** PacingBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Party = Node & {
  __typename?: 'Party';
  /** Party::firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Party::id */
  id: Scalars['ID']['output'];
  /** Party::lastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Party::primaryState */
  primaryState?: Maybe<PartyState>;
  /** Party::secondaryState */
  secondaryState?: Maybe<Scalars['String']['output']>;
  /** Party::size */
  size: Scalars['Int']['output'];
};

export type PartyDetails = {
  __typename?: 'PartyDetails';
  /** PartyDetails::addOns */
  addOns: Array<SlimPurchasedOption>;
  /** PartyDetails::amountDueCents */
  amountDueCents?: Maybe<Scalars['Float']['output']>;
  /** PartyDetails::arrivalTime */
  arrivalTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::bookingNotes */
  bookingNotes: Array<BookingNoteEntity>;
  /** PartyDetails::confirmationCode */
  confirmationCode?: Maybe<Scalars['String']['output']>;
  /** PartyDetails::expectedTurnTimeForTicketType */
  expectedTurnTimeForTicketType?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::guestNotes */
  guestNotes: Array<PatronNoteEntity>;
  /** PartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** PartyDetails::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::leftTime */
  leftTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::pastVisitsCount */
  pastVisitsCount?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::patron */
  patron?: Maybe<PatronEntity>;
  /** PartyDetails::patronVisitsInBusiness */
  patronVisitsInBusiness: Array<PatronVisit>;
  /** PartyDetails::patronVisitsInBusinessGroup */
  patronVisitsInBusinessGroup: Array<PatronVisit>;
  /** PartyDetails::preVisitQuestions */
  preVisitQuestions: Array<PurchaseQuestionEntity>;
  /** PartyDetails::seatedTime */
  seatedTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** PartyDetails::ticketGroupId */
  ticketGroupId?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::ticketTypeId */
  ticketTypeId?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::turnTimeSecondsOverride */
  turnTimeSecondsOverride?: Maybe<Scalars['Int']['output']>;
  /** PartyDetails::visitTags */
  visitTags: Array<VisitTagEntity>;
};

export type PartyDetailsResponse = {
  __typename?: 'PartyDetailsResponse';
  /** PartyDetailsResponse::slimDetails */
  slimDetails: Array<SlimPartyDetails>;
};

export type PartyDetailsUpdate = {
  __typename?: 'PartyDetailsUpdate';
  /** PartyDetailsUpdate::slimDetails */
  slimDetails: Array<SlimPartyDetails>;
};

export type PartyRangeTicketPriceInformation = {
  __typename?: 'PartyRangeTicketPriceInformation';
  /** PartyRangeTicketPriceInformation::asList */
  asList: Array<PartyRangeTicketPriceInformationPartition>;
};

export type PartyRangeTicketPriceInformationPartition = {
  __typename?: 'PartyRangeTicketPriceInformationPartition';
  /** Partition::maxPartySizeExclusive */
  maxPartySizeExclusive?: Maybe<Scalars['Int']['output']>;
  /** Partition::minPartySizeInclusive */
  minPartySizeInclusive: Scalars['Int']['output'];
  /** Partition::ticketPriceInformation */
  ticketPriceInformation?: Maybe<TicketPriceInformation>;
};

export type PartyRangeTicketPriceInformationPartitionInput = {
  maxPartySizeExclusive?: InputMaybe<Scalars['Int']['input']>;
  minPartySizeInclusive: Scalars['Int']['input'];
  ticketPriceInformation?: InputMaybe<TicketPriceInformationInput>;
};

export const PartyState = {
  Arrived: 'ARRIVED',
  AwaitingResponse: 'AWAITING_RESPONSE',
  Canceled: 'CANCELED',
  ConfirmedViaEmail: 'CONFIRMED_VIA_EMAIL',
  ConfirmedViaText: 'CONFIRMED_VIA_TEXT',
  Expected: 'EXPECTED',
  Finished: 'FINISHED',
  Left: 'LEFT',
  NoShow: 'NO_SHOW',
  Paid: 'PAID',
  PartiallyArrived: 'PARTIALLY_ARRIVED',
  PartiallySeated: 'PARTIALLY_SEATED',
  Seated: 'SEATED'
} as const;

export type PartyState = typeof PartyState[keyof typeof PartyState];
export const PasscodeAction = {
  BookInHouseTableCombo: 'BOOK_IN_HOUSE_TABLE_COMBO',
  ChangeReservationDate: 'CHANGE_RESERVATION_DATE',
  ChangeReservationSize: 'CHANGE_RESERVATION_SIZE',
  ChangeReservationTime: 'CHANGE_RESERVATION_TIME',
  ChargeCcHold: 'CHARGE_CC_HOLD',
  CompExistingReservation: 'COMP_EXISTING_RESERVATION',
  CompNewReservation: 'COMP_NEW_RESERVATION',
  CreateInventory: 'CREATE_INVENTORY',
  ExcludePartyFromPacingLimits: 'EXCLUDE_PARTY_FROM_PACING_LIMITS',
  OverbookReservation: 'OVERBOOK_RESERVATION',
  PayLater: 'PAY_LATER',
  RefundCanceledReservation: 'REFUND_CANCELED_RESERVATION',
  RefundCcHold: 'REFUND_CC_HOLD',
  ShuffleTableAssignments: 'SHUFFLE_TABLE_ASSIGNMENTS'
} as const;

export type PasscodeAction = typeof PasscodeAction[keyof typeof PasscodeAction];
export type Patron = {
  __typename?: 'Patron';
  /** Patron::email */
  email?: Maybe<Scalars['String']['output']>;
  /** Patron::firstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Patron::id */
  id: Scalars['Int']['output'];
  /** Patron::lastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** AggregateTagsResolvers::getTags */
  tags: Array<GuestProfileTagEntity>;
};

export type PatronAddressEntity = {
  __typename?: 'PatronAddressEntity';
  /** PatronAddressEntity_Generated::getAddress */
  address: LocationEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PatronAddressEntity_Generated::getFirstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronAddressEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PatronAddressEntity_Generated::getLastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** PatronAddressEntity_Generated::getPhone */
  phone?: Maybe<PhoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronEntity = {
  __typename?: 'PatronEntity';
  /** The user's associated patron addresses. Only for currently logged in user. (PatronResolvers::getAddresses) */
  addresses: Array<PatronAddressEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PatronEntity_Generated::getEmail */
  email?: Maybe<Scalars['String']['output']>;
  /** PatronEntity_Generated::getFirstName */
  firstName?: Maybe<Scalars['String']['output']>;
  /** PatronEntity::getFullName */
  fullName?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronEntity_Generated::getIsEligibleForSelfOnboarding */
  isEligibleForSelfOnboarding: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getIsTockEmployee */
  isTockEmployee: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getLastName */
  lastName?: Maybe<Scalars['String']['output']>;
  /** OrderResolvers::getOrder */
  order?: Maybe<OrderEntity>;
  /** OrderResolvers::getOrderByConfirmationCode */
  orderByConfirmationCode?: Maybe<OrderEntity>;
  /** OrderResolvers::orders */
  orders: Array<OrderEntity>;
  /** PatronEntity_Generated::getPhone */
  phone?: Maybe<Scalars['String']['output']>;
  /** PatronEntity_Generated::getPhoneCountryCode */
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  /** The user's profile. Only for currently logged in user. (PatronResolvers::profile) */
  profile?: Maybe<PatronProfileEntity>;
  /** PatronEntity_Generated::getRequiresMfa */
  requiresMfa: Scalars['Boolean']['output'];
  /** PatronEntity_Generated::getTockGiftCardBalanceCents */
  tockGiftCardBalanceCents?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PatronEntity_Generated::getUuid */
  uuid?: Maybe<Scalars['String']['output']>;
};


export type PatronEntityOrderArgs = {
  id: Scalars['Int']['input'];
};


export type PatronEntityOrderByConfirmationCodeArgs = {
  confirmationCode: Scalars['String']['input'];
};

export type PatronNoteEntity = {
  __typename?: 'PatronNoteEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PatronNoteEntity_Generated::getNote */
  note?: Maybe<Scalars['String']['output']>;
  /** PatronNoteEntity_Generated::getNoteType */
  noteType?: Maybe<NoteType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronPhoneInput = {
  countryCode: Scalars['String']['input'];
  defaultRegionCode: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PatronProfileEntity = {
  __typename?: 'PatronProfileEntity';
  /** PatronProfileResolvers::canBookForGuest */
  canBookForGuest: Scalars['Boolean']['output'];
  /** PatronProfileEntity_Generated::getCompany */
  company?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PatronProfileEntity_Generated::getJobTitle */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** PatronProfileEntity_Generated::getPatron */
  patron: PatronEntity;
  /** PatronProfileEntity_Generated::getPatronAversions */
  patronAversions?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PatronVisit = {
  __typename?: 'PatronVisit';
  /** PatronVisit::leftDateTime */
  leftDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** PatronVisit::partySize */
  partySize?: Maybe<Scalars['Int']['output']>;
  /** PatronVisit::startDateTime */
  startDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** PatronVisit::ticketTypeId */
  ticketTypeId?: Maybe<Scalars['Int']['output']>;
};

export type PaymentCardHold = {
  __typename?: 'PaymentCardHold';
  /** PaymentCardHold::brand */
  brand?: Maybe<Scalars['String']['output']>;
  /** PaymentCardHold::maskedNumber */
  maskedNumber?: Maybe<Scalars['String']['output']>;
};

export type PaymentCardSetupIntent = {
  __typename?: 'PaymentCardSetupIntent';
  /** PaymentCardSetupIntent::clientSecret */
  clientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentDisputeEntity = {
  __typename?: 'PaymentDisputeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentDisputeEntity_Generated::getReason */
  reason?: Maybe<Scalars['String']['output']>;
  /** PaymentDisputeEntity_Generated::getStatus */
  status?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentEntity = {
  __typename?: 'PaymentEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentEntity_Generated::getDisputes */
  disputes: Array<PaymentDisputeEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentEntity_Generated::getPatron */
  patron?: Maybe<PatronEntity>;
  /** PaymentEntity_Generated::getPaymentCardBrand */
  paymentCardBrand?: Maybe<Scalars['String']['output']>;
  /** PaymentEntity_Generated::getPaymentCardMaskedNumber */
  paymentCardMaskedNumber?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const PaymentProcessorType = {
  Amex: 'AMEX',
  ApplePay: 'APPLE_PAY',
  AuthorizeLegacy: 'AUTHORIZE_LEGACY',
  Braintree: 'BRAINTREE',
  BraintreeLegacy: 'BRAINTREE_LEGACY',
  ChasePay: 'CHASE_PAY',
  ChaseUltimateRewards: 'CHASE_ULTIMATE_REWARDS',
  Check: 'CHECK',
  Complimentary: 'COMPLIMENTARY',
  PayOnSite: 'PAY_ON_SITE',
  Stripe: 'STRIPE',
  TockGiftCard: 'TOCK_GIFT_CARD'
} as const;

export type PaymentProcessorType = typeof PaymentProcessorType[keyof typeof PaymentProcessorType];
export type PaymentSelection_StoredCreditCardPaymentMethodInput = {
  amountCents: Scalars['Int']['input'];
  method: StoredCreditCardPaymentMethodInput;
};

export type PaymentSelection_TockGiftCardPaymentMethodInput = {
  amountCents: Scalars['Int']['input'];
  method: TockGiftCardPaymentMethodInput;
};

export type PaymentSelectionsInput = {
  creditCards?: InputMaybe<Array<PaymentSelection_StoredCreditCardPaymentMethodInput>>;
  giftCards?: InputMaybe<Array<PaymentSelection_TockGiftCardPaymentMethodInput>>;
};

export type PaymentSubscriptionAddonEntity = Node & {
  __typename?: 'PaymentSubscriptionAddonEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionAddonEntity::getId */
  id: Scalars['ID']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionEntity = {
  __typename?: 'PaymentSubscriptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentSubscriptionEntity_Generated::getInvoiceSubscriptionName */
  invoiceSubscriptionName?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionEntity_Generated::getProcessorType */
  processorType?: Maybe<PaymentProcessorType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionPlanAddonEntity = Node & {
  __typename?: 'PaymentSubscriptionPlanAddonEntity';
  /** PaymentSubscriptionPlanAddonEntity_Generated::getAmountCents */
  amountCents?: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanAddonEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getCanonicalType */
  canonicalType?: Maybe<SubscriptionAddonCanonicalType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getCurrencyCode */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanAddonEntity_Generated::getEntitlementSet */
  entitlementSet?: Maybe<EntitlementSetEntity>;
  /** PaymentSubscriptionPlanAddonEntity::getId */
  id: Scalars['ID']['output'];
  /** PaymentSubscriptionPlanAddonEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanAddonEntity_Generated::getPaymentSubscriptionAddons */
  paymentSubscriptionAddons: Array<PaymentSubscriptionAddonEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PaymentSubscriptionPlanEntity = Node & {
  __typename?: 'PaymentSubscriptionPlanEntity';
  /** PaymentSubscriptionPlanEntity::getBusinessCount */
  businessCount: Scalars['Int']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getCanonicalName */
  canonicalName?: Maybe<SubscriptionCanonicalName>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanEntity::getCurrencyCode */
  currencyCode?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getEntitlementSet */
  entitlementSet?: Maybe<EntitlementSetEntity>;
  /** PaymentSubscriptionPlanEntity::getId */
  id: Scalars['ID']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getInvoiceSubscriptionPlanName */
  invoiceSubscriptionPlanName?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlyPerTicketBaseFee */
  monthlyPerTicketBaseFee?: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlyPerTicketFee */
  monthlyPerTicketFee?: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlySmsFee */
  monthlySmsFee?: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getMonthlySubscriptionFee */
  monthlySubscriptionFee?: Maybe<Scalars['Int']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getPaymentSubscriptions */
  paymentSubscriptions: Array<PaymentSubscriptionEntity>;
  /** PaymentSubscriptionPlanEntity_Generated::getPurchaseProcessingFeePercentage */
  purchaseProcessingFeePercentage?: Maybe<Scalars['Float']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getSubscriptionPlanName */
  subscriptionPlanName?: Maybe<Scalars['String']['output']>;
  /** PaymentSubscriptionPlanEntity_Generated::getToGoFeePercentage */
  toGoFeePercentage?: Maybe<Scalars['Float']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PaymentSubscriptionPlanEntity_Generated::getYearlySubscriptionFee */
  yearlySubscriptionFee?: Maybe<Scalars['Int']['output']>;
};

export type PaymentTaxEntity = Tax & {
  __typename?: 'PaymentTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PaymentTaxEntity_Generated::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** PaymentTaxEntity_Generated::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** PaymentTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** PaymentTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** PaymentTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PaymentTaxEntity_Generated::getNetTaxableAmountCents */
  netTaxableAmountCents: Scalars['Int']['output'];
  /** PaymentTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** PaymentTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PaymentTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /** PaymentTransaction::amountCents */
  amountCents: Scalars['Int']['output'];
  /** PaymentTransaction::brand */
  brand?: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::date */
  date?: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::maskedNumber */
  maskedNumber?: Maybe<Scalars['String']['output']>;
  /** PaymentTransaction::transactionType */
  transactionType?: Maybe<PaymentTransactionType>;
  /** PaymentTransaction::usedApplePay */
  usedApplePay: Scalars['Boolean']['output'];
};

export const PaymentTransactionType = {
  Paid: 'PAID',
  Refunded: 'REFUNDED'
} as const;

export type PaymentTransactionType = typeof PaymentTransactionType[keyof typeof PaymentTransactionType];
export type PayoutEntity = {
  __typename?: 'PayoutEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PerServiceInfo = {
  __typename?: 'PerServiceInfo';
  /** PerServiceInfo::isAutoRelease */
  autoRelease: Scalars['Boolean']['output'];
  /** PerServiceInfo::autoReleaseMinutes */
  autoReleaseMinutes: Scalars['Int']['output'];
  /** PerServiceInfo::serviceType */
  serviceType: Type;
};

export type Percent = {
  __typename?: 'Percent';
  /** Percent::getDoubleValue */
  asNumber: Scalars['Float']['output'];
  /** Percent::value */
  asString?: Maybe<Scalars['String']['output']>;
};

export type PermissionPreflightResponse = {
  __typename?: 'PermissionPreflightResponse';
  /** PermissionPreflightResponse::passcode */
  passcode?: Maybe<Scalars['String']['output']>;
};

export type PhoneEntity = {
  __typename?: 'PhoneEntity';
  /** PhoneEntity_Generated::getCountryCode */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PhoneEntity_Generated::getDefaultRegionCodeIso */
  defaultRegionCodeIso?: Maybe<Scalars['String']['output']>;
  /** PhoneEntity_Generated::getExtension */
  extension?: Maybe<Scalars['String']['output']>;
  /** PhoneEntity::formattedPhone */
  formattedPhone?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PhoneEntity_Generated::getPhone */
  phone?: Maybe<Scalars['String']['output']>;
  /** PhoneEntity::regionCodeIso */
  regionCodeIso?: Maybe<Scalars['String']['output']>;
  /** PhoneEntity_Generated::getSourceData */
  sourceData?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type PhoneEntityFormattedPhoneArgs = {
  format: PhoneNumberFormat;
};

export const PhoneNumberFormat = {
  E164: 'E164',
  International: 'INTERNATIONAL',
  National: 'NATIONAL',
  Rfc3966: 'RFC3966'
} as const;

export type PhoneNumberFormat = typeof PhoneNumberFormat[keyof typeof PhoneNumberFormat];
export type PreBookingBlock = DateTimeRange & Node & TableStateRange & {
  __typename?: 'PreBookingBlock';
  /** PreBookingBlock::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** PreBookingBlock::offeredOnline */
  offeredOnline: Scalars['Boolean']['output'];
  /** PreBookingBlock::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** PreBookingBlock::tableAssignmentPriorityLevel */
  tableAssignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** PreBookingBlock::tableId */
  tableId: Scalars['Int']['output'];
};

export const PriceDistribution = {
  PerParty: 'PER_PARTY',
  PerTicket: 'PER_TICKET'
} as const;

export type PriceDistribution = typeof PriceDistribution[keyof typeof PriceDistribution];
export const PriceRange = {
  PriceRangeFour: 'PRICE_RANGE_FOUR',
  PriceRangeOne: 'PRICE_RANGE_ONE',
  PriceRangeThree: 'PRICE_RANGE_THREE',
  PriceRangeTwo: 'PRICE_RANGE_TWO',
  PriceRangeUnspecified: 'PRICE_RANGE_UNSPECIFIED'
} as const;

export type PriceRange = typeof PriceRange[keyof typeof PriceRange];
export const PriceType = {
  Deposit: 'DEPOSIT',
  Free: 'FREE',
  PaymentCardHold: 'PAYMENT_CARD_HOLD',
  Prepaid: 'PREPAID'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];
export const ProductType = {
  Ale: 'ALE',
  AppleCider: 'APPLE_CIDER',
  Beer: 'BEER',
  BottleBeer: 'BOTTLE_BEER',
  CanBeer: 'CAN_BEER',
  Cider: 'CIDER',
  DraughtBeer: 'DRAUGHT_BEER',
  Food: 'FOOD',
  Freight: 'FREIGHT',
  KegBeer: 'KEG_BEER',
  MaltLiquor: 'MALT_LIQUOR',
  Merchandise: 'MERCHANDISE',
  MerchandiseNonTaxable: 'MERCHANDISE_NON_TAXABLE',
  SparklingWine: 'SPARKLING_WINE',
  Spirits: 'SPIRITS',
  Wine: 'WINE',
  WineCooler: 'WINE_COOLER'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];
export const ProviderType = {
  Apple: 'APPLE',
  Azure: 'AZURE',
  Chase: 'CHASE',
  Facebook: 'FACEBOOK',
  Gdus: 'GDUS',
  Google: 'GOOGLE',
  Password: 'PASSWORD',
  TwitterDeprecated: 'TWITTER_DEPRECATED'
} as const;

export type ProviderType = typeof ProviderType[keyof typeof ProviderType];
export const PublicationStatus = {
  Archived: 'ARCHIVED',
  Deleted: 'DELETED',
  Draft: 'DRAFT',
  Published: 'PUBLISHED'
} as const;

export type PublicationStatus = typeof PublicationStatus[keyof typeof PublicationStatus];
export type Purchasable = {
  /** Purchasable::getId */
  id: Scalars['Int']['output'];
  /** Purchasable::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Purchasable::getPurchasableType */
  purchasableType: PurchasableType;
  /** Taxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type PurchasableIdInput = {
  id: Scalars['Int']['input'];
  purchasableType: PurchasableType;
};

export type PurchasableItem = Purchasable & Taxable & {
  __typename?: 'PurchasableItem';
  /** Purchasable::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Purchasable::getPurchasableType */
  purchasableType: PurchasableType;
  /** Taxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type PurchasableTax = {
  /** PurchasableTax::getFlatTaxCents */
  flatTaxCents?: Maybe<Scalars['Int']['output']>;
  /** PurchasableTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** PurchasableTax::getTaxApplicationType */
  taxApplicationType?: Maybe<TaxApplicationType>;
  /** PurchasableTax::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export const PurchasableType = {
  AddOn: 'ADD_ON',
  AddOnOption: 'ADD_ON_OPTION',
  BookByEmailOption: 'BOOK_BY_EMAIL_OPTION',
  DineIn: 'DINE_IN',
  Event: 'EVENT',
  MenuItem: 'MENU_ITEM',
  MenuModifierOption: 'MENU_MODIFIER_OPTION',
  Tableside: 'TABLESIDE',
  ToGo: 'TO_GO'
} as const;

export type PurchasableType = typeof PurchasableType[keyof typeof PurchasableType];
export type Purchase = BookingBase & Node & {
  __typename?: 'Purchase';
  /** Purchase::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** Represents a VisitEntity id from the database (Purchase::id) */
  id: Scalars['ID']['output'];
  /** Purchase::originalOriginatedAt */
  originalOriginatedAt: OriginatedAt;
  /** Purchase::originalPurchaseId */
  originalPurchaseId: Scalars['ID']['output'];
  /** Purchase::party */
  party: Party;
  /** Purchase::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** Purchase::purchaseId */
  purchaseId: Scalars['ID']['output'];
  /** Purchase::seatingArea */
  seatingArea?: Maybe<SeatingAreaOutput>;
  /** Purchase::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** Purchase::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
  /** Purchase::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** Purchase::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
};

export type PurchaseEntity = {
  __typename?: 'PurchaseEntity';
  /** PurchaseEntity_Generated::getOwnConfirmationCode */
  confirmationCode: ConfirmationCode;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** PurchaseEntity_Generated::getDate */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * PurchaseEntity_Generated::getDiner
   * @deprecated Deprecated in favor of secureDiner which will be renamed after this removal
   */
  diner?: Maybe<PatronEntity>;
  /** PurchaseEntity_Generated::getFirstTicketTransfer */
  firstTicketTransfer?: Maybe<TicketTransferEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseEntity_Generated::getOriginalPurchaseId */
  originalPurchaseId?: Maybe<Scalars['Int']['output']>;
  /**
   * PurchaseEntity_Generated::getOwnerPatron
   * @deprecated Deprecated in favor of secureOwner which will be renamed after this removal
   */
  ownerPatron?: Maybe<PatronEntity>;
  /** PurchaseEntity_Generated::getRefunds */
  refunds: Array<RefundEntity>;
  /** PurchasePatronResolvers::secureDiner */
  secureDiner?: Maybe<Patron>;
  /** PurchasePatronResolvers::secureOwner */
  secureOwner?: Maybe<Patron>;
  /** PurchaseEntity_Generated::getStartTime */
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  /** PurchaseEntity_Generated::getTicketCount */
  ticketCount?: Maybe<Scalars['Int']['output']>;
  /** PurchaseEntity_Generated::getTicketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** PurchaseEntity_Generated::getTotalPrice */
  totalPrice?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** Gets the visit corresponding to this purchase (PurchaseEntity::getVisit) */
  visit?: Maybe<VisitEntity>;
};

export type PurchaseFilterInput = {
  /** Date range for purchases to match. This is the reservation date, not the date the purchase was created. */
  dateRange: DateRangeInput;
  /** If present, only match reservations for ticket types with any of the given IDs. By convention, anempty set matches anything rather than nothing. */
  ticketTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  visitFilter?: InputMaybe<VisitFilterInput>;
};

export type PurchaseQuestionEntity = {
  __typename?: 'PurchaseQuestionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseQuestionEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** PurchaseQuestionEntity_Generated::getResponses */
  responses: Array<PurchaseQuestionResponseEntity>;
  /** PurchaseQuestionEntity_Generated::getText */
  text?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseQuestionResponseEntity = {
  __typename?: 'PurchaseQuestionResponseEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseQuestionResponseEntity_Generated::getText */
  text?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseVerifyOptionEntity = Purchasable & Taxable & {
  __typename?: 'PurchaseVerifyOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchaseVerifyOptionEntity::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** PurchaseVerifyOptionEntity::getName */
  name: Scalars['String']['output'];
  /** PurchaseVerifyOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** PurchaseVerifyOptionEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const PurchaseVerifyType = {
  Email: 'EMAIL',
  Sms: 'SMS'
} as const;

export type PurchaseVerifyType = typeof PurchaseVerifyType[keyof typeof PurchaseVerifyType];
export type PurchasedCustomChargeEntity = Taxable & {
  __typename?: 'PurchasedCustomChargeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedCustomChargeEntity::getName */
  name: Scalars['String']['output'];
  /** PurchasedCustomChargeEntity::getPerUnitPriceCents */
  perUnitPriceCents?: Maybe<Scalars['Int']['output']>;
  /** PurchasedCustomChargeEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedFeeEntity = Taxable & {
  __typename?: 'PurchasedFeeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedFeeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedFeeEntity::getPerUnitPriceCents */
  perUnitPriceCents?: Maybe<Scalars['Int']['output']>;
  /** PurchasedFeeEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedOption = {
  __typename?: 'PurchasedOption';
  /** PurchasedOption::backingMode */
  backingMode?: Maybe<BackingMode>;
  /** PurchasedOption::id */
  id: Scalars['Int']['output'];
  /** PurchasedOption::modifiers */
  modifiers: Array<PurchasedOptionModifier>;
  /** PurchasedOption::name */
  name?: Maybe<Scalars['String']['output']>;
  /** PurchasedOption::parentGroupId */
  parentGroupId: Scalars['Int']['output'];
  /** PurchasedOption::unitPriceCents */
  unitPriceCents: Scalars['Int']['output'];
};

export type PurchasedOptionEntity = Taxable & {
  __typename?: 'PurchasedOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedOptionEntity::getName */
  name: Scalars['String']['output'];
  /** PurchasedOptionEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type PurchasedOptionModifier = {
  __typename?: 'PurchasedOptionModifier';
  /** PurchasedOptionModifier::backingMode */
  backingMode?: Maybe<BackingMode>;
  /** PurchasedOptionModifier::id */
  id: Scalars['Int']['output'];
  /** PurchasedOptionModifier::name */
  name?: Maybe<Scalars['String']['output']>;
  /** PurchasedOptionModifier::parentGroupId */
  parentGroupId: Scalars['Int']['output'];
  /** PurchasedOptionModifier::unitPriceCents */
  unitPriceCents: Scalars['Int']['output'];
};

export type PurchasedTax = Tax & {
  __typename?: 'PurchasedTax';
  /** PurchasedTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type PurchasedTaxImpl = Tax & {
  __typename?: 'PurchasedTaxImpl';
  /** PurchasedTaxImpl::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** PurchasedTaxImpl::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** PurchasedTaxImpl::getName */
  name: Scalars['String']['output'];
  /** PurchasedTaxImpl::getTaxSource */
  taxSource: TaxSource;
};

export type PurchasedTaxable = Taxable & {
  __typename?: 'PurchasedTaxable';
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type PurchasedTicketOptionTaxEntity = Tax & {
  __typename?: 'PurchasedTicketOptionTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** PurchasedTicketOptionTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** PurchasedTicketOptionTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PurchasedTicketOptionTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export type PurchasedTicketTypeTaxEntity = Tax & {
  __typename?: 'PurchasedTicketTypeTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** PurchasedTicketTypeTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** PurchasedTicketTypeTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** PurchasedTicketTypeTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export const QuantityLimitType = {
  InStock: 'IN_STOCK',
  Per_15Mins: 'PER_15_MINS',
  PerDay: 'PER_DAY',
  PerHour: 'PER_HOUR'
} as const;

export type QuantityLimitType = typeof QuantityLimitType[keyof typeof QuantityLimitType];
/** Query root */
export type Query = {
  __typename?: 'Query';
  /** CancelBookingsSubscriptionResolvers::acceptCancellationRequest */
  acceptCancellationRequest: Array<CancelBookingsOutput>;
  /** All accolade type ratings (AccoladeTypeResolvers::accoladeTypeRatings) */
  accoladeTypeRatings: Array<AccoladeTypeRatingEntity>;
  /** All accolade type ratings with total count used and accolades with rating (AccoladeTypeResolvers::getAccoladeTypeRatingsWithCounts) */
  accoladeTypeRatingsWithCounts: Array<AccoladeTypeRatingInfo>;
  /** All accolade types (AccoladeTypeResolvers::accoladeTypes) */
  accoladeTypes: Array<AccoladeTypeEntity>;
  /** All accolade types with total count used and businesses with accolade (AccoladeTypeResolvers::getAccoladeTypesWithCounts) */
  accoladeTypesWithCounts: Array<AccoladeTypeInfo>;
  /** WaitlistResolvers::getActiveWaitlistsForPatron */
  activeWaitlistsForPatron: Array<WaitlistEntity>;
  /** Admin view of patron notify (waitlist) history. (AdminPatronResolvers::adminPatronNotifies) */
  adminPatronNotifies: Array<AdminPatronNotifySummary>;
  /** Admin view of patron purchases for search functionality. (AdminPatronResolvers::adminPatronPurchases) */
  adminPatronPurchases: Array<AdminPatronPurchaseSummary>;
  /** TockApiKeyResolvers::getAllApiKeys */
  allApiKeys: Array<TockApiKeyEntity>;
  /** Get all business content entries (BusinessContentResolvers::getAllBusinessContent) */
  allBusinessContent: Array<BusinessContentEntity>;
  /** TaxResolvers::getAllEnablementStates */
  allEnablementStates: Array<EnablementState>;
  /** All homepage geographies (JceHomepageResolvers::getAllGeographies) */
  allGeographies: Array<JceHomepageGeographyEntity>;
  /** Get all possible shipment statuses (OrderShipmentResolvers::getAllShipmentStatuses) */
  allShipmentStatuses: Array<TockShipmentStatus>;
  /** OrderResolvers::beta_calculateMultipleOrderPrice_v2 */
  beta_calculateMultipleOrderPrice_v2: Array<OrderPriceCalculationResponse>;
  /** OrderResolvers::beta_calculateOrderPrice_v2 */
  beta_calculateOrderPrice_v2?: Maybe<OrderPriceCalculationResponse>;
  /** Find a particular business (BusinessResolvers::business) */
  business?: Maybe<BusinessEntity>;
  /** All business accolades for a business (BusinessResolvers::businessAccolades) */
  businessAccolades: Array<BusinessAccoladeEntity>;
  /** All business accolades for a business (BusinessResolvers::businessAccoladesV2) */
  businessAccoladesV2: Array<BusinessAccoladeOutput>;
  /** Find a particular business by domain name (BusinessResolvers::businessByDomainName) */
  businessByDomainName?: Maybe<BusinessEntity>;
  /** Get venue content for a Tock venue by business ID (BusinessContentResolvers::businessContentByBusinessId) */
  businessContentByBusinessId?: Maybe<BusinessContent>;
  /** Get venue content for a Resy venue by venue ID (BusinessContentResolvers::businessContentByVenueId) */
  businessContentByVenueId?: Maybe<BusinessContent>;
  /** Find a particular business group by id (BusinessGroupResolvers::businessGroup) */
  businessGroup?: Maybe<BusinessGroupEntity>;
  /** Find a particular business group by slug (BusinessGroupResolvers::businessGroupBySlug) */
  businessGroupBySlug?: Maybe<BusinessGroupEntity>;
  /** List of all business groups as used in Clowncar (BusinessGroupResolvers::businessGroups) */
  businessGroups: Array<BusinessGroupInfo>;
  /** All business groups, paginated (BusinessGroupResolvers::businessGroupsPaginated) */
  businessGroupsPaginated: BusinessGroupEntityConnection;
  /** Get all meta tags eligible for businesses (MetaTagResolvers::businessMetaTagsInternal) */
  businessMetaTagsInternal: Array<MetaTagEntity>;
  /** All businesses (BusinessResolvers::businesses) */
  businesses: Array<BusinessEntity>;
  /** All businesses, paginated (BusinessResolvers::businessesPaginated) */
  businessesPaginated: BusinessEntityConnection;
  /** TimelineResolvers::calendarDay */
  calendarDay?: Maybe<Timeline>;
  /** ShippingMethodResolvers::cheapestShippingZoneOptionForBusinessAndLocation */
  cheapestShippingZoneOptionForBusinessAndLocation?: Maybe<CheckoutCartShippingOption>;
  /** All venue collections for a given geography id (JceHomepageResolvers::getCollectionsForGeography) */
  collectionsForGeography?: Maybe<OrderingEntriesAndUnorderedCollections>;
  /** All venue collections for a given geography, by slug (JceHomepageResolvers::getCollectionsForGeographyBySlug) */
  collectionsForGeographyBySlug?: Maybe<OrderingEntriesAndUnorderedCollections>;
  /** All collections for a given venue (JceHomepageResolvers::getCollectionsForVenueId) */
  collectionsForVenueId: Array<JceVenueCollectionEntity>;
  /** ConsumerReservationResolvers::consumerPurchases */
  consumerPurchases?: Maybe<ConsumerPurchaseWithCount>;
  /** The current business scope (BusinessResolvers::currentBusiness) */
  currentBusiness?: Maybe<BusinessEntity>;
  /** PatronResolvers::currentUser */
  currentUser?: Maybe<PatronEntity>;
  /** PatronMfaMethodsResolver::currentUserMfaMethods */
  currentUserMfaMethods: Array<MfaFactor>;
  /** Hack, do not use (DevSubscriptionResolvers::dummy) */
  dummy: Scalars['Boolean']['output'];
  /** BookingPolicyResolvers::eligibleForHoldCharge */
  eligibleForHoldCharge: Scalars['Boolean']['output'];
  /** All entitlement sets (EntitlementSetResolvers::entitlementSets) */
  entitlementSets: Array<EntitlementSetEntity>;
  /** Not to be used in prod. Throws a fake error, convenient while building error handling functionality. (DevNonSubscriptionResolvers::error) */
  error: Scalars['Boolean']['output'];
  /** Find a single event by businessId and shortCode (BusinessResolvers::eventInfo) */
  eventInfo?: Maybe<EventInfo>;
  /** All experiments configurations (ExperimentResolvers::experiments) */
  experiments: Array<ExperimentEntity>;
  /** A single feature flag (FeatureResolvers::feature) */
  feature?: Maybe<FeatureEntity>;
  /** Fetches feature flags (FeatureResolvers::features) */
  features: Array<FeatureEntity>;
  /** The list of free experiences that can be sent to Google in an availability feed (GoogleSettingsResolvers::freeExperiencesAvailable) */
  freeExperiencesAvailable: Array<TicketTypeEntity>;
  /** Gets all fulfillment warehouses.. (ShipCompliantConstantsResolvers::getFulfillmentWarehouses) */
  fulfillmentWarehouses: Array<FulfillmentWarehouseWrapper>;
  /** The Google settings for the business in scope (GoogleSettingsResolvers::googleSettings) */
  googleSettings?: Maybe<GoogleSettingsEntity>;
  /** Gets all 'help menu display items' (processed help menu entries) appropriate for surfacing in a given business dashboard (HelpMenuEntryResolvers::helpMenuDisplayItems) */
  helpMenuDisplayItems: Array<HelpMenuDisplayItem>;
  /** Get all help menu entries, with a possible search string that will filter on the headline textand/or possible boolean that includes archived entries (HelpMenuEntryResolvers::helpMenuEntries) */
  helpMenuEntries: Array<HelpMenuEntryEntity>;
  /** Get help menu entry by ID (HelpMenuEntryResolvers::helpMenuEntry) */
  helpMenuEntry?: Maybe<HelpMenuEntryEntity>;
  /** Given a state, returns whether tax center taxes apply and if the tax center migration period is enabled for this state. (TaxResolvers::isTaxCenterState) */
  isTaxCenterState?: Maybe<TaxCenterLaunchFlags>;
  /** Fetches wine items for a business with optional name filter and pagination (WineItemsResolvers::itemWineTypesPaginated) */
  itemWineTypesPaginated?: Maybe<ItemWineTypeEntityConnection>;
  /** SsoLoginDomainResolvers::loginDomainsForBusiness */
  loginDomainsForBusiness: Array<SsoLoginDomainEntity>;
  /** Get all item meta tags (MetaTagResolvers::metaItemTags) */
  metaItemTags: Array<IMetaTag>;
  /** Get all shop brand meta tags (MetaTagResolvers::metaShopBrandTags) */
  metaShopBrandTags: Array<IMetaTag>;
  /** Get all meta tags by tag type (MetaTagResolvers::metaTagsByTagType) */
  metaTagsByTagType: Array<MetaTagEntity>;
  /** Get all meta tags by tag type (MetaTagResolvers::metaTagsByTagTypeInternal) */
  metaTagsByTagTypeInternal: Array<MetaTagEntity>;
  /** A specific metro area (MetroAreaResolvers::metroArea) */
  metroArea?: Maybe<MetroAreaEntity>;
  /** All metro areas (MetroAreaResolvers::metroAreas) */
  metroAreas: Array<MetroAreaEntity>;
  /** TimelineResolvers::notifyPartyDetailsForCalendarDay */
  notifyPartyDetailsForCalendarDay: Array<SlimNotifyPartyDetails>;
  /** TimelineResolvers::notifyPartyDetailsForWaitlistItem */
  notifyPartyDetailsForWaitlistItem?: Maybe<NotifyPartyDetails>;
  /** OrderResolvers::getOrder */
  order?: Maybe<OrderEntity>;
  /** TimelineResolvers::partyDetailsForCalendarDay */
  partyDetailsForCalendarDay?: Maybe<PartyDetailsResponse>;
  /** TimelineResolvers::partyDetailsForVisit */
  partyDetailsForVisit?: Maybe<PartyDetails>;
  /** PaymentSubscriptionPlanAddonResolvers::paymentSubscriptionPlanAddons */
  paymentSubscriptionPlanAddons: Array<PaymentSubscriptionPlanAddonEntity>;
  /** All payment subscription plans (PaymentSubscriptionPlanResolvers::paymentSubscriptionPlans) */
  paymentSubscriptionPlans: Array<PaymentSubscriptionPlanEntity>;
  /** Requests a passcode for the provided action if necessary (PatronPermissionsResolvers::permissionPreflight) */
  permissionPreflight?: Maybe<PermissionPreflightResponse>;
  /** Fetch total count of purchases to be updated with new exclusivity. (FinanceBusinessResolvers::purchaseExclusivityUpdateCount) */
  purchaseExclusivityUpdateCount: Scalars['Int']['output'];
  /** The user's associated reservations. (PatronReservationResolvers::getPurchases) */
  purchases: Array<ConsumerPurchaseSummary>;
  /** Get all region tags (ItemRegionResolvers::regionTags) */
  regionTags: Array<RegionTagWrapper>;
  /** Get reservation details (PatronReservationDetailsResolver::getReservationDetails) */
  reservationDetails?: Maybe<ConsumerPurchase>;
  /** The count of the user's reservation history. (PatronReservationResolvers::getReservationHistoryCount) */
  reservationHistoryCount?: Maybe<ReservationHistoryCount>;
  /** Get all item scale tags (MetaTagResolvers::scaleItemTags) */
  scaleItemTags: Array<ScaleTag>;
  /** Get all available seating area options (SeatingAreaResolvers::seatingAreaOptions) */
  seatingAreaOptions?: Maybe<SeatingAreaOptions>;
  /** Gets a shipment by ID (ShopOrderResolvers::shipmentById) */
  shipmentById?: Maybe<OrderShipmentEntity>;
  /** Gets all shipping carriers, optionally including those that don't ship alcohol. (ShipCompliantConstantsResolvers::getShippingCarriers) */
  shippingCarriers: Array<ShippingCarriersEnum>;
  /** Gets all shipping codes. (ShipCompliantConstantsResolvers::getShippingCodes) */
  shippingCodes: Array<ShippingCodesEnum>;
  /** ShippingMethodResolvers::shippingZoneOptionsForBusinessAndLocation */
  shippingZoneOptionsForBusinessAndLocation: Array<CheckoutCartShippingOption>;
  /** Gets a Brand based on the provided Slug (its unique URL). (ShopBrandResolvers::getShopBrandBySlug) */
  shopBrandBySlug?: Maybe<ShopBrandEntity>;
  /** Gets the ShopBusinessEntity by businessId. Returns null if no ShopBusinessEntity is found. (ShopBusinessResolvers::getShopBusinessForBusiness) */
  shopBusinessForBusiness?: Maybe<ShopBusinessEntity>;
  /** Get information for a single shop item (ShopItemPublicResolvers::getShopItem) */
  shopItem?: Maybe<ShopItem>;
  /** Get information for multiple shop item (ShopItemPublicResolvers::getShopItems) */
  shopItems: Array<ShopItem>;
  /** All businesses with single tax rate, paginated (BusinessTaxMigratorResolvers::singleTaxBusiness) */
  singleTaxBusiness?: Maybe<BusinessTaxMigration>;
  /** Businesses with a single tax rate (tax library and tax center unlaunched) (BusinessTaxMigratorResolvers::singleTaxBusinessesForSwitcher) */
  singleTaxBusinessesForSwitcher: Array<BusinessEntity>;
  /** Count of tags by business (GuestProfileTagResolvers::tagCountsByBusiness) */
  tagCountsByBusiness: Array<GuestProfileTagCount>;
  /** Gets a single tax category entity matching the given ID. (TaxResolvers::taxCategory) */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** Gets all enabled tax category entities, optionally filtered by US state. (TaxResolvers::taxCategoryEntities) */
  taxCategoryEntities: Array<TaxCategoryEntity>;
  /** Returns all Tax Category entities (including inactive + disabled). Only enabled for ENG/Hospitality. (TaxResolvers::taxCategoryEntitiesForConfiguration) */
  taxCategoryEntitiesForConfiguration: Array<TaxCategoryEntity>;
  /** Accessor to permissions requests (PermissionResolvers::temporaryPermissions) */
  temporaryPermissions?: Maybe<TemporaryPermissions>;
  /** Get all meta tags eligible for ticket types (MetaTagResolvers::ticketTypeMetaTagsInternal) */
  ticketTypeMetaTagsInternal: Array<MetaTagEntity>;
  /** TicketTypeResolvers::getTicketTypesWithFuturePurchases */
  ticketTypesWithFuturePurchases: Array<TicketTypeEntity>;
  /** The tier for a given geography, by slug (JceHomepageResolvers::getTierBySlug) */
  tierBySlug?: Maybe<JceHomepageGeographyTier>;
  /** TockTenResolvers::tockTenConfigs */
  tockTenConfigs: Array<TockTenConfigEntity>;
  /** Upcoming events for a business (otherUpcomingEvents) (BusinessResolvers::upcomingEventsForBusiness) */
  upcomingEventsForBusiness: Array<UpcomingEvent>;
  /** Get venue business info by domain name (BusinessResolvers::venueBusinessInfoByDomainName) */
  venueBusinessInfoByDomainName?: Maybe<VenueBusinessInfo>;
  /** Gets a Brand based on the provided Slug (its unique URL). (ShopBrandResolvers::getVisibleShopBrandBySlug) */
  visibleShopBrandBySlug?: Maybe<ShopBrandEntity>;
  /** Gets a wine item from the specified wine item ID. Throws an error if the wine item doesn't belong to this business. (WineItemsResolvers::wineItem) */
  wineItem?: Maybe<ItemWineTypeEntity>;
};


/** Query root */
export type QueryAcceptCancellationRequestArgs = {
  input: CancelBookingsInputInput;
};


/** Query root */
export type QueryAdminPatronNotifiesArgs = {
  limit: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
};


/** Query root */
export type QueryAdminPatronPurchasesArgs = {
  limit: Scalars['Int']['input'];
  patronId: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryBeta_CalculateMultipleOrderPrice_V2Args = {
  inputs: Array<OrderPriceCalculationRequestInput>;
};


/** Query root */
export type QueryBeta_CalculateOrderPrice_V2Args = {
  input: OrderPriceCalculationRequestInput;
};


/** Query root */
export type QueryBusinessArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessByDomainNameArgs = {
  domainName: Scalars['String']['input'];
};


/** Query root */
export type QueryBusinessContentByBusinessIdArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessContentByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessGroupArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryBusinessGroupBySlugArgs = {
  businessGroupSlug: Scalars['String']['input'];
};


/** Query root */
export type QueryBusinessGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryBusinessesPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Query root */
export type QueryCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryCheapestShippingZoneOptionForBusinessAndLocationArgs = {
  businessId: Scalars['Int']['input'];
  cart: OrderCartInput;
  state: Scalars['String']['input'];
};


/** Query root */
export type QueryCollectionsForGeographyArgs = {
  geographyId: Scalars['Int']['input'];
};


/** Query root */
export type QueryCollectionsForGeographyBySlugArgs = {
  geographySlug: Scalars['String']['input'];
};


/** Query root */
export type QueryCollectionsForVenueIdArgs = {
  venue: CollectionForVenueRequestInput;
};


/** Query root */
export type QueryConsumerPurchasesArgs = {
  isForConciergeReservations: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryEligibleForHoldChargeArgs = {
  purchaseId: Scalars['Int']['input'];
};


/** Query root */
export type QueryEventInfoArgs = {
  businessId: Scalars['Int']['input'];
  ticketTypeId: Scalars['Int']['input'];
};


/** Query root */
export type QueryFeatureArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryFeaturesArgs = {
  type?: InputMaybe<FeatureType>;
};


/** Query root */
export type QueryHelpMenuEntriesArgs = {
  headline: Scalars['String']['input'];
  includeArchivedEntries: Scalars['Boolean']['input'];
};


/** Query root */
export type QueryHelpMenuEntryArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryIsTaxCenterStateArgs = {
  stateOrRegion: Scalars['String']['input'];
};


/** Query root */
export type QueryItemWineTypesPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryLoginDomainsForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryMetaTagsByTagTypeArgs = {
  tagTypes: Array<TagType>;
};


/** Query root */
export type QueryMetaTagsByTagTypeInternalArgs = {
  tagTypes: Array<TagType>;
};


/** Query root */
export type QueryMetroAreaArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryMetroAreasArgs = {
  activeMode?: InputMaybe<ActiveMode>;
};


/** Query root */
export type QueryNotifyPartyDetailsForCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryNotifyPartyDetailsForWaitlistItemArgs = {
  waitlistId: Scalars['Int']['input'];
};


/** Query root */
export type QueryOrderArgs = {
  id: Scalars['Int']['input'];
};


/** Query root */
export type QueryPartyDetailsForCalendarDayArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Query root */
export type QueryPartyDetailsForVisitArgs = {
  visitId: Scalars['Int']['input'];
};


/** Query root */
export type QueryPermissionPreflightArgs = {
  action: PasscodeAction;
};


/** Query root */
export type QueryPurchaseExclusivityUpdateCountArgs = {
  purchaseConfirmationCodes: Array<Scalars['String']['input']>;
};


/** Query root */
export type QueryPurchasesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  selection: Scalars['String']['input'];
};


/** Query root */
export type QueryReservationDetailsArgs = {
  confirmationCode: Scalars['String']['input'];
};


/** Query root */
export type QueryShipmentByIdArgs = {
  shipmentId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShippingCarriersArgs = {
  includeProvidersThatDoNotShipAlcohol?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Query root */
export type QueryShippingZoneOptionsForBusinessAndLocationArgs = {
  businessId: Scalars['Int']['input'];
  cart: OrderCartInput;
  state: Scalars['String']['input'];
};


/** Query root */
export type QueryShopBrandBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Query root */
export type QueryShopBusinessForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShopItemArgs = {
  filter: ShopItemFilterInput;
  itemId: Scalars['Int']['input'];
};


/** Query root */
export type QueryShopItemsArgs = {
  filter: ShopItemFilterInput;
  itemIds: Array<Scalars['Int']['input']>;
};


/** Query root */
export type QuerySingleTaxBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QuerySingleTaxBusinessesForSwitcherArgs = {
  after: Scalars['String']['input'];
  first: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  unlisted: Scalars['Boolean']['input'];
};


/** Query root */
export type QueryTagCountsByBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTaxCategoryArgs = {
  taxCategoryId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTaxCategoryEntitiesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryTicketTypesWithFuturePurchasesArgs = {
  businessId: Scalars['Int']['input'];
};


/** Query root */
export type QueryTierBySlugArgs = {
  geographySlug: Scalars['String']['input'];
};


/** Query root */
export type QueryUpcomingEventsForBusinessArgs = {
  businessId: Scalars['Int']['input'];
  excludedTicketTypeId?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryVenueBusinessInfoByDomainNameArgs = {
  domainName?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryVisibleShopBrandBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Query root */
export type QueryWineItemArgs = {
  id: Scalars['Int']['input'];
};

export const Rating = {
  Bad: 'BAD',
  Good: 'GOOD',
  Neutral: 'NEUTRAL'
} as const;

export type Rating = typeof Rating[keyof typeof Rating];
export const RatingType = {
  FivePointStar: 'FIVE_POINT_STAR',
  ThreePointEmoticon: 'THREE_POINT_EMOTICON'
} as const;

export type RatingType = typeof RatingType[keyof typeof RatingType];
export type RebalanceExecutionResult = {
  __typename?: 'RebalanceExecutionResult';
  /** RebalanceExecutionResult::rebalancePlan */
  rebalancePlan?: Maybe<RebalancePlan>;
};

export type RebalancePlan = {
  __typename?: 'RebalancePlan';
  /** RebalancePlan::after */
  after: SeatingPlan;
  /** RebalancePlan::before */
  before: SeatingPlan;
  /** RebalancePlan::getComputationTimeMillis */
  computationTimeMillis: Scalars['Int']['output'];
  /** RebalancePlan::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
};

export type RebalancePlanComparison = {
  __typename?: 'RebalancePlanComparison';
  /** RebalancePlanComparison::getDifference */
  difference: SeatingPlanDifference;
  /** RebalancePlanComparison::getRebalancePlan */
  rebalancePlan: RebalancePlan;
  /** RebalancePlanComparison::getServiceFloorplan */
  serviceFloorplan: ServiceFloorplan;
};

export type RebalanceRequestInput = {
  allowBookingOverBlocks: Scalars['Boolean']['input'];
  fromDate?: InputMaybe<Scalars['String']['input']>;
  mediumScoreOptions?: InputMaybe<MediumScoreOptionsInput>;
  softScoreOptions?: InputMaybe<SoftScoreOptionsInput>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type RefundEntity = {
  __typename?: 'RefundEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type RefundTaxEntity = Tax & {
  __typename?: 'RefundTaxEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** RefundTaxEntity_Generated::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** RefundTaxEntity_Generated::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** RefundTaxEntity_Generated::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** RefundTaxEntity_Generated::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** RefundTaxEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** RefundTaxEntity_Generated::getNetTaxableAmountCents */
  netTaxableAmountCents: Scalars['Int']['output'];
  /** RefundTaxEntity_Generated::getTaxRate */
  taxRate?: Maybe<Percent>;
  /** RefundTaxEntity_Generated::getTaxSource */
  taxSource: TaxSource;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** RefundTaxEntity_Generated::getUsState */
  usState?: Maybe<UsState>;
};

export const RegionTag = {
  AvaAdelaidaDistrict: 'AVA_ADELAIDA_DISTRICT',
  AvaAlexanderValley: 'AVA_ALEXANDER_VALLEY',
  AvaAlisosCanyon: 'AVA_ALISOS_CANYON',
  AvaAltaMesa: 'AVA_ALTA_MESA',
  AvaAltus: 'AVA_ALTUS',
  AvaAmadorCounty: 'AVA_AMADOR_COUNTY',
  AvaAncientLakesOfColumbiaValley: 'AVA_ANCIENT_LAKES_OF_COLUMBIA_VALLEY',
  AvaAndersonValley: 'AVA_ANDERSON_VALLEY',
  AvaApplegateValley: 'AVA_APPLEGATE_VALLEY',
  AvaArkansasMountain: 'AVA_ARKANSAS_MOUNTAIN',
  AvaArroyoGrandeValley: 'AVA_ARROYO_GRANDE_VALLEY',
  AvaArroyoSeco: 'AVA_ARROYO_SECO',
  AvaAtlasPeak: 'AVA_ATLAS_PEAK',
  AvaBallardCanyon: 'AVA_BALLARD_CANYON',
  AvaBellMountain: 'AVA_BELL_MOUNTAIN',
  AvaBenmoreValley: 'AVA_BENMORE_VALLEY',
  AvaBennettValley: 'AVA_BENNETT_VALLEY',
  AvaBenLomondMountain: 'AVA_BEN_LOMOND_MOUNTAIN',
  AvaBigValleyDistrictLakeCounty: 'AVA_BIG_VALLEY_DISTRICT_LAKE_COUNTY',
  AvaBordenRanch: 'AVA_BORDEN_RANCH',
  AvaCaliforniaShenandoahValley: 'AVA_CALIFORNIA_SHENANDOAH_VALLEY',
  AvaCalistoga: 'AVA_CALISTOGA',
  AvaCandyMountain: 'AVA_CANDY_MOUNTAIN',
  AvaCapeMayPeninsula: 'AVA_CAPE_MAY_PENINSULA',
  AvaCarmelValley: 'AVA_CARMEL_VALLEY',
  AvaCayugaLake: 'AVA_CAYUGA_LAKE',
  AvaChalkHill: 'AVA_CHALK_HILL',
  AvaChalone: 'AVA_CHALONE',
  AvaChehalemMountains: 'AVA_CHEHALEM_MOUNTAINS',
  AvaChilesValley: 'AVA_CHILES_VALLEY',
  AvaCienegaValley: 'AVA_CIENEGA_VALLEY',
  AvaClearLake: 'AVA_CLEAR_LAKE',
  AvaClementsHills: 'AVA_CLEMENTS_HILLS',
  AvaColeRanch: 'AVA_COLE_RANCH',
  AvaCoombsville: 'AVA_COOMBSVILLE',
  AvaCosumnesRiver: 'AVA_COSUMNES_RIVER',
  AvaCrestonDistrict: 'AVA_CRESTON_DISTRICT',
  AvaDiamondMountainDistrict: 'AVA_DIAMOND_MOUNTAIN_DISTRICT',
  AvaDryCreekValley: 'AVA_DRY_CREEK_VALLEY',
  AvaDundeeHills: 'AVA_DUNDEE_HILLS',
  AvaEagleFoothills: 'AVA_EAGLE_FOOTHILLS',
  AvaEaglePeakMendocinoCounty: 'AVA_EAGLE_PEAK_MENDOCINO_COUNTY',
  AvaEdnaValley: 'AVA_EDNA_VALLEY',
  AvaElktonOregon: 'AVA_ELKTON_OREGON',
  AvaElDorado: 'AVA_EL_DORADO',
  AvaElPomarDistrict: 'AVA_EL_POMAR_DISTRICT',
  AvaEolaAmityHills: 'AVA_EOLA_AMITY_HILLS',
  AvaFairPlay: 'AVA_FAIR_PLAY',
  AvaFennville: 'AVA_FENNVILLE',
  AvaFiddletown: 'AVA_FIDDLETOWN',
  AvaFortRossSeaview: 'AVA_FORT_ROSS_SEAVIEW',
  AvaFountaingroveDistrict: 'AVA_FOUNTAINGROVE_DISTRICT',
  AvaFredericksburgInTheTexasHillCountry: 'AVA_FREDERICKSBURG_IN_THE_TEXAS_HILL_COUNTRY',
  AvaGooseGap: 'AVA_GOOSE_GAP',
  AvaGrandRiverValley: 'AVA_GRAND_RIVER_VALLEY',
  AvaGreenValleyOfRussianRiverValley: 'AVA_GREEN_VALLEY_OF_RUSSIAN_RIVER_VALLEY',
  AvaGuenocValley: 'AVA_GUENOC_VALLEY',
  AvaHamesValley: 'AVA_HAMES_VALLEY',
  AvaHappyCanyonOfSantaBarbara: 'AVA_HAPPY_CANYON_OF_SANTA_BARBARA',
  AvaHermann: 'AVA_HERMANN',
  AvaHighValley: 'AVA_HIGH_VALLEY',
  AvaHorseHeavenHills: 'AVA_HORSE_HEAVEN_HILLS',
  AvaHowellMountain: 'AVA_HOWELL_MOUNTAIN',
  AvaIsleStGeorge: 'AVA_ISLE_ST_GEORGE',
  AvaJahant: 'AVA_JAHANT',
  AvaKanawhaRiverValley: 'AVA_KANAWHA_RIVER_VALLEY',
  AvaKelseyBenchLakeCounty: 'AVA_KELSEY_BENCH_LAKE_COUNTY',
  AvaKnightsValley: 'AVA_KNIGHTS_VALLEY',
  AvaLakeChelan: 'AVA_LAKE_CHELAN',
  AvaLakeWisconsin: 'AVA_LAKE_WISCONSIN',
  AvaLamorinda: 'AVA_LAMORINDA',
  AvaLaurelwoodDistrict: 'AVA_LAURELWOOD_DISTRICT',
  AvaLimeKilnValley: 'AVA_LIME_KILN_VALLEY',
  AvaLivermoreValley: 'AVA_LIVERMORE_VALLEY',
  AvaLosCarneros: 'AVA_LOS_CARNEROS',
  AvaLosOlivosDistrict: 'AVA_LOS_OLIVOS_DISTRICT',
  AvaLowerLongTom: 'AVA_LOWER_LONG_TOM',
  AvaMalibuNewtonCanyon: 'AVA_MALIBU_NEWTON_CANYON',
  AvaMarthaSVineyard: 'AVA_MARTHA_S_VINEYARD',
  AvaMcdowellValley: 'AVA_MCDOWELL_VALLEY',
  AvaMcminnville: 'AVA_MCMINNVILLE',
  AvaMendocino: 'AVA_MENDOCINO',
  AvaMendocinoridge: 'AVA_MENDOCINORIDGE',
  AvaMerrittIsland: 'AVA_MERRITT_ISLAND',
  AvaMokelumneRiver: 'AVA_MOKELUMNE_RIVER',
  AvaMonterey: 'AVA_MONTEREY',
  AvaMoonMountainDistrictSonomaCounty: 'AVA_MOON_MOUNTAIN_DISTRICT_SONOMA_COUNTY',
  AvaMtHarlan: 'AVA_MT_HARLAN',
  AvaMtVeeder: 'AVA_MT_VEEDER',
  AvaNachesHeights: 'AVA_NACHES_HEIGHTS',
  AvaNapaValley: 'AVA_NAPA_VALLEY',
  AvaNorthernSonoma: 'AVA_NORTHERN_SONOMA',
  AvaNorthForkOfLongIsland: 'AVA_NORTH_FORK_OF_LONG_ISLAND',
  AvaNorthYuba: 'AVA_NORTH_YUBA',
  AvaOakville: 'AVA_OAKVILLE',
  AvaOakKnollDistrictOfNapaValley: 'AVA_OAK_KNOLL_DISTRICT_OF_NAPA_VALLEY',
  AvaOzarkHighlands: 'AVA_OZARK_HIGHLANDS',
  AvaPachecoPass: 'AVA_PACHECO_PASS',
  AvaPaicines: 'AVA_PAICINES',
  AvaPasoRobles: 'AVA_PASO_ROBLES',
  AvaPasoRoblesEstrellaDistrict: 'AVA_PASO_ROBLES_ESTRELLA_DISTRICT',
  AvaPasoRoblesGeneseoDistrict: 'AVA_PASO_ROBLES_GENESEO_DISTRICT',
  AvaPasoRoblesHighlandsDistrict: 'AVA_PASO_ROBLES_HIGHLANDS_DISTRICT',
  AvaPasoRoblesWillowCreekDistrict: 'AVA_PASO_ROBLES_WILLOW_CREEK_DISTRICT',
  AvaPetalumaGap: 'AVA_PETALUMA_GAP',
  AvaPineMountainCloverdalePeak: 'AVA_PINE_MOUNTAIN_CLOVERDALE_PEAK',
  AvaPotterValley: 'AVA_POTTER_VALLEY',
  AvaRamonaValley: 'AVA_RAMONA_VALLEY',
  AvaRattlesnakeHills: 'AVA_RATTLESNAKE_HILLS',
  AvaRedwoodValley: 'AVA_REDWOOD_VALLEY',
  AvaRedHillsLakeCounty: 'AVA_RED_HILLS_LAKE_COUNTY',
  AvaRedHillDouglasCountyOregon: 'AVA_RED_HILL_DOUGLAS_COUNTY_OREGON',
  AvaRedMountain: 'AVA_RED_MOUNTAIN',
  AvaRibbonRidge: 'AVA_RIBBON_RIDGE',
  AvaRockpile: 'AVA_ROCKPILE',
  AvaRogueValley: 'AVA_ROGUE_VALLEY',
  AvaRoyalSlope: 'AVA_ROYAL_SLOPE',
  AvaRussianRiverValley: 'AVA_RUSSIAN_RIVER_VALLEY',
  AvaRutherford: 'AVA_RUTHERFORD',
  AvaSaddleRockMalibu: 'AVA_SADDLE_ROCK_MALIBU',
  AvaSantaBarbaraCounty: 'AVA_SANTA_BARBARA_COUNTY',
  AvaSantaClaraValley: 'AVA_SANTA_CLARA_VALLEY',
  AvaSantaLuciaHighlands: 'AVA_SANTA_LUCIA_HIGHLANDS',
  AvaSantaMargaritaRanch: 'AVA_SANTA_MARGARITA_RANCH',
  AvaSantaMariaValley: 'AVA_SANTA_MARIA_VALLEY',
  AvaSantaYnezValley: 'AVA_SANTA_YNEZ_VALLEY',
  AvaSanAntonioValley: 'AVA_SAN_ANTONIO_VALLEY',
  AvaSanBenito: 'AVA_SAN_BENITO',
  AvaSanBernabe: 'AVA_SAN_BERNABE',
  AvaSanFranciscoBay: 'AVA_SAN_FRANCISCO_BAY',
  AvaSanJuanCreek: 'AVA_SAN_JUAN_CREEK',
  AvaSanLucas: 'AVA_SAN_LUCAS',
  AvaSanLuisObispoCoast: 'AVA_SAN_LUIS_OBISPO_COAST',
  AvaSanMiguelDistrict: 'AVA_SAN_MIGUEL_DISTRICT',
  AvaSanPasqualValley: 'AVA_SAN_PASQUAL_VALLEY',
  AvaSanYsidroDistrict: 'AVA_SAN_YSIDRO_DISTRICT',
  AvaSenecaLake: 'AVA_SENECA_LAKE',
  AvaSloughhouse: 'AVA_SLOUGHHOUSE',
  AvaSnipesMountain: 'AVA_SNIPES_MOUNTAIN',
  AvaSolanoCountyGreenValley: 'AVA_SOLANO_COUNTY_GREEN_VALLEY',
  AvaSonomaCoast: 'AVA_SONOMA_COAST',
  AvaSonomaCounty: 'AVA_SONOMA_COUNTY',
  AvaSonomaMountain: 'AVA_SONOMA_MOUNTAIN',
  AvaSonomaValley: 'AVA_SONOMA_VALLEY',
  AvaSpringMountainDistrict: 'AVA_SPRING_MOUNTAIN_DISTRICT',
  AvaStagsLeapDistrict: 'AVA_STAGS_LEAP_DISTRICT',
  AvaStaRitaHills: 'AVA_STA_RITA_HILLS',
  AvaStHelena: 'AVA_ST_HELENA',
  AvaSuisunValley: 'AVA_SUISUN_VALLEY',
  AvaSwanCreek: 'AVA_SWAN_CREEK',
  AvaTemeculaValley: 'AVA_TEMECULA_VALLEY',
  AvaTempletonGapDistrict: 'AVA_TEMPLETON_GAP_DISTRICT',
  AvaTheBurnOfColumbiaValley: 'AVA_THE_BURN_OF_COLUMBIA_VALLEY',
  AvaTheHamptonsLongIsland: 'AVA_THE_HAMPTONS_LONG_ISLAND',
  AvaTheRocksDistrictOfMiltonFreewater: 'AVA_THE_ROCKS_DISTRICT_OF_MILTON_FREEWATER',
  AvaTualatinHills: 'AVA_TUALATIN_HILLS',
  AvaUmpquaValley: 'AVA_UMPQUA_VALLEY',
  AvaUpperMississippiRiverValley: 'AVA_UPPER_MISSISSIPPI_RIVER_VALLEY',
  AvaVanDuzerCorridor: 'AVA_VAN_DUZER_CORRIDOR',
  AvaWahlukeSlope: 'AVA_WAHLUKE_SLOPE',
  AvaWallaWallaValley: 'AVA_WALLA_WALLA_VALLEY',
  AvaWhiteBluffs: 'AVA_WHITE_BLUFFS',
  AvaWildHorseValley: 'AVA_WILD_HORSE_VALLEY',
  AvaYakimaValley: 'AVA_YAKIMA_VALLEY',
  AvaYamhillCarlton: 'AVA_YAMHILL_CARLTON',
  AvaYorkvilleHighlands: 'AVA_YORKVILLE_HIGHLANDS',
  AvaYorkMountain: 'AVA_YORK_MOUNTAIN',
  AvaYountville: 'AVA_YOUNTVILLE',
  CountryUs: 'COUNTRY_US',
  RegionAlexandriaLakes: 'REGION_ALEXANDRIA_LAKES',
  RegionAntelopeValleyOfTheCaliforniaHighDesert: 'REGION_ANTELOPE_VALLEY_OF_THE_CALIFORNIA_HIGH_DESERT',
  RegionAppalachianHighCountry: 'REGION_APPALACHIAN_HIGH_COUNTRY',
  RegionAugusta: 'REGION_AUGUSTA',
  RegionCapayValley: 'REGION_CAPAY_VALLEY',
  RegionCatoctin: 'REGION_CATOCTIN',
  RegionCentralCoast: 'REGION_CENTRAL_COAST',
  RegionCentralDelawareValley: 'REGION_CENTRAL_DELAWARE_VALLEY',
  RegionChamplainValleyOfNewYork: 'REGION_CHAMPLAIN_VALLEY_OF_NEW_YORK',
  RegionClarksburg: 'REGION_CLARKSBURG',
  RegionColumbiaGorge: 'REGION_COLUMBIA_GORGE',
  RegionColumbiaValley: 'REGION_COLUMBIA_VALLEY',
  RegionCovelo: 'REGION_COVELO',
  RegionCrestOfTheBlueRidgeHendersonCounty: 'REGION_CREST_OF_THE_BLUE_RIDGE_HENDERSON_COUNTY',
  RegionCucamongaValley: 'REGION_CUCAMONGA_VALLEY',
  RegionCumberlandValley: 'REGION_CUMBERLAND_VALLEY',
  RegionDahlonegaPlateau: 'REGION_DAHLONEGA_PLATEAU',
  RegionDiabloGrande: 'REGION_DIABLO_GRANDE',
  RegionDosRios: 'REGION_DOS_RIOS',
  RegionDunniganHills: 'REGION_DUNNIGAN_HILLS',
  RegionEasternConnecticutHighlands: 'REGION_EASTERN_CONNECTICUT_HIGHLANDS',
  RegionEscondidoValley: 'REGION_ESCONDIDO_VALLEY',
  RegionFingerLakes: 'REGION_FINGER_LAKES',
  RegionGrandValley: 'REGION_GRAND_VALLEY',
  RegionHawRiverValley: 'REGION_HAW_RIVER_VALLEY',
  RegionHudsonRiverRegion: 'REGION_HUDSON_RIVER_REGION',
  RegionIndianaUplands: 'REGION_INDIANA_UPLANDS',
  RegionInwoodValley: 'REGION_INWOOD_VALLEY',
  RegionLakeErie: 'REGION_LAKE_ERIE',
  RegionLakeMichiganShore: 'REGION_LAKE_MICHIGAN_SHORE',
  RegionLancasterValley: 'REGION_LANCASTER_VALLEY',
  RegionLeelanauPeninsula: 'REGION_LEELANAU_PENINSULA',
  RegionLehighValley: 'REGION_LEHIGH_VALLEY',
  RegionLeonaValley: 'REGION_LEONA_VALLEY',
  RegionLewisClarkValley: 'REGION_LEWIS_CLARK_VALLEY',
  RegionLinganore: 'REGION_LINGANORE',
  RegionLodi: 'REGION_LODI',
  RegionLoessHillsDistrict: 'REGION_LOESS_HILLS_DISTRICT',
  RegionLongIsland: 'REGION_LONG_ISLAND',
  RegionLoramieCreek: 'REGION_LORAMIE_CREEK',
  RegionMadera: 'REGION_MADERA',
  RegionMalibuCoast: 'REGION_MALIBU_COAST',
  RegionMantonValley: 'REGION_MANTON_VALLEY',
  RegionMesillaValley: 'REGION_MESILLA_VALLEY',
  RegionMiddleburgVirginia: 'REGION_MIDDLEBURG_VIRGINIA',
  RegionMiddleRioGrandeValley: 'REGION_MIDDLE_RIO_GRANDE_VALLEY',
  RegionMimbresValley: 'REGION_MIMBRES_VALLEY',
  RegionMississippiDelta: 'REGION_MISSISSIPPI_DELTA',
  RegionMonticello: 'REGION_MONTICELLO',
  RegionNiagaraEscarpment: 'REGION_NIAGARA_ESCARPMENT',
  RegionNorthernNeckGeorgeWashingtonBirthplace: 'REGION_NORTHERN_NECK_GEORGE_WASHINGTON_BIRTHPLACE',
  RegionNorthCoast: 'REGION_NORTH_COAST',
  RegionNorthForkOfRoanoke: 'REGION_NORTH_FORK_OF_ROANOKE',
  RegionNotfound: 'REGION_NOTFOUND',
  RegionOhioRiverValley: 'REGION_OHIO_RIVER_VALLEY',
  RegionOldMissionPeninsula: 'REGION_OLD_MISSION_PENINSULA',
  RegionOuterCoastalPlain: 'REGION_OUTER_COASTAL_PLAIN',
  RegionOzarkMountain: 'REGION_OZARK_MOUNTAIN',
  RegionPalosVerdesPeninsula: 'REGION_PALOS_VERDES_PENINSULA',
  RegionPugetSound: 'REGION_PUGET_SOUND',
  RegionRiverJunction: 'REGION_RIVER_JUNCTION',
  RegionRockyKnob: 'REGION_ROCKY_KNOB',
  RegionSaladoCreek: 'REGION_SALADO_CREEK',
  RegionSantaCruzMountains: 'REGION_SANTA_CRUZ_MOUNTAINS',
  RegionSeiadValley: 'REGION_SEIAD_VALLEY',
  RegionShawneeHills: 'REGION_SHAWNEE_HILLS',
  RegionShenandoahValley: 'REGION_SHENANDOAH_VALLEY',
  RegionSierraFoothills: 'REGION_SIERRA_FOOTHILLS',
  RegionSierraPelonaValley: 'REGION_SIERRA_PELONA_VALLEY',
  RegionSnakeRiverValley: 'REGION_SNAKE_RIVER_VALLEY',
  RegionSonoita: 'REGION_SONOITA',
  RegionSoutheasternNewEngland: 'REGION_SOUTHEASTERN_NEW_ENGLAND',
  RegionSouthernOregon: 'REGION_SOUTHERN_OREGON',
  RegionSouthCoast: 'REGION_SOUTH_COAST',
  RegionSquawValleyMiramonte: 'REGION_SQUAW_VALLEY_MIRAMONTE',
  RegionTehachapiMountains: 'REGION_TEHACHAPI_MOUNTAINS',
  RegionTexasDavisMountains: 'REGION_TEXAS_DAVIS_MOUNTAINS',
  RegionTexasHighPlains: 'REGION_TEXAS_HIGH_PLAINS',
  RegionTexasHillCountry: 'REGION_TEXAS_HILL_COUNTRY',
  RegionTexoma: 'REGION_TEXOMA',
  RegionTipOfTheMitt: 'REGION_TIP_OF_THE_MITT',
  RegionTracyHills: 'REGION_TRACY_HILLS',
  RegionTrinityLakes: 'REGION_TRINITY_LAKES',
  RegionUlupalakua: 'REGION_ULUPALAKUA',
  RegionUpperHiwasseeHighlands: 'REGION_UPPER_HIWASSEE_HIGHLANDS',
  RegionUpperHudson: 'REGION_UPPER_HUDSON',
  RegionUpperMississippiRiverValley: 'REGION_UPPER_MISSISSIPPI_RIVER_VALLEY',
  RegionVerdeValley: 'REGION_VERDE_VALLEY',
  RegionVirginiaPeninsula: 'REGION_VIRGINIA_PENINSULA',
  RegionVirginiaSEasternShore: 'REGION_VIRGINIA_S_EASTERN_SHORE',
  RegionWarrenHills: 'REGION_WARREN_HILLS',
  RegionWesternConnecticutHighlands: 'REGION_WESTERN_CONNECTICUT_HIGHLANDS',
  RegionWestElks: 'REGION_WEST_ELKS',
  RegionWillametteValley: 'REGION_WILLAMETTE_VALLEY',
  RegionWillcox: 'REGION_WILLCOX',
  RegionWillowCreek: 'REGION_WILLOW_CREEK',
  RegionWisconsinLedge: 'REGION_WISCONSIN_LEDGE',
  RegionYadkinValley: 'REGION_YADKIN_VALLEY',
  StateAk: 'STATE_AK',
  StateAl: 'STATE_AL',
  StateAr: 'STATE_AR',
  StateAz: 'STATE_AZ',
  StateCa: 'STATE_CA',
  StateCo: 'STATE_CO',
  StateCt: 'STATE_CT',
  StateDe: 'STATE_DE',
  StateFl: 'STATE_FL',
  StateGa: 'STATE_GA',
  StateHi: 'STATE_HI',
  StateIa: 'STATE_IA',
  StateId: 'STATE_ID',
  StateIl: 'STATE_IL',
  StateIn: 'STATE_IN',
  StateKs: 'STATE_KS',
  StateKy: 'STATE_KY',
  StateLa: 'STATE_LA',
  StateMa: 'STATE_MA',
  StateMd: 'STATE_MD',
  StateMe: 'STATE_ME',
  StateMi: 'STATE_MI',
  StateMn: 'STATE_MN',
  StateMo: 'STATE_MO',
  StateMs: 'STATE_MS',
  StateMt: 'STATE_MT',
  StateNc: 'STATE_NC',
  StateNd: 'STATE_ND',
  StateNe: 'STATE_NE',
  StateNh: 'STATE_NH',
  StateNj: 'STATE_NJ',
  StateNm: 'STATE_NM',
  StateNv: 'STATE_NV',
  StateNy: 'STATE_NY',
  StateOh: 'STATE_OH',
  StateOk: 'STATE_OK',
  StateOr: 'STATE_OR',
  StatePa: 'STATE_PA',
  StateRi: 'STATE_RI',
  StateSc: 'STATE_SC',
  StateSd: 'STATE_SD',
  StateTn: 'STATE_TN',
  StateTx: 'STATE_TX',
  StateUt: 'STATE_UT',
  StateVa: 'STATE_VA',
  StateVt: 'STATE_VT',
  StateWa: 'STATE_WA',
  StateWi: 'STATE_WI',
  StateWv: 'STATE_WV',
  StateWy: 'STATE_WY'
} as const;

export type RegionTag = typeof RegionTag[keyof typeof RegionTag];
export const RegionTagType = {
  Ava: 'AVA',
  Country: 'COUNTRY',
  Region: 'REGION',
  State: 'STATE'
} as const;

export type RegionTagType = typeof RegionTagType[keyof typeof RegionTagType];
export type RegionTagWrapper = {
  __typename?: 'RegionTagWrapper';
  /** RegionTagWrapper::getEnumName */
  enumName: Scalars['String']['output'];
  /** RegionTagWrapper::getName */
  name: Scalars['String']['output'];
  /** RegionTagWrapper::getParents */
  parents: Array<RegionTagWrapper>;
  /** RegionTagWrapper::getType */
  type: RegionTagType;
};

export const RelevantInventoryType = {
  Any: 'ANY',
  FlexOnly: 'FLEX_ONLY',
  SlotOnly: 'SLOT_ONLY'
} as const;

export type RelevantInventoryType = typeof RelevantInventoryType[keyof typeof RelevantInventoryType];
export const RepetitionInterval = {
  Day: 'DAY',
  Month: 'MONTH',
  Week: 'WEEK'
} as const;

export type RepetitionInterval = typeof RepetitionInterval[keyof typeof RepetitionInterval];
export type RepetitionOccurrenceSet = {
  __typename?: 'RepetitionOccurrenceSet';
  /** RepetitionOccurrenceSet::nthDay */
  nthDay: Array<Scalars['Int']['output']>;
  /** RepetitionOccurrenceSet::nthWeekday */
  nthWeekday: Array<NthWeekday>;
};

export type ReservationHistoryCount = {
  __typename?: 'ReservationHistoryCount';
  /** ReservationHistoryCount::cancelledBookingsCount */
  cancelledBookingsCount: Scalars['Int']['output'];
  /** ReservationHistoryCount::pastBookingsCount */
  pastBookingsCount: Scalars['Int']['output'];
  /** ReservationHistoryCount::patron */
  patron?: Maybe<PatronEntity>;
  /** ReservationHistoryCount::upComingBookingsCount */
  upComingBookingsCount: Scalars['Int']['output'];
};

export type ReservationQuestion = {
  /** ReservationQuestion::name */
  name?: Maybe<Scalars['String']['output']>;
  /** ReservationQuestion::question */
  question?: Maybe<Scalars['String']['output']>;
};

export type ReservationQuestionnaire = {
  __typename?: 'ReservationQuestionnaire';
  /** ReservationQuestionnaire::introductionMessage */
  introductionMessage?: Maybe<Scalars['String']['output']>;
  /** ReservationQuestionnaire::questions */
  questions: Array<ReservationQuestion>;
  /** ReservationQuestionnaire::isSurveySubmissionAllowed */
  surveySubmissionAllowed: Scalars['Boolean']['output'];
};

export type ResetCompromisedAccountPayload = {
  __typename?: 'ResetCompromisedAccountPayload';
  /** ResetCompromisedAccountPayload::errors */
  errors: Array<ErrorResult>;
  /** ResetCompromisedAccountPayload::failedPatronIds */
  failedPatronIds: Array<Scalars['Int']['output']>;
  /** ResetCompromisedAccountPayload::successCount */
  successCount: Scalars['Int']['output'];
};

export const ResultType = {
  Failure: 'FAILURE',
  Success: 'SUCCESS'
} as const;

export type ResultType = typeof ResultType[keyof typeof ResultType];
export type RoleBusinessPermissionRequestEntity = {
  __typename?: 'RoleBusinessPermissionRequestEntity';
  /** RoleBusinessPermissionRequestEntity_Generated::getApprovedAt */
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getApproverPatron */
  approverPatron?: Maybe<PatronEntity>;
  /** RoleBusinessPermissionRequestEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getExpiresAt */
  expiresAt?: Maybe<Scalars['Instant']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getIsApproved */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getIsExpired */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /** RoleBusinessPermissionRequestEntity_Generated::getReason */
  reason: Scalars['String']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestWorkflowId */
  requestWorkflowId: Scalars['String']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestedAt */
  requestedAt: Scalars['Instant']['output'];
  /** RoleBusinessPermissionRequestEntity_Generated::getRequestingPatron */
  requestingPatron: PatronEntity;
  /** RoleBusinessPermissionRequestEntity_Generated::getRole */
  role: BusinessRole;
  /** RoleBusinessPermissionRequestEntity::getStatus */
  status?: Maybe<Status>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ScaleTag = {
  __typename?: 'ScaleTag';
  /** ScaleTag::enumValue */
  enumValue: Scalars['String']['output'];
  /** ScaleTag::maxLabel */
  maxLabel: Scalars['String']['output'];
  /** ScaleTag::maxValue */
  maxValue: Scalars['Int']['output'];
  /** ScaleTag::minLabel */
  minLabel: Scalars['String']['output'];
  /** ScaleTag::minValue */
  minValue: Scalars['Int']['output'];
  /** ScaleTag::name */
  name: Scalars['String']['output'];
  /** ScaleTag::scaleTagType */
  scaleTagType: ScaleTagType;
};

export type ScaleTagInfo = {
  __typename?: 'ScaleTagInfo';
  /** ScaleTagInfo::maxLabel */
  maxLabel?: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::minLabel */
  minLabel?: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::name */
  name?: Maybe<Scalars['String']['output']>;
  /** ScaleTagInfo::value */
  value?: Maybe<Scalars['Int']['output']>;
};

export const ScaleTagType = {
  WineStructure: 'WINE_STRUCTURE'
} as const;

export type ScaleTagType = typeof ScaleTagType[keyof typeof ScaleTagType];
export type ScaleTagValueInput = {
  enumValue?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** Schedule::scheduleDate */
  scheduleDate: Array<ScheduleDateEntity>;
  /** Schedule::scheduleRepetition */
  scheduleRepetition: Array<ScheduleRepetition>;
};

export type ScheduleDateEntity = {
  __typename?: 'ScheduleDateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ScheduleDateEntity_Generated::getDate */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ScheduleEndingAction = AvailabilityAction & {
  __typename?: 'ScheduleEndingAction';
  /** ScheduleEndingAction::schedule */
  schedule: BusinessInventoryScheduleEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type ScheduleInPastAction = AvailabilityAction & {
  __typename?: 'ScheduleInPastAction';
  /** ScheduleInPastAction::schedule */
  schedule: BusinessInventoryScheduleEntity;
  /** AvailabilityCriticalAction::type */
  type: AvailabilityActionType;
};

export type ScheduleRepetition = {
  __typename?: 'ScheduleRepetition';
  /** ScheduleRepetition::id */
  id: Scalars['Int']['output'];
  /** ScheduleRepetition::repeatsEvery */
  repeatsEvery?: Maybe<RepetitionInterval>;
  /** ScheduleRepetition::repeatsFrom */
  repeatsFrom?: Maybe<Scalars['LocalDate']['output']>;
  /** ScheduleRepetition::repeatsOn */
  repeatsOn?: Maybe<RepetitionOccurrenceSet>;
  /** ScheduleRepetition::repeatsUntil */
  repeatsUntil?: Maybe<Scalars['LocalDate']['output']>;
  /** ScheduleRepetition::repeatsUntilNDays */
  repeatsUntilNDays: Scalars['Int']['output'];
};

export type Score = {
  __typename?: 'Score';
  /** Score::getExplanation */
  explanation: Scalars['String']['output'];
  /** Score::getHardScore */
  hardScore: Scalars['Int']['output'];
  /** Score::getMediumScore */
  mediumScore: Scalars['Int']['output'];
  /** Score::getSoftScore */
  softScore: Scalars['Int']['output'];
};

export type ScoreForService = {
  __typename?: 'ScoreForService';
  /** ScoreForService::getScore */
  score: Score;
  /** ScoreForService::getServiceEndLocalTime */
  serviceEndLocalTime: Scalars['LocalTime']['output'];
  /** ScoreForService::getServiceStartLocalTime */
  serviceStartLocalTime: Scalars['LocalTime']['output'];
};

export type SearchAttributeEntity = {
  __typename?: 'SearchAttributeEntity';
  /** SearchAttributeEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** SearchAttributeEntity_Generated::getIsArchived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** SearchAttributeEntity_Generated::getMetroArea */
  metroArea?: Maybe<MetroAreaEntity>;
  /** SearchAttributeEntity_Generated::getNearestMetro */
  nearestMetro?: Maybe<Scalars['String']['output']>;
  /** SearchAttributeEntity_Generated::getNeighborhood */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type SearchAttributeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  metroAreaId?: InputMaybe<Scalars['Int']['input']>;
  nearestMetro?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
};

export type SeatingArea = {
  __typename?: 'SeatingArea';
  /** SeatingArea::enumValue */
  enumValue: SeatingAreaTypes;
  /** SeatingArea::name */
  name: Scalars['String']['output'];
};

export type SeatingAreaEntity = {
  __typename?: 'SeatingAreaEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type SeatingAreaOptions = {
  __typename?: 'SeatingAreaOptions';
  /** SeatingAreaOptions::indoor */
  indoor: Array<SeatingArea>;
  /** SeatingAreaOptions::outdoor */
  outdoor: Array<SeatingArea>;
};

export type SeatingAreaOutput = {
  __typename?: 'SeatingAreaOutput';
  /** SeatingAreaOutput::enumValue */
  enumValue: SeatingAreaTypes;
  /** SeatingAreaOutput::name */
  name: Scalars['String']['output'];
  /** SeatingAreaOutput::isOutdoor */
  outdoor: Scalars['Boolean']['output'];
  /** SeatingAreaOutput::seatingAreaId */
  seatingAreaId: Scalars['Int']['output'];
};

export const SeatingAreaTypes = {
  Bar: 'BAR',
  Booth: 'BOOTH',
  Cellar: 'CELLAR',
  ChefsCounter: 'CHEFS_COUNTER',
  ChefsTable: 'CHEFS_TABLE',
  CommunalTable: 'COMMUNAL_TABLE',
  Counter: 'COUNTER',
  Courtyard: 'COURTYARD',
  DiningRoom: 'DINING_ROOM',
  Dome: 'DOME',
  Downstairs: 'DOWNSTAIRS',
  Garden: 'GARDEN',
  HighTop: 'HIGH_TOP',
  Igloo: 'IGLOO',
  Indoor: 'INDOOR',
  KitchenCounter: 'KITCHEN_COUNTER',
  KitchenTable: 'KITCHEN_TABLE',
  Lounge: 'LOUNGE',
  Outdoor: 'OUTDOOR',
  OutdoorBar: 'OUTDOOR_BAR',
  Patio: 'PATIO',
  Rooftop: 'ROOFTOP',
  Table: 'TABLE',
  TastingRoom: 'TASTING_ROOM',
  Terrace: 'TERRACE',
  Upstairs: 'UPSTAIRS',
  Veranda: 'VERANDA',
  Vineyard: 'VINEYARD'
} as const;

export type SeatingAreaTypes = typeof SeatingAreaTypes[keyof typeof SeatingAreaTypes];
export type SeatingPlan = {
  __typename?: 'SeatingPlan';
  /** SeatingPlan::getBookingsToTables */
  bookingsToTables: Array<BookingToTables>;
  /** SeatingPlan::getHoldsToTables */
  holdsToTables: Array<HoldToTables>;
  /** SeatingPlan::scoresForServices */
  scoresForServices: Array<ScoreForService>;
  /** SeatingPlan::serviceDate */
  serviceDate: Scalars['LocalDate']['output'];
  /** SeatingPlan::slotBookings */
  slotBookings: Array<Booking>;
  /** SeatingPlan::unassignedBookings */
  unassignedBookings: Array<Booking>;
  /** SeatingPlan::unassignedHolds */
  unassignedHolds: Array<Hold>;
};

export type SeatingPlanDifference = {
  __typename?: 'SeatingPlanDifference';
  /** SeatingPlanDifference::bookingsOnTablesWithDifferingExperienceLeft */
  bookingsOnTablesWithDifferingExperienceLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::bookingsOnTablesWithDifferingExperienceRight */
  bookingsOnTablesWithDifferingExperienceRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::differingTableAssignments */
  differingTableAssignments: Scalars['Int']['output'];
  /** SeatingPlanDifference::exactMatch */
  exactMatch: Scalars['Boolean']['output'];
  /** SeatingPlanDifference::overbookedTablesLeft */
  overbookedTablesLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::overbookedTablesRight */
  overbookedTablesRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::totalTableAssignmentsLeft */
  totalTableAssignmentsLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::totalTableAssignmentsRight */
  totalTableAssignmentsRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedBookingsLeft */
  unassignedBookingsLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedBookingsRight */
  unassignedBookingsRight: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedCoversLeft */
  unassignedCoversLeft: Scalars['Int']['output'];
  /** SeatingPlanDifference::unassignedCoversRight */
  unassignedCoversRight: Scalars['Int']['output'];
};

export type SeatingTemplateTableEntity = {
  __typename?: 'SeatingTemplateTableEntity';
  /** SeatingTemplateTableEntity_Generated::getAssignmentPriorityLevel */
  assignmentPriorityLevel: TableAssignmentPriorityLevel;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type Section = {
  __typename?: 'Section';
  /** Section::bookedCoverCount */
  bookedCoverCount: Scalars['Int']['output'];
  /** Section::sectionLabel */
  sectionLabel: Scalars['ID']['output'];
};

export type ServiceChargePurchasedTaxable = Taxable & {
  __typename?: 'ServiceChargePurchasedTaxable';
  /** ServiceChargePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** ServiceChargePurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type ServiceFloorplan = {
  __typename?: 'ServiceFloorplan';
  /** ServiceFloorplan::bookableTables */
  bookableTables: Array<BookableTable>;
  /** ServiceFloorplan::serviceEndLocalTime */
  serviceEndLocalTime: Scalars['LocalTime']['output'];
  /** ServiceFloorplan::serviceStartLocalTime */
  serviceStartLocalTime: Scalars['LocalTime']['output'];
};

export type ShipCompliantItemInput = {
  brandKey: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export type ShipCompliantItemValidation = {
  __typename?: 'ShipCompliantItemValidation';
  /** ShipCompliantItemValidation::brandKey */
  brandKey?: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::description */
  description?: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::errorMessage */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::name */
  name?: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::percentAlcohol */
  percentAlcohol?: Maybe<Scalars['Int']['output']>;
  /** ShipCompliantItemValidation::priceCents */
  priceCents?: Maybe<Scalars['Int']['output']>;
  /** ShipCompliantItemValidation::productType */
  productType?: Maybe<ProductType>;
  /** ShipCompliantItemValidation::sku */
  sku?: Maybe<Scalars['String']['output']>;
  /** ShipCompliantItemValidation::success */
  success: Scalars['Boolean']['output'];
};

export const ShipCompliantShipmentStatus = {
  Delivered: 'DELIVERED',
  InProcess: 'IN_PROCESS',
  PaymentAccepted: 'PAYMENT_ACCEPTED',
  SentToFulfillment: 'SENT_TO_FULFILLMENT',
  Shipped: 'SHIPPED',
  Voided: 'VOIDED'
} as const;

export type ShipCompliantShipmentStatus = typeof ShipCompliantShipmentStatus[keyof typeof ShipCompliantShipmentStatus];
export const ShipCompliantStatus = {
  Active: 'ACTIVE',
  Archived: 'ARCHIVED',
  AutoArchived: 'AUTO_ARCHIVED'
} as const;

export type ShipCompliantStatus = typeof ShipCompliantStatus[keyof typeof ShipCompliantStatus];
export type ShippingCarriersEnum = {
  __typename?: 'ShippingCarriersEnum';
  /** ShippingCarriersEnum::canShipAlcohol */
  canShipAlcohol?: Maybe<Scalars['Boolean']['output']>;
  /** ShippingCarriersEnum::key */
  key?: Maybe<Scalars['String']['output']>;
};

export type ShippingCodesEnum = {
  __typename?: 'ShippingCodesEnum';
  /** ShippingCodesEnum::estimatedDays */
  estimatedDays?: Maybe<Scalars['Int']['output']>;
  /** ShippingCodesEnum::key */
  key?: Maybe<Scalars['String']['output']>;
  /** ShippingCodesEnum::name */
  name?: Maybe<Scalars['String']['output']>;
};

export type ShippingConfigurationEntity = {
  __typename?: 'ShippingConfigurationEntity';
  /** ShippingConfigurationEntity::getActiveShippingZones */
  activeShippingZones: Array<ShippingZoneEntity>;
  /** ShippingConfigurationEntity_Generated::getCommunicationEnabled */
  communicationEnabled: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShippingConfigurationEntity_Generated::getDefaultShippingStatus */
  defaultShippingStatus: ShipCompliantShipmentStatus;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingConfigurationEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingConfigurationEntity_Generated::getProcessingTimeDays */
  processingTimeDays: Scalars['Int']['output'];
  /** ShippingConfigurationEntity_Generated::getShippingZones */
  shippingZones: Array<ShippingZoneEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingConfigurationInput = {
  communicationEnabled: Scalars['Boolean']['input'];
  defaultShippingStatus: ShipCompliantShipmentStatus;
  processingTimeDays: Scalars['Int']['input'];
};

export type ShippingStateEntity = {
  __typename?: 'ShippingStateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingStateEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingStateEntity_Generated::getShippingStateItemTypes */
  shippingStateItemTypes: Array<ShippingStateItemTypeEntity>;
  /** ShippingStateEntity_Generated::getShippingZone */
  shippingZone: ShippingZoneEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShippingStateEntity_Generated::getUsState */
  usState: Scalars['String']['output'];
};

export type ShippingStateItemTypeEntity = {
  __typename?: 'ShippingStateItemTypeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingStateItemTypeEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingStateItemTypeEntity_Generated::getShipCompliantItemTypeEligibility */
  shipCompliantItemTypeEligibility: ProductType;
  /** ShippingStateItemTypeEntity_Generated::getShippingState */
  shippingState: ShippingStateEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingStateOptionInput = {
  eligibility?: InputMaybe<Array<ProductType>>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingZoneEntity = {
  __typename?: 'ShippingZoneEntity';
  /** ShippingZoneEntity::getActiveOptions */
  activeOptions: Array<ShippingZoneOptionEntity>;
  /** ShippingZoneEntity::getActiveStates */
  activeStates: Array<ShippingStateEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShippingZoneEntity_Generated::getOptions */
  options: Array<ShippingZoneOptionEntity>;
  /** ShippingZoneEntity_Generated::getStates */
  states: Array<ShippingStateEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingZoneInfoInput = {
  businessId: Scalars['Int']['input'];
  shippingConfigurationId?: InputMaybe<Scalars['Int']['input']>;
  shippingZone: ShippingZoneInput;
};

export type ShippingZoneInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  options: Array<ShippingZoneOptionInput>;
  stateOptions: Array<ShippingStateOptionInput>;
};

export const ShippingZoneOptionConfigVersion = {
  Blended: 'BLENDED',
  Friendly: 'FRIENDLY',
  FriendlyAtSuggestedRate: 'FRIENDLY_AT_SUGGESTED_RATE'
} as const;

export type ShippingZoneOptionConfigVersion = typeof ShippingZoneOptionConfigVersion[keyof typeof ShippingZoneOptionConfigVersion];
export type ShippingZoneOptionEntity = {
  __typename?: 'ShippingZoneOptionEntity';
  /** ShippingZoneOptionEntity::getActiveRates */
  activeRates: Array<ShippingZoneOptionRateEntity>;
  /** ShippingZoneOptionEntity_Generated::getAdditionalPerUnitCents */
  additionalPerUnitCents?: Maybe<Scalars['Int']['output']>;
  /** ShippingZoneOptionEntity_Generated::getAllowAboveMaxUnits */
  allowAboveMaxUnits: Scalars['Boolean']['output'];
  /** ShippingZoneOptionEntity_Generated::getCarrier */
  carrier: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getCode */
  code: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getConfigVersion */
  configVersion?: Maybe<ShippingZoneOptionConfigVersion>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShippingZoneOptionEntity_Generated::getEstimatedShippingDays */
  estimatedShippingDays?: Maybe<Scalars['Int']['output']>;
  /** ShippingZoneOptionEntity_Generated::getFulfillmentAccount */
  fulfillmentAccount?: Maybe<Scalars['String']['output']>;
  /** ShippingZoneOptionEntity_Generated::getFulfillmentWarehouse */
  fulfillmentWarehouse: FulfillmentWarehouse;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShippingZoneOptionEntity_Generated::getOrderingIndex */
  orderingIndex: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getRates */
  rates: Array<ShippingZoneOptionRateEntity>;
  /** ShippingZoneOptionEntity_Generated::getService */
  service: Scalars['String']['output'];
  /** ShippingZoneOptionEntity::getTotalDaysToShip */
  totalDaysToShip: Scalars['Int']['output'];
  /** ShippingZoneOptionEntity_Generated::getUnitType */
  unitType: ShippingZoneOptionUnitType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShippingZoneOptionEntity_Generated::getUseIceCodePrefix */
  useIceCodePrefix: Scalars['Boolean']['output'];
};

export type ShippingZoneOptionInput = {
  additionalPerUnitCents?: InputMaybe<Scalars['Int']['input']>;
  allowAboveMaxUnits?: InputMaybe<Scalars['Boolean']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configVersion?: InputMaybe<ShippingZoneOptionConfigVersion>;
  estimatedShippingDays?: InputMaybe<Scalars['Int']['input']>;
  fulfillmentAccount?: InputMaybe<Scalars['String']['input']>;
  fulfillmentWarehouse?: InputMaybe<FulfillmentWarehouse>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  rates?: InputMaybe<Array<ShippingZoneOptionRateInput>>;
  service?: InputMaybe<Scalars['String']['input']>;
  unitType?: InputMaybe<ShippingZoneOptionUnitType>;
  useIceCodePrefix?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShippingZoneOptionRateEntity = {
  __typename?: 'ShippingZoneOptionRateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getMaxUnitsInclusive */
  maxUnitsInclusive: Scalars['Int']['output'];
  /** ShippingZoneOptionRateEntity_Generated::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShippingZoneOptionRateInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  maxUnitsInclusive: Scalars['Int']['input'];
  priceCents: Scalars['Int']['input'];
};

export const ShippingZoneOptionUnitType = {
  Flat: 'FLAT',
  Quantity: 'QUANTITY',
  WeightLb: 'WEIGHT_LB'
} as const;

export type ShippingZoneOptionUnitType = typeof ShippingZoneOptionUnitType[keyof typeof ShippingZoneOptionUnitType];
export type ShopBrandEntity = {
  __typename?: 'ShopBrandEntity';
  /** ShopBrandEntity::getActiveShopBrandImages */
  activeShopBrandImages: Array<ShopBrandImageEntity>;
  /** ShopBrandEntity::getBrandImages */
  brandImages: Array<UploadedImageEntity>;
  /** Get the Business that the provided Brand belongs to. (ShopBrandResolvers::getBusiness) */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** Get brand factoids (ShopBrandResolvers::getFactoids) */
  factoids?: Maybe<ShopBrandFactoids>;
  /** ShopBrandEntity_Generated::getFoundedYear */
  foundedYear?: Maybe<Scalars['Int']['output']>;
  /** ShopBrandEntity::getHeroImage */
  heroImage?: Maybe<UploadedImageEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBrandEntity_Generated::getIsVisible */
  isVisible: Scalars['Boolean']['output'];
  /** ShopBrandEntity_Generated::getItemContexts */
  itemContexts: Array<ItemContextShopBrandEntity>;
  /** Get all Item Wines for this Brand. (WineItemsResolvers::itemWines) */
  itemWines: Array<ItemWineTypeEntity>;
  /** ShopBrandEntity_Generated::getLocation */
  location?: Maybe<Scalars['String']['output']>;
  /** ShopBrandEntity_Generated::getLogoImage */
  logoImage?: Maybe<UploadedImageEntity>;
  /** ShopBrandEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** Get related Brands for the provided Brand. (ShopBrandResolvers::getRelatedBrands) */
  relatedBrands: Array<ShopBrandEntity>;
  /** Get product types that are ineligible to ship to a given state. (ShopBrandResolvers::getShippingIneligibleProductTypes) */
  shippingIneligibleProductTypes: Array<ProductType>;
  /** ShopBrandEntity_Generated::getShopBrandImages */
  shopBrandImages: Array<ShopBrandImageEntity>;
  /** ShopBrandEntity::getShopBrandStory */
  shopBrandStory?: Maybe<ShopBrandStoryEntity>;
  /** ShopBrandEntity_Generated::getShopBrandTags */
  shopBrandTags: Array<ShopBrandTagEntity>;
  /** ShopBrandEntity_Generated::getSlug */
  slug: Scalars['String']['output'];
  /** ShopBrandEntity_Generated::getTagline */
  tagline: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShopBrandEntity_Generated::getWinemaker */
  winemaker?: Maybe<Scalars['String']['output']>;
};


export type ShopBrandEntityItemWinesArgs = {
  includeFullyArchivedWineItems?: InputMaybe<Scalars['Boolean']['input']>;
  includeWineItemsArchivedFromBrand?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ShopBrandEntityShippingIneligibleProductTypesArgs = {
  shippingState: Scalars['String']['input'];
};

export type ShopBrandFactoids = {
  __typename?: 'ShopBrandFactoids';
  /** ShopBrandFactoids::getAVAs */
  AVAs: Array<Scalars['String']['output']>;
  /** ShopBrandFactoids::getFoundedIn */
  foundedIn?: Maybe<Scalars['Int']['output']>;
  /** ShopBrandFactoids::getLocation */
  location?: Maybe<Scalars['String']['output']>;
  /** ShopBrandFactoids::getRelatedBrands */
  relatedBrands: Array<Scalars['String']['output']>;
  /** ShopBrandFactoids::getVarietals */
  varietals: Array<Scalars['String']['output']>;
};

export type ShopBrandImageEntity = {
  __typename?: 'ShopBrandImageEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandImageEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** ShopBrandImageEntity_Generated::getUploadedImage */
  uploadedImage: UploadedImageEntity;
};

export type ShopBrandInput = {
  brandImageIds: Array<Scalars['Int']['input']>;
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  logoImageId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  shopBrandTagEnumValues?: InputMaybe<Array<Scalars['String']['input']>>;
  slug: Scalars['String']['input'];
  tagline: Scalars['String']['input'];
  winemaker?: InputMaybe<Scalars['String']['input']>;
};

export type ShopBrandStoryEntity = {
  __typename?: 'ShopBrandStoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandStoryEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBrandStoryEntity_Generated::getStoryImage */
  storyImage?: Maybe<UploadedImageEntity>;
  /** ShopBrandStoryEntity_Generated::getStoryPullQuote */
  storyPullQuote: Scalars['String']['output'];
  /** ShopBrandStoryEntity_Generated::getStoryText */
  storyText: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBrandStoryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  storyImageId: Scalars['Int']['input'];
  storyPullQuote?: InputMaybe<Scalars['String']['input']>;
  storyText?: InputMaybe<Scalars['String']['input']>;
};

export type ShopBrandTagEntity = {
  __typename?: 'ShopBrandTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShopBrandTagEntity_Generated::getEnumTag */
  enumTag?: Maybe<MetaTagDecorated>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBrandTagEntity_Generated::getMetaTag */
  metaTag?: Maybe<MetaTagEntity>;
  /** ShopBrandTagEntity_Generated::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBusinessEntity = {
  __typename?: 'ShopBusinessEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** ShopBusinessEntity_Generated::getEmail */
  email?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** ShopBusinessEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** ShopBusinessEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** ShopBusinessEntity_Generated::getNotificationEmails */
  notificationEmails?: Maybe<Scalars['String']['output']>;
  /** ShopBusinessEntity::getShippingConfiguration */
  shippingConfiguration?: Maybe<ShippingConfigurationEntity>;
  /** ShopBusinessEntity_Generated::getShippingConfigurations */
  shippingConfigurations: Array<ShippingConfigurationEntity>;
  /** ShopBusinessEntity_Generated::getShopBrands */
  shopBrands: Array<ShopBrandEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopBusinessInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type ShopConfigOnboardingStateEntity = {
  __typename?: 'ShopConfigOnboardingStateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type ShopItem = {
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory?: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage?: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
};


export type ShopItemCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopItemBasicType = ShopItem & {
  __typename?: 'ShopItemBasicType';
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory?: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage?: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
};


export type ShopItemBasicTypeCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopItemFilterInput = {
  activeMode: ActiveMode;
};

export type ShopItemWineType = ShopItem & {
  __typename?: 'ShopItemWineType';
  /** ShopItemWineType::getAlcoholByVolumePercent */
  alcoholByVolumePercent: Scalars['Float']['output'];
  /** ShopItem::getBusiness */
  business: BusinessEntity;
  /** ShopItem::canShipToState */
  canShipToState: Scalars['Boolean']['output'];
  /** ShopItem::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** ShopItem::getDisplayPriceCents */
  displayPriceCents: Scalars['Int']['output'];
  /** ShopItemWineType::getExclusiveAndAgricultureTags */
  exclusiveAndAgricultureTags: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getFlavorNames */
  flavorNames: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getFlavors */
  flavors: Array<FlavorTagInfo>;
  /** ShopItemWineType::getFullDescription */
  fullDescription?: Maybe<Scalars['String']['output']>;
  /** ShopItem::getId */
  id: Scalars['Int']['output'];
  /** ShopItem::getInventory */
  inventory?: Maybe<Scalars['Int']['output']>;
  /** ShopItem::getItemImage */
  itemImage?: Maybe<UploadedImageEntity>;
  /** ShopItem::getName */
  name: Scalars['String']['output'];
  /** ShopItem::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** ShopItemWineType::getRegionNames */
  regionNames: Array<Scalars['String']['output']>;
  /** ShopItem::getRequiredAge */
  requiredAge: Scalars['Int']['output'];
  /** ShopItem::getShopBrand */
  shopBrand: ShopBrandEntity;
  /** ShopItemWineType::getStructureTags */
  structureTags: Array<ScaleTagInfo>;
  /** ShopItemWineType::getVarietalNames */
  varietalNames: Array<Scalars['String']['output']>;
  /** ShopItemWineType::getVintage */
  vintage?: Maybe<Scalars['Int']['output']>;
  /** ShopItemWineType::getVolumeMl */
  volumeMl: Scalars['Int']['output'];
  /** ShopItemWineType::getWeightLb */
  weightLb: Scalars['Float']['output'];
  /** ShopItemWineType::getWineStyleNames */
  wineStyleNames: Array<Scalars['String']['output']>;
};


export type ShopItemWineTypeCanShipToStateArgs = {
  state: Scalars['String']['input'];
};

export type ShopOnboardingState = {
  __typename?: 'ShopOnboardingState';
  /** ShopOnboardingState::states */
  states: Array<ShopOnboardingStepState>;
};

export type ShopOnboardingStepState = {
  __typename?: 'ShopOnboardingStepState';
  /** ShopOnboardingStepState::state */
  state: OnboardingState;
  /** ShopOnboardingStepState::step */
  step: OnboardingStep;
};

export type ShopOrderSearchParamsInput = {
  dateFilterType?: InputMaybe<DateFilterType>;
  dateRange?: InputMaybe<DateRangeInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TockShipmentStatus>;
};

export const ShopOrderSortProperties = {
  CreatedAt: 'CREATED_AT',
  OrderId: 'ORDER_ID',
  ShipCompliantShipmentStatus: 'SHIP_COMPLIANT_SHIPMENT_STATUS',
  ShopperEmail: 'SHOPPER_EMAIL',
  ShopperName: 'SHOPPER_NAME',
  TotalPrice: 'TOTAL_PRICE'
} as const;

export type ShopOrderSortProperties = typeof ShopOrderSortProperties[keyof typeof ShopOrderSortProperties];
export type SlimNotifyPartyDetails = {
  __typename?: 'SlimNotifyPartyDetails';
  /** SlimNotifyPartyDetails::desiredPartySize */
  desiredPartySize?: Maybe<Scalars['Int']['output']>;
  /** SlimNotifyPartyDetails::endTime */
  endTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimNotifyPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** SlimNotifyPartyDetails::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** SlimNotifyPartyDetails::patron */
  patron?: Maybe<PatronEntity>;
  /** SlimNotifyPartyDetails::startTime */
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimNotifyPartyDetails::state */
  state?: Maybe<State>;
  /** SlimNotifyPartyDetails::ticketType */
  ticketType?: Maybe<TicketTypeEntity>;
};

export type SlimPartyDetails = {
  __typename?: 'SlimPartyDetails';
  /** SlimPartyDetails::addOns */
  addOns: Array<SlimPurchasedOption>;
  /** SlimPartyDetails::amountDueCents */
  amountDueCents?: Maybe<Scalars['Float']['output']>;
  /** SlimPartyDetails::arrivalTime */
  arrivalTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::bookingNotes */
  bookingNotes: Array<BookingNoteEntity>;
  /** SlimPartyDetails::guestNotes */
  guestNotes: Array<PatronNoteEntity>;
  /** SlimPartyDetails::guestTags */
  guestTags: Array<GuestProfileTagEntity>;
  /** SlimPartyDetails::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::leftTime */
  leftTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::patron */
  patron?: Maybe<PatronEntity>;
  /** SlimPartyDetails::seatedTime */
  seatedTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** SlimPartyDetails::ticketGroupId */
  ticketGroupId?: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::ticketTypeId */
  ticketTypeId?: Maybe<Scalars['Int']['output']>;
  /** SlimPartyDetails::visitTags */
  visitTags: Array<VisitTagEntity>;
};

export type SlimPurchasedOption = {
  __typename?: 'SlimPurchasedOption';
  /** SlimPurchasedOption::id */
  id?: Maybe<Scalars['Int']['output']>;
  /** SlimPurchasedOption::name */
  name?: Maybe<Scalars['String']['output']>;
};

export type Slot = {
  /** Slot::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** Slot::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** Slot::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** Slot::ticketType */
  ticketType: TicketTypeEntity;
};

export type SocialMediaLink = {
  __typename?: 'SocialMediaLink';
  /** SocialMediaLink::platform */
  platform: SocialMediaPlatform;
  /** SocialMediaLink::url */
  url: Scalars['String']['output'];
};

export const SocialMediaPlatform = {
  SocialMediaPlatformFacebook: 'SOCIAL_MEDIA_PLATFORM_FACEBOOK',
  SocialMediaPlatformGeneric: 'SOCIAL_MEDIA_PLATFORM_GENERIC',
  SocialMediaPlatformInstagram: 'SOCIAL_MEDIA_PLATFORM_INSTAGRAM',
  SocialMediaPlatformLinkedin: 'SOCIAL_MEDIA_PLATFORM_LINKEDIN',
  SocialMediaPlatformSnapchat: 'SOCIAL_MEDIA_PLATFORM_SNAPCHAT',
  SocialMediaPlatformThreads: 'SOCIAL_MEDIA_PLATFORM_THREADS',
  SocialMediaPlatformTwitter: 'SOCIAL_MEDIA_PLATFORM_TWITTER'
} as const;

export type SocialMediaPlatform = typeof SocialMediaPlatform[keyof typeof SocialMediaPlatform];
export type SoftScoreOptions = {
  __typename?: 'SoftScoreOptions';
  /** SoftScoreOptions::penalizeDeprioritizedAssignments */
  penalizeDeprioritizedAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferBackToBackBookingsOnSameTable */
  preferBackToBackBookingsOnSameTable: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferFewestSupportedExperiences */
  preferFewestSupportedExperiences?: Maybe<Scalars['Boolean']['output']>;
  /** SoftScoreOptions::preferPerfectFits */
  preferPerfectFits: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferPrioritizedAssignments */
  preferPrioritizedAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferSingleTableAssignments */
  preferSingleTableAssignments: Scalars['Boolean']['output'];
  /** SoftScoreOptions::preferTableNotPartOfCombinationScore */
  preferTableNotPartOfCombinationScore: Scalars['Boolean']['output'];
};

export type SoftScoreOptionsInput = {
  penalizeDeprioritizedAssignments: Scalars['Boolean']['input'];
  preferBackToBackBookingsOnSameTable: Scalars['Boolean']['input'];
  preferFewestSupportedExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  preferPerfectFits: Scalars['Boolean']['input'];
  preferPrioritizedAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  preferSingleTableAssignments: Scalars['Boolean']['input'];
  preferTableNotPartOfCombinationScore: Scalars['Boolean']['input'];
};

export const SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export type SsoLoginDomainEntity = {
  __typename?: 'SsoLoginDomainEntity';
  /** SsoLoginDomainEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** SsoLoginDomainEntity_Generated::getDomainName */
  domainName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** SsoLoginDomainEntity_Generated::getProviderType */
  providerType: ProviderType;
  /** SsoLoginDomainEntity_Generated::getTenantId */
  tenantId?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const State = {
  Active: 'ACTIVE',
  Fulfilled: 'FULFILLED',
  Notified: 'NOTIFIED'
} as const;

export type State = typeof State[keyof typeof State];
export const Status = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Pending: 'PENDING',
  Rejected: 'REJECTED'
} as const;

export type Status = typeof Status[keyof typeof Status];
export type StoredCreditCardPaymentMethodInput = {
  cvvRevalidateToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** Subscription root */
export type Subscription = {
  __typename?: 'Subscription';
  /** The high-level availability status of the current business, updating in real time. (AvailabilitySubscriptionResolvers::availabilityStatus) */
  availabilityStatus?: Maybe<AvailabilityStatus>;
  /** OrderSubscriptions::beta_subscribeOrderCancellation */
  beta_subscribeOrderCancellation?: Maybe<TemporalWorkflowStatus>;
  /** OrderSubscriptions::beta_subscribeOrderResponse_v2 */
  beta_subscribeOrderResponse_v2?: Maybe<OrderExecutionResponse>;
  /** OrderSubscriptions::beta_subscribeOrderResponse_v3 */
  beta_subscribeOrderResponse_v3?: Maybe<OrderEntity>;
  /** BulkPatronActionSubscriptionResolvers::bulkDeletePatronAccounts */
  bulkDeletePatronAccounts?: Maybe<BulkPatronActionWorkflowStatus>;
  /** BulkPatronActionSubscriptionResolvers::bulkResetCompromisedAccounts */
  bulkResetCompromisedAccounts?: Maybe<BulkPatronActionWorkflowStatus>;
  /** TimelineSubscriptionResolvers::calendarDayUpdate */
  calendarDayUpdate?: Maybe<TimelineUpdate>;
  /** A subscription that responds with the passed in string (or nothing, if nothing is provided) and completes immediately. (DevSubscriptionResolvers::completeImmediately) */
  completeImmediately?: Maybe<Scalars['String']['output']>;
  /** Subscribe to the current business, updating every second. This depends on database calls and Guice injections. (DevSubscriptionResolvers::currentBusinessEverySecond) */
  currentBusinessEverySecond?: Maybe<BusinessEntity>;
  /** Respond with the current business actively fetched from the database using a dao, then complete the subscription. (DevSubscriptionResolvers::currentBusinessFromDao) */
  currentBusinessFromDao?: Maybe<BusinessEntity>;
  /** Respond with the current business from the Guice scope, then complete the subscription. (DevSubscriptionResolvers::currentBusinessFromScope) */
  currentBusinessFromScope?: Maybe<BusinessEntity>;
  /** GenerateDataSubscriptionResolvers::generateData */
  generateData?: Maybe<FakePurchaseWorkflowStatus>;
  /** ImportSubscriptionResolvers::importStatus */
  importStatus?: Maybe<ImportResponse>;
  /** A subscription that responds with the passed in string (or never responds, if nothing is provided) and never completes. The client can still unsubscribe from this. (DevSubscriptionResolvers::neverComplete) */
  neverComplete?: Maybe<Scalars['String']['output']>;
  /** TimelineSubscriptionResolvers::partyDetailsUpdate */
  partyDetailsUpdate?: Maybe<PartyDetailsUpdate>;
  /** Receive a string from pubsub. Used for debugging. (DevSubscriptionResolvers::receiveString) */
  receiveString?: Maybe<Scalars['String']['output']>;
  /** CancelBookingsSubscriptionResolvers::refundCancelFutureBookings */
  refundCancelFutureBookings?: Maybe<CancelBookingsWorkflowStatus>;
  /** The high-level shop onboarding status of the current business, updating in real time. (ShopOnboardingStateSubscriptionResolvers::shopOnboardingStatus) */
  shopOnboardingStatus?: Maybe<ShopOnboardingState>;
  /** Throw an exception to test error handling (DevSubscriptionResolvers::throwException) */
  throwException?: Maybe<Scalars['Boolean']['output']>;
  /** Subscribe to the current time at the current business, updating every second. This depends on database calls and Guice injections. (DevSubscriptionResolvers::timeAtCurrentBusiness) */
  timeAtCurrentBusiness?: Maybe<Scalars['LocalTime']['output']>;
  /** Subscribe to the current time in UTC, updating every second. This has no dependency on the database or any Guice injections. (DevSubscriptionResolvers::timeUtc) */
  timeUtc?: Maybe<Scalars['LocalTime']['output']>;
  /** ImportSubscriptionResolvers::undoImport */
  undoImport?: Maybe<ImportUndoResponse>;
  /** Subscribe to messages published to user redis topic (UserNotificationResolvers::userNotifications) */
  userNotifications?: Maybe<UserMessage>;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderCancellationArgs = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderResponse_V2Args = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBeta_SubscribeOrderResponse_V3Args = {
  workflowIdentifier: WorkflowIdentifierInput;
};


/** Subscription root */
export type SubscriptionBulkDeletePatronAccountsArgs = {
  deleteReason: DeleteReason;
  emailBehavior: EmailBehavior;
  patronIds: Array<Scalars['Int']['input']>;
};


/** Subscription root */
export type SubscriptionBulkResetCompromisedAccountsArgs = {
  patronIds: Array<Scalars['Int']['input']>;
};


/** Subscription root */
export type SubscriptionCalendarDayUpdateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Subscription root */
export type SubscriptionCompleteImmediatelyArgs = {
  arg?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription root */
export type SubscriptionGenerateDataArgs = {
  input: FakePurchasesInputInput;
};


/** Subscription root */
export type SubscriptionImportStatusArgs = {
  businessId: Scalars['Int']['input'];
};


/** Subscription root */
export type SubscriptionNeverCompleteArgs = {
  arg?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription root */
export type SubscriptionPartyDetailsUpdateArgs = {
  serviceDate: Scalars['LocalDate']['input'];
};


/** Subscription root */
export type SubscriptionReceiveStringArgs = {
  topic: Scalars['String']['input'];
};


/** Subscription root */
export type SubscriptionRefundCancelFutureBookingsArgs = {
  input: CancelBookingsInputInput;
};


/** Subscription root */
export type SubscriptionThrowExceptionArgs = {
  async: Scalars['Boolean']['input'];
  useDatabase: Scalars['Boolean']['input'];
};


/** Subscription root */
export type SubscriptionUndoImportArgs = {
  businessId: Scalars['Int']['input'];
};

export const SubscriptionAddonCanonicalType = {
  PlanAddon_2021_03SmsWaitlist: 'PLAN_ADDON_2021_03_SMS_WAITLIST'
} as const;

export type SubscriptionAddonCanonicalType = typeof SubscriptionAddonCanonicalType[keyof typeof SubscriptionAddonCanonicalType];
export const SubscriptionCanonicalName = {
  Custom: 'CUSTOM',
  Legacy: 'LEGACY',
  Plan_2020_05EventsEssential: 'PLAN_2020_05_EVENTS_ESSENTIAL',
  Plan_2020_05EventsPremium: 'PLAN_2020_05_EVENTS_PREMIUM',
  Plan_2020_05ReservationsIntro: 'PLAN_2020_05_RESERVATIONS_INTRO',
  Plan_2020_05ReservationsPlus: 'PLAN_2020_05_RESERVATIONS_PLUS',
  Plan_2020_05ReservationsPlusLite: 'PLAN_2020_05_RESERVATIONS_PLUS_LITE',
  Plan_2020_05ReservationsPlusYearly: 'PLAN_2020_05_RESERVATIONS_PLUS_YEARLY',
  Plan_2020_05ReservationsPro: 'PLAN_2020_05_RESERVATIONS_PRO',
  Plan_2020_05ReservationsProYearly: 'PLAN_2020_05_RESERVATIONS_PRO_YEARLY',
  Plan_2020_05ReservationsTtg: 'PLAN_2020_05_RESERVATIONS_TTG',
  Plan_2020_05ReservationsTtgPremium: 'PLAN_2020_05_RESERVATIONS_TTG_PREMIUM',
  Plan_2021_03SmsWaitlist: 'PLAN_2021_03_SMS_WAITLIST',
  Plan_2023_02ReservationsPlus: 'PLAN_2023_02_RESERVATIONS_PLUS',
  Plan_2023_02ReservationsPlusYearly: 'PLAN_2023_02_RESERVATIONS_PLUS_YEARLY',
  Plan_2023_02ReservationsPro: 'PLAN_2023_02_RESERVATIONS_PRO',
  Plan_2023_02ReservationsProYearly: 'PLAN_2023_02_RESERVATIONS_PRO_YEARLY',
  Plan_2024_01ReservationsAdvanced: 'PLAN_2024_01_RESERVATIONS_ADVANCED',
  Plan_2024_01ReservationsEssentials: 'PLAN_2024_01_RESERVATIONS_ESSENTIALS',
  Plan_2024_01ReservationsUnlimited: 'PLAN_2024_01_RESERVATIONS_UNLIMITED',
  Plan_2024_01SmsWaitlist: 'PLAN_2024_01_SMS_WAITLIST'
} as const;

export type SubscriptionCanonicalName = typeof SubscriptionCanonicalName[keyof typeof SubscriptionCanonicalName];
export const System = {
  Bell: 'BELL',
  Diamond: 'DIAMOND',
  Hats: 'HATS',
  Point: 'POINT',
  Ranking: 'RANKING',
  Rosette: 'ROSETTE',
  Star: 'STAR'
} as const;

export type System = typeof System[keyof typeof System];
export const TableAssignmentPriorityLevel = {
  High: 'HIGH',
  Highest: 'HIGHEST',
  Low: 'LOW',
  Lowest: 'LOWEST',
  Neutral: 'NEUTRAL'
} as const;

export type TableAssignmentPriorityLevel = typeof TableAssignmentPriorityLevel[keyof typeof TableAssignmentPriorityLevel];
export type TableBooking = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBooking::partyId */
  partyId: Scalars['ID']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableBookingPurchase = DateTimeRange & Node & TableBooking & TableStateRange & {
  __typename?: 'TableBookingPurchase';
  /** TableBookingPurchase::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBookingPurchase::partyId */
  partyId: Scalars['ID']['output'];
  /** TableBookingPurchase::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableBookingWalkIn = DateTimeRange & Node & TableBooking & TableStateRange & {
  __typename?: 'TableBookingWalkIn';
  /** TableBookingWalkIn::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableBooking::id */
  id: Scalars['ID']['output'];
  /** TableBookingWalkIn::partyId */
  partyId: Scalars['ID']['output'];
  /** TableBookingWalkIn::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableEntity = {
  __typename?: 'TableEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TableEntity_Generated::getMinPartySize */
  minSize?: Maybe<Scalars['Int']['output']>;
  /** TableEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** TableEntity_Generated::getRoom */
  room?: Maybe<Scalars['String']['output']>;
  /** TableEntity::getSeatingTemplateTable */
  seatingTemplateTable?: Maybe<SeatingTemplateTableEntity>;
  /** TableEntity_Generated::getSection */
  section?: Maybe<Scalars['String']['output']>;
  /** TableEntity_Generated::getSize */
  size?: Maybe<Scalars['Int']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TableHold = DateTimeRange & Node & TableStateRange & {
  __typename?: 'TableHold';
  /** TableHold::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** TableHold::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableStateRange = {
  /** DateTimeRange::endDateTime */
  endDateTime: Scalars['LocalDateTime']['output'];
  /** TableStateRange::id */
  id: Scalars['ID']['output'];
  /** DateTimeRange::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
};

export type TableStatesForTable = {
  __typename?: 'TableStatesForTable';
  /** TableStatesForTable::id */
  id: Scalars['Int']['output'];
  /** TableStatesForTable::tableStateRanges */
  tableStateRanges: Array<TableStateRange>;
};

export const TagSource = {
  Customer: 'CUSTOMER',
  Internal: 'INTERNAL'
} as const;

export type TagSource = typeof TagSource[keyof typeof TagSource];
export const TagType = {
  BusinessValues: 'BUSINESS_VALUES',
  Campaign: 'CAMPAIGN',
  CovidSafetyMeasureDistancing: 'COVID_SAFETY_MEASURE_DISTANCING',
  CovidSafetyMeasurePpe: 'COVID_SAFETY_MEASURE_PPE',
  CovidSafetyMeasureSanitizing: 'COVID_SAFETY_MEASURE_SANITIZING',
  CovidSafetyMeasureScreening: 'COVID_SAFETY_MEASURE_SCREENING',
  Cuisine: 'CUISINE',
  Exclusives: 'EXCLUSIVES',
  ExperienceAll: 'EXPERIENCE_ALL',
  ExperienceInPerson: 'EXPERIENCE_IN_PERSON',
  ExperienceToGo: 'EXPERIENCE_TO_GO',
  SeatingArea: 'SEATING_AREA',
  WineFlavor: 'WINE_FLAVOR',
  WineStyle: 'WINE_STYLE',
  WineVarietal: 'WINE_VARIETAL'
} as const;

export type TagType = typeof TagType[keyof typeof TagType];
export type Tax = {
  /** Tax::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export const TaxApplicationType = {
  FlatFee: 'FLAT_FEE',
  Rate: 'RATE'
} as const;

export type TaxApplicationType = typeof TaxApplicationType[keyof typeof TaxApplicationType];
export type TaxCategoryEnablementEntity = {
  __typename?: 'TaxCategoryEnablementEntity';
  /** TaxCategoryEnablementEntity::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TaxCategoryEnablementEntity_Generated::getEnablementState */
  enablementState: EnablementState;
  /** TaxCategoryEnablementEntity_Generated::getEnablementType */
  enablementType: EnablementType;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryEnablementEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TaxCategoryEnablementEntity::getRegion */
  region?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TaxCategoryEnablementInput = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  enablementState?: InputMaybe<EnablementState>;
  enablementType?: InputMaybe<EnablementType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type TaxCategoryEntity = {
  __typename?: 'TaxCategoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TaxCategoryEntity_Generated::getDisplayName */
  displayName: Scalars['String']['output'];
  /** TaxCategoryEntity_Generated::getTaxCategoryEnablements */
  enablements: Array<TaxCategoryEnablementEntity>;
  /** TaxCategoryEntity_Generated::getGlobalEnablementState */
  globalEnablementState: EnablementState;
  /** TaxCategoryEntity::isGlobalFallback */
  globalFallback: Scalars['Boolean']['output'];
  /** TaxCategoryEntity::isGloballyEnabled */
  globallyEnabled: Scalars['Boolean']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryEntity_Generated::getIsArchived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** TaxCategoryEntity_Generated::getIsGlobalFallback */
  isGlobalFallback: Scalars['Boolean']['output'];
  /** TaxCategoryEntity::getOptionalId */
  optionalId?: Maybe<Scalars['Int']['output']>;
  /** Get purchasables for the given tax category. NOTE: purchasables requires a business entity as local context. (TaxPurchasablesResolvers::purchasables) */
  purchasables: Array<Purchasable>;
  /** Get tax rates for a tax category. (TaxResolvers::rates) */
  rates?: Maybe<TaxCategoryRate_PurchasableTax>;
  /** TaxCategoryEntity_Generated::getTaxCategoryTaxSources */
  sources: Array<TaxCategoryTaxSourceEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};


export type TaxCategoryEntityRatesArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  stateOrRegion?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type TaxCategoryInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  enablementIds?: InputMaybe<Array<TaxCategoryEnablementInput>>;
  globalEnablementState?: InputMaybe<EnablementState>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isGlobalFallback?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<TaxCategoryTaxSourceInput>>;
  taxCategoryType?: InputMaybe<TaxCategoryType>;
};

export type TaxCategoryRate_PurchasableTax = {
  __typename?: 'TaxCategoryRate_PurchasableTax';
  /** TaxCategoryRate::getAggregateRate */
  aggregateRate: Percent;
  /** TaxCategoryRate::getTaxCategoryId */
  taxCategoryId: Scalars['Int']['output'];
  /** TaxCategoryRate::getTaxes */
  taxes: Array<PurchasableTax>;
};

export type TaxCategoryTaxSourceEntity = {
  __typename?: 'TaxCategoryTaxSourceEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TaxCategoryTaxSourceEntity_Generated::getSourceIdentifier */
  sourceIdentifier?: Maybe<Scalars['String']['output']>;
  /** TaxCategoryTaxSourceEntity_Generated::getTaxSource */
  taxSource?: Maybe<TaxSource>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TaxCategoryTaxSourceInput = {
  source?: InputMaybe<TaxSource>;
  sourceIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export const TaxCategoryType = {
  Alcohol: 'ALCOHOL',
  Amusement: 'AMUSEMENT',
  BakedGoods: 'BAKED_GOODS',
  BowlingAdmissions: 'BOWLING_ADMISSIONS',
  BusinessAndOccupationServiceAndOtherActivities: 'BUSINESS_AND_OCCUPATION_SERVICE_AND_OTHER_ACTIVITIES',
  ColoradoShippingFee: 'COLORADO_SHIPPING_FEE',
  ConcertAdmissions: 'CONCERT_ADMISSIONS',
  CulinaryClass: 'CULINARY_CLASS',
  ElectronicGiftCard: 'ELECTRONIC_GIFT_CARD',
  ExemptCharitableDonation: 'EXEMPT_CHARITABLE_DONATION',
  Food: 'FOOD',
  GenericAdmissions: 'GENERIC_ADMISSIONS',
  LodgingAccommodations: 'LODGING_ACCOMMODATIONS',
  NonTaxable: 'NON_TAXABLE',
  PackagedAlcohol: 'PACKAGED_ALCOHOL',
  PreparedFoodSingleServing: 'PREPARED_FOOD_SINGLE_SERVING',
  Retail: 'RETAIL',
  Shipping: 'SHIPPING',
  Tea: 'TEA'
} as const;

export type TaxCategoryType = typeof TaxCategoryType[keyof typeof TaxCategoryType];
export type TaxCenterLaunchFlags = {
  __typename?: 'TaxCenterLaunchFlags';
  /** TaxCenterLaunchFlags::isMigrationPeriodEnabled */
  migrationPeriodEnabled: Scalars['Boolean']['output'];
  /** TaxCenterLaunchFlags::isTaxCenterEnabled */
  taxCenterEnabled: Scalars['Boolean']['output'];
};

export const TaxSource = {
  Avalara: 'AVALARA',
  BusinessTax: 'BUSINESS_TAX',
  TockSingleTax: 'TOCK_SINGLE_TAX'
} as const;

export type TaxSource = typeof TaxSource[keyof typeof TaxSource];
export type Taxable = {
  /** Taxable::getName */
  name: Scalars['String']['output'];
  /** Taxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type TaxableAddon = {
  __typename?: 'TaxableAddon';
  /** TaxableAddon::id */
  id: Scalars['Int']['output'];
  /** TaxableAddon::name */
  name?: Maybe<Scalars['String']['output']>;
};

export type TaxableTicketTypesWithTaxableAddons = {
  __typename?: 'TaxableTicketTypesWithTaxableAddons';
  /** TaxableTicketTypesWithTaxableAddons::taxableAddons */
  taxableAddons: Array<TaxableAddon>;
  /** TaxableTicketTypesWithTaxableAddons::ticketTypeId */
  ticketTypeId: Scalars['Int']['output'];
  /** TaxableTicketTypesWithTaxableAddons::ticketTypeName */
  ticketTypeName?: Maybe<Scalars['String']['output']>;
};

export type TemporalWorkflowStatus = {
  __typename?: 'TemporalWorkflowStatus';
  /** TemporalWorkflowStatus::isCompleted */
  completed: Scalars['Boolean']['output'];
  /** TemporalWorkflowStatus::state */
  state: State;
};

export type TemporaryPermissions = {
  __typename?: 'TemporaryPermissions';
  /** TemporaryPermissions::activeRequestForBusiness */
  activeRequestForBusiness?: Maybe<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requestWorkflow */
  requestWorkflow?: Maybe<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requests */
  requests: Array<RoleBusinessPermissionRequestEntity>;
  /** TemporaryPermissions::requestsWithFilter */
  requestsWithFilter: Array<RoleBusinessPermissionRequestEntity>;
};


export type TemporaryPermissionsActiveRequestForBusinessArgs = {
  businessId: Scalars['Int']['input'];
};


export type TemporaryPermissionsRequestWorkflowArgs = {
  workflowId?: InputMaybe<Scalars['String']['input']>;
};


export type TemporaryPermissionsRequestsWithFilterArgs = {
  filter: FilterInput;
};

export const TextType = {
  Textarea: 'TEXTAREA',
  Textinput: 'TEXTINPUT'
} as const;

export type TextType = typeof TextType[keyof typeof TextType];
export const ThirdPartyOrderProvider = {
  ShipCompliant: 'SHIP_COMPLIANT'
} as const;

export type ThirdPartyOrderProvider = typeof ThirdPartyOrderProvider[keyof typeof ThirdPartyOrderProvider];
export type TicketGroupEntity = {
  __typename?: 'TicketGroupEntity';
  /** TicketGroupEntity::isCommunal */
  communal: Scalars['Boolean']['output'];
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketGroupEntity::getEndDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketGroupEntity_Generated::getMaxPurchaseSize */
  maxPurchaseSize: Scalars['Int']['output'];
  /** TicketGroupEntity_Generated::getMinPurchaseSize */
  minPurchaseSize: Scalars['Int']['output'];
  /** TicketGroupEntity::getStartDateTime */
  startDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketGroupEntity_Generated::getTicketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionEntity = Purchasable & Taxable & {
  __typename?: 'TicketOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionEntity::getDisplayName */
  displayName: Scalars['String']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketOptionEntity::isModifier */
  isModifier: Scalars['Boolean']['output'];
  /** TicketOptionEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** TicketOptionEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** TicketOptionEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** TicketOptionEntity::getTicketOptionGroup */
  ticketOptionGroup: TicketOptionGroupEntity;
  /** TicketOptionEntity_Generated::getTicketType */
  ticketType: TicketTypeEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionGroupEntity = {
  __typename?: 'TicketOptionGroupEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionGroupEntity::getDisplayName */
  displayName: Scalars['String']['output'];
  /** TicketOptionGroupEntity::getId */
  id: Scalars['Int']['output'];
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketOptionGroupEntity::isModifierGroup */
  isModifierGroup: Scalars['Boolean']['output'];
  /** TicketOptionGroupEntity::getParentTicketOption */
  parentTicketOption?: Maybe<TicketOptionEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketOptionInventoryEntity = {
  __typename?: 'TicketOptionInventoryEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketOptionInventoryEntity_Generated::getCurrentQuantity */
  currentQuantity?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketOptionInventoryEntity_Generated::getIsArchived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLastLimitType */
  lastLimitType?: Maybe<QuantityLimitType>;
  /** TicketOptionInventoryEntity_Generated::getLastQuantitySet */
  lastQuantitySet?: Maybe<Scalars['Int']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLastQuantityUpdatedAt */
  lastQuantityUpdatedAt?: Maybe<Scalars['Instant']['output']>;
  /** TicketOptionInventoryEntity_Generated::getLimitType */
  limitType?: Maybe<QuantityLimitType>;
  /** TicketOptionInventoryEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketPriceInformation = {
  __typename?: 'TicketPriceInformation';
  /** TicketPriceInformation::amountCents */
  amountCents: Scalars['Int']['output'];
  /** TicketPriceInformation::priceDistribution */
  priceDistribution?: Maybe<PriceDistribution>;
  /** TicketPriceInformation::priceType */
  priceType?: Maybe<PriceType>;
};

export type TicketPriceInformationInput = {
  amountCents: Scalars['Int']['input'];
  priceDistribution?: InputMaybe<PriceDistribution>;
  priceType?: InputMaybe<PriceType>;
};

export type TicketTransferEntity = {
  __typename?: 'TicketTransferEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketType = {
  __typename?: 'TicketType';
  /** TicketType::getId */
  id: Scalars['Int']['output'];
  /** TicketType::getName */
  name: Scalars['String']['output'];
  /** TicketType::getShortCode */
  shortCode: Scalars['String']['output'];
  /** TicketType::getVariety */
  variety: TicketTypeVariety;
};

export type TicketTypeChargesInput = {
  customFeeName: Scalars['String']['input'];
  customFeeRate: Scalars['Float']['input'];
  eventFeeRate: Scalars['Float']['input'];
  extraChargeDetails?: InputMaybe<ExtraChargeDetailsInput>;
};

export type TicketTypeEntity = Purchasable & Taxable & {
  __typename?: 'TicketTypeEntity';
  /** TicketTypeEntity::getActiveTicketOptionCount */
  activeTicketOptionCount: Scalars['Int']['output'];
  /** TicketTypeEntity::getActiveTicketOptionGroupCount */
  activeTicketOptionGroupCount: Scalars['Int']['output'];
  /** TicketTypeEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** TicketTypeResolvers::getCancellationPolicyTextForTicketType */
  cancellationPolicyTextForTicketType?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TicketTypeEntity_Generated::getDeliveryServiceProvider */
  deliveryServiceProvider?: Maybe<DeliveryServiceProvider>;
  /** TicketTypeEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** TicketTypeResolvers::getDescriptiveVariety */
  descriptiveVariety?: Maybe<DescriptiveVariety>;
  /** TicketTypeEntity::getEffectiveConfirmationText */
  effectiveConfirmationText?: Maybe<Scalars['String']['output']>;
  /** TurnTimeResolvers::expectedTurnTimeMinutes */
  expectedTurnTimeMinutes: Scalars['Int']['output'];
  /** TicketTypeEntity_Generated::getFees */
  fees: Array<FeeEntity>;
  /** TicketTypeEntity_Generated::getGuestProfileGroups */
  guestProfileGroups: Array<GuestProfileGroupEntity>;
  /** TicketTypeEntity_Generated::getHasPrivateUrl */
  hasPrivateUrl?: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** Images used on the experience page for this experience (TicketTypeResolvers::graphQLGetImages) */
  images: Array<BusinessImage>;
  /** Archivable::isArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getIsBookable */
  isBookable: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getIsUsingMobileTicket */
  isUsingMobileTicket?: Maybe<Scalars['Boolean']['output']>;
  /** TicketTypeEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** TicketTypeEntity::getOrdering */
  ordering: Scalars['Int']['output'];
  /** TicketTypeResolvers::getPartyRangeTicketPriceInformation */
  partyRangeTicketPriceInformation?: Maybe<PartyRangeTicketPriceInformation>;
  /** TicketTypeEntity::getPurchasableType */
  purchasableType: PurchasableType;
  /** TicketTypeEntity_Generated::getReleasedUntil */
  releasedUntil?: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeResolvers::getReserveShippingTime */
  reserveShippingTime: Scalars['Boolean']['output'];
  /** TicketTypeEntity_Generated::getShortCode */
  shortCode: Scalars['String']['output'];
  /** TicketTypeResolvers::getSingleUnitQuantity */
  singleUnitQuantity?: Maybe<Scalars['Int']['output']>;
  /** TicketTypeEntity::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
  /** TicketTypeResolvers::getTicketPriceInformation */
  ticketPriceInformation?: Maybe<TicketPriceInformation>;
  /** BookingPolicyResolvers::getTicketTypeBookingPolicy */
  ticketTypeBookingPolicy?: Maybe<BookingPolicy>;
  /** TicketTypeEntity_Generated::getTicketTypePriceConfigs */
  ticketTypePriceConfigs: Array<TicketTypePriceConfigEntity>;
  /** TicketTypeEntity_Generated::getUnlisted */
  unlisted?: Maybe<Scalars['Boolean']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** TicketTypeEntity_Generated::getVariety */
  variety: TicketTypeVariety;
};


export type TicketTypeEntityExpectedTurnTimeMinutesArgs = {
  bookingRequest: BookingRequestForTurnTimesInput;
};


export type TicketTypeEntityTicketPriceInformationArgs = {
  bookingRequest: BookingRequestForPriceSheetInput;
};


export type TicketTypeEntityTicketTypeBookingPolicyArgs = {
  partySize: Scalars['Int']['input'];
};

export type TicketTypeGaEventDetails = {
  __typename?: 'TicketTypeGAEventDetails';
  /** TicketTypeGAEventDetails::businessDay */
  businessDay?: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeGAEventDetails::endTime */
  endTime?: Maybe<Scalars['LocalTime']['output']>;
  /** TicketTypeGAEventDetails::maxPerPerson */
  maxPerPerson: Scalars['Int']['output'];
  /** TicketTypeGAEventDetails::startTime */
  startTime?: Maybe<Scalars['LocalTime']['output']>;
  /** TicketTypeGAEventDetails::ticketGroupId */
  ticketGroupId: Scalars['Int']['output'];
  /** TicketTypeGAEventDetails::totalAvailable */
  totalAvailable: Scalars['Int']['output'];
};

export type TicketTypeOutput = {
  __typename?: 'TicketTypeOutput';
  /** TicketTypeOutput::defaultPrice */
  defaultPrice: Scalars['Int']['output'];
  /** TicketTypeOutput::gaEventDetails */
  gaEventDetails?: Maybe<TicketTypeGaEventDetails>;
  /** TicketTypeOutput::inventoryDates */
  inventoryDates: Array<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::nextAvailableDate */
  nextAvailableDate?: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::numTicketGroups */
  numTicketGroups?: Maybe<Scalars['Int']['output']>;
  /** TicketTypeOutput::onlyBusinessDay */
  onlyBusinessDay?: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeOutput::slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** TicketTypeOutput::ticketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** TicketTypeOutput::ticketTypeGroupSummaries */
  ticketTypeGroupSummaries: Array<TicketTypeTicketGroupSummary>;
};

export type TicketTypePriceConfigEntity = {
  __typename?: 'TicketTypePriceConfigEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypePriceConfigEntity_Generated::getMinPartySizeInclusive */
  minPartySizeInclusive?: Maybe<Scalars['Int']['output']>;
  /** TicketTypePriceConfigEntity_Generated::getPriceCents */
  priceCents: Scalars['Int']['output'];
  /** TicketTypePriceConfigEntity_Generated::getPriceDistribution */
  priceDistribution: PriceDistribution;
  /** TicketTypePriceConfigEntity_Generated::getPriceType */
  priceType: PriceType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypePurchasedTaxable = Taxable & {
  __typename?: 'TicketTypePurchasedTaxable';
  /** TicketTypePurchasedTaxable::getName */
  name: Scalars['String']['output'];
  /** TicketTypePurchasedTaxable::getTaxCategory */
  taxCategory?: Maybe<TaxCategoryEntity>;
};

export type TicketTypeQuestionEntity = {
  __typename?: 'TicketTypeQuestionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypeQuestionEntity_Generated::getName */
  name?: Maybe<Scalars['String']['output']>;
  /** TicketTypeQuestionEntity_Generated::getTicketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeQuestionOptionEntity = {
  __typename?: 'TicketTypeQuestionOptionEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeSlim = {
  __typename?: 'TicketTypeSlim';
  /** TicketTypeSlim::id */
  id: Scalars['Int']['output'];
  /** TicketTypeSlim::name */
  name?: Maybe<Scalars['String']['output']>;
  /** TicketTypeSlim::variety */
  variety?: Maybe<TicketTypeVariety>;
};

export type TicketTypeSlimTicketGroup = {
  __typename?: 'TicketTypeSlimTicketGroup';
  /** TicketTypeSlimTicketGroup::date */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** TicketTypeSlimTicketGroup::dateTime */
  dateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketTypeSlimTicketGroup::id */
  id: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::maxPurchaseSize */
  maxPurchaseSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::maxSize */
  maxSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::minPurchaseSize */
  minPurchaseSize: Scalars['Int']['output'];
  /** TicketTypeSlimTicketGroup::startTime */
  startTime?: Maybe<Scalars['LocalTime']['output']>;
};

export type TicketTypeTagEntity = {
  __typename?: 'TicketTypeTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TicketTypeTagEntity_Generated::getSource */
  source: TagSource;
  /** TicketTypeTagEntity_Generated::getTicketType */
  ticketType: TicketTypeEntity;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TicketTypeTicketGroupSummary = {
  __typename?: 'TicketTypeTicketGroupSummary';
  /** TicketTypeTicketGroupSummary::dateTime */
  dateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** TicketTypeTicketGroupSummary::slimTicketGroup */
  slimTicketGroup: Array<TicketTypeSlimTicketGroup>;
  /** TicketTypeTicketGroupSummary::totalledMaxSize */
  totalledMaxSize: Scalars['Int']['output'];
};

export const TicketTypeVariety = {
  Deposit: 'DEPOSIT',
  DeprecatedEvent: 'DEPRECATED_EVENT',
  DeprecatedSpecialTable: 'DEPRECATED_SPECIAL_TABLE',
  Full: 'FULL',
  GaEvent: 'GA_EVENT',
  OrderDelivery: 'ORDER_DELIVERY',
  OrderPickup: 'ORDER_PICKUP',
  Reservation: 'RESERVATION',
  SeatedEvent: 'SEATED_EVENT',
  Tableside: 'TABLESIDE'
} as const;

export type TicketTypeVariety = typeof TicketTypeVariety[keyof typeof TicketTypeVariety];
export type Timeline = {
  __typename?: 'Timeline';
  /** Timeline::bookings */
  bookings: Array<BookingBase>;
  /** Timeline::dateTimeStats */
  dateTimeStats: Array<DateTimeStats>;
  /** Timeline::getId */
  id?: Maybe<Scalars['String']['output']>;
  /** Timeline::sections */
  sections: Array<Section>;
  /** Timeline::slots */
  slots: Array<Slot>;
  /** Timeline::tableStateRanges */
  tableStateRanges: Array<TableStatesForTable>;
  /** Timeline::tableStates */
  tableStates: Array<TableStatesForTable>;
  /** Timeline::tables */
  tables: Array<CalendarTable>;
  /** Ticket types relevant to the service day. (Timeline::ticketTypes) */
  ticketTypes: Array<TicketType>;
  /** Timeline::turnTimes */
  turnTimes?: Maybe<TurnTimesQuery>;
};

export const TimelineExportType = {
  Cron: 'CRON',
  Publish: 'PUBLISH',
  TimelineButton: 'TIMELINE_BUTTON'
} as const;

export type TimelineExportType = typeof TimelineExportType[keyof typeof TimelineExportType];
export type TimelineUpdate = {
  __typename?: 'TimelineUpdate';
  /** TimelineUpdate::bookings */
  bookings: Array<BookingBase>;
  /** TimelineUpdate::dateTimeStats */
  dateTimeStats: Array<DateTimeStats>;
  /** TimelineUpdate::sections */
  sections: Array<Section>;
  /** TimelineUpdate::slots */
  slots: Array<Slot>;
  /** TimelineUpdate::tableStateRanges */
  tableStateRanges: Array<TableStatesForTable>;
  /** TimelineUpdate::tables */
  tables: Array<CalendarTable>;
  /** TimelineUpdate::ticketTypes */
  ticketTypes: Array<TicketType>;
};

export type ToGoExperienceEndingAction = AvailabilityAction & {
  __typename?: 'ToGoExperienceEndingAction';
  /** ToGoExperienceEndingAction::endingDate */
  endingDate: Scalars['LocalDate']['output'];
  /** ToGoExperienceEndingAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type ToGoExperienceInPastAction = AvailabilityAction & {
  __typename?: 'ToGoExperienceInPastAction';
  /** ToGoExperienceInPastAction::experience */
  experience: TicketTypeEntity;
  /** AvailabilityRecommendedAction::type */
  type: AvailabilityActionType;
};

export type TockApiKeyEntity = {
  __typename?: 'TockApiKeyEntity';
  /** TockApiKeyEntity::getBusinessGroup */
  businessGroup?: Maybe<BusinessGroupEntity>;
  /** TockApiKeyEntity::getContactEmail */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TockApiKeyEntity::getCreatedByPatron */
  createdByPatron: PatronEntity;
  /** TockApiKeyEntity::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** TockApiKeyEntity::getExternalSystemType */
  externalSystemType?: Maybe<ExternalSystemType>;
  /** TockApiKeyEntity::getKeyType */
  keyType: KeyType;
  /** TockApiKeyEntity::getStatus */
  status: TockApiKeyStatus;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** BaseUuidEntity::getUuid */
  uuid?: Maybe<Scalars['UUID']['output']>;
};

export type TockApiKeyGenerationRequestInput = {
  businessGroupId?: InputMaybe<Scalars['Int']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalSystemType?: InputMaybe<ExternalSystemType>;
  keyType: KeyType;
  requestingPatronId: Scalars['Int']['input'];
};

export const TockApiKeyStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED',
  Unknown: 'UNKNOWN'
} as const;

export type TockApiKeyStatus = typeof TockApiKeyStatus[keyof typeof TockApiKeyStatus];
export type TockGiftCardPaymentMethodInput = {
  patronId: Scalars['Int']['input'];
};

export const TockShipmentStatus = {
  Delivered: 'DELIVERED',
  InProcess: 'IN_PROCESS',
  PaymentAccepted: 'PAYMENT_ACCEPTED',
  SentToFulfillment: 'SENT_TO_FULFILLMENT',
  Shipped: 'SHIPPED',
  Voided: 'VOIDED'
} as const;

export type TockShipmentStatus = typeof TockShipmentStatus[keyof typeof TockShipmentStatus];
export type TockTenConfigEntity = {
  __typename?: 'TockTenConfigEntity';
  /** TockTenConfigEntity_Generated::getBusinesss */
  businesss: Array<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** TockTenConfigEntity_Generated::getDescription */
  description?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** TockTenConfigEntity_Generated::getImage */
  image: UploadedImageEntity;
  /** TockTenConfigEntity_Generated::getIsArchived */
  isArchived: Scalars['Boolean']['output'];
  /** TockTenConfigEntity_Generated::getMarketingUrl */
  marketingUrl: Scalars['String']['output'];
  /** TockTenConfigEntity_Generated::getName */
  name: Scalars['String']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type TockTenInput = {
  businessIds: Array<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  marketingUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  uploadedImageId: Scalars['Int']['input'];
};

export type TooltipRationale = {
  __typename?: 'TooltipRationale';
  /** TooltipRationale::category */
  category: Category;
  /** TooltipRationale::detailText */
  detailText: Scalars['String']['output'];
  /** TooltipRationale::indicatesInternalOnly */
  indicatesInternalOnly: Scalars['Boolean']['output'];
};

export type TrackingInfo = {
  __typename?: 'TrackingInfo';
  /** TrackingInfo::trackingNumber */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** TrackingInfo::trackingURL */
  trackingURL?: Maybe<Scalars['String']['output']>;
};

export type TransactedTax = Tax & {
  __typename?: 'TransactedTax';
  /** TransactedTax::getIsMarketplaceTax */
  isMarketplaceTax: Scalars['Boolean']['output'];
  /** TransactedTax::getIsRetainedByTock */
  isRetainedByTock: Scalars['Boolean']['output'];
  /** Tax::getJurisdictionName */
  jurisdictionName?: Maybe<Scalars['String']['output']>;
  /** Tax::getJurisdictionType */
  jurisdictionType?: Maybe<JurisdictionType>;
  /** Tax::getName */
  name: Scalars['String']['output'];
  /** Tax::getTaxSource */
  taxSource: TaxSource;
};

export type TurnTimeForTimeSpan = {
  __typename?: 'TurnTimeForTimeSpan';
  /** TurnTimeForTimeSpan::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** TurnTimeForTimeSpan::expectedTurnTimeMinutes */
  expectedTurnTimeMinutes: Scalars['Int']['output'];
  /** TurnTimeForTimeSpan::startTime */
  startTime: Scalars['LocalTime']['output'];
};

export type TurnTimesByPartySizeRange = {
  __typename?: 'TurnTimesByPartySizeRange';
  /** TurnTimesByPartySizeRange::max */
  max?: Maybe<Scalars['Int']['output']>;
  /** TurnTimesByPartySizeRange::min */
  min: Scalars['Int']['output'];
  /** TurnTimesByPartySizeRange::turnTimeForTimeSpan */
  turnTimeForTimeSpan: Array<TurnTimeForTimeSpan>;
};

export type TurnTimesForTicketType = {
  __typename?: 'TurnTimesForTicketType';
  /** TurnTimesForTicketType::ticketTypeId */
  ticketTypeId?: Maybe<Scalars['Int']['output']>;
  /** TurnTimesForTicketType::turnTimesByPartySizeRange */
  turnTimesByPartySizeRange: Array<TurnTimesByPartySizeRange>;
};

export type TurnTimesQuery = {
  __typename?: 'TurnTimesQuery';
  /** Returns turn times by ticket type id, party size range, and start times (TurnTimesQuery::turnTimesForTicketTypes) */
  turnTimesForTicketTypes: Array<TurnTimesForTicketType>;
};

export const Type = {
  Breakfast: 'BREAKFAST',
  Brunch: 'BRUNCH',
  Dinner: 'DINNER',
  Lunch: 'LUNCH'
} as const;

export type Type = typeof Type[keyof typeof Type];
export type UnassignedBooking = Slot & {
  __typename?: 'UnassignedBooking';
  /** UnassignedBooking::endDateTime */
  endDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** UnassignedBooking::partyId */
  partyId: Scalars['ID']['output'];
  /** UnassignedBooking::startDateTime */
  startDateTime: Scalars['LocalDateTime']['output'];
  /** UnassignedBooking::ticketCount */
  ticketCount: Scalars['Int']['output'];
  /** UnassignedBooking::ticketGroup */
  ticketGroup: TicketGroupEntity;
  /** UnassignedBooking::ticketType */
  ticketType: TicketTypeEntity;
  /** UnassignedBooking::getVisit */
  visit: VisitEntity;
};

export type UnassignedReservations = {
  __typename?: 'UnassignedReservations';
  /** UnassignedReservations::experienceName */
  experienceName: Scalars['String']['output'];
  /** UnassignedReservations::guestName */
  guestName: Scalars['String']['output'];
  /** UnassignedReservations::lastAssignedTableInfos */
  lastAssignedTableInfos: Array<LastAssignedTableInfo>;
  /** UnassignedReservations::partySize */
  partySize: Scalars['Int']['output'];
  /** UnassignedReservations::purchaseConfirmationCode */
  purchaseConfirmationCode: Scalars['String']['output'];
  /** UnassignedReservations::resoDateTime */
  resoDateTime: Scalars['String']['output'];
};

export type UpcomingEvent = {
  __typename?: 'UpcomingEvent';
  /** UpcomingEvent::date */
  date?: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::endTime */
  endTime?: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::hasMultipleTimes */
  hasMultipleTimes?: Maybe<Scalars['Boolean']['output']>;
  /** UpcomingEvent::id */
  id?: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::name */
  name?: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::repetitionSchedule */
  repetitionSchedule?: Maybe<EventRepetitionSchedule>;
  /** UpcomingEvent::startTime */
  startTime?: Maybe<Scalars['String']['output']>;
  /** UpcomingEvent::uploadedImage */
  uploadedImage?: Maybe<Image>;
  /** UpcomingEvent::url */
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateBusinessContentInput = {
  businessId?: InputMaybe<Scalars['Int']['input']>;
  needToKnow?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
  whyWeLikeIt?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessEntitlementSetPayload = {
  __typename?: 'UpdateBusinessEntitlementSetPayload';
  /** UpdateBusinessEntitlementSetPayload::businessEntitlementSet */
  businessEntitlementSet?: Maybe<BusinessEntitlementSetEntity>;
  /** UpdateBusinessEntitlementSetPayload::error */
  error?: Maybe<ErrorResult>;
};

export type UpdateBusinessFaqInput = {
  answer: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  orderingIndex?: InputMaybe<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
};

export type UpdateBusinessInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  addressLat?: InputMaybe<Scalars['Float']['input']>;
  addressLng?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  googlePlacesId?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  shouldDisplayAddress: Scalars['Boolean']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntitlementSetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entitlementIds: Array<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntitlementSetPayload = {
  __typename?: 'UpdateEntitlementSetPayload';
  /** UpdateEntitlementSetPayload::entitlementSet */
  entitlementSet?: Maybe<EntitlementSetEntity>;
  /** UpdateEntitlementSetPayload::error */
  error?: Maybe<ErrorResult>;
};

export type UpdateGoogleSettingsInput = {
  disableOrderFeed: Scalars['Boolean']['input'];
  disableReservationFeed: Scalars['Boolean']['input'];
  disableReserveWithGoogle: Scalars['Boolean']['input'];
  disableServiceFeed: Scalars['Boolean']['input'];
};

export type UpdatePatronAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googlePlacesId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PatronPhoneInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatronCommunicationsOptInInput = {
  businessIds: Array<Scalars['Int']['input']>;
  optInSource: Scalars['Int']['input'];
  optedIn: Scalars['Boolean']['input'];
};

export type UpdatePaymentSubscriptionPlanAddonInput = {
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  paymentSubscriptionPlanAddonId: Scalars['ID']['input'];
};

export type UpdatePaymentSubscriptionPlanAddonPayload = {
  __typename?: 'UpdatePaymentSubscriptionPlanAddonPayload';
  /** UpdatePaymentSubscriptionPlanAddonPayload::error */
  error?: Maybe<ErrorResult>;
  /** UpdatePaymentSubscriptionPlanAddonPayload::paymentSubscriptionPlanAddon */
  paymentSubscriptionPlanAddon?: Maybe<PaymentSubscriptionPlanAddonEntity>;
};

export type UpdatePaymentSubscriptionPlanInput = {
  entitlementSetId?: InputMaybe<Scalars['ID']['input']>;
  paymentSubscriptionPlanId: Scalars['ID']['input'];
};

export type UpdatePaymentSubscriptionPlanPayload = {
  __typename?: 'UpdatePaymentSubscriptionPlanPayload';
  /** UpdatePaymentSubscriptionPlanPayload::error */
  error?: Maybe<ErrorResult>;
  /** UpdatePaymentSubscriptionPlanPayload::paymentSubscriptionPlan */
  paymentSubscriptionPlan?: Maybe<PaymentSubscriptionPlanEntity>;
};

export type UpdatePayoutConfigParamsInput = {
  firstPostServiceDays?: InputMaybe<Scalars['Int']['input']>;
  firstPostServicePercentage?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  postPaymentDays?: InputMaybe<Scalars['Int']['input']>;
  postPaymentPercentage?: InputMaybe<Scalars['Int']['input']>;
  rollingDays: Scalars['Int']['input'];
  secondPostServiceDays?: InputMaybe<Scalars['Int']['input']>;
  secondPostServicePercentage?: InputMaybe<Scalars['Int']['input']>;
  type: ConfigType;
};

export type UpdateWaitlistResponse = {
  __typename?: 'UpdateWaitlistResponse';
  /** UpdateWaitlistResponse::success */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UploadedImageEntity = UploadedImageEntityInterface & {
  __typename?: 'UploadedImageEntity';
  /** Alt text for the image, may be autogenerated. (UploadedImageEntity_Generated::getAltText) */
  altText?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** An autodetected dominant color for the image, in #ffffff format. (UploadedImageEntity_Generated::getDominantColor) */
  dominantColor?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** UploadedImageEntity_Generated::getImageBackingUrl */
  imageBackingUrl?: Maybe<Scalars['String']['output']>;
  /** External URL for the image. (UploadedImageEntity_Generated::getImageUrl) */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type UploadedImageEntityInterface = {
  /** Alt text for the image, may be autogenerated. (UploadedImageEntityInterface::getAltText) */
  altText?: Maybe<Scalars['String']['output']>;
  /** An autodetected dominant color for the image, in #ffffff format. (UploadedImageEntityInterface::getDominantColor) */
  dominantColor?: Maybe<Scalars['String']['output']>;
  /** UploadedImageEntityInterface::getId */
  id: Scalars['Int']['output'];
  /** External URL for the image. (UploadedImageEntityInterface::getImageUrl) */
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type UpsertHelpMenuInput = {
  bodyText: Scalars['String']['input'];
  effectiveDate: Scalars['LocalDate']['input'];
  headline: Scalars['String']['input'];
  helpCenterUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  linkedFeatureFlagNames: Array<Scalars['String']['input']>;
  publicationStatus: PublicationStatus;
  relevantInventoryType: RelevantInventoryType;
  uploadedImageEntityId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertPhoneInput = {
  countryCode: Scalars['String']['input'];
  defaultRegionCode: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type UpsertShippingZoneResult = {
  __typename?: 'UpsertShippingZoneResult';
  /** UpsertShippingZoneResult::error */
  error?: Maybe<ErrorResult>;
  /** UpsertShippingZoneResult::shippingZone */
  shippingZone?: Maybe<ShippingZoneEntity>;
};

export type UpsertTockContactInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<UpsertPhoneInput>;
};

export const UsState = {
  Ak: 'AK',
  Al: 'AL',
  Ar: 'AR',
  As: 'AS',
  Az: 'AZ',
  Ca: 'CA',
  Co: 'CO',
  Ct: 'CT',
  Dc: 'DC',
  De: 'DE',
  Fl: 'FL',
  Ga: 'GA',
  Gu: 'GU',
  Hi: 'HI',
  Ia: 'IA',
  Id: 'ID',
  Il: 'IL',
  In: 'IN',
  Ks: 'KS',
  Ky: 'KY',
  La: 'LA',
  Ma: 'MA',
  Md: 'MD',
  Me: 'ME',
  Mi: 'MI',
  Mn: 'MN',
  Mo: 'MO',
  Mp: 'MP',
  Ms: 'MS',
  Mt: 'MT',
  Nc: 'NC',
  Nd: 'ND',
  Ne: 'NE',
  Nh: 'NH',
  Nj: 'NJ',
  Nm: 'NM',
  Nv: 'NV',
  Ny: 'NY',
  Oh: 'OH',
  Ok: 'OK',
  Or: 'OR',
  Pa: 'PA',
  Pr: 'PR',
  Ri: 'RI',
  Sc: 'SC',
  Sd: 'SD',
  Tn: 'TN',
  Tx: 'TX',
  Ut: 'UT',
  Va: 'VA',
  Vi: 'VI',
  Vt: 'VT',
  Wa: 'WA',
  Wi: 'WI',
  Wv: 'WV',
  Wy: 'WY'
} as const;

export type UsState = typeof UsState[keyof typeof UsState];
export type UserMessage = {
  __typename?: 'UserMessage';
  /** UserMessage::id */
  id: Scalars['String']['output'];
  /** UserMessage::status */
  status: UserNotificationStatus;
  /** UserMessage::title */
  title: Scalars['String']['output'];
  /** UserMessage::type */
  type: UserNotificationType;
  /** UserMessage::workflowData */
  workflowData?: Maybe<WorkflowData>;
};

export const UserNotificationStatus = {
  Failure: 'FAILURE',
  Success: 'SUCCESS'
} as const;

export type UserNotificationStatus = typeof UserNotificationStatus[keyof typeof UserNotificationStatus];
export const UserNotificationType = {
  SchedulePublish: 'SCHEDULE_PUBLISH'
} as const;

export type UserNotificationType = typeof UserNotificationType[keyof typeof UserNotificationType];
export type VenueBusinessInfo = {
  __typename?: 'VenueBusinessInfo';
  /** VenueBusinessInfo::about */
  about: Scalars['String']['output'];
  /** VenueBusinessInfo::acceptsWalkIns */
  acceptsWalkIns?: Maybe<AcceptsWalkIns>;
  /** VenueBusinessInfo::address */
  address?: Maybe<Address>;
  /** VenueBusinessInfo::affiliatedVenues */
  affiliatedVenues: Array<AffiliatedVenue>;
  /** VenueBusinessInfo::announcement */
  announcement?: Maybe<Announcement>;
  /** VenueBusinessInfo::awards */
  awards: Array<Award>;
  /** VenueBusinessInfo::cuisines */
  cuisines: Array<Cuisine>;
  /** VenueBusinessInfo::customerFacingPhone */
  customerFacingPhone?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::email */
  email?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::emailIsHidden */
  emailIsHidden: Scalars['Boolean']['output'];
  /** VenueBusinessInfo::faq */
  faq: Array<Faq>;
  /** VenueBusinessInfo::hasTripleseatIntegration */
  hasTripleseatIntegration?: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::id */
  id: Scalars['String']['output'];
  /** VenueBusinessInfo::menuUrl */
  menuUrl?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::name */
  name: Scalars['String']['output'];
  /** VenueBusinessInfo::needToKnow */
  needToKnow?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::phoneExtension */
  phoneExtension?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::priceRange */
  priceRange?: Maybe<PriceRange>;
  /** VenueBusinessInfo::isResyCreditEligible */
  resyCreditEligible?: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::shouldDisplayAddress */
  shouldDisplayAddress: Scalars['Boolean']['output'];
  /** VenueBusinessInfo::showWaitList */
  showWaitList?: Maybe<Scalars['Boolean']['output']>;
  /** VenueBusinessInfo::socialMediaLinks */
  socialMediaLinks: Array<SocialMediaLink>;
  /** VenueBusinessInfo::timeZone */
  timeZone: Scalars['String']['output'];
  /** VenueBusinessInfo::uploadedImages */
  uploadedImages: Array<UploadedImageEntity>;
  /** VenueBusinessInfo::websiteUrl */
  websiteUrl?: Maybe<Scalars['String']['output']>;
  /** VenueBusinessInfo::whyWeLikeIt */
  whyWeLikeIt?: Maybe<Scalars['String']['output']>;
};

export const VerificationStatus = {
  ClosedAbandoned: 'CLOSED_ABANDONED',
  PendingApprovalToClose: 'PENDING_APPROVAL_TO_CLOSE',
  PendingW9: 'PENDING_W9'
} as const;

export type VerificationStatus = typeof VerificationStatus[keyof typeof VerificationStatus];
export type VisitEntity = {
  __typename?: 'VisitEntity';
  /** VisitEntity::getArrivalTime */
  arrivalTime?: Maybe<Scalars['Instant']['output']>;
  /** VisitEntity::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** VisitEntity::getCurrentPurchase */
  currentPurchase?: Maybe<PurchaseEntity>;
  /** Guest-provided feedback about the visit (VisitEntity::feedback) */
  feedback?: Maybe<VisitFeedbackEntity>;
  /** VisitEntity::getGuest */
  guest?: Maybe<PatronEntity>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitEntity::getLatestSnapshot */
  latestSnapshot?: Maybe<VisitSummaryPartySnapshotEntity>;
  /** VisitEntity::getLeftTime */
  leftTime?: Maybe<Scalars['Instant']['output']>;
  /** VisitEntity::getNumberOfPeoplePresent */
  numberOfPeoplePresent?: Maybe<Scalars['Int']['output']>;
  /** VisitEntity::getPartyId */
  partyId?: Maybe<Scalars['Int']['output']>;
  /** The current primary state for the party in table management (VisitEntity::getPrimaryStateEnum) */
  primaryState?: Maybe<PartyState>;
  /** VisitEntity::getPurchase */
  purchase?: Maybe<PurchaseEntity>;
  /** VisitEntity::getSeatedTime */
  seatedTime?: Maybe<Scalars['Instant']['output']>;
  /** The current secondary state for the party in table management (VisitEntity::getSecondaryState) */
  secondaryState?: Maybe<Scalars['String']['output']>;
  /** The current servers assigned to the party, or servers who served the party if the party has left (VisitEntity::getBusinessServers) */
  servers: Array<BusinessServerEntity>;
  /** VisitEntity::getServiceDate */
  serviceDate?: Maybe<Scalars['LocalDate']['output']>;
  /** VisitEntity::getStartDateTime */
  startDateTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** AggregateTagsResolvers::getTags */
  tags: Array<VisitTagEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type VisitFeedbackEntity = {
  __typename?: 'VisitFeedbackEntity';
  /** VisitFeedbackEntity_Generated::getBusiness */
  business: BusinessEntity;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** VisitFeedbackEntity::getFivePointStarRating */
  fivePointStarRating?: Maybe<Scalars['Int']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitFeedbackEntity_Generated::getMessage */
  message?: Maybe<Scalars['String']['output']>;
  /** VisitFeedbackEntity_Generated::getPatron */
  patron: PatronEntity;
  /** VisitFeedbackEntity::getThreePointEmoticonRating */
  rating?: Maybe<Rating>;
  /** VisitFeedbackEntity::getRatingAsFivePointStar */
  ratingAsFivePointStar: Scalars['Int']['output'];
  /** VisitFeedbackEntity::getRatingAsThreePointEmoticon */
  ratingAsThreePointEmoticon?: Maybe<Rating>;
  /** VisitFeedbackEntity_Generated::getRatingType */
  ratingType: RatingType;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
  /** VisitFeedbackEntity_Generated::getVisit */
  visit: VisitEntity;
};

export type VisitFeedbackReportPayload = {
  __typename?: 'VisitFeedbackReportPayload';
  /** VisitFeedbackReportPayload::averageRating */
  averageRating?: Maybe<Scalars['Float']['output']>;
  /** VisitFeedbackReportPayload::error */
  error?: Maybe<ErrorResult>;
  /** VisitFeedbackReportPayload::feedback */
  feedback: Array<VisitFeedbackEntity>;
  /** VisitFeedbackReportPayload::ratingSummaries */
  ratingSummaries: Array<VisitFeedbackStarRatingSummary>;
};

export type VisitFeedbackStarRatingSummary = {
  __typename?: 'VisitFeedbackStarRatingSummary';
  /** VisitFeedbackStarRatingSummary::rating */
  rating: Scalars['Int']['output'];
  /** VisitFeedbackStarRatingSummary::ratingCount */
  ratingCount: Scalars['Int']['output'];
};

export type VisitFilterInput = {
  /** A filter for feedback left by the diner. If hasFeedback is not set but feedbackFilter is, then the filter will allow visits with no feedback or visits that match this filter. */
  feedbackFilter?: InputMaybe<FeedbackFilterInput>;
  /** Whether the diner has left feedback. */
  hasFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the server who served the visit. */
  serverName?: InputMaybe<Scalars['String']['input']>;
  /** Names of servers who served the visit. This will filter out feedback that does not have a server included in the list */
  serverNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type VisitSummaryPartySnapshotEntity = {
  __typename?: 'VisitSummaryPartySnapshotEntity';
  /** VisitSummaryPartySnapshotEntity::getArrivalTime */
  arrivalTime?: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getBusinessServers */
  businessServers: Array<BusinessServerEntity>;
  /** VisitSummaryPartySnapshotEntity::getEventTimestamp */
  eventTimestamp?: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getLeftTime */
  leftTime?: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getNumPeoplePresent */
  numPeoplePresent?: Maybe<Scalars['Int']['output']>;
  /** VisitSummaryPartySnapshotEntity::getPrimaryStateEnum */
  primaryStateEnum?: Maybe<PartyState>;
  /** VisitSummaryPartySnapshotEntity::getSeatedTime */
  seatedTime?: Maybe<Scalars['Instant']['output']>;
  /** VisitSummaryPartySnapshotEntity::getSecondaryState */
  secondaryState?: Maybe<Scalars['String']['output']>;
  /** This snapshot's visit (VisitSummaryPartySnapshotEntity::getVisit) */
  visit?: Maybe<VisitEntity>;
};

export type VisitTagEntity = {
  __typename?: 'VisitTagEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** VisitTagEntity_Generated::getTag */
  tag?: Maybe<Scalars['String']['output']>;
  /** VisitTagEntity_Generated::getTagSource */
  tagSource?: Maybe<TagSource>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistDateEntity = {
  __typename?: 'WaitlistDateEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistDateEntity_Generated::getDate */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** WaitlistDateEntity_Generated::getEndTimeInclusive */
  endTimeInclusive?: Maybe<Scalars['LocalTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistDateEntity_Generated::getStartTimeInclusive */
  startTimeInclusive?: Maybe<Scalars['LocalTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistEntity = {
  __typename?: 'WaitlistEntity';
  /** WaitlistEntity_Generated::getBusiness */
  business?: Maybe<BusinessEntity>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistEntity_Generated::getDates */
  dates: Array<WaitlistDateEntity>;
  /** WaitlistEntity_Generated::getDesiredService */
  desiredService?: Maybe<Type>;
  /** WaitlistEntity_Generated::getDesiredSize */
  desiredSize?: Maybe<Scalars['Int']['output']>;
  /** WaitlistEntity::eventHistory */
  eventHistory: Array<WaitlistEvent>;
  /** WaitlistEntity_Generated::getGuestNote */
  guestNote?: Maybe<Scalars['String']['output']>;
  /** WaitlistEntity_Generated::getHasRequestBeenFulfilled */
  hasRequestBeenFulfilled?: Maybe<Scalars['Boolean']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistEntity_Generated::getNote */
  note?: Maybe<Scalars['String']['output']>;
  /** WaitlistEntity::getSortedUpcomingDates */
  sortedUpcomingDates: Array<WaitlistDateEntity>;
  /** WaitlistEntity_Generated::getTicketType */
  ticketType?: Maybe<TicketTypeEntity>;
  /** WaitlistEntity::getTimeRanges */
  timeRanges: Array<WaitlistTimeRangeEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistEvent = {
  /** WaitlistEvent::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistEvent::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** WaitlistEvent::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistEvent::id */
  id: Scalars['Int']['output'];
};

export type WaitlistEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistEventEntity';
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistEvent::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const WaitlistEventType = {
  Added: 'ADDED',
  Fulfilled: 'FULFILLED',
  SentEmailNotification: 'SENT_EMAIL_NOTIFICATION',
  SentPushNotification: 'SENT_PUSH_NOTIFICATION'
} as const;

export type WaitlistEventType = typeof WaitlistEventType[keyof typeof WaitlistEventType];
export type WaitlistFulfilledEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistFulfilledEventEntity';
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistFulfilledEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistFulfilledEventEntity::purchase */
  purchase?: Maybe<PurchaseEntity>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistJoinEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistJoinEventEntity';
  /** WaitlistJoinEventEntity::actor */
  actor?: Maybe<Scalars['String']['output']>;
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistJoinEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistJoinEventEntity::id */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistSentEmailNotificationEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistSentEmailNotificationEventEntity';
  /** WaitlistSentEmailNotificationEventEntity::actor */
  actor?: Maybe<Scalars['String']['output']>;
  /** WaitlistSentEmailNotificationEventEntity::isAutomated */
  automated: Scalars['Boolean']['output'];
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistSentEmailNotificationEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistSentPushNotificationEventEntity = WaitlistEvent & {
  __typename?: 'WaitlistSentPushNotificationEventEntity';
  /** WaitlistSentPushNotificationEventEntity::actor */
  actor?: Maybe<Scalars['String']['output']>;
  /** WaitlistSentPushNotificationEventEntity::isAutomated */
  automated: Scalars['Boolean']['output'];
  /** WaitlistEventEntity_Generated::getCanonicalType */
  canonicalType: Scalars['String']['output'];
  /** WaitlistSentPushNotificationEventEntity::getCanonicalTypeEnum */
  canonicalTypeEnum?: Maybe<WaitlistEventType>;
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WaitlistTimeRangeEntity = {
  __typename?: 'WaitlistTimeRangeEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WaitlistTimeRangeEntity_Generated::getEndTime */
  endTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WaitlistTimeRangeEntity_Generated::getStartTime */
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export type WalkIn = BookingBase & Node & {
  __typename?: 'WalkIn';
  /** WalkIn::endTime */
  endTime: Scalars['LocalTime']['output'];
  /** Represents a VisitEntity id from the database (WalkIn::id) */
  id: Scalars['ID']['output'];
  /** WalkIn::party */
  party: Party;
  /** WalkIn::isPinnedToTable */
  pinnedToTable: Scalars['Boolean']['output'];
  /** WalkIn::startTime */
  startTime: Scalars['LocalTime']['output'];
  /** WalkIn::tableIds */
  tableIds: Array<Scalars['Int']['output']>;
  /** WalkIn::walkInId */
  walkInId: Scalars['ID']['output'];
};

export type WalkInEstimationCompleteFeatures = {
  __typename?: 'WalkInEstimationCompleteFeatures';
  /** WalkInEstimationCompleteFeatures::actualWaitTime */
  actualWaitTime?: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::amountOfWaitTimeForHeadOfList */
  amountOfWaitTimeForHeadOfList: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::isAssignedToTable */
  assignedToTable: Scalars['Boolean']['output'];
  /** WalkInEstimationCompleteFeatures::averageWaitingPartySize */
  averageWaitingPartySize: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::businessId */
  businessId: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::date */
  date?: Maybe<Scalars['LocalDate']['output']>;
  /** WalkInEstimationCompleteFeatures::estimatedWaitTime */
  estimatedWaitTime?: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::finishRateInLast15 */
  finishRateInLast15: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast30 */
  finishRateInLast30: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast45 */
  finishRateInLast45: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::finishRateInLast60 */
  finishRateInLast60: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::hostSelectedQuotedTime */
  hostSelectedQuotedTime: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::lastHourSeatingRate */
  lastHourSeatingRate: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::lastKnownWaitTime */
  lastKnownWaitTime: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::mlSuggestedQuotedTime */
  mlSuggestedQuotedTime?: Maybe<Scalars['Int']['output']>;
  /** WalkInEstimationCompleteFeatures::modelVersion */
  modelVersion?: Maybe<Scalars['String']['output']>;
  /** WalkInEstimationCompleteFeatures::partySize */
  partySize: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTables */
  percentageOccupiedTables: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn15 */
  percentageOccupiedTablesIn15: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn30 */
  percentageOccupiedTablesIn30: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn45 */
  percentageOccupiedTablesIn45: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::percentageOccupiedTablesIn60 */
  percentageOccupiedTablesIn60: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::time */
  time?: Maybe<Scalars['LocalTime']['output']>;
  /** WalkInEstimationCompleteFeatures::timeSinceLastArrival */
  timeSinceLastArrival: Scalars['Float']['output'];
  /** WalkInEstimationCompleteFeatures::turnTime */
  turnTime: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::waitlistSize */
  waitlistSize: Scalars['Int']['output'];
  /** WalkInEstimationCompleteFeatures::walkInId */
  walkInId?: Maybe<Scalars['String']['output']>;
};

export type WalkInEstimationIncomingFeaturesInput = {
  actualWaitTime?: InputMaybe<Scalars['Float']['input']>;
  date: Scalars['LocalDate']['input'];
  hostSelectedQuotedTime?: InputMaybe<Scalars['Int']['input']>;
  isAssignedToTable: Scalars['Boolean']['input'];
  mlSuggestedQuotedTime?: InputMaybe<Scalars['Int']['input']>;
  partySize: Scalars['Int']['input'];
  time: Scalars['LocalTime']['input'];
  turnTime: Scalars['Int']['input'];
  walkInId: Scalars['String']['input'];
};

export type WalkinPredictIncomingFeaturesInput = {
  partySize: Scalars['Int']['input'];
  turnTime: Scalars['Int']['input'];
};

export type WebhookEndpointEntity = {
  __typename?: 'WebhookEndpointEntity';
  /** BaseVersionedEntity::getCreatedAt */
  createdAt: Scalars['Instant']['output'];
  /** WebhookEndpointEntity_Generated::getEndpointUrl */
  endpointUrl?: Maybe<Scalars['String']['output']>;
  /** WebhookEndpointEntity_Generated::getHeaders */
  headers?: Maybe<Scalars['String']['output']>;
  /** BaseEntity::getId */
  id: Scalars['Int']['output'];
  /** WebhookEndpointEntity_Generated::getPushVisitUpdates */
  pushVisitUpdates?: Maybe<Scalars['Boolean']['output']>;
  /** WebhookEndpointEntity_Generated::getType */
  type?: Maybe<EndpointType>;
  /** BaseVersionedEntity::getUpdatedAt */
  updatedAt: Scalars['Instant']['output'];
};

export const WebhookRequestAction = {
  Delete: 'DELETE',
  Upsert: 'UPSERT'
} as const;

export type WebhookRequestAction = typeof WebhookRequestAction[keyof typeof WebhookRequestAction];
export const WebhookType = {
  Guests: 'GUESTS',
  PurchaseEdits: 'PURCHASE_EDITS',
  PurchaseEditsAndVisitUpdates: 'PURCHASE_EDITS_AND_VISIT_UPDATES',
  WalkIns: 'WALK_INS'
} as const;

export type WebhookType = typeof WebhookType[keyof typeof WebhookType];
export const Weekday = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const;

export type Weekday = typeof Weekday[keyof typeof Weekday];
export type WineItemDetailsInput = {
  alcoholByVolumePercent: Scalars['Float']['input'];
  businessTaxIds: Array<Scalars['Int']['input']>;
  chitName?: InputMaybe<Scalars['String']['input']>;
  currentQuantity?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  flavorTagEnumValues: Array<Scalars['String']['input']>;
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['Int']['input'];
  isQuantityLimitEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  priceInCents: Scalars['Int']['input'];
  regions: Array<Scalars['String']['input']>;
  requiredAge: Scalars['Int']['input'];
  scaleTagValues: Array<ScaleTagValueInput>;
  sku?: InputMaybe<Scalars['String']['input']>;
  styleTagEnumValue: Scalars['String']['input'];
  taxCategoryId?: InputMaybe<Scalars['Int']['input']>;
  tockDisregardStructureTags?: InputMaybe<Scalars['Boolean']['input']>;
  tockExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  varietalTagEnumValues: Array<Scalars['String']['input']>;
  vintage?: InputMaybe<Scalars['Int']['input']>;
  volumeMl: Scalars['Int']['input'];
  weightLb: Scalars['Float']['input'];
};

export type WineItemFullDetailsInput = {
  shipCompliantBrandKey?: InputMaybe<Scalars['String']['input']>;
  shipCompliantProductType: ProductType;
  shipCompliantSku: Scalars['String']['input'];
  shopBrandId: Scalars['Int']['input'];
  wineItemDetails: WineItemDetailsInput;
};

export type WorkflowData = {
  __typename?: 'WorkflowData';
  /** WorkflowData::runId */
  runId: Scalars['String']['output'];
  /** WorkflowData::workflowId */
  workflowId: Scalars['String']['output'];
};

export type WorkflowIdentifier = {
  __typename?: 'WorkflowIdentifier';
  /** WorkflowIdentifier::runId */
  runId: Scalars['String']['output'];
  /** WorkflowIdentifier::workflowId */
  workflowId: Scalars['String']['output'];
};

export type WorkflowIdentifierInput = {
  runId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type PaginatedBusinessGroupsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedBusinessGroupsQuery = { __typename?: 'Query', businessGroupsPaginated: { __typename?: 'BusinessGroupEntityConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'BusinessGroupEntityEdge', node?: { __typename?: 'BusinessGroupEntity', id: number, name: string, groupLevelTags?: boolean | null, slug?: string | null } | null } | null> | null } };

export type BusinessGroupSummaryFieldsFragment = { __typename?: 'BusinessGroupEntity', id: number, name: string, groupLevelTags?: boolean | null, slug?: string | null };

export type BusinessImportRecordsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BusinessImportRecordsQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, importRecords: Array<{ __typename?: 'ImportEntity', id: number, status?: ImportStatus | null }> } | null };

export type UpdateImportStatusMutationVariables = Exact<{
  importStatus: ImportStatus;
  id: Scalars['Int']['input'];
}>;


export type UpdateImportStatusMutation = { __typename?: 'Mutation', updateImportStatus: boolean };

export type CurrentBusinessAccessPendingQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type CurrentBusinessAccessPendingQuery = { __typename?: 'Query', temporaryPermissions?: { __typename?: 'TemporaryPermissions', activeRequestForBusiness?: { __typename?: 'RoleBusinessPermissionRequestEntity', id: number, status?: Status | null, requestWorkflowId: string } | null } | null };

export type PaginatedBusinessesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after: Scalars['String']['input'];
  unlisted?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type PaginatedBusinessesQuery = { __typename?: 'Query', businessesPaginated: { __typename?: 'BusinessEntityConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'BusinessEntityEdge', node?: { __typename?: 'BusinessEntity', id: number, name: string, domainName?: string | null, webUrl?: string | null, bookingsDisabled?: boolean | null, isDeleted?: boolean | null, isAuthorizedByTock: boolean, unlisted: boolean, businessGroup: { __typename?: 'BusinessGroupEntity', id: number, name: string } } | null } | null> | null } };

export type BusinessSummaryFieldsFragment = { __typename?: 'BusinessEntity', id: number, name: string, domainName?: string | null, webUrl?: string | null, bookingsDisabled?: boolean | null, isDeleted?: boolean | null, isAuthorizedByTock: boolean, unlisted: boolean, businessGroup: { __typename?: 'BusinessGroupEntity', id: number, name: string } };

export type CancelBookingsSubscriptionVariables = Exact<{
  input: CancelBookingsInputInput;
}>;


export type CancelBookingsSubscription = { __typename?: 'Subscription', refundCancelFutureBookings?: { __typename?: 'CancelBookingsWorkflowStatus', numSuccess: number, numFailed: number, numTotal: number, workflowRunId: string, done: boolean } | null };

export type CancelBookingsWorkflowStatusFieldsFragment = { __typename?: 'CancelBookingsWorkflowStatus', numSuccess: number, numFailed: number, numTotal: number, workflowRunId: string, done: boolean };

export type FetchTicketTypesWithFutureBookingsQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type FetchTicketTypesWithFutureBookingsQuery = { __typename?: 'Query', ticketTypesWithFuturePurchases: Array<{ __typename?: 'TicketTypeEntity', id: number, name: string }> };

export type GetCancellationRequestQueryVariables = Exact<{
  input: CancelBookingsInputInput;
}>;


export type GetCancellationRequestQuery = { __typename?: 'Query', acceptCancellationRequest: Array<{ __typename?: 'CancelBookingsOutput', ticketTypeId: number, ticketTypeName?: string | null, purchaseCount: number }> };

export type CancelBookingsOutputFieldsFragment = { __typename?: 'CancelBookingsOutput', ticketTypeId: number, ticketTypeName?: string | null, purchaseCount: number };

export type RequestSpecialSigningPermissionMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type RequestSpecialSigningPermissionMutation = { __typename?: 'Mutation', requestSpecialSigningPermission: boolean };

export type ApproveSpecialSigningPermissionMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type ApproveSpecialSigningPermissionMutation = { __typename?: 'Mutation', approveSpecialSigningPermission: boolean };

export type BusinessPayoutConfigQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BusinessPayoutConfigQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, currencyCode: string, createdAt: string, updatedAt: string, paymentProcessorType?: PaymentProcessorType | null, payoutConfigs: Array<{ __typename?: 'BusinessPayoutConfigEntity', id: number, createdAt: string, updatedAt: string, allowDebits: boolean, disablePayout?: boolean | null, negativeBalanceAdjustmentCents?: number | null, note?: string | null, payoutMonthly: boolean, orderPayoutParameters?: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } | null, purchasePayoutParameters: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } }> } | null };

export type PayoutParameterFieldsFragment = { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null };

export type PayoutConfigFieldsFragment = { __typename?: 'BusinessEntity', currencyCode: string, id: number, createdAt: string, updatedAt: string, paymentProcessorType?: PaymentProcessorType | null, payoutConfigs: Array<{ __typename?: 'BusinessPayoutConfigEntity', id: number, createdAt: string, updatedAt: string, allowDebits: boolean, disablePayout?: boolean | null, negativeBalanceAdjustmentCents?: number | null, note?: string | null, payoutMonthly: boolean, orderPayoutParameters?: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } | null, purchasePayoutParameters: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } }> };

export type UpdateBusinessPayoutConfigParamsMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  updatePayoutConfigParams: UpdatePayoutConfigParamsInput;
}>;


export type UpdateBusinessPayoutConfigParamsMutation = { __typename?: 'Mutation', updatePayoutConfigParams?: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } | null };

export type RequestBusinessAccessMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  role: BusinessRole;
  reason: Scalars['String']['input'];
}>;


export type RequestBusinessAccessMutation = { __typename?: 'Mutation', requestBusinessAccess: boolean };

export type CreateBusinessEntitlementSetsMutationVariables = Exact<{
  input: CreateBusinessEntitlementSetsInput;
}>;


export type CreateBusinessEntitlementSetsMutation = { __typename?: 'Mutation', createBusinessEntitlementSets?: { __typename?: 'CreateBusinessEntitlementSetsPayload', error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type AddEntitlementToEntitlementSetsMutationVariables = Exact<{
  entitlementId: Scalars['Int']['input'];
  entitlementSetIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type AddEntitlementToEntitlementSetsMutation = { __typename?: 'Mutation', addEntitlementToEntitlementSets?: { __typename?: 'AddEntitlementToEntitlementSetsPayload', entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number }>, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type BusinessEntitlementSetsQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type BusinessEntitlementSetsQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', businessEntitlementSets: Array<{ __typename?: 'BusinessEntitlementSetEntity', id: string, isArchived: boolean, source: BusinessEntitlementSetSource, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, description?: string | null, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string, description: string } }> } }> } | null };

export type EntitlementSetFragment = { __typename?: 'EntitlementSetEntity', id: number, description?: string | null, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string, description: string } }> };

export type AllEntitlementSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEntitlementSetsQuery = { __typename?: 'Query', entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number, isArchived: boolean, name: string }> };

export type ArchiveBusinessEntitlementSetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveBusinessEntitlementSetMutation = { __typename?: 'Mutation', archiveBusinessEntitlementSet?: { __typename?: 'UpdateBusinessEntitlementSetPayload', businessEntitlementSet?: { __typename?: 'BusinessEntitlementSetEntity', id: string, isArchived: boolean } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type UpdateExperimentVariantsMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  variants: Array<ExperimentVariantInput> | ExperimentVariantInput;
}>;


export type UpdateExperimentVariantsMutation = { __typename?: 'Mutation', updateExperimentVariants?: { __typename?: 'ExperimentEntity', id: number, experimentVariants: Array<{ __typename?: 'ExperimentVariantEntity', id: number, description: string, name: string, trafficAllocation: number, variant: number }> } | null };

export type UpdateFeatureMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  state: FeatureState;
}>;


export type UpdateFeatureMutation = { __typename?: 'Mutation', updateFeature?: { __typename?: 'FeatureEntity', id: number, state: FeatureState } | null };

export type DeleteFeatureMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteFeatureMutation = { __typename?: 'Mutation', deleteFeature: boolean };

export type IssueManualInvoiceMutationVariables = Exact<{
  manualInvoiceRequest: ManualInvoiceRequestInput;
}>;


export type IssueManualInvoiceMutation = { __typename?: 'Mutation', issueManualInvoice: boolean };

export type GenerateDataSubscriptionVariables = Exact<{
  input: FakePurchasesInputInput;
}>;


export type GenerateDataSubscription = { __typename?: 'Subscription', generateData?: { __typename?: 'FakePurchaseWorkflowStatus', numSuccess: number, numFailed: number, numTotal: number, done: boolean } | null };

export type FakePurchaseWorkflowStatusFieldsFragment = { __typename?: 'FakePurchaseWorkflowStatus', numSuccess: number, numFailed: number, numTotal: number, done: boolean };

export type ChangeHelpMenuEntryPublicationStatusMutationVariables = Exact<{
  publicationStatus: PublicationStatus;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  changeHelpMenuEntryPublicationStatusId: Scalars['Int']['input'];
}>;


export type ChangeHelpMenuEntryPublicationStatusMutation = { __typename?: 'Mutation', changeHelpMenuEntryPublicationStatus?: { __typename?: 'HelpMenuEntryEntity', bodyText: string, createdAt: string, effectiveDate: string, headline: string, helpCenterUrl?: string | null, id: number, publicationStatus: PublicationStatus, relevantInventoryType: RelevantInventoryType, updatedAt: string, features: Array<{ __typename?: 'FeatureEntity', id: number }>, image?: { __typename?: 'UploadedImageEntity', id: number } | null } | null };

export type UpsertHelpMenuEntryMutationMutationVariables = Exact<{
  entry: UpsertHelpMenuInput;
}>;


export type UpsertHelpMenuEntryMutationMutation = { __typename?: 'Mutation', upsertHelpMenuEntry?: { __typename?: 'HelpMenuEntryEntity', bodyText: string, createdAt: string, effectiveDate: string, headline: string, helpCenterUrl?: string | null, id: number, publicationStatus: PublicationStatus, relevantInventoryType: RelevantInventoryType, updatedAt: string, features: Array<{ __typename?: 'FeatureEntity', id: number }>, image?: { __typename?: 'UploadedImageEntity', id: number } | null } | null };

export type GetHelpMenuEntriesQueryVariables = Exact<{
  includeArchivedEntries: Scalars['Boolean']['input'];
  headline: Scalars['String']['input'];
}>;


export type GetHelpMenuEntriesQuery = { __typename?: 'Query', helpMenuEntries: Array<{ __typename?: 'HelpMenuEntryEntity', bodyText: string, createdAt: string, effectiveDate: string, headline: string, helpCenterUrl?: string | null, id: number, publicationStatus: PublicationStatus, relevantInventoryType: RelevantInventoryType, updatedAt: string, features: Array<{ __typename?: 'FeatureEntity', name: string }>, image?: { __typename?: 'UploadedImageEntity', imageBackingUrl?: string | null } | null }> };

export type CreateJceHomepageOrderingEntryMutationVariables = Exact<{
  homepageOrderingEntry: JceHomepageOrderingEntryInput;
}>;


export type CreateJceHomepageOrderingEntryMutation = { __typename?: 'Mutation', createJceHomepageOrderingEntry?: { __typename?: 'JceHomepageOrderingEntryEntity', id: number, position: number, specialCollection?: JceVenueSpecialCollection | null, collection?: { __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null } | null } | null };

export type SetJceHomepageEntriesForGeographyMutationVariables = Exact<{
  geographyId: Scalars['Int']['input'];
  orderingEntries: Array<JceHomepageOrderingEntryInput> | JceHomepageOrderingEntryInput;
}>;


export type SetJceHomepageEntriesForGeographyMutation = { __typename?: 'Mutation', setJceHomepageOrderingEntriesForGeography: Array<{ __typename?: 'JceHomepageOrderingEntryEntity', id: number, position: number, specialCollection?: JceVenueSpecialCollection | null, isDesignatedForLeaderboard: boolean, collection?: { __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null } | null }> };

export type UpdateJceHomepageGeographyMutationVariables = Exact<{
  geography: JceHomepageGeographyInput;
}>;


export type UpdateJceHomepageGeographyMutation = { __typename?: 'Mutation', updateJceHomepageGeography?: { __typename?: 'JceHomepageGeographyEntity', id: number, name?: string | null, urlSlug?: string | null, resyBlogKey?: string | null, tier?: JceHomepageGeographyTier | null, priorityWithinTier?: number | null } | null };

export type SetJceVenueCollectionEntriesForCollectionMutationVariables = Exact<{
  collectionId: Scalars['Int']['input'];
  entries: Array<JceVenueCollectionEntryInput> | JceVenueCollectionEntryInput;
}>;


export type SetJceVenueCollectionEntriesForCollectionMutation = { __typename?: 'Mutation', setJceVenueCollectionEntriesForCollection: Array<{ __typename?: 'JceVenueCollectionEntryEntity', id: number, resyVenueId?: number | null, tockVenueId?: number | null }> };

export type GetCollectionsForGeographyQueryVariables = Exact<{
  geographyId: Scalars['Int']['input'];
}>;


export type GetCollectionsForGeographyQuery = { __typename?: 'Query', collectionsForGeography?: { __typename?: 'OrderingEntriesAndUnorderedCollections', orderingEntries: Array<{ __typename?: 'JceHomepageOrderingEntryEntity', id: number, position: number, specialCollection?: JceVenueSpecialCollection | null, isDesignatedForLeaderboard: boolean, collection?: { __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null, description?: string | null, iconIndicator?: JceVenueCollectionIconIndicator | null, status?: JceVenueCollectionStatus | null, urlSlug?: string | null, collectionEntrys: Array<{ __typename?: 'JceVenueCollectionEntryEntity', id: number, resyVenueId?: number | null, tockVenueId?: number | null }> } | null }>, unorderedCollections: Array<{ __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null, description?: string | null, iconIndicator?: JceVenueCollectionIconIndicator | null, status?: JceVenueCollectionStatus | null, urlSlug?: string | null, collectionEntrys: Array<{ __typename?: 'JceVenueCollectionEntryEntity', id: number, resyVenueId?: number | null, tockVenueId?: number | null }> }> } | null };

export type BulkResetCompromisedAccountsSubscriptionVariables = Exact<{
  patronIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type BulkResetCompromisedAccountsSubscription = { __typename?: 'Subscription', bulkResetCompromisedAccounts?: { __typename?: 'BulkPatronActionWorkflowStatus', numSuccess: number, numFailed: number, numProcessed: number, numTotal: number, failedPatronIds: Array<number>, numTruncatedErrors: number, done: boolean, attachedToExistingRun: boolean } | null };

export type BulkDeletePatronAccountsSubscriptionVariables = Exact<{
  patronIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  deleteReason: DeleteReason;
  emailBehavior: EmailBehavior;
}>;


export type BulkDeletePatronAccountsSubscription = { __typename?: 'Subscription', bulkDeletePatronAccounts?: { __typename?: 'BulkPatronActionWorkflowStatus', numSuccess: number, numFailed: number, numProcessed: number, numTotal: number, failedPatronIds: Array<number>, numTruncatedErrors: number, done: boolean, attachedToExistingRun: boolean } | null };

export type RemoveTockGiftCardBalanceMutationVariables = Exact<{
  patronId: Scalars['Int']['input'];
  tockGiftCardBalance: Scalars['Int']['input'];
}>;


export type RemoveTockGiftCardBalanceMutation = { __typename?: 'Mutation', clearTockGiftCardBalanceV2?: { __typename?: 'PatronEntity', id: number, tockGiftCardBalanceCents?: number | null } | null };

export type ResetCompromisedAccountMutationVariables = Exact<{
  patronId: Scalars['Int']['input'];
  sendEmail: Scalars['Boolean']['input'];
}>;


export type ResetCompromisedAccountMutation = { __typename?: 'Mutation', resetCompromisedAccountV2?: { __typename?: 'BulkAdminPatronActionPayload', failedPatronIds: Array<number>, successCount: number, errors: Array<{ __typename?: 'ErrorResult', displayMessage: string }> } | null };

export type UpdatePatronSelfOnboardingEligibilityMutationVariables = Exact<{
  email: Scalars['String']['input'];
  eligibilityStatus: Scalars['Boolean']['input'];
}>;


export type UpdatePatronSelfOnboardingEligibilityMutation = { __typename?: 'Mutation', updatePatronSelfOnboardingEligibility: { __typename?: 'PatronEntity', id: number, isEligibleForSelfOnboarding: boolean } };

export type BulkPatronActionWorkflowStatusFieldsFragment = { __typename?: 'BulkPatronActionWorkflowStatus', numSuccess: number, numFailed: number, numProcessed: number, numTotal: number, failedPatronIds: Array<number>, numTruncatedErrors: number, done: boolean, attachedToExistingRun: boolean };

export type TemporaryPermissionRequestFragment = { __typename: 'RoleBusinessPermissionRequestEntity', approvedAt?: string | null, requestedAt: string, role: BusinessRole, reason: string, isExpired?: boolean | null, isApproved?: boolean | null, expiresAt?: string | null, approverPatron?: { __typename?: 'PatronEntity', firstName?: string | null, lastName?: string | null } | null, requestingPatron: { __typename?: 'PatronEntity', firstName?: string | null, lastName?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null };

export type CompareRebalancePlansQueryVariables = Exact<{
  env: Scalars['String']['input'];
  service: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  serviceDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
  filename: Scalars['String']['input'];
  businessId: Scalars['Int']['input'];
  timeLimitMillis: Scalars['Int']['input'];
}>;


export type CompareRebalancePlansQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, name: string, compareRebalancePlans?: { __typename?: 'RebalancePlanComparison', rebalancePlan: { __typename?: 'RebalancePlan', computationTimeMillis: number, before: { __typename?: 'SeatingPlan', serviceDate: string, scoresForServices: Array<{ __typename?: 'ScoreForService', serviceStartLocalTime: string, serviceEndLocalTime: string, score: { __typename?: 'Score', hardScore: number, mediumScore: number, softScore: number, explanation: string } }>, unassignedBookings: Array<{ __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } }>, bookingsToTables: Array<{ __typename?: 'BookingToTables', bookableTables: Array<{ __typename?: 'BookableTable', offeredOnline: boolean, maxSize: number, minSize: number, name: string, blockedLocalTimes: Array<string>, supportedExperiences: Array<{ __typename?: 'Experience', name: string, shortCode: string }> }>, booking: { __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } } }> }, after: { __typename?: 'SeatingPlan', serviceDate: string, scoresForServices: Array<{ __typename?: 'ScoreForService', serviceStartLocalTime: string, serviceEndLocalTime: string, score: { __typename?: 'Score', hardScore: number, mediumScore: number, softScore: number, explanation: string } }>, unassignedBookings: Array<{ __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } }>, bookingsToTables: Array<{ __typename?: 'BookingToTables', bookableTables: Array<{ __typename?: 'BookableTable', offeredOnline: boolean, maxSize: number, minSize: number, name: string, blockedLocalTimes: Array<string>, supportedExperiences: Array<{ __typename?: 'Experience', name: string, shortCode: string }> }>, booking: { __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } } }> } }, difference: { __typename?: 'SeatingPlanDifference', unassignedBookingsLeft: number, unassignedBookingsRight: number, unassignedCoversLeft: number, unassignedCoversRight: number, totalTableAssignmentsLeft: number, totalTableAssignmentsRight: number, differingTableAssignments: number, bookingsOnTablesWithDifferingExperienceLeft: number, bookingsOnTablesWithDifferingExperienceRight: number, overbookedTablesLeft: number, overbookedTablesRight: number }, serviceFloorplan: { __typename?: 'ServiceFloorplan', serviceStartLocalTime: string, serviceEndLocalTime: string, bookableTables: Array<{ __typename?: 'BookableTable', name: string, maxSize: number, minSize: number, offeredOnline: boolean, blockedLocalTimes: Array<string>, supportedExperiences: Array<{ __typename?: 'Experience', name: string, shortCode: string }> }> } } | null } | null };

export type SeatingPlanFieldsFragment = { __typename?: 'SeatingPlan', serviceDate: string, scoresForServices: Array<{ __typename?: 'ScoreForService', serviceStartLocalTime: string, serviceEndLocalTime: string, score: { __typename?: 'Score', hardScore: number, mediumScore: number, softScore: number, explanation: string } }>, unassignedBookings: Array<{ __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } }>, bookingsToTables: Array<{ __typename?: 'BookingToTables', bookableTables: Array<{ __typename?: 'BookableTable', offeredOnline: boolean, maxSize: number, minSize: number, name: string, blockedLocalTimes: Array<string>, supportedExperiences: Array<{ __typename?: 'Experience', name: string, shortCode: string }> }>, booking: { __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } } }> };

export type BookingFieldsFragment = { __typename?: 'Booking', assignedToSlot: boolean, date: string, startLocalTime: string, endLocalTime: string, partyName: string, partySize: number, pinned: boolean, uniqueIdentifier: string, experience: { __typename?: 'Experience', name: string, shortCode: string } };

export type RestoreTableAssignmentsMutationVariables = Exact<{
  historyId: Scalars['Int']['input'];
  fromBefore: Scalars['Boolean']['input'];
  restoreToday: Scalars['Boolean']['input'];
}>;


export type RestoreTableAssignmentsMutation = { __typename?: 'Mutation', restoreTablesFromScheduleHistory: boolean };

export type SsoLoginDomainsQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type SsoLoginDomainsQuery = { __typename?: 'Query', loginDomainsForBusiness: Array<{ __typename?: 'SsoLoginDomainEntity', id: number, domainName: string, tenantId?: string | null }> };

export type SsoLoginDomainFieldsFragment = { __typename?: 'SsoLoginDomainEntity', id: number, domainName: string, tenantId?: string | null };

export type AddSsoLoginDomainsToBusinessMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  domains: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
}>;


export type AddSsoLoginDomainsToBusinessMutation = { __typename?: 'Mutation', addSsoLoginDomainsToBusiness: boolean };

export type EntitlementSetFormSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type EntitlementSetFormSelectFieldQuery = { __typename?: 'Query', entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number, name: string }> };

export type CreateEntitlementSetMutationVariables = Exact<{
  input: CreateEntitlementSetInput;
}>;


export type CreateEntitlementSetMutation = { __typename?: 'Mutation', createEntitlementSet?: { __typename?: 'CreateEntitlementSetPayload', entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, description?: string | null, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', name: string } }> } | null } | null };

export type CreateEntitlementSetDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateEntitlementSetDialogQuery = { __typename?: 'Query', features: Array<{ __typename?: 'FeatureEntity', id: number, name: string, description: string }> };

export type UpdateEntitlementSetMutationVariables = Exact<{
  input: UpdateEntitlementSetInput;
}>;


export type UpdateEntitlementSetMutation = { __typename?: 'Mutation', updateEntitlementSet?: { __typename?: 'UpdateEntitlementSetPayload', entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, description?: string | null, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', name: string } }> } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type EditEntitlementSetDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type EditEntitlementSetDialogQuery = { __typename?: 'Query', features: Array<{ __typename?: 'FeatureEntity', id: number, name: string, description: string }> };

export type EditEntitlementSetDialog_EntitlementSetFragment = { __typename?: 'EntitlementSetEntity', id: number, name: string, description?: string | null, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> };

export type EntitlementSetFieldSet_FeaturesFragment = { __typename?: 'FeatureEntity', id: number, name: string, description: string };

export type EntitlementSetsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EntitlementSetsPageQuery = { __typename?: 'Query', entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number, name: string, description?: string | null, businessCount: number, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', name: string, id: number } }> }> };

export type EntitlementSetsPage_EntitlementSetsFragment = { __typename?: 'EntitlementSetEntity', id: number, name: string, description?: string | null, businessCount: number, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', name: string } }> };

export type CreatePaymentSubscriptionPlanMutationVariables = Exact<{
  input: CreatePaymentSubscriptionPlanInput;
}>;


export type CreatePaymentSubscriptionPlanMutation = { __typename?: 'Mutation', createPaymentSubscriptionPlan?: { __typename?: 'CreatePaymentSubscriptionPlanPayload', paymentSubscriptionPlan?: { __typename?: 'PaymentSubscriptionPlanEntity', id: string, canonicalName?: SubscriptionCanonicalName | null, subscriptionPlanName?: string | null, currencyCode?: string | null, businessCount: number, monthlySubscriptionFee?: number | null, monthlyPerTicketFee?: number | null, monthlyPerTicketBaseFee?: number | null, toGoFeePercentage?: number | null, purchaseProcessingFeePercentage?: number | null, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type UpdatePaymentSubscriptionPlanMutationVariables = Exact<{
  input: UpdatePaymentSubscriptionPlanInput;
}>;


export type UpdatePaymentSubscriptionPlanMutation = { __typename?: 'Mutation', updatePaymentSubscriptionPlan?: { __typename?: 'UpdatePaymentSubscriptionPlanPayload', paymentSubscriptionPlan?: { __typename?: 'PaymentSubscriptionPlanEntity', id: string, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string } | null } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type EditPaymentSubscriptionPlan_SubscriptionFragment = { __typename?: 'PaymentSubscriptionPlanEntity', entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string } | null };

export type EditPaymentSubscriptionPlanDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type EditPaymentSubscriptionPlanDialogQuery = { __typename?: 'Query', entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number, name: string }> };

export type PaymentSubscriptionPlansPageQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentSubscriptionPlansPageQuery = { __typename?: 'Query', paymentSubscriptionPlans: Array<{ __typename?: 'PaymentSubscriptionPlanEntity', id: string, canonicalName?: SubscriptionCanonicalName | null, subscriptionPlanName?: string | null, currencyCode?: string | null, businessCount: number, monthlySubscriptionFee?: number | null, monthlyPerTicketFee?: number | null, monthlyPerTicketBaseFee?: number | null, toGoFeePercentage?: number | null, purchaseProcessingFeePercentage?: number | null, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null }> };

export type PaymentSubscriptionPlansPage_SubscriptionFragment = { __typename?: 'PaymentSubscriptionPlanEntity', id: string, canonicalName?: SubscriptionCanonicalName | null, subscriptionPlanName?: string | null, currencyCode?: string | null, businessCount: number, monthlySubscriptionFee?: number | null, monthlyPerTicketFee?: number | null, monthlyPerTicketBaseFee?: number | null, toGoFeePercentage?: number | null, purchaseProcessingFeePercentage?: number | null, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null };

export type CreateSubscriptionAddonMutationVariables = Exact<{
  input: CreatePaymentSubscriptionPlanAddonInput;
}>;


export type CreateSubscriptionAddonMutation = { __typename?: 'Mutation', createPaymentSubscriptionPlanAddon?: { __typename?: 'CreatePaymentSubscriptionPlanAddonPayload', paymentSubscriptionPlanAddon?: { __typename?: 'PaymentSubscriptionPlanAddonEntity', id: string, name?: string | null, amountCents?: number | null, canonicalType?: SubscriptionAddonCanonicalType | null, currencyCode?: string | null, businessCount: number, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type UpdateSubscriptionAddonMutationVariables = Exact<{
  input: UpdatePaymentSubscriptionPlanAddonInput;
}>;


export type UpdateSubscriptionAddonMutation = { __typename?: 'Mutation', updatePaymentSubscriptionPlanAddon?: { __typename?: 'UpdatePaymentSubscriptionPlanAddonPayload', paymentSubscriptionPlanAddon?: { __typename?: 'PaymentSubscriptionPlanAddonEntity', id: string, name?: string | null, amountCents?: number | null, canonicalType?: SubscriptionAddonCanonicalType | null, currencyCode?: string | null, businessCount: number, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null } | null, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type EditSubscriptionAddonDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type EditSubscriptionAddonDialogQuery = { __typename?: 'Query', entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number, name: string }> };

export type AddonsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type AddonsPageQuery = { __typename?: 'Query', paymentSubscriptionPlanAddons: Array<{ __typename?: 'PaymentSubscriptionPlanAddonEntity', id: string, name?: string | null, amountCents?: number | null, canonicalType?: SubscriptionAddonCanonicalType | null, currencyCode?: string | null, businessCount: number, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null }> };

export type Addons_PaymentSubscriptionPlanAddonsFragment = { __typename?: 'PaymentSubscriptionPlanAddonEntity', id: string, name?: string | null, amountCents?: number | null, canonicalType?: SubscriptionAddonCanonicalType | null, currencyCode?: string | null, businessCount: number, entitlementSet?: { __typename?: 'EntitlementSetEntity', id: number, name: string, entitlementSetFeatures: Array<{ __typename?: 'EntitlementSetFeatureEntity', id: number, feature: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null };

export type CreateFeatureMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  state: FeatureState;
  canonicalType?: InputMaybe<FeatureType>;
}>;


export type CreateFeatureMutation = { __typename?: 'Mutation', createFeature?: { __typename?: 'FeatureEntity', id: number, name: string, description: string, canonicalType: FeatureType, createdAt: string, updatedAt: string, overridesCount: number, state: FeatureState, unused: boolean, entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number }>, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null } | null };

export type UpdateBankVerificationStatusMutationVariables = Exact<{
  bankVerificationStatus?: InputMaybe<VerificationStatus>;
  businessId: Scalars['Int']['input'];
}>;


export type UpdateBankVerificationStatusMutation = { __typename?: 'Mutation', updateBankVerificationStatus: boolean };

export type UpdateTosSignedDateMutationVariables = Exact<{
  tosSignedDate: Scalars['LocalDate']['input'];
  businessId: Scalars['Int']['input'];
}>;


export type UpdateTosSignedDateMutation = { __typename?: 'Mutation', updateTosSignedDate: boolean };

export type UpdateLockDurationMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  lockDuration: Scalars['Int']['input'];
}>;


export type UpdateLockDurationMutation = { __typename?: 'Mutation', updateLockDuration: { __typename?: 'BusinessEntity', id: number } };

export type UpdateCurrencyCodeMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
}>;


export type UpdateCurrencyCodeMutation = { __typename?: 'Mutation', updateCurrencyCode: { __typename?: 'BusinessEntity', id: number } };

export type SetGiftCardProviderMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  giftCardProvider: GiftCardProvider;
}>;


export type SetGiftCardProviderMutation = { __typename?: 'Mutation', updateGiftCardProvider: { __typename?: 'BusinessEntity', id: number } };

export type PreviewEntitlementChangesQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  paymentSubscriptionPlanId?: InputMaybe<Scalars['Int']['input']>;
  paymentSubscriptionPlanAddonIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type PreviewEntitlementChangesQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, previewEntitlementChanges?: { __typename?: 'EntitlementChangePreview', entitlementSetsBefore: Array<{ __typename?: 'EntitlementSetChange', action?: ChangeAction | null, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, name: string } }>, entitlementSetsAfter: Array<{ __typename?: 'EntitlementSetChange', action?: ChangeAction | null, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, name: string } }>, entitlementsBefore: Array<{ __typename?: 'EntitlementChange', action?: ChangeAction | null, entitlement: { __typename?: 'FeatureEntity', id: number, name: string } }>, entitlementsAfter: Array<{ __typename?: 'EntitlementChange', action?: ChangeAction | null, entitlement: { __typename?: 'FeatureEntity', id: number, name: string } }> } | null } | null };

export type PreviewEntitlementChangesFragment = { __typename?: 'EntitlementChangePreview', entitlementSetsBefore: Array<{ __typename?: 'EntitlementSetChange', action?: ChangeAction | null, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, name: string } }>, entitlementSetsAfter: Array<{ __typename?: 'EntitlementSetChange', action?: ChangeAction | null, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, name: string } }>, entitlementsBefore: Array<{ __typename?: 'EntitlementChange', action?: ChangeAction | null, entitlement: { __typename?: 'FeatureEntity', id: number, name: string } }>, entitlementsAfter: Array<{ __typename?: 'EntitlementChange', action?: ChangeAction | null, entitlement: { __typename?: 'FeatureEntity', id: number, name: string } }> };

export type PreviewEntitlementChanges_EntitlementSetChangeFragment = { __typename?: 'EntitlementSetChange', action?: ChangeAction | null, entitlementSet: { __typename?: 'EntitlementSetEntity', id: number, name: string } };

export type PreviewEntitlementChanges_EntitlementChangeFragment = { __typename?: 'EntitlementChange', action?: ChangeAction | null, entitlement: { __typename?: 'FeatureEntity', id: number, name: string } };

export type BusinessesForRebalanceComparisonFormQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessesForRebalanceComparisonFormQuery = { __typename?: 'Query', businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string, isAuthorizedByTock: boolean, isDeleted?: boolean | null }> };

export type AvailableTimelineExportsQueryVariables = Exact<{
  env: Scalars['String']['input'];
  exportDate: Scalars['LocalDate']['input'];
  exportType: TimelineExportType;
  businessId: Scalars['Int']['input'];
}>;


export type AvailableTimelineExportsQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, name: string, availableTimelineExports?: { __typename?: 'AvailableTimelineExportDetails', fileDescriptors: Array<{ __typename?: 'ExportFileDescriptor', id: string, label: string }> } | null } | null };

export type BatchDeleteBusinessFeatureMutationVariables = Exact<{
  featureId: Scalars['Int']['input'];
  businessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type BatchDeleteBusinessFeatureMutation = { __typename?: 'Mutation', batchDeleteBusinessFeature: boolean };

export type UpdateExperimentIsActiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  isActive: Scalars['Boolean']['input'];
}>;


export type UpdateExperimentIsActiveMutation = { __typename?: 'Mutation', updateExperimentIsActive?: { __typename?: 'ExperimentEntity', id: number, isActive: boolean } | null };

export type FetchAllAccoladeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllAccoladeTypesQuery = { __typename?: 'Query', accoladeTypesWithCounts: Array<{ __typename?: 'AccoladeTypeInfo', totalNumBusinessAccolades: number, businessesWithAccoladeType: Array<string>, accoladeTypeEntity?: { __typename?: 'AccoladeTypeEntity', id: number, name: string, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink?: string | null, isActive: boolean, orgLink?: string | null, displayName?: string | null, defaultAchievement?: string | null, accoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null } | null, businessEntitiesWithAccoladeType: Array<{ __typename?: 'BusinessEntity', id: number, isDeleted?: boolean | null, name: string }> }> };

export type AccoladeTypeInfoFragment = { __typename?: 'AccoladeTypeInfo', totalNumBusinessAccolades: number, businessesWithAccoladeType: Array<string>, accoladeTypeEntity?: { __typename?: 'AccoladeTypeEntity', id: number, name: string, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink?: string | null, isActive: boolean, orgLink?: string | null, displayName?: string | null, defaultAchievement?: string | null, accoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null } | null, businessEntitiesWithAccoladeType: Array<{ __typename?: 'BusinessEntity', id: number, isDeleted?: boolean | null, name: string }> };

export type DeleteAccoladeTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAccoladeTypeMutation = { __typename?: 'Mutation', deleteAccoladeType: boolean };

export type CreateAccoladeTypeMutationVariables = Exact<{
  accoladeType: AccoladeTypeInput;
}>;


export type CreateAccoladeTypeMutation = { __typename?: 'Mutation', createAccoladeType?: { __typename: 'AccoladeTypeEntity', displayName?: string | null, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink?: string | null, id: number, isActive: boolean, name: string, orgLink?: string | null, accoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', id: number } | null } | null };

export type UpdateAccoladeTypeMutationVariables = Exact<{
  accoladeType: AccoladeTypeInput;
}>;


export type UpdateAccoladeTypeMutation = { __typename?: 'Mutation', updateAccoladeType?: { __typename?: 'AccoladeTypeEntity', displayName?: string | null, hasAchievement: boolean, hasCritic: boolean, hasLink: boolean, iconImgLink?: string | null, id: number, isActive: boolean, name: string, orgLink?: string | null, accoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', isHalfPoints: boolean, id: number, maxValue: number, minValue: number, name: string, systemType: System } | null } | null };

export type FetchAllAccoladeTypeRatingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllAccoladeTypeRatingsQuery = { __typename?: 'Query', accoladeTypeRatingsWithCounts: Array<{ __typename?: 'AccoladeTypeRatingInfo', totalNumAccoladesUsingRating: number, accoladeTypesWithRating: Array<string>, accoladeTypeRatingEntity?: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null }> };

export type AccoladeTypeRatingInfoFragment = { __typename?: 'AccoladeTypeRatingInfo', totalNumAccoladesUsingRating: number, accoladeTypesWithRating: Array<string>, accoladeTypeRatingEntity?: { __typename?: 'AccoladeTypeRatingEntity', id: number, name: string, minValue: number, maxValue: number, isHalfPoints: boolean, systemType: System } | null };

export type CreateAccoladeTypeRatingMutationVariables = Exact<{
  accoladeTypeRating: AccoladeTypeRatingInput;
}>;


export type CreateAccoladeTypeRatingMutation = { __typename?: 'Mutation', createAccoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', id: number, isHalfPoints: boolean, name: string, minValue: number, maxValue: number, systemType: System } | null };

export type UpdateAccoladeTypeRatingMutationVariables = Exact<{
  accoladeTypeRating: AccoladeTypeRatingInput;
}>;


export type UpdateAccoladeTypeRatingMutation = { __typename?: 'Mutation', updateAccoladeTypeRating?: { __typename?: 'AccoladeTypeRatingEntity', id: number, isHalfPoints: boolean, name: string, minValue: number, maxValue: number, systemType: System } | null };

export type DeleteAccoladeTypeRatingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteAccoladeTypeRatingMutation = { __typename?: 'Mutation', deleteAccoladeTypeRating: boolean };

export type FetchBusinessGroupQueryVariables = Exact<{
  businessGroupId: Scalars['Int']['input'];
}>;


export type FetchBusinessGroupQuery = { __typename?: 'Query', businessGroup?: { __typename?: 'BusinessGroupEntity', id: number, name: string, groupLevelTags?: boolean | null, groupUrlPageTitle?: string | null, slug?: string | null, businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string }> } | null };

export type BusinessGroupFragment = { __typename?: 'BusinessGroupEntity', id: number, name: string, groupLevelTags?: boolean | null, groupUrlPageTitle?: string | null, slug?: string | null, businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string }> };

export type UpdateBusinessGroupMutationVariables = Exact<{
  businessGroup: BusinessGroupInput;
}>;


export type UpdateBusinessGroupMutation = { __typename?: 'Mutation', updateBusinessGroup?: { __typename?: 'BusinessGroupEntity', id: number, groupLevelTags?: boolean | null, groupUrlPageTitle?: string | null, name: string, slug?: string | null } | null };

export type CreateBusinessGroupMutationVariables = Exact<{
  businessGroup: BusinessGroupInput;
}>;


export type CreateBusinessGroupMutation = { __typename?: 'Mutation', createBusinessGroup?: { __typename: 'BusinessGroupEntity', id: number, name: string, groupLevelTags?: boolean | null, slug?: string | null } | null };

export type BusinessPhotosQueryVariables = Exact<{
  domainName: Scalars['String']['input'];
}>;


export type BusinessPhotosQuery = { __typename?: 'Query', businessByDomainName?: { __typename?: 'BusinessEntity', id: number, name: string, profileImages: Array<{ __typename?: 'BusinessImage', id: number, imageUrl?: string | null, backingUrl?: string | null }>, ticketTypes: Array<{ __typename?: 'TicketTypeEntity', id: number, name: string, images: Array<{ __typename?: 'BusinessImage', id: number, imageUrl?: string | null, backingUrl?: string | null }> }>, images: Array<{ __typename?: 'BusinessImage', id: number, imageUrl?: string | null, backingUrl?: string | null }> } | null };

export type ImageInfoFragment = { __typename?: 'BusinessImage', id: number, imageUrl?: string | null, backingUrl?: string | null };

export type FetchBusinessQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type FetchBusinessQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, name: string, shouldDisplayAddress: boolean, timeZone?: string | null, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null }, searchAttributes: Array<{ __typename?: 'SearchAttributeEntity', id: number, isArchived?: boolean | null, nearestMetro?: string | null, neighborhood?: string | null, metroArea?: { __typename?: 'MetroAreaEntity', id: number } | null }> } | null };

export type BusinessWithSearchAttributesFragment = { __typename?: 'BusinessEntity', id: number, name: string, shouldDisplayAddress: boolean, timeZone?: string | null, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null }, searchAttributes: Array<{ __typename?: 'SearchAttributeEntity', id: number, isArchived?: boolean | null, nearestMetro?: string | null, neighborhood?: string | null, metroArea?: { __typename?: 'MetroAreaEntity', id: number } | null }> };

export type FetchActiveMetroAreasQueryVariables = Exact<{
  activeMode?: InputMaybe<ActiveMode>;
}>;


export type FetchActiveMetroAreasQuery = { __typename?: 'Query', metroAreas: Array<{ __typename?: 'MetroAreaEntity', id: number, name?: string | null }> };

export type ActiveMetroAreaNamesFragment = { __typename?: 'MetroAreaEntity', id: number, name?: string | null };

export type UpdateBusinessCityStateMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  input: UpdateBusinessLocationInput;
}>;


export type UpdateBusinessCityStateMutation = { __typename?: 'Mutation', updateBusinessCityState: { __typename?: 'BusinessEntity', id: number } };

export type UpdateSearchAttributeMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  searchAttribute: SearchAttributeInput;
}>;


export type UpdateSearchAttributeMutation = { __typename?: 'Mutation', updateSearchAttribute: boolean };

export type FetchBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBusinessesQuery = { __typename?: 'Query', businesses: Array<{ __typename?: 'BusinessEntity', bookingsDisabled?: boolean | null, id: number, isAuthorizedByTock: boolean, domainName?: string | null, isDeleted?: boolean | null, name: string, webUrl?: string | null, ticketsAvailableUntil?: string | null, unlisted: boolean, businessGroup: { __typename?: 'BusinessGroupEntity', name: string } }> };

export type FormikTaxCategoryBusinessOverridesQueryVariables = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
}>;


export type FormikTaxCategoryBusinessOverridesQuery = { __typename?: 'Query', businessesPaginated: { __typename?: 'BusinessEntityConnection', edges?: Array<{ __typename?: 'BusinessEntityEdge', node?: { __typename?: 'BusinessEntity', id: number, name: string, emailLogoUrl?: string | null, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null } } | null } | null> | null } };

export type BusinessSearchField_BusinessFragment = { __typename?: 'BusinessEntity', id: number, name: string, emailLogoUrl?: string | null, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null } };

export type SingleTaxBusinessesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after: Scalars['String']['input'];
  query: Scalars['String']['input'];
  unlisted: Scalars['Boolean']['input'];
}>;


export type SingleTaxBusinessesQuery = { __typename?: 'Query', singleTaxBusinessesForSwitcher: Array<{ __typename?: 'BusinessEntity', emailLogoUrl?: string | null, id: number, name: string, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null } }> };

export type BusinessTaxMigratorFieldsFragment = { __typename?: 'BusinessTaxMigration', businessId: number, businessName?: string | null, taxRate?: { __typename?: 'Percent', asNumber: number } | null, taxableTicketTypesWithTaxableAddons: Array<{ __typename?: 'TaxableTicketTypesWithTaxableAddons', ticketTypeId: number, ticketTypeName?: string | null, taxableAddons: Array<{ __typename?: 'TaxableAddon', id: number, name?: string | null }> }> };

export type BusinessTaxMigrationQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type BusinessTaxMigrationQuery = { __typename?: 'Query', singleTaxBusiness?: { __typename?: 'BusinessTaxMigration', businessId: number, businessName?: string | null, taxRate?: { __typename?: 'Percent', asNumber: number } | null, taxableTicketTypesWithTaxableAddons: Array<{ __typename?: 'TaxableTicketTypesWithTaxableAddons', ticketTypeId: number, ticketTypeName?: string | null, taxableAddons: Array<{ __typename?: 'TaxableAddon', id: number, name?: string | null }> }> } | null };

export type MigrateBusinessToTaxLibraryMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type MigrateBusinessToTaxLibraryMutation = { __typename?: 'Mutation', updateBusinessToTaxLibrary?: { __typename?: 'BusinessTaxMigrationPayload', success: boolean, error?: { __typename?: 'ErrorResult', displayMessage: string } | null } | null };

export type TemporaryPermissionsRequestFragment = { __typename?: 'RoleBusinessPermissionRequestEntity', requestWorkflowId: string, requestedAt: string, isApproved?: boolean | null, role: BusinessRole, requestingPatron: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null, approverPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type OpenRequestsQueryVariables = Exact<{
  since: Scalars['Instant']['input'];
}>;


export type OpenRequestsQuery = { __typename?: 'Query', temporaryPermissions?: { __typename?: 'TemporaryPermissions', pending: Array<{ __typename?: 'RoleBusinessPermissionRequestEntity', id: number, requestWorkflowId: string, requestedAt: string, isApproved?: boolean | null, role: BusinessRole, requestingPatron: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null, approverPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null }>, active: Array<{ __typename?: 'RoleBusinessPermissionRequestEntity', id: number, requestWorkflowId: string, requestedAt: string, isApproved?: boolean | null, role: BusinessRole, requestingPatron: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null, approverPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null }>, history: Array<{ __typename?: 'RoleBusinessPermissionRequestEntity', requestWorkflowId: string, requestedAt: string, isApproved?: boolean | null, role: BusinessRole, requestingPatron: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null, approverPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null }> } | null };

export type GrantAccessMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  approved: Scalars['Boolean']['input'];
}>;


export type GrantAccessMutation = { __typename?: 'Mutation', approveBusinessAccess: boolean };

export type DashboardAccessRouteQueryVariables = Exact<{
  workflowId: Scalars['String']['input'];
}>;


export type DashboardAccessRouteQuery = { __typename?: 'Query', temporaryPermissions?: { __typename?: 'TemporaryPermissions', requestWorkflow?: { __typename: 'RoleBusinessPermissionRequestEntity', approvedAt?: string | null, requestedAt: string, role: BusinessRole, reason: string, isExpired?: boolean | null, isApproved?: boolean | null, expiresAt?: string | null, approverPatron?: { __typename?: 'PatronEntity', firstName?: string | null, lastName?: string | null } | null, requestingPatron: { __typename?: 'PatronEntity', firstName?: string | null, lastName?: string | null }, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null } | null } | null };

export type FetchAllExperimentsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllExperimentsQuery = { __typename?: 'Query', experiments: Array<{ __typename?: 'ExperimentEntity', id: number, description?: string | null, isActive: boolean, name: string, experimentVariants: Array<{ __typename?: 'ExperimentVariantEntity', description: string, id: number, name: string, trafficAllocation: number, variant: number }> }> };

export type ExperimentForListFragment = { __typename?: 'ExperimentEntity', id: number, description?: string | null, isActive: boolean, name: string, experimentVariants: Array<{ __typename?: 'ExperimentVariantEntity', description: string, id: number, name: string, trafficAllocation: number, variant: number }> };

export type CreateExperimentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type CreateExperimentMutation = { __typename?: 'Mutation', createExperiment?: { __typename?: 'ExperimentEntity', id: number, description?: string | null, isActive: boolean, name: string, experimentVariants: Array<{ __typename?: 'ExperimentVariantEntity', description: string, id: number, name: string, trafficAllocation: number, variant: number }> } | null };

export type DeleteExperimentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteExperimentMutation = { __typename?: 'Mutation', deleteExperiment: boolean };

export type SingleFeatureHistoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SingleFeatureHistoryQuery = { __typename?: 'Query', feature?: { __typename?: 'FeatureEntity', id: number, name: string, description: string, overridesCount: number, historys: Array<{ __typename?: 'FeatureHistoryEntity', id: number, state: FeatureState, updatedAt: string, editedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null, email?: string | null } | null }>, businessFeatures: Array<{ __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } }> } | null };

export type SingleBusinessFeatureFragment = { __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } };

export type SingleFeatureQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SingleFeatureQuery = { __typename?: 'Query', feature?: { __typename?: 'FeatureEntity', id: number, name: string, overridesCount: number, businessFeatures: Array<{ __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } }> } | null };

export type FetchAllFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchAllFeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'FeatureEntity', id: number, name: string, description: string, canonicalType: FeatureType, createdAt: string, updatedAt: string, overridesCount: number, state: FeatureState, unused: boolean, entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number }>, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null }> };

export type FeatureForListFragment = { __typename?: 'FeatureEntity', id: number, name: string, description: string, canonicalType: FeatureType, createdAt: string, updatedAt: string, overridesCount: number, state: FeatureState, unused: boolean, entitlementSets: Array<{ __typename?: 'EntitlementSetEntity', id: number }>, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null };

export type UpdateBusinessFeatureMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
}>;


export type UpdateBusinessFeatureMutation = { __typename?: 'Mutation', updateBusinessFeature?: { __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } } | null };

export type BatchUpdateBusinessFeatureMutationVariables = Exact<{
  businessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  featureId: Scalars['Int']['input'];
  state: BusinessFeatureState;
}>;


export type BatchUpdateBusinessFeatureMutation = { __typename?: 'Mutation', batchUpdateBusinessFeature: Array<{ __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } }> };

export type RandomUpdateBusinessFeatureMutationVariables = Exact<{
  featureId: Scalars['Int']['input'];
  count: Scalars['Int']['input'];
  state: BusinessFeatureState;
}>;


export type RandomUpdateBusinessFeatureMutation = { __typename?: 'Mutation', updateBusinessFeatureRandom: Array<{ __typename?: 'BusinessFeatureEntity', id?: number | null, updatedAt: string, state: BusinessFeatureState, lastEditedByPatron?: { __typename?: 'PatronEntity', id: number, firstName?: string | null, lastName?: string | null } | null, business: { __typename?: 'BusinessEntity', id: number, name: string } }> };

export type BusinessesForSwitcherQueryVariables = Exact<{ [key: string]: never; }>;


export type BusinessesForSwitcherQuery = { __typename?: 'Query', businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string, emailLogoUrl?: string | null, location: { __typename?: 'BusinessLocation', city?: string | null, state?: string | null } }> };

export type GuestProfileTagsByBusinessQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type GuestProfileTagsByBusinessQuery = { __typename?: 'Query', tagCountsByBusiness: Array<{ __typename?: 'GuestProfileTagCount', archivedTagCount: number, tag: string, unarchivedTagCount: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> };

export type GuestProfileTagFragment = { __typename?: 'GuestProfileTagCount', archivedTagCount: number, tag: string, unarchivedTagCount: number, business: { __typename?: 'BusinessEntity', id: number, name: string } };

export type BulkUpdateGuestProfileTagsMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
  tagName: Scalars['String']['input'];
}>;


export type BulkUpdateGuestProfileTagsMutation = { __typename?: 'Mutation', updateGuestProfileTags: boolean };

export type GetHelpMenuEntryByIdQueryVariables = Exact<{
  helpMenuEntryById: Scalars['Int']['input'];
}>;


export type GetHelpMenuEntryByIdQuery = { __typename?: 'Query', helpMenuEntry?: { __typename?: 'HelpMenuEntryEntity', bodyText: string, createdAt: string, effectiveDate: string, headline: string, helpCenterUrl?: string | null, id: number, publicationStatus: PublicationStatus, relevantInventoryType: RelevantInventoryType, updatedAt: string, features: Array<{ __typename?: 'FeatureEntity', name: string }>, image?: { __typename?: 'UploadedImageEntity', id: number, imageBackingUrl?: string | null } | null } | null };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'FeatureEntity', name: string }> };

export type TicketTypesForBusinessQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type TicketTypesForBusinessQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, name: string, ticketTypes: Array<{ __typename?: 'TicketTypeEntity', id: number, name: string, variety: TicketTypeVariety, activeTicketOptionGroupCount: number, activeTicketOptionCount: number }> } | null };

export type TicketTypeForMigratorExportFragment = { __typename?: 'TicketTypeEntity', id: number, name: string, variety: TicketTypeVariety, activeTicketOptionGroupCount: number, activeTicketOptionCount: number };

export type UpdateMetaTagMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  newExperienceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  removeExperienceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  newBusinessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  removeBusinessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateMetaTagMutation = { __typename?: 'Mutation', updateMetaTag?: { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null, ticketTypeTags: Array<{ __typename?: 'TicketTypeTagEntity', id: number, source: TagSource, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } }>, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> } | null };

export type CreateMetaTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  isInternal: Scalars['Boolean']['input'];
  type: TagType;
  newExperienceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  newBusinessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateMetaTagMutation = { __typename?: 'Mutation', createMetaTag?: { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null, ticketTypeTags: Array<{ __typename?: 'TicketTypeTagEntity', id: number, source: TagSource, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } }>, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> } | null };

export type MetaTagsByTagTypeInternalQueryVariables = Exact<{
  tagTypes: Array<TagType> | TagType;
}>;


export type MetaTagsByTagTypeInternalQuery = { __typename?: 'Query', metaTagsByTagTypeInternal: Array<{ __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null, ticketTypeTags: Array<{ __typename?: 'TicketTypeTagEntity', id: number, source: TagSource, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } }>, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> }> };

export type ListMetaTagFragment = { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null, ticketTypeTags: Array<{ __typename?: 'TicketTypeTagEntity', id: number, source: TagSource, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } }>, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> };

export type TicketTypeMetaTagsInternalQueryVariables = Exact<{ [key: string]: never; }>;


export type TicketTypeMetaTagsInternalQuery = { __typename?: 'Query', ticketTypeMetaTagsInternal: Array<{ __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null, ticketTypeTags: Array<{ __typename?: 'TicketTypeTagEntity', id: number, source: TagSource, ticketType: { __typename?: 'TicketTypeEntity', id: number, name: string } }>, businessTags: Array<{ __typename?: 'BusinessTagEntity', id: number, business: { __typename?: 'BusinessEntity', id: number, name: string } }> }> };

export type CreateTockApiKeyMutationVariables = Exact<{
  keyType: KeyType;
  patronId: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
}>;


export type CreateTockApiKeyMutation = { __typename?: 'Mutation', createTockApiKey?: string | null };

export type UpdateTockApiKeyStatusMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
}>;


export type UpdateTockApiKeyStatusMutation = { __typename?: 'Mutation', updateKeyStatus?: boolean | null };

export type GetAllTockApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTockApiKeyQuery = { __typename?: 'Query', allApiKeys: Array<{ __typename?: 'TockApiKeyEntity', uuid?: any | null, keyType: KeyType, status: TockApiKeyStatus, createdAt: string, description?: string | null, contactEmail?: string | null, createdByPatron: { __typename?: 'PatronEntity', firstName?: string | null, lastName?: string | null } }> };

export type GetTockTenConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTockTenConfigsQuery = { __typename?: 'Query', tockTenConfigs: Array<{ __typename?: 'TockTenConfigEntity', id: number, name: string, description?: string | null, marketingUrl: string, isArchived: boolean, image: { __typename?: 'UploadedImageEntity', imageUrl?: string | null }, businesss: Array<{ __typename?: 'BusinessEntity', id: number, name: string }> }> };

export type CreateTockTenListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  uploadedImageId: Scalars['Int']['input'];
  businessIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  marketingUrl: Scalars['String']['input'];
}>;


export type CreateTockTenListMutation = { __typename?: 'Mutation', createTockTenList?: number | null };

export type UpdateTockTenListMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type UpdateTockTenListMutation = { __typename?: 'Mutation', updateTockTenList: boolean };

export type MetaTagsByTaggableInternalQueryVariables = Exact<{ [key: string]: never; }>;


export type MetaTagsByTaggableInternalQuery = { __typename?: 'Query', ticketTypeMetaTagsInternal: Array<{ __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null }>, businessMetaTagsInternal: Array<{ __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null }> };

export type SimpleMetaTagFragment = { __typename?: 'MetaTagEntity', id: number, name: string, type: TagType, isInternal?: boolean | null, isActive?: boolean | null };

export type ResendBankVerificationDepositsMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type ResendBankVerificationDepositsMutation = { __typename?: 'Mutation', resendBankVerificationDeposits: boolean };

export type ReverseInvoiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  forcePayoutRemoval: Scalars['Boolean']['input'];
}>;


export type ReverseInvoiceMutation = { __typename?: 'Mutation', reverseInvoice: boolean };

export type MarkInvoiceAsPaidByCheckMutationVariables = Exact<{
  invoiceId: Scalars['Int']['input'];
}>;


export type MarkInvoiceAsPaidByCheckMutation = { __typename?: 'Mutation', markInvoiceAsPaidByCheck: boolean };

export type SetSubscriptionToPaidByCheckMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type SetSubscriptionToPaidByCheckMutation = { __typename?: 'Mutation', setSubscriptionToPaidByCheck: boolean };

export type UpdateBusinessPayoutConfigMutationVariables = Exact<{
  businessPayoutConfig: BusinessPayoutConfigInput;
}>;


export type UpdateBusinessPayoutConfigMutation = { __typename?: 'Mutation', updateBusinessPayoutConfig?: { __typename?: 'BusinessPayoutConfigEntity', id: number } | null };

export type ReverseBusinessPayoutMutationVariables = Exact<{
  payoutId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
}>;


export type ReverseBusinessPayoutMutation = { __typename?: 'Mutation', reverseBusinessPayout: boolean };

export type ReimburseBusinessThroughStripeMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  amountCents: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  creditCardId: Scalars['String']['input'];
}>;


export type ReimburseBusinessThroughStripeMutation = { __typename?: 'Mutation', reimburseBusinessThroughStripe?: string | null };

export type FinanceBusinessQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FinanceBusinessQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, name: string, currencyCode: string, createdAt: string, updatedAt: string, paymentProcessorType?: PaymentProcessorType | null, bankAccount?: { __typename?: 'BusinessBankAccountEntity', id: number, bankName?: string | null, depositsSent?: boolean | null, depositsSentDate?: string | null, depositedCents1?: number | null, maskedAccountNumber?: string | null, verificationDepositsRequired?: boolean | null, verified?: boolean | null } | null, invoices: Array<{ __typename?: 'InvoiceEntity', id: number, periodEndDate: string, periodStartDate: string, processorType: PaymentProcessorType, totalAmountCents: number }>, paymentSubscription?: { __typename?: 'PaymentSubscriptionEntity', id: number, processorType?: PaymentProcessorType | null } | null, payoutConfigs: Array<{ __typename?: 'BusinessPayoutConfigEntity', id: number, createdAt: string, updatedAt: string, allowDebits: boolean, disablePayout?: boolean | null, negativeBalanceAdjustmentCents?: number | null, note?: string | null, payoutMonthly: boolean, orderPayoutParameters?: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } | null, purchasePayoutParameters: { __typename?: 'BusinessPayoutConfigParametersEntity', id: number, createdAt: string, updatedAt: string, type: ConfigType, rollingDays: number, postPaymentDays?: number | null, postPaymentPercentage?: number | null, firstPostServiceDays?: number | null, firstPostServicePercentage?: number | null, secondPostServiceDays?: number | null, secondPostServicePercentage?: number | null, payoutDescriptionString?: string | null, note?: string | null } }>, payoutSummarys: Array<{ __typename?: 'BusinessPayoutSummaryEntity', id: number, amountCents?: number | null, createdAt: string, payoutId?: number | null, wasRejected?: boolean | null }> } | null };

export type FinanceBusinessFieldsFragment = { __typename?: 'BusinessEntity', id: number, name: string, currencyCode: string, bankAccount?: { __typename?: 'BusinessBankAccountEntity', id: number, bankName?: string | null, depositsSent?: boolean | null, depositsSentDate?: string | null, depositedCents1?: number | null, maskedAccountNumber?: string | null, verificationDepositsRequired?: boolean | null, verified?: boolean | null } | null, invoices: Array<{ __typename?: 'InvoiceEntity', id: number, periodEndDate: string, periodStartDate: string, processorType: PaymentProcessorType, totalAmountCents: number }>, paymentSubscription?: { __typename?: 'PaymentSubscriptionEntity', id: number, processorType?: PaymentProcessorType | null } | null, payoutConfigs: Array<{ __typename?: 'BusinessPayoutConfigEntity', id: number }>, payoutSummarys: Array<{ __typename?: 'BusinessPayoutSummaryEntity', id: number, amountCents?: number | null, createdAt: string, payoutId?: number | null, wasRejected?: boolean | null }> };

export type ImportStatusFieldsFragment = { __typename?: 'ImportResponse', importUuid?: any | null, businessName?: string | null, currentStage?: ImportStage | null, currentStageDisplayName?: string | null, numberOfChunksUploaded: number, patrons: number, paused: boolean, reservations: number, runTime: number, startedAt?: string | null, totalChunks: number, waitlistEntries: number, assignmentWarnings: Array<string>, workflowIdentifier?: { __typename?: 'WorkflowIdentifier', workflowId: string, runId: string } | null };

export type ImportStatusSubscriptionVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type ImportStatusSubscription = { __typename?: 'Subscription', importStatus?: { __typename?: 'ImportResponse', importUuid?: any | null, businessName?: string | null, currentStage?: ImportStage | null, currentStageDisplayName?: string | null, numberOfChunksUploaded: number, patrons: number, paused: boolean, reservations: number, runTime: number, startedAt?: string | null, totalChunks: number, waitlistEntries: number, assignmentWarnings: Array<string>, workflowIdentifier?: { __typename?: 'WorkflowIdentifier', workflowId: string, runId: string } | null } | null };

export type StartUndoImportMutationVariables = Exact<{
  importUuid: Scalars['UUID']['input'];
  businessId: Scalars['Int']['input'];
  maxConcurrentTasks: Scalars['Int']['input'];
}>;


export type StartUndoImportMutation = { __typename?: 'Mutation', startImportUndo?: { __typename?: 'ImportUndoStartResponse', started: boolean } | null };

export type PauseOrContinueWorkflowMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  pause: Scalars['Boolean']['input'];
}>;


export type PauseOrContinueWorkflowMutation = { __typename?: 'Mutation', pauseOrContinueWorkflow?: { __typename?: 'ImportResponse', importUuid?: any | null, businessName?: string | null, currentStage?: ImportStage | null, currentStageDisplayName?: string | null, numberOfChunksUploaded: number, patrons: number, paused: boolean, reservations: number, runTime: number, startedAt?: string | null, totalChunks: number, waitlistEntries: number, assignmentWarnings: Array<string>, workflowIdentifier?: { __typename?: 'WorkflowIdentifier', workflowId: string, runId: string } | null } | null };

export type ImportUndoResponseFieldsFragment = { __typename?: 'ImportUndoResponse', completed: boolean, reservationDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, guestDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, waitlistDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, errorMessage?: { __typename?: 'ErrorMessage', message?: string | null } | null };

export type UndoImportSubscriptionVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type UndoImportSubscription = { __typename?: 'Subscription', undoImport?: { __typename?: 'ImportUndoResponse', completed: boolean, reservationDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, guestDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, waitlistDeletionResult?: { __typename?: 'ImportUndoDeletionResult', countDeleted: number } | null, errorMessage?: { __typename?: 'ErrorMessage', message?: string | null } | null } | null };

export type FetchBusinessGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBusinessGroupsQuery = { __typename?: 'Query', businessGroups: Array<{ __typename?: 'BusinessGroupInfo', id: number, name: string, slug?: string | null, businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string }> }> };

export type BusinessGroupInfoFragment = { __typename?: 'BusinessGroupInfo', id: number, name: string, slug?: string | null, businesses: Array<{ __typename?: 'BusinessEntity', id: number, name: string }> };

export type CreateTaxCategoryEntitiesMutationVariables = Exact<{
  taxCategories: Array<TaxCategoryInput> | TaxCategoryInput;
}>;


export type CreateTaxCategoryEntitiesMutation = { __typename?: 'Mutation', createTaxCategoryEntities: Array<{ __typename: 'TaxCategoryEntity', id: number, displayName: string, optionalId?: number | null, globalEnablementState: EnablementState, updatedAt: string, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, sourceIdentifier?: string | null, taxSource?: TaxSource | null }> }> };

export type GetTaxCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTaxCategoriesQuery = { __typename?: 'Query', allEnablementStates: Array<EnablementState>, taxCategoryEntitiesForConfiguration: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, optionalId?: number | null, globalEnablementState: EnablementState, updatedAt: string, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, taxSource?: TaxSource | null, sourceIdentifier?: string | null }>, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number } | null }> }> };

export type TaxCategories_TaxCategoryEntitiesFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string, optionalId?: number | null, globalEnablementState: EnablementState, updatedAt: string, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, taxSource?: TaxSource | null, sourceIdentifier?: string | null }>, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number } | null }> };

export type BusinessTaxCategoryEnablementFragment = { __typename?: 'TaxCategoryEnablementEntity', id: number, enablementState: EnablementState, isArchived: boolean, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null };

export type TaxCategoryDeletionFragment = { __typename?: 'TaxCategoryEntity', id: number, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, enablementType: EnablementType, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null }> };

export type DeleteTaxCategoryEnablementMutationVariables = Exact<{
  taxCategories: Array<TaxCategoryInput> | TaxCategoryInput;
}>;


export type DeleteTaxCategoryEnablementMutation = { __typename?: 'Mutation', updateTaxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, enablementType: EnablementType, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null }> }> };

export type GetTaxCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetTaxCategoryQuery = { __typename?: 'Query', taxCategory?: { __typename?: 'TaxCategoryEntity', id: number, createdAt: string, updatedAt: string, displayName: string, globalEnablementState: EnablementState, isArchived?: boolean | null, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, createdAt: string, updatedAt: string, enablementState: EnablementState, enablementType: EnablementType, isArchived: boolean, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null }>, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, createdAt: string, updatedAt: string, taxSource?: TaxSource | null, sourceIdentifier?: string | null }> } | null };

export type TaxCategoryDetailsFragment = { __typename?: 'TaxCategoryEntity', id: number, createdAt: string, updatedAt: string, displayName: string, globalEnablementState: EnablementState, isArchived?: boolean | null, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, createdAt: string, updatedAt: string, enablementState: EnablementState, enablementType: EnablementType, isArchived: boolean, region?: string | null, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null }>, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, createdAt: string, updatedAt: string, taxSource?: TaxSource | null, sourceIdentifier?: string | null }> };

export type UpdateTaxCategoryEntitiesMutationVariables = Exact<{
  taxCategories: Array<TaxCategoryInput> | TaxCategoryInput;
}>;


export type UpdateTaxCategoryEntitiesMutation = { __typename?: 'Mutation', updateTaxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, enablements: Array<{ __typename?: 'TaxCategoryEnablementEntity', id: number, region?: string | null, enablementState: EnablementState, enablementType: EnablementType, isArchived: boolean, business?: { __typename?: 'BusinessEntity', id: number, name: string } | null }> }> };

export type TaxCategoryDetailFormFragment = { __typename?: 'TaxCategoryEntity', id: number, createdAt: string, updatedAt: string, displayName: string, globalEnablementState: EnablementState, isArchived?: boolean | null, sources: Array<{ __typename?: 'TaxCategoryTaxSourceEntity', id: number, createdAt: string, updatedAt: string, sourceIdentifier?: string | null, taxSource?: TaxSource | null }> };

export type RegionalTaxCategoryEnablementFragment = { __typename?: 'TaxCategoryEnablementEntity', id: number, enablementState: EnablementState, enablementType: EnablementType, isArchived: boolean, region?: string | null };

export type ClowncarTaxResultAvalaraTaxFragment = { __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxType: string, taxRate: { __typename?: 'Percent', asNumber: number, asString?: string | null } };

export type ClowncarTaxResultFragment = { __typename?: 'TaxCategoryEntity', id: number, displayName: string, rates?: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asString?: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxType: string, taxRate: { __typename?: 'Percent', asNumber: number, asString?: string | null } } | { __typename?: 'BusinessTaxEntity' }> } | null };

export type GetAddressTaxesQueryVariables = Exact<{
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
}>;


export type GetAddressTaxesQuery = { __typename?: 'Query', taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, rates?: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asString?: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxType: string, taxRate: { __typename?: 'Percent', asNumber: number, asString?: string | null } } | { __typename?: 'BusinessTaxEntity' }> } | null }> };

export type GetBusinessTaxesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBusinessTaxesQuery = { __typename?: 'Query', business?: { __typename?: 'BusinessEntity', id: number, taxCategoryEntities: Array<{ __typename?: 'TaxCategoryEntity', id: number, displayName: string, rates?: { __typename?: 'TaxCategoryRate_PurchasableTax', aggregateRate: { __typename?: 'Percent', asString?: string | null }, taxes: Array<{ __typename?: 'AvalaraTax', isRetainedByTock: boolean, jurisdictionName: string, jurisdictionType: JurisdictionType, name: string, taxType: string, taxRate: { __typename?: 'Percent', asNumber: number, asString?: string | null } } | { __typename?: 'BusinessTaxEntity' }> } | null }>, location: { __typename?: 'BusinessLocation', address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } } | null };

export type CreateBusinessContentMutationVariables = Exact<{
  businessContent: UpdateBusinessContentInput;
}>;


export type CreateBusinessContentMutation = { __typename?: 'Mutation', createBusinessContent?: { __typename?: 'BusinessContentEntity', venueId?: number | null, businessId?: number | null, needToKnow?: string | null, whyWeLikeIt?: string | null } | null };

export type UpdateBusinessContentMutationVariables = Exact<{
  businessContent: UpdateBusinessContentInput;
}>;


export type UpdateBusinessContentMutation = { __typename?: 'Mutation', updateBusinessContent?: { __typename?: 'BusinessContentEntity', venueId?: number | null, businessId?: number | null, needToKnow?: string | null, whyWeLikeIt?: string | null } | null };

export type GetAllBusinessContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllBusinessContentQuery = { __typename?: 'Query', allBusinessContent: Array<{ __typename?: 'BusinessContentEntity', businessId?: number | null, venueId?: number | null, needToKnow?: string | null, whyWeLikeIt?: string | null }> };

export type CreateBusinessContentBulkMutationVariables = Exact<{
  businessContents: Array<UpdateBusinessContentInput> | UpdateBusinessContentInput;
}>;


export type CreateBusinessContentBulkMutation = { __typename?: 'Mutation', createBusinessContentBulk: Array<{ __typename?: 'BusinessContentEntity', businessId?: number | null, venueId?: number | null, needToKnow?: string | null, whyWeLikeIt?: string | null }> };

export type CreateJceHomepageGeographyMutationVariables = Exact<{
  geography: JceHomepageGeographyInput;
}>;


export type CreateJceHomepageGeographyMutation = { __typename?: 'Mutation', createJceHomepageGeography?: { __typename?: 'JceHomepageGeographyEntity', id: number, name?: string | null, urlSlug?: string | null, resyBlogKey?: string | null, tier?: JceHomepageGeographyTier | null, priorityWithinTier?: number | null } | null };

export type GetAllGeographiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGeographiesQuery = { __typename?: 'Query', allGeographies: Array<{ __typename?: 'JceHomepageGeographyEntity', id: number, name?: string | null, urlSlug?: string | null, resyBlogKey?: string | null, tier?: JceHomepageGeographyTier | null, priorityWithinTier?: number | null }> };

export type CreateJceVenueCollectionMutationVariables = Exact<{
  collection: JceVenueCollectionInput;
  geographyId: Scalars['Int']['input'];
}>;


export type CreateJceVenueCollectionMutation = { __typename?: 'Mutation', createJceVenueCollection?: { __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null, description?: string | null, iconIndicator?: JceVenueCollectionIconIndicator | null, status?: JceVenueCollectionStatus | null, urlSlug?: string | null } | null };

export type UpdateJceVenueCollectionMutationVariables = Exact<{
  collection: JceVenueCollectionInput;
}>;


export type UpdateJceVenueCollectionMutation = { __typename?: 'Mutation', updateJceVenueCollection?: { __typename?: 'JceVenueCollectionEntity', id: number, name?: string | null, description?: string | null, iconIndicator?: JceVenueCollectionIconIndicator | null, status?: JceVenueCollectionStatus | null, urlSlug?: string | null } | null };

export const BusinessGroupSummaryFieldsFragmentDoc = gql`
    fragment businessGroupSummaryFields on BusinessGroupEntity {
  id
  name
  groupLevelTags
  slug
}
    `;
export const BusinessSummaryFieldsFragmentDoc = gql`
    fragment businessSummaryFields on BusinessEntity {
  id
  name
  domainName
  webUrl
  bookingsDisabled
  isDeleted
  isAuthorizedByTock
  unlisted
  businessGroup {
    id
    name
  }
}
    `;
export const CancelBookingsWorkflowStatusFieldsFragmentDoc = gql`
    fragment cancelBookingsWorkflowStatusFields on CancelBookingsWorkflowStatus {
  numSuccess
  numFailed
  numTotal
  workflowRunId
  done
}
    `;
export const CancelBookingsOutputFieldsFragmentDoc = gql`
    fragment cancelBookingsOutputFields on CancelBookingsOutput {
  ticketTypeId
  ticketTypeName
  purchaseCount
}
    `;
export const PayoutParameterFieldsFragmentDoc = gql`
    fragment payoutParameterFields on BusinessPayoutConfigParametersEntity {
  id
  type
  rollingDays
  postPaymentDays
  postPaymentPercentage
  firstPostServiceDays
  firstPostServicePercentage
  secondPostServiceDays
  secondPostServicePercentage
  payoutDescriptionString
  note
}
    `;
export const PayoutConfigFieldsFragmentDoc = gql`
    fragment payoutConfigFields on BusinessEntity {
  currencyCode
  id
  createdAt
  updatedAt
  paymentProcessorType
  payoutConfigs {
    id
    createdAt
    updatedAt
    allowDebits
    disablePayout
    orderPayoutParameters {
      id
      createdAt
      updatedAt
      ...payoutParameterFields
    }
    purchasePayoutParameters {
      id
      createdAt
      updatedAt
      ...payoutParameterFields
    }
    negativeBalanceAdjustmentCents
    note
    payoutMonthly
  }
}
    ${PayoutParameterFieldsFragmentDoc}`;
export const EntitlementSetFragmentDoc = gql`
    fragment entitlementSet on EntitlementSetEntity {
  id
  description
  name
  entitlementSetFeatures {
    id
    feature {
      id
      name
      description
    }
  }
}
    `;
export const FakePurchaseWorkflowStatusFieldsFragmentDoc = gql`
    fragment fakePurchaseWorkflowStatusFields on FakePurchaseWorkflowStatus {
  numSuccess
  numFailed
  numTotal
  done
}
    `;
export const BulkPatronActionWorkflowStatusFieldsFragmentDoc = gql`
    fragment bulkPatronActionWorkflowStatusFields on BulkPatronActionWorkflowStatus {
  numSuccess
  numFailed
  numProcessed
  numTotal
  failedPatronIds
  numTruncatedErrors
  done
  attachedToExistingRun
}
    `;
export const TemporaryPermissionRequestFragmentDoc = gql`
    fragment TemporaryPermissionRequest on RoleBusinessPermissionRequestEntity {
  __typename
  approvedAt
  approverPatron {
    firstName
    lastName
  }
  requestingPatron {
    firstName
    lastName
  }
  requestedAt
  business {
    id
    name
  }
  role
  reason
  isExpired
  isApproved
  expiresAt
}
    `;
export const BookingFieldsFragmentDoc = gql`
    fragment bookingFields on Booking {
  assignedToSlot
  date
  startLocalTime
  endLocalTime
  experience {
    name
    shortCode
  }
  partyName
  partySize
  pinned
  uniqueIdentifier
}
    `;
export const SeatingPlanFieldsFragmentDoc = gql`
    fragment seatingPlanFields on SeatingPlan {
  serviceDate
  scoresForServices {
    serviceStartLocalTime
    serviceEndLocalTime
    score {
      hardScore
      mediumScore
      softScore
      explanation
    }
  }
  unassignedBookings {
    ...bookingFields
  }
  bookingsToTables {
    bookableTables {
      supportedExperiences {
        name
        shortCode
      }
      offeredOnline
      maxSize
      minSize
      name
      blockedLocalTimes
    }
    booking {
      ...bookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}`;
export const SsoLoginDomainFieldsFragmentDoc = gql`
    fragment ssoLoginDomainFields on SsoLoginDomainEntity {
  id
  domainName
  tenantId
}
    `;
export const EditEntitlementSetDialog_EntitlementSetFragmentDoc = gql`
    fragment EditEntitlementSetDialog_entitlementSet on EntitlementSetEntity {
  id
  name
  description
  entitlementSetFeatures {
    id
    feature {
      id
      name
    }
  }
}
    `;
export const EntitlementSetFieldSet_FeaturesFragmentDoc = gql`
    fragment EntitlementSetFieldSet_features on FeatureEntity {
  id
  name
  description
}
    `;
export const EntitlementSetsPage_EntitlementSetsFragmentDoc = gql`
    fragment EntitlementSetsPage_entitlementSets on EntitlementSetEntity {
  id
  name
  description
  entitlementSetFeatures {
    id
    feature {
      name
    }
  }
  businessCount
}
    `;
export const EditPaymentSubscriptionPlan_SubscriptionFragmentDoc = gql`
    fragment EditPaymentSubscriptionPlan_subscription on PaymentSubscriptionPlanEntity {
  entitlementSet {
    id
    name
  }
}
    `;
export const PaymentSubscriptionPlansPage_SubscriptionFragmentDoc = gql`
    fragment PaymentSubscriptionPlansPage_subscription on PaymentSubscriptionPlanEntity {
  id
  canonicalName
  subscriptionPlanName
  currencyCode
  entitlementSet {
    id
    name
    entitlementSetFeatures {
      id
      feature {
        id
        name
      }
    }
  }
  businessCount
  monthlySubscriptionFee
  monthlyPerTicketFee
  monthlyPerTicketBaseFee
  toGoFeePercentage
  purchaseProcessingFeePercentage
}
    `;
export const Addons_PaymentSubscriptionPlanAddonsFragmentDoc = gql`
    fragment Addons_paymentSubscriptionPlanAddons on PaymentSubscriptionPlanAddonEntity {
  id
  name
  amountCents
  canonicalType
  currencyCode
  entitlementSet {
    id
    name
    entitlementSetFeatures {
      id
      feature {
        id
        name
      }
    }
  }
  businessCount
}
    `;
export const PreviewEntitlementChanges_EntitlementSetChangeFragmentDoc = gql`
    fragment PreviewEntitlementChanges_EntitlementSetChange on EntitlementSetChange {
  action
  entitlementSet {
    id
    name
  }
}
    `;
export const PreviewEntitlementChanges_EntitlementChangeFragmentDoc = gql`
    fragment PreviewEntitlementChanges_EntitlementChange on EntitlementChange {
  action
  entitlement {
    id
    name
  }
}
    `;
export const PreviewEntitlementChangesFragmentDoc = gql`
    fragment PreviewEntitlementChanges on EntitlementChangePreview {
  entitlementSetsBefore {
    ...PreviewEntitlementChanges_EntitlementSetChange
  }
  entitlementSetsAfter {
    ...PreviewEntitlementChanges_EntitlementSetChange
  }
  entitlementsBefore {
    ...PreviewEntitlementChanges_EntitlementChange
  }
  entitlementsAfter {
    ...PreviewEntitlementChanges_EntitlementChange
  }
}
    ${PreviewEntitlementChanges_EntitlementSetChangeFragmentDoc}
${PreviewEntitlementChanges_EntitlementChangeFragmentDoc}`;
export const AccoladeTypeInfoFragmentDoc = gql`
    fragment AccoladeTypeInfo on AccoladeTypeInfo {
  accoladeTypeEntity {
    id
    name
    hasAchievement
    hasCritic
    hasLink
    iconImgLink
    isActive
    orgLink
    displayName
    accoladeTypeRating {
      id
      name
      minValue
      maxValue
      isHalfPoints
      systemType
    }
    defaultAchievement
  }
  totalNumBusinessAccolades
  businessesWithAccoladeType
  businessEntitiesWithAccoladeType {
    id
    isDeleted
    name
  }
}
    `;
export const AccoladeTypeRatingInfoFragmentDoc = gql`
    fragment AccoladeTypeRatingInfo on AccoladeTypeRatingInfo {
  accoladeTypeRatingEntity {
    id
    name
    minValue
    maxValue
    isHalfPoints
    systemType
  }
  totalNumAccoladesUsingRating
  accoladeTypesWithRating
}
    `;
export const BusinessGroupFragmentDoc = gql`
    fragment BusinessGroup on BusinessGroupEntity {
  businesses {
    id
    name
  }
  id
  name
  groupLevelTags
  groupUrlPageTitle
  slug
}
    `;
export const ImageInfoFragmentDoc = gql`
    fragment ImageInfo on BusinessImage {
  id
  imageUrl
  backingUrl
}
    `;
export const BusinessWithSearchAttributesFragmentDoc = gql`
    fragment BusinessWithSearchAttributes on BusinessEntity {
  id
  location {
    city
    state
  }
  name
  searchAttributes {
    id
    isArchived
    nearestMetro
    neighborhood
    metroArea {
      id
    }
  }
  shouldDisplayAddress
  timeZone
}
    `;
export const ActiveMetroAreaNamesFragmentDoc = gql`
    fragment ActiveMetroAreaNames on MetroAreaEntity {
  id
  name
}
    `;
export const BusinessSearchField_BusinessFragmentDoc = gql`
    fragment BusinessSearchField_Business on BusinessEntity {
  id
  name
  emailLogoUrl
  location {
    city
    state
  }
}
    `;
export const BusinessTaxMigratorFieldsFragmentDoc = gql`
    fragment businessTaxMigratorFields on BusinessTaxMigration {
  businessId
  businessName
  taxRate {
    asNumber
  }
  taxableTicketTypesWithTaxableAddons {
    taxableAddons {
      id
      name
    }
    ticketTypeId
    ticketTypeName
  }
}
    `;
export const TemporaryPermissionsRequestFragmentDoc = gql`
    fragment temporaryPermissionsRequest on RoleBusinessPermissionRequestEntity {
  requestingPatron {
    id
    firstName
    lastName
    email
  }
  requestWorkflowId
  requestedAt
  isApproved
  business {
    id
    name
  }
  role
  approverPatron {
    id
    firstName
    lastName
    email
  }
}
    `;
export const ExperimentForListFragmentDoc = gql`
    fragment experimentForList on ExperimentEntity {
  id
  description
  isActive
  name
  experimentVariants {
    description
    id
    name
    trafficAllocation
    variant
  }
}
    `;
export const SingleBusinessFeatureFragmentDoc = gql`
    fragment singleBusinessFeature on BusinessFeatureEntity {
  id
  updatedAt
  state
  lastEditedByPatron {
    id
    firstName
    lastName
  }
  business {
    id
    name
  }
}
    `;
export const FeatureForListFragmentDoc = gql`
    fragment featureForList on FeatureEntity {
  id
  name
  description
  canonicalType
  createdAt
  updatedAt
  overridesCount
  state
  unused
  entitlementSets {
    id
  }
  lastEditedByPatron {
    id
    firstName
    lastName
  }
}
    `;
export const GuestProfileTagFragmentDoc = gql`
    fragment GuestProfileTag on GuestProfileTagCount {
  archivedTagCount
  business {
    id
    name
  }
  tag
  unarchivedTagCount
}
    `;
export const TicketTypeForMigratorExportFragmentDoc = gql`
    fragment TicketTypeForMigratorExport on TicketTypeEntity {
  id
  name
  variety
  activeTicketOptionGroupCount
  activeTicketOptionCount
}
    `;
export const ListMetaTagFragmentDoc = gql`
    fragment listMetaTag on MetaTagEntity {
  id
  name
  type
  isInternal
  isActive
  ticketTypeTags {
    id
    source
    ticketType {
      id
      name
    }
  }
  businessTags {
    id
    business {
      id
      name
    }
  }
}
    `;
export const SimpleMetaTagFragmentDoc = gql`
    fragment simpleMetaTag on MetaTagEntity {
  id
  name
  type
  isInternal
  isActive
}
    `;
export const FinanceBusinessFieldsFragmentDoc = gql`
    fragment financeBusinessFields on BusinessEntity {
  id
  name
  currencyCode
  bankAccount {
    id
    bankName
    depositsSent
    depositsSentDate
    depositedCents1
    maskedAccountNumber
    verificationDepositsRequired
    verified
  }
  invoices {
    id
    periodEndDate
    periodStartDate
    processorType
    totalAmountCents
  }
  paymentSubscription {
    id
    processorType
  }
  payoutConfigs {
    id
  }
  payoutSummarys {
    id
    amountCents
    createdAt
    payoutId
    wasRejected
  }
}
    `;
export const ImportStatusFieldsFragmentDoc = gql`
    fragment importStatusFields on ImportResponse {
  importUuid
  businessName
  currentStage
  currentStageDisplayName
  numberOfChunksUploaded
  patrons
  paused
  reservations
  runTime
  startedAt
  totalChunks
  waitlistEntries
  workflowIdentifier {
    workflowId
    runId
  }
  assignmentWarnings
}
    `;
export const ImportUndoResponseFieldsFragmentDoc = gql`
    fragment importUndoResponseFields on ImportUndoResponse {
  reservationDeletionResult {
    countDeleted
  }
  guestDeletionResult {
    countDeleted
  }
  waitlistDeletionResult {
    countDeleted
  }
  completed
  errorMessage {
    message
  }
}
    `;
export const BusinessGroupInfoFragmentDoc = gql`
    fragment BusinessGroupInfo on BusinessGroupInfo {
  id
  name
  businesses {
    id
    name
  }
  slug
}
    `;
export const TaxCategories_TaxCategoryEntitiesFragmentDoc = gql`
    fragment TaxCategories_taxCategoryEntities on TaxCategoryEntity {
  id
  displayName
  optionalId
  globalEnablementState
  updatedAt
  sources {
    id
    taxSource
    sourceIdentifier
  }
  enablements {
    id
    business {
      id
    }
    region
  }
}
    `;
export const BusinessTaxCategoryEnablementFragmentDoc = gql`
    fragment BusinessTaxCategoryEnablement on TaxCategoryEnablementEntity {
  id
  business {
    id
    name
  }
  enablementState
  isArchived
}
    `;
export const TaxCategoryDeletionFragmentDoc = gql`
    fragment TaxCategoryDeletion on TaxCategoryEntity {
  id
  enablements {
    id
    enablementType
    business {
      id
      name
    }
    region
  }
}
    `;
export const TaxCategoryDetailsFragmentDoc = gql`
    fragment TaxCategoryDetails on TaxCategoryEntity {
  id
  createdAt
  updatedAt
  displayName
  globalEnablementState
  isArchived
  enablements {
    id
    createdAt
    updatedAt
    business {
      id
      name
    }
    enablementState
    enablementType
    isArchived
    region
  }
  sources {
    id
    createdAt
    updatedAt
    taxSource
    sourceIdentifier
  }
}
    `;
export const TaxCategoryDetailFormFragmentDoc = gql`
    fragment TaxCategoryDetailForm on TaxCategoryEntity {
  id
  createdAt
  updatedAt
  displayName
  globalEnablementState
  isArchived
  sources {
    id
    createdAt
    updatedAt
    sourceIdentifier
    taxSource
  }
}
    `;
export const RegionalTaxCategoryEnablementFragmentDoc = gql`
    fragment RegionalTaxCategoryEnablement on TaxCategoryEnablementEntity {
  id
  enablementState
  enablementType
  isArchived
  region
}
    `;
export const ClowncarTaxResultAvalaraTaxFragmentDoc = gql`
    fragment clowncarTaxResultAvalaraTax on AvalaraTax {
  isRetainedByTock
  jurisdictionName
  jurisdictionType
  name
  taxRate {
    asNumber
    asString
  }
  taxType
}
    `;
export const ClowncarTaxResultFragmentDoc = gql`
    fragment clowncarTaxResult on TaxCategoryEntity {
  id
  displayName
  rates {
    aggregateRate {
      asString
    }
    taxes {
      ...clowncarTaxResultAvalaraTax
    }
  }
}
    ${ClowncarTaxResultAvalaraTaxFragmentDoc}`;
export const PaginatedBusinessGroupsDocument = gql`
    query PaginatedBusinessGroups($first: Int!, $after: String!, $query: String) {
  businessGroupsPaginated(first: $first, after: $after, query: $query) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...businessGroupSummaryFields
      }
    }
  }
}
    ${BusinessGroupSummaryFieldsFragmentDoc}`;

/**
 * __usePaginatedBusinessGroupsQuery__
 *
 * To run a query within a React component, call `usePaginatedBusinessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedBusinessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedBusinessGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePaginatedBusinessGroupsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables> & ({ variables: PaginatedBusinessGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>(PaginatedBusinessGroupsDocument, options);
      }
export function usePaginatedBusinessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>(PaginatedBusinessGroupsDocument, options);
        }
export function usePaginatedBusinessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>(PaginatedBusinessGroupsDocument, options);
        }
export type PaginatedBusinessGroupsQueryHookResult = ReturnType<typeof usePaginatedBusinessGroupsQuery>;
export type PaginatedBusinessGroupsLazyQueryHookResult = ReturnType<typeof usePaginatedBusinessGroupsLazyQuery>;
export type PaginatedBusinessGroupsSuspenseQueryHookResult = ReturnType<typeof usePaginatedBusinessGroupsSuspenseQuery>;
export type PaginatedBusinessGroupsQueryResult = Apollo.QueryResult<PaginatedBusinessGroupsQuery, PaginatedBusinessGroupsQueryVariables>;
export const BusinessImportRecordsDocument = gql`
    query BusinessImportRecords($id: Int!) {
  business(id: $id) {
    id
    importRecords {
      id
      status
    }
  }
}
    `;

/**
 * __useBusinessImportRecordsQuery__
 *
 * To run a query within a React component, call `useBusinessImportRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessImportRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessImportRecordsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessImportRecordsQuery(baseOptions: Apollo.QueryHookOptions<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables> & ({ variables: BusinessImportRecordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>(BusinessImportRecordsDocument, options);
      }
export function useBusinessImportRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>(BusinessImportRecordsDocument, options);
        }
export function useBusinessImportRecordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>(BusinessImportRecordsDocument, options);
        }
export type BusinessImportRecordsQueryHookResult = ReturnType<typeof useBusinessImportRecordsQuery>;
export type BusinessImportRecordsLazyQueryHookResult = ReturnType<typeof useBusinessImportRecordsLazyQuery>;
export type BusinessImportRecordsSuspenseQueryHookResult = ReturnType<typeof useBusinessImportRecordsSuspenseQuery>;
export type BusinessImportRecordsQueryResult = Apollo.QueryResult<BusinessImportRecordsQuery, BusinessImportRecordsQueryVariables>;
export const UpdateImportStatusDocument = gql`
    mutation UpdateImportStatus($importStatus: ImportStatus!, $id: Int!) {
  updateImportStatus(importStatus: $importStatus, id: $id)
}
    `;
export type UpdateImportStatusMutationFn = Apollo.MutationFunction<UpdateImportStatusMutation, UpdateImportStatusMutationVariables>;

/**
 * __useUpdateImportStatusMutation__
 *
 * To run a mutation, you first call `useUpdateImportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImportStatusMutation, { data, loading, error }] = useUpdateImportStatusMutation({
 *   variables: {
 *      importStatus: // value for 'importStatus'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateImportStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImportStatusMutation, UpdateImportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImportStatusMutation, UpdateImportStatusMutationVariables>(UpdateImportStatusDocument, options);
      }
export type UpdateImportStatusMutationHookResult = ReturnType<typeof useUpdateImportStatusMutation>;
export type UpdateImportStatusMutationResult = Apollo.MutationResult<UpdateImportStatusMutation>;
export type UpdateImportStatusMutationOptions = Apollo.BaseMutationOptions<UpdateImportStatusMutation, UpdateImportStatusMutationVariables>;
export const CurrentBusinessAccessPendingDocument = gql`
    query CurrentBusinessAccessPending($businessId: Int!) {
  temporaryPermissions {
    activeRequestForBusiness(businessId: $businessId) {
      id
      status
      requestWorkflowId
    }
  }
}
    `;

/**
 * __useCurrentBusinessAccessPendingQuery__
 *
 * To run a query within a React component, call `useCurrentBusinessAccessPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentBusinessAccessPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentBusinessAccessPendingQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useCurrentBusinessAccessPendingQuery(baseOptions: Apollo.QueryHookOptions<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables> & ({ variables: CurrentBusinessAccessPendingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>(CurrentBusinessAccessPendingDocument, options);
      }
export function useCurrentBusinessAccessPendingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>(CurrentBusinessAccessPendingDocument, options);
        }
export function useCurrentBusinessAccessPendingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>(CurrentBusinessAccessPendingDocument, options);
        }
export type CurrentBusinessAccessPendingQueryHookResult = ReturnType<typeof useCurrentBusinessAccessPendingQuery>;
export type CurrentBusinessAccessPendingLazyQueryHookResult = ReturnType<typeof useCurrentBusinessAccessPendingLazyQuery>;
export type CurrentBusinessAccessPendingSuspenseQueryHookResult = ReturnType<typeof useCurrentBusinessAccessPendingSuspenseQuery>;
export type CurrentBusinessAccessPendingQueryResult = Apollo.QueryResult<CurrentBusinessAccessPendingQuery, CurrentBusinessAccessPendingQueryVariables>;
export const PaginatedBusinessesDocument = gql`
    query PaginatedBusinesses($first: Int!, $after: String!, $unlisted: Boolean, $query: String) {
  businessesPaginated(
    first: $first
    after: $after
    unlisted: $unlisted
    query: $query
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        ...businessSummaryFields
      }
    }
  }
}
    ${BusinessSummaryFieldsFragmentDoc}`;

/**
 * __usePaginatedBusinessesQuery__
 *
 * To run a query within a React component, call `usePaginatedBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedBusinessesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      unlisted: // value for 'unlisted'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePaginatedBusinessesQuery(baseOptions: Apollo.QueryHookOptions<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables> & ({ variables: PaginatedBusinessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>(PaginatedBusinessesDocument, options);
      }
export function usePaginatedBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>(PaginatedBusinessesDocument, options);
        }
export function usePaginatedBusinessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>(PaginatedBusinessesDocument, options);
        }
export type PaginatedBusinessesQueryHookResult = ReturnType<typeof usePaginatedBusinessesQuery>;
export type PaginatedBusinessesLazyQueryHookResult = ReturnType<typeof usePaginatedBusinessesLazyQuery>;
export type PaginatedBusinessesSuspenseQueryHookResult = ReturnType<typeof usePaginatedBusinessesSuspenseQuery>;
export type PaginatedBusinessesQueryResult = Apollo.QueryResult<PaginatedBusinessesQuery, PaginatedBusinessesQueryVariables>;
export const CancelBookingsDocument = gql`
    subscription CancelBookings($input: CancelBookingsInputInput!) {
  refundCancelFutureBookings(input: $input) {
    ...cancelBookingsWorkflowStatusFields
  }
}
    ${CancelBookingsWorkflowStatusFieldsFragmentDoc}`;

/**
 * __useCancelBookingsSubscription__
 *
 * To run a query within a React component, call `useCancelBookingsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCancelBookingsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelBookingsSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelBookingsSubscription(baseOptions: Apollo.SubscriptionHookOptions<CancelBookingsSubscription, CancelBookingsSubscriptionVariables> & ({ variables: CancelBookingsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CancelBookingsSubscription, CancelBookingsSubscriptionVariables>(CancelBookingsDocument, options);
      }
export type CancelBookingsSubscriptionHookResult = ReturnType<typeof useCancelBookingsSubscription>;
export type CancelBookingsSubscriptionResult = Apollo.SubscriptionResult<CancelBookingsSubscription>;
export const FetchTicketTypesWithFutureBookingsDocument = gql`
    query FetchTicketTypesWithFutureBookings($businessId: Int!) {
  ticketTypesWithFuturePurchases(businessId: $businessId) {
    id
    name
  }
}
    `;

/**
 * __useFetchTicketTypesWithFutureBookingsQuery__
 *
 * To run a query within a React component, call `useFetchTicketTypesWithFutureBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchTicketTypesWithFutureBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchTicketTypesWithFutureBookingsQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useFetchTicketTypesWithFutureBookingsQuery(baseOptions: Apollo.QueryHookOptions<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables> & ({ variables: FetchTicketTypesWithFutureBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>(FetchTicketTypesWithFutureBookingsDocument, options);
      }
export function useFetchTicketTypesWithFutureBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>(FetchTicketTypesWithFutureBookingsDocument, options);
        }
export function useFetchTicketTypesWithFutureBookingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>(FetchTicketTypesWithFutureBookingsDocument, options);
        }
export type FetchTicketTypesWithFutureBookingsQueryHookResult = ReturnType<typeof useFetchTicketTypesWithFutureBookingsQuery>;
export type FetchTicketTypesWithFutureBookingsLazyQueryHookResult = ReturnType<typeof useFetchTicketTypesWithFutureBookingsLazyQuery>;
export type FetchTicketTypesWithFutureBookingsSuspenseQueryHookResult = ReturnType<typeof useFetchTicketTypesWithFutureBookingsSuspenseQuery>;
export type FetchTicketTypesWithFutureBookingsQueryResult = Apollo.QueryResult<FetchTicketTypesWithFutureBookingsQuery, FetchTicketTypesWithFutureBookingsQueryVariables>;
export const GetCancellationRequestDocument = gql`
    query GetCancellationRequest($input: CancelBookingsInputInput!) {
  acceptCancellationRequest(input: $input) {
    ...cancelBookingsOutputFields
  }
}
    ${CancelBookingsOutputFieldsFragmentDoc}`;

/**
 * __useGetCancellationRequestQuery__
 *
 * To run a query within a React component, call `useGetCancellationRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationRequestQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCancellationRequestQuery(baseOptions: Apollo.QueryHookOptions<GetCancellationRequestQuery, GetCancellationRequestQueryVariables> & ({ variables: GetCancellationRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>(GetCancellationRequestDocument, options);
      }
export function useGetCancellationRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>(GetCancellationRequestDocument, options);
        }
export function useGetCancellationRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>(GetCancellationRequestDocument, options);
        }
export type GetCancellationRequestQueryHookResult = ReturnType<typeof useGetCancellationRequestQuery>;
export type GetCancellationRequestLazyQueryHookResult = ReturnType<typeof useGetCancellationRequestLazyQuery>;
export type GetCancellationRequestSuspenseQueryHookResult = ReturnType<typeof useGetCancellationRequestSuspenseQuery>;
export type GetCancellationRequestQueryResult = Apollo.QueryResult<GetCancellationRequestQuery, GetCancellationRequestQueryVariables>;
export const RequestSpecialSigningPermissionDocument = gql`
    mutation RequestSpecialSigningPermission($businessId: Int!) {
  requestSpecialSigningPermission(businessId: $businessId)
}
    `;
export type RequestSpecialSigningPermissionMutationFn = Apollo.MutationFunction<RequestSpecialSigningPermissionMutation, RequestSpecialSigningPermissionMutationVariables>;

/**
 * __useRequestSpecialSigningPermissionMutation__
 *
 * To run a mutation, you first call `useRequestSpecialSigningPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSpecialSigningPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSpecialSigningPermissionMutation, { data, loading, error }] = useRequestSpecialSigningPermissionMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useRequestSpecialSigningPermissionMutation(baseOptions?: Apollo.MutationHookOptions<RequestSpecialSigningPermissionMutation, RequestSpecialSigningPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSpecialSigningPermissionMutation, RequestSpecialSigningPermissionMutationVariables>(RequestSpecialSigningPermissionDocument, options);
      }
export type RequestSpecialSigningPermissionMutationHookResult = ReturnType<typeof useRequestSpecialSigningPermissionMutation>;
export type RequestSpecialSigningPermissionMutationResult = Apollo.MutationResult<RequestSpecialSigningPermissionMutation>;
export type RequestSpecialSigningPermissionMutationOptions = Apollo.BaseMutationOptions<RequestSpecialSigningPermissionMutation, RequestSpecialSigningPermissionMutationVariables>;
export const ApproveSpecialSigningPermissionDocument = gql`
    mutation ApproveSpecialSigningPermission($businessId: Int!) {
  approveSpecialSigningPermission(businessId: $businessId)
}
    `;
export type ApproveSpecialSigningPermissionMutationFn = Apollo.MutationFunction<ApproveSpecialSigningPermissionMutation, ApproveSpecialSigningPermissionMutationVariables>;

/**
 * __useApproveSpecialSigningPermissionMutation__
 *
 * To run a mutation, you first call `useApproveSpecialSigningPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveSpecialSigningPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveSpecialSigningPermissionMutation, { data, loading, error }] = useApproveSpecialSigningPermissionMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useApproveSpecialSigningPermissionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveSpecialSigningPermissionMutation, ApproveSpecialSigningPermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveSpecialSigningPermissionMutation, ApproveSpecialSigningPermissionMutationVariables>(ApproveSpecialSigningPermissionDocument, options);
      }
export type ApproveSpecialSigningPermissionMutationHookResult = ReturnType<typeof useApproveSpecialSigningPermissionMutation>;
export type ApproveSpecialSigningPermissionMutationResult = Apollo.MutationResult<ApproveSpecialSigningPermissionMutation>;
export type ApproveSpecialSigningPermissionMutationOptions = Apollo.BaseMutationOptions<ApproveSpecialSigningPermissionMutation, ApproveSpecialSigningPermissionMutationVariables>;
export const BusinessPayoutConfigDocument = gql`
    query BusinessPayoutConfig($id: Int!) {
  business(id: $id) {
    id
    ...payoutConfigFields
  }
}
    ${PayoutConfigFieldsFragmentDoc}`;

/**
 * __useBusinessPayoutConfigQuery__
 *
 * To run a query within a React component, call `useBusinessPayoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessPayoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessPayoutConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessPayoutConfigQuery(baseOptions: Apollo.QueryHookOptions<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables> & ({ variables: BusinessPayoutConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>(BusinessPayoutConfigDocument, options);
      }
export function useBusinessPayoutConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>(BusinessPayoutConfigDocument, options);
        }
export function useBusinessPayoutConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>(BusinessPayoutConfigDocument, options);
        }
export type BusinessPayoutConfigQueryHookResult = ReturnType<typeof useBusinessPayoutConfigQuery>;
export type BusinessPayoutConfigLazyQueryHookResult = ReturnType<typeof useBusinessPayoutConfigLazyQuery>;
export type BusinessPayoutConfigSuspenseQueryHookResult = ReturnType<typeof useBusinessPayoutConfigSuspenseQuery>;
export type BusinessPayoutConfigQueryResult = Apollo.QueryResult<BusinessPayoutConfigQuery, BusinessPayoutConfigQueryVariables>;
export const UpdateBusinessPayoutConfigParamsDocument = gql`
    mutation UpdateBusinessPayoutConfigParams($businessId: Int!, $updatePayoutConfigParams: UpdatePayoutConfigParamsInput!) {
  updatePayoutConfigParams(
    businessId: $businessId
    updatePayoutConfigParams: $updatePayoutConfigParams
  ) {
    id
    type
    rollingDays
    postPaymentDays
    postPaymentPercentage
    firstPostServiceDays
    firstPostServicePercentage
    secondPostServiceDays
    secondPostServicePercentage
    payoutDescriptionString
    note
  }
}
    `;
export type UpdateBusinessPayoutConfigParamsMutationFn = Apollo.MutationFunction<UpdateBusinessPayoutConfigParamsMutation, UpdateBusinessPayoutConfigParamsMutationVariables>;

/**
 * __useUpdateBusinessPayoutConfigParamsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessPayoutConfigParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessPayoutConfigParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessPayoutConfigParamsMutation, { data, loading, error }] = useUpdateBusinessPayoutConfigParamsMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      updatePayoutConfigParams: // value for 'updatePayoutConfigParams'
 *   },
 * });
 */
export function useUpdateBusinessPayoutConfigParamsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessPayoutConfigParamsMutation, UpdateBusinessPayoutConfigParamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessPayoutConfigParamsMutation, UpdateBusinessPayoutConfigParamsMutationVariables>(UpdateBusinessPayoutConfigParamsDocument, options);
      }
export type UpdateBusinessPayoutConfigParamsMutationHookResult = ReturnType<typeof useUpdateBusinessPayoutConfigParamsMutation>;
export type UpdateBusinessPayoutConfigParamsMutationResult = Apollo.MutationResult<UpdateBusinessPayoutConfigParamsMutation>;
export type UpdateBusinessPayoutConfigParamsMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessPayoutConfigParamsMutation, UpdateBusinessPayoutConfigParamsMutationVariables>;
export const RequestBusinessAccessDocument = gql`
    mutation RequestBusinessAccess($businessId: Int!, $role: BusinessRole!, $reason: String!) {
  requestBusinessAccess(business: $businessId, role: $role, reason: $reason)
}
    `;
export type RequestBusinessAccessMutationFn = Apollo.MutationFunction<RequestBusinessAccessMutation, RequestBusinessAccessMutationVariables>;

/**
 * __useRequestBusinessAccessMutation__
 *
 * To run a mutation, you first call `useRequestBusinessAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBusinessAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBusinessAccessMutation, { data, loading, error }] = useRequestBusinessAccessMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      role: // value for 'role'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRequestBusinessAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestBusinessAccessMutation, RequestBusinessAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBusinessAccessMutation, RequestBusinessAccessMutationVariables>(RequestBusinessAccessDocument, options);
      }
export type RequestBusinessAccessMutationHookResult = ReturnType<typeof useRequestBusinessAccessMutation>;
export type RequestBusinessAccessMutationResult = Apollo.MutationResult<RequestBusinessAccessMutation>;
export type RequestBusinessAccessMutationOptions = Apollo.BaseMutationOptions<RequestBusinessAccessMutation, RequestBusinessAccessMutationVariables>;
export const CreateBusinessEntitlementSetsDocument = gql`
    mutation CreateBusinessEntitlementSets($input: CreateBusinessEntitlementSetsInput!) {
  createBusinessEntitlementSets(input: $input) {
    error {
      displayMessage
    }
  }
}
    `;
export type CreateBusinessEntitlementSetsMutationFn = Apollo.MutationFunction<CreateBusinessEntitlementSetsMutation, CreateBusinessEntitlementSetsMutationVariables>;

/**
 * __useCreateBusinessEntitlementSetsMutation__
 *
 * To run a mutation, you first call `useCreateBusinessEntitlementSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessEntitlementSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessEntitlementSetsMutation, { data, loading, error }] = useCreateBusinessEntitlementSetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessEntitlementSetsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessEntitlementSetsMutation, CreateBusinessEntitlementSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessEntitlementSetsMutation, CreateBusinessEntitlementSetsMutationVariables>(CreateBusinessEntitlementSetsDocument, options);
      }
export type CreateBusinessEntitlementSetsMutationHookResult = ReturnType<typeof useCreateBusinessEntitlementSetsMutation>;
export type CreateBusinessEntitlementSetsMutationResult = Apollo.MutationResult<CreateBusinessEntitlementSetsMutation>;
export type CreateBusinessEntitlementSetsMutationOptions = Apollo.BaseMutationOptions<CreateBusinessEntitlementSetsMutation, CreateBusinessEntitlementSetsMutationVariables>;
export const AddEntitlementToEntitlementSetsDocument = gql`
    mutation AddEntitlementToEntitlementSets($entitlementId: Int!, $entitlementSetIds: [Int!]!) {
  addEntitlementToEntitlementSets(
    input: {entitlementId: $entitlementId, entitlementSetIds: $entitlementSetIds}
  ) {
    entitlementSetFeatures {
      id
    }
    error {
      displayMessage
    }
  }
}
    `;
export type AddEntitlementToEntitlementSetsMutationFn = Apollo.MutationFunction<AddEntitlementToEntitlementSetsMutation, AddEntitlementToEntitlementSetsMutationVariables>;

/**
 * __useAddEntitlementToEntitlementSetsMutation__
 *
 * To run a mutation, you first call `useAddEntitlementToEntitlementSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEntitlementToEntitlementSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEntitlementToEntitlementSetsMutation, { data, loading, error }] = useAddEntitlementToEntitlementSetsMutation({
 *   variables: {
 *      entitlementId: // value for 'entitlementId'
 *      entitlementSetIds: // value for 'entitlementSetIds'
 *   },
 * });
 */
export function useAddEntitlementToEntitlementSetsMutation(baseOptions?: Apollo.MutationHookOptions<AddEntitlementToEntitlementSetsMutation, AddEntitlementToEntitlementSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEntitlementToEntitlementSetsMutation, AddEntitlementToEntitlementSetsMutationVariables>(AddEntitlementToEntitlementSetsDocument, options);
      }
export type AddEntitlementToEntitlementSetsMutationHookResult = ReturnType<typeof useAddEntitlementToEntitlementSetsMutation>;
export type AddEntitlementToEntitlementSetsMutationResult = Apollo.MutationResult<AddEntitlementToEntitlementSetsMutation>;
export type AddEntitlementToEntitlementSetsMutationOptions = Apollo.BaseMutationOptions<AddEntitlementToEntitlementSetsMutation, AddEntitlementToEntitlementSetsMutationVariables>;
export const BusinessEntitlementSetsDocument = gql`
    query BusinessEntitlementSets($businessId: Int!) {
  business(id: $businessId) {
    businessEntitlementSets {
      id
      isArchived
      source
      entitlementSet {
        ...entitlementSet
      }
    }
  }
}
    ${EntitlementSetFragmentDoc}`;

/**
 * __useBusinessEntitlementSetsQuery__
 *
 * To run a query within a React component, call `useBusinessEntitlementSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessEntitlementSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessEntitlementSetsQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useBusinessEntitlementSetsQuery(baseOptions: Apollo.QueryHookOptions<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables> & ({ variables: BusinessEntitlementSetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>(BusinessEntitlementSetsDocument, options);
      }
export function useBusinessEntitlementSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>(BusinessEntitlementSetsDocument, options);
        }
export function useBusinessEntitlementSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>(BusinessEntitlementSetsDocument, options);
        }
export type BusinessEntitlementSetsQueryHookResult = ReturnType<typeof useBusinessEntitlementSetsQuery>;
export type BusinessEntitlementSetsLazyQueryHookResult = ReturnType<typeof useBusinessEntitlementSetsLazyQuery>;
export type BusinessEntitlementSetsSuspenseQueryHookResult = ReturnType<typeof useBusinessEntitlementSetsSuspenseQuery>;
export type BusinessEntitlementSetsQueryResult = Apollo.QueryResult<BusinessEntitlementSetsQuery, BusinessEntitlementSetsQueryVariables>;
export const AllEntitlementSetsDocument = gql`
    query AllEntitlementSets {
  entitlementSets {
    id
    isArchived
    name
  }
}
    `;

/**
 * __useAllEntitlementSetsQuery__
 *
 * To run a query within a React component, call `useAllEntitlementSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEntitlementSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEntitlementSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEntitlementSetsQuery(baseOptions?: Apollo.QueryHookOptions<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>(AllEntitlementSetsDocument, options);
      }
export function useAllEntitlementSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>(AllEntitlementSetsDocument, options);
        }
export function useAllEntitlementSetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>(AllEntitlementSetsDocument, options);
        }
export type AllEntitlementSetsQueryHookResult = ReturnType<typeof useAllEntitlementSetsQuery>;
export type AllEntitlementSetsLazyQueryHookResult = ReturnType<typeof useAllEntitlementSetsLazyQuery>;
export type AllEntitlementSetsSuspenseQueryHookResult = ReturnType<typeof useAllEntitlementSetsSuspenseQuery>;
export type AllEntitlementSetsQueryResult = Apollo.QueryResult<AllEntitlementSetsQuery, AllEntitlementSetsQueryVariables>;
export const ArchiveBusinessEntitlementSetDocument = gql`
    mutation ArchiveBusinessEntitlementSet($id: ID!) {
  archiveBusinessEntitlementSet(id: $id) {
    businessEntitlementSet {
      id
      isArchived
    }
    error {
      displayMessage
    }
  }
}
    `;
export type ArchiveBusinessEntitlementSetMutationFn = Apollo.MutationFunction<ArchiveBusinessEntitlementSetMutation, ArchiveBusinessEntitlementSetMutationVariables>;

/**
 * __useArchiveBusinessEntitlementSetMutation__
 *
 * To run a mutation, you first call `useArchiveBusinessEntitlementSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveBusinessEntitlementSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveBusinessEntitlementSetMutation, { data, loading, error }] = useArchiveBusinessEntitlementSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveBusinessEntitlementSetMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveBusinessEntitlementSetMutation, ArchiveBusinessEntitlementSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveBusinessEntitlementSetMutation, ArchiveBusinessEntitlementSetMutationVariables>(ArchiveBusinessEntitlementSetDocument, options);
      }
export type ArchiveBusinessEntitlementSetMutationHookResult = ReturnType<typeof useArchiveBusinessEntitlementSetMutation>;
export type ArchiveBusinessEntitlementSetMutationResult = Apollo.MutationResult<ArchiveBusinessEntitlementSetMutation>;
export type ArchiveBusinessEntitlementSetMutationOptions = Apollo.BaseMutationOptions<ArchiveBusinessEntitlementSetMutation, ArchiveBusinessEntitlementSetMutationVariables>;
export const UpdateExperimentVariantsDocument = gql`
    mutation UpdateExperimentVariants($id: Int!, $variants: [ExperimentVariantInput!]!) {
  updateExperimentVariants(id: $id, experimentVariants: $variants) {
    id
    experimentVariants {
      id
      description
      name
      trafficAllocation
      variant
    }
  }
}
    `;
export type UpdateExperimentVariantsMutationFn = Apollo.MutationFunction<UpdateExperimentVariantsMutation, UpdateExperimentVariantsMutationVariables>;

/**
 * __useUpdateExperimentVariantsMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentVariantsMutation, { data, loading, error }] = useUpdateExperimentVariantsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      variants: // value for 'variants'
 *   },
 * });
 */
export function useUpdateExperimentVariantsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperimentVariantsMutation, UpdateExperimentVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperimentVariantsMutation, UpdateExperimentVariantsMutationVariables>(UpdateExperimentVariantsDocument, options);
      }
export type UpdateExperimentVariantsMutationHookResult = ReturnType<typeof useUpdateExperimentVariantsMutation>;
export type UpdateExperimentVariantsMutationResult = Apollo.MutationResult<UpdateExperimentVariantsMutation>;
export type UpdateExperimentVariantsMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentVariantsMutation, UpdateExperimentVariantsMutationVariables>;
export const UpdateFeatureDocument = gql`
    mutation UpdateFeature($id: Int!, $state: FeatureState!) {
  updateFeature(id: $id, state: $state) {
    id
    state
  }
}
    `;
export type UpdateFeatureMutationFn = Apollo.MutationFunction<UpdateFeatureMutation, UpdateFeatureMutationVariables>;

/**
 * __useUpdateFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureMutation, { data, loading, error }] = useUpdateFeatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureMutation, UpdateFeatureMutationVariables>(UpdateFeatureDocument, options);
      }
export type UpdateFeatureMutationHookResult = ReturnType<typeof useUpdateFeatureMutation>;
export type UpdateFeatureMutationResult = Apollo.MutationResult<UpdateFeatureMutation>;
export type UpdateFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>;
export const DeleteFeatureDocument = gql`
    mutation DeleteFeature($id: Int!) {
  deleteFeature(id: $id)
}
    `;
export type DeleteFeatureMutationFn = Apollo.MutationFunction<DeleteFeatureMutation, DeleteFeatureMutationVariables>;

/**
 * __useDeleteFeatureMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureMutation, { data, loading, error }] = useDeleteFeatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureMutation, DeleteFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureMutation, DeleteFeatureMutationVariables>(DeleteFeatureDocument, options);
      }
export type DeleteFeatureMutationHookResult = ReturnType<typeof useDeleteFeatureMutation>;
export type DeleteFeatureMutationResult = Apollo.MutationResult<DeleteFeatureMutation>;
export type DeleteFeatureMutationOptions = Apollo.BaseMutationOptions<DeleteFeatureMutation, DeleteFeatureMutationVariables>;
export const IssueManualInvoiceDocument = gql`
    mutation IssueManualInvoice($manualInvoiceRequest: ManualInvoiceRequestInput!) {
  issueManualInvoice(manualInvoiceRequest: $manualInvoiceRequest)
}
    `;
export type IssueManualInvoiceMutationFn = Apollo.MutationFunction<IssueManualInvoiceMutation, IssueManualInvoiceMutationVariables>;

/**
 * __useIssueManualInvoiceMutation__
 *
 * To run a mutation, you first call `useIssueManualInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueManualInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueManualInvoiceMutation, { data, loading, error }] = useIssueManualInvoiceMutation({
 *   variables: {
 *      manualInvoiceRequest: // value for 'manualInvoiceRequest'
 *   },
 * });
 */
export function useIssueManualInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IssueManualInvoiceMutation, IssueManualInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueManualInvoiceMutation, IssueManualInvoiceMutationVariables>(IssueManualInvoiceDocument, options);
      }
export type IssueManualInvoiceMutationHookResult = ReturnType<typeof useIssueManualInvoiceMutation>;
export type IssueManualInvoiceMutationResult = Apollo.MutationResult<IssueManualInvoiceMutation>;
export type IssueManualInvoiceMutationOptions = Apollo.BaseMutationOptions<IssueManualInvoiceMutation, IssueManualInvoiceMutationVariables>;
export const GenerateDataDocument = gql`
    subscription GenerateData($input: FakePurchasesInputInput!) {
  generateData(input: $input) {
    ...fakePurchaseWorkflowStatusFields
  }
}
    ${FakePurchaseWorkflowStatusFieldsFragmentDoc}`;

/**
 * __useGenerateDataSubscription__
 *
 * To run a query within a React component, call `useGenerateDataSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGenerateDataSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateDataSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateDataSubscription(baseOptions: Apollo.SubscriptionHookOptions<GenerateDataSubscription, GenerateDataSubscriptionVariables> & ({ variables: GenerateDataSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GenerateDataSubscription, GenerateDataSubscriptionVariables>(GenerateDataDocument, options);
      }
export type GenerateDataSubscriptionHookResult = ReturnType<typeof useGenerateDataSubscription>;
export type GenerateDataSubscriptionResult = Apollo.SubscriptionResult<GenerateDataSubscription>;
export const ChangeHelpMenuEntryPublicationStatusDocument = gql`
    mutation ChangeHelpMenuEntryPublicationStatus($publicationStatus: PublicationStatus!, $effectiveDate: LocalDate, $changeHelpMenuEntryPublicationStatusId: Int!) {
  changeHelpMenuEntryPublicationStatus(
    publicationStatus: $publicationStatus
    effectiveDate: $effectiveDate
    id: $changeHelpMenuEntryPublicationStatusId
  ) {
    bodyText
    createdAt
    effectiveDate
    features {
      id
    }
    headline
    helpCenterUrl
    id
    image {
      id
    }
    publicationStatus
    relevantInventoryType
    updatedAt
  }
}
    `;
export type ChangeHelpMenuEntryPublicationStatusMutationFn = Apollo.MutationFunction<ChangeHelpMenuEntryPublicationStatusMutation, ChangeHelpMenuEntryPublicationStatusMutationVariables>;

/**
 * __useChangeHelpMenuEntryPublicationStatusMutation__
 *
 * To run a mutation, you first call `useChangeHelpMenuEntryPublicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeHelpMenuEntryPublicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeHelpMenuEntryPublicationStatusMutation, { data, loading, error }] = useChangeHelpMenuEntryPublicationStatusMutation({
 *   variables: {
 *      publicationStatus: // value for 'publicationStatus'
 *      effectiveDate: // value for 'effectiveDate'
 *      changeHelpMenuEntryPublicationStatusId: // value for 'changeHelpMenuEntryPublicationStatusId'
 *   },
 * });
 */
export function useChangeHelpMenuEntryPublicationStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeHelpMenuEntryPublicationStatusMutation, ChangeHelpMenuEntryPublicationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeHelpMenuEntryPublicationStatusMutation, ChangeHelpMenuEntryPublicationStatusMutationVariables>(ChangeHelpMenuEntryPublicationStatusDocument, options);
      }
export type ChangeHelpMenuEntryPublicationStatusMutationHookResult = ReturnType<typeof useChangeHelpMenuEntryPublicationStatusMutation>;
export type ChangeHelpMenuEntryPublicationStatusMutationResult = Apollo.MutationResult<ChangeHelpMenuEntryPublicationStatusMutation>;
export type ChangeHelpMenuEntryPublicationStatusMutationOptions = Apollo.BaseMutationOptions<ChangeHelpMenuEntryPublicationStatusMutation, ChangeHelpMenuEntryPublicationStatusMutationVariables>;
export const UpsertHelpMenuEntryMutationDocument = gql`
    mutation UpsertHelpMenuEntryMutation($entry: UpsertHelpMenuInput!) {
  upsertHelpMenuEntry(entry: $entry) {
    bodyText
    createdAt
    effectiveDate
    features {
      id
    }
    headline
    helpCenterUrl
    id
    image {
      id
    }
    publicationStatus
    relevantInventoryType
    updatedAt
  }
}
    `;
export type UpsertHelpMenuEntryMutationMutationFn = Apollo.MutationFunction<UpsertHelpMenuEntryMutationMutation, UpsertHelpMenuEntryMutationMutationVariables>;

/**
 * __useUpsertHelpMenuEntryMutationMutation__
 *
 * To run a mutation, you first call `useUpsertHelpMenuEntryMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHelpMenuEntryMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHelpMenuEntryMutationMutation, { data, loading, error }] = useUpsertHelpMenuEntryMutationMutation({
 *   variables: {
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useUpsertHelpMenuEntryMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHelpMenuEntryMutationMutation, UpsertHelpMenuEntryMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHelpMenuEntryMutationMutation, UpsertHelpMenuEntryMutationMutationVariables>(UpsertHelpMenuEntryMutationDocument, options);
      }
export type UpsertHelpMenuEntryMutationMutationHookResult = ReturnType<typeof useUpsertHelpMenuEntryMutationMutation>;
export type UpsertHelpMenuEntryMutationMutationResult = Apollo.MutationResult<UpsertHelpMenuEntryMutationMutation>;
export type UpsertHelpMenuEntryMutationMutationOptions = Apollo.BaseMutationOptions<UpsertHelpMenuEntryMutationMutation, UpsertHelpMenuEntryMutationMutationVariables>;
export const GetHelpMenuEntriesDocument = gql`
    query getHelpMenuEntries($includeArchivedEntries: Boolean!, $headline: String!) {
  helpMenuEntries(
    includeArchivedEntries: $includeArchivedEntries
    headline: $headline
  ) {
    bodyText
    createdAt
    effectiveDate
    features {
      name
    }
    headline
    helpCenterUrl
    id
    image {
      imageBackingUrl
    }
    publicationStatus
    relevantInventoryType
    updatedAt
  }
}
    `;

/**
 * __useGetHelpMenuEntriesQuery__
 *
 * To run a query within a React component, call `useGetHelpMenuEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpMenuEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpMenuEntriesQuery({
 *   variables: {
 *      includeArchivedEntries: // value for 'includeArchivedEntries'
 *      headline: // value for 'headline'
 *   },
 * });
 */
export function useGetHelpMenuEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables> & ({ variables: GetHelpMenuEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>(GetHelpMenuEntriesDocument, options);
      }
export function useGetHelpMenuEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>(GetHelpMenuEntriesDocument, options);
        }
export function useGetHelpMenuEntriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>(GetHelpMenuEntriesDocument, options);
        }
export type GetHelpMenuEntriesQueryHookResult = ReturnType<typeof useGetHelpMenuEntriesQuery>;
export type GetHelpMenuEntriesLazyQueryHookResult = ReturnType<typeof useGetHelpMenuEntriesLazyQuery>;
export type GetHelpMenuEntriesSuspenseQueryHookResult = ReturnType<typeof useGetHelpMenuEntriesSuspenseQuery>;
export type GetHelpMenuEntriesQueryResult = Apollo.QueryResult<GetHelpMenuEntriesQuery, GetHelpMenuEntriesQueryVariables>;
export const CreateJceHomepageOrderingEntryDocument = gql`
    mutation CreateJceHomepageOrderingEntry($homepageOrderingEntry: JceHomepageOrderingEntryInput!) {
  createJceHomepageOrderingEntry(homepageOrderingEntry: $homepageOrderingEntry) {
    id
    position
    specialCollection
    collection {
      id
      name
    }
  }
}
    `;
export type CreateJceHomepageOrderingEntryMutationFn = Apollo.MutationFunction<CreateJceHomepageOrderingEntryMutation, CreateJceHomepageOrderingEntryMutationVariables>;

/**
 * __useCreateJceHomepageOrderingEntryMutation__
 *
 * To run a mutation, you first call `useCreateJceHomepageOrderingEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJceHomepageOrderingEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJceHomepageOrderingEntryMutation, { data, loading, error }] = useCreateJceHomepageOrderingEntryMutation({
 *   variables: {
 *      homepageOrderingEntry: // value for 'homepageOrderingEntry'
 *   },
 * });
 */
export function useCreateJceHomepageOrderingEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateJceHomepageOrderingEntryMutation, CreateJceHomepageOrderingEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJceHomepageOrderingEntryMutation, CreateJceHomepageOrderingEntryMutationVariables>(CreateJceHomepageOrderingEntryDocument, options);
      }
export type CreateJceHomepageOrderingEntryMutationHookResult = ReturnType<typeof useCreateJceHomepageOrderingEntryMutation>;
export type CreateJceHomepageOrderingEntryMutationResult = Apollo.MutationResult<CreateJceHomepageOrderingEntryMutation>;
export type CreateJceHomepageOrderingEntryMutationOptions = Apollo.BaseMutationOptions<CreateJceHomepageOrderingEntryMutation, CreateJceHomepageOrderingEntryMutationVariables>;
export const SetJceHomepageEntriesForGeographyDocument = gql`
    mutation SetJceHomepageEntriesForGeography($geographyId: Int!, $orderingEntries: [JceHomepageOrderingEntryInput!]!) {
  setJceHomepageOrderingEntriesForGeography(
    geographyId: $geographyId
    orderingEntries: $orderingEntries
  ) {
    id
    position
    specialCollection
    isDesignatedForLeaderboard
    collection {
      id
      name
    }
  }
}
    `;
export type SetJceHomepageEntriesForGeographyMutationFn = Apollo.MutationFunction<SetJceHomepageEntriesForGeographyMutation, SetJceHomepageEntriesForGeographyMutationVariables>;

/**
 * __useSetJceHomepageEntriesForGeographyMutation__
 *
 * To run a mutation, you first call `useSetJceHomepageEntriesForGeographyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJceHomepageEntriesForGeographyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJceHomepageEntriesForGeographyMutation, { data, loading, error }] = useSetJceHomepageEntriesForGeographyMutation({
 *   variables: {
 *      geographyId: // value for 'geographyId'
 *      orderingEntries: // value for 'orderingEntries'
 *   },
 * });
 */
export function useSetJceHomepageEntriesForGeographyMutation(baseOptions?: Apollo.MutationHookOptions<SetJceHomepageEntriesForGeographyMutation, SetJceHomepageEntriesForGeographyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetJceHomepageEntriesForGeographyMutation, SetJceHomepageEntriesForGeographyMutationVariables>(SetJceHomepageEntriesForGeographyDocument, options);
      }
export type SetJceHomepageEntriesForGeographyMutationHookResult = ReturnType<typeof useSetJceHomepageEntriesForGeographyMutation>;
export type SetJceHomepageEntriesForGeographyMutationResult = Apollo.MutationResult<SetJceHomepageEntriesForGeographyMutation>;
export type SetJceHomepageEntriesForGeographyMutationOptions = Apollo.BaseMutationOptions<SetJceHomepageEntriesForGeographyMutation, SetJceHomepageEntriesForGeographyMutationVariables>;
export const UpdateJceHomepageGeographyDocument = gql`
    mutation UpdateJceHomepageGeography($geography: JceHomepageGeographyInput!) {
  updateJceHomepageGeography(geography: $geography) {
    id
    name
    urlSlug
    resyBlogKey
    tier
    priorityWithinTier
  }
}
    `;
export type UpdateJceHomepageGeographyMutationFn = Apollo.MutationFunction<UpdateJceHomepageGeographyMutation, UpdateJceHomepageGeographyMutationVariables>;

/**
 * __useUpdateJceHomepageGeographyMutation__
 *
 * To run a mutation, you first call `useUpdateJceHomepageGeographyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJceHomepageGeographyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJceHomepageGeographyMutation, { data, loading, error }] = useUpdateJceHomepageGeographyMutation({
 *   variables: {
 *      geography: // value for 'geography'
 *   },
 * });
 */
export function useUpdateJceHomepageGeographyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJceHomepageGeographyMutation, UpdateJceHomepageGeographyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJceHomepageGeographyMutation, UpdateJceHomepageGeographyMutationVariables>(UpdateJceHomepageGeographyDocument, options);
      }
export type UpdateJceHomepageGeographyMutationHookResult = ReturnType<typeof useUpdateJceHomepageGeographyMutation>;
export type UpdateJceHomepageGeographyMutationResult = Apollo.MutationResult<UpdateJceHomepageGeographyMutation>;
export type UpdateJceHomepageGeographyMutationOptions = Apollo.BaseMutationOptions<UpdateJceHomepageGeographyMutation, UpdateJceHomepageGeographyMutationVariables>;
export const SetJceVenueCollectionEntriesForCollectionDocument = gql`
    mutation SetJceVenueCollectionEntriesForCollection($collectionId: Int!, $entries: [JceVenueCollectionEntryInput!]!) {
  setJceVenueCollectionEntriesForCollection(
    collectionId: $collectionId
    entries: $entries
  ) {
    id
    resyVenueId
    tockVenueId
  }
}
    `;
export type SetJceVenueCollectionEntriesForCollectionMutationFn = Apollo.MutationFunction<SetJceVenueCollectionEntriesForCollectionMutation, SetJceVenueCollectionEntriesForCollectionMutationVariables>;

/**
 * __useSetJceVenueCollectionEntriesForCollectionMutation__
 *
 * To run a mutation, you first call `useSetJceVenueCollectionEntriesForCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetJceVenueCollectionEntriesForCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setJceVenueCollectionEntriesForCollectionMutation, { data, loading, error }] = useSetJceVenueCollectionEntriesForCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useSetJceVenueCollectionEntriesForCollectionMutation(baseOptions?: Apollo.MutationHookOptions<SetJceVenueCollectionEntriesForCollectionMutation, SetJceVenueCollectionEntriesForCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetJceVenueCollectionEntriesForCollectionMutation, SetJceVenueCollectionEntriesForCollectionMutationVariables>(SetJceVenueCollectionEntriesForCollectionDocument, options);
      }
export type SetJceVenueCollectionEntriesForCollectionMutationHookResult = ReturnType<typeof useSetJceVenueCollectionEntriesForCollectionMutation>;
export type SetJceVenueCollectionEntriesForCollectionMutationResult = Apollo.MutationResult<SetJceVenueCollectionEntriesForCollectionMutation>;
export type SetJceVenueCollectionEntriesForCollectionMutationOptions = Apollo.BaseMutationOptions<SetJceVenueCollectionEntriesForCollectionMutation, SetJceVenueCollectionEntriesForCollectionMutationVariables>;
export const GetCollectionsForGeographyDocument = gql`
    query GetCollectionsForGeography($geographyId: Int!) {
  collectionsForGeography(geographyId: $geographyId) {
    orderingEntries {
      id
      position
      specialCollection
      isDesignatedForLeaderboard
      collection {
        id
        name
        description
        iconIndicator
        status
        urlSlug
        collectionEntrys {
          id
          resyVenueId
          tockVenueId
        }
      }
    }
    unorderedCollections {
      id
      name
      description
      iconIndicator
      status
      urlSlug
      collectionEntrys {
        id
        resyVenueId
        tockVenueId
      }
    }
  }
}
    `;

/**
 * __useGetCollectionsForGeographyQuery__
 *
 * To run a query within a React component, call `useGetCollectionsForGeographyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsForGeographyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsForGeographyQuery({
 *   variables: {
 *      geographyId: // value for 'geographyId'
 *   },
 * });
 */
export function useGetCollectionsForGeographyQuery(baseOptions: Apollo.QueryHookOptions<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables> & ({ variables: GetCollectionsForGeographyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>(GetCollectionsForGeographyDocument, options);
      }
export function useGetCollectionsForGeographyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>(GetCollectionsForGeographyDocument, options);
        }
export function useGetCollectionsForGeographySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>(GetCollectionsForGeographyDocument, options);
        }
export type GetCollectionsForGeographyQueryHookResult = ReturnType<typeof useGetCollectionsForGeographyQuery>;
export type GetCollectionsForGeographyLazyQueryHookResult = ReturnType<typeof useGetCollectionsForGeographyLazyQuery>;
export type GetCollectionsForGeographySuspenseQueryHookResult = ReturnType<typeof useGetCollectionsForGeographySuspenseQuery>;
export type GetCollectionsForGeographyQueryResult = Apollo.QueryResult<GetCollectionsForGeographyQuery, GetCollectionsForGeographyQueryVariables>;
export const BulkResetCompromisedAccountsDocument = gql`
    subscription BulkResetCompromisedAccounts($patronIds: [Int!]!) {
  bulkResetCompromisedAccounts(patronIds: $patronIds) {
    ...bulkPatronActionWorkflowStatusFields
  }
}
    ${BulkPatronActionWorkflowStatusFieldsFragmentDoc}`;

/**
 * __useBulkResetCompromisedAccountsSubscription__
 *
 * To run a query within a React component, call `useBulkResetCompromisedAccountsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBulkResetCompromisedAccountsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkResetCompromisedAccountsSubscription({
 *   variables: {
 *      patronIds: // value for 'patronIds'
 *   },
 * });
 */
export function useBulkResetCompromisedAccountsSubscription(baseOptions: Apollo.SubscriptionHookOptions<BulkResetCompromisedAccountsSubscription, BulkResetCompromisedAccountsSubscriptionVariables> & ({ variables: BulkResetCompromisedAccountsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BulkResetCompromisedAccountsSubscription, BulkResetCompromisedAccountsSubscriptionVariables>(BulkResetCompromisedAccountsDocument, options);
      }
export type BulkResetCompromisedAccountsSubscriptionHookResult = ReturnType<typeof useBulkResetCompromisedAccountsSubscription>;
export type BulkResetCompromisedAccountsSubscriptionResult = Apollo.SubscriptionResult<BulkResetCompromisedAccountsSubscription>;
export const BulkDeletePatronAccountsDocument = gql`
    subscription BulkDeletePatronAccounts($patronIds: [Int!]!, $deleteReason: DeleteReason!, $emailBehavior: EmailBehavior!) {
  bulkDeletePatronAccounts(
    patronIds: $patronIds
    deleteReason: $deleteReason
    emailBehavior: $emailBehavior
  ) {
    ...bulkPatronActionWorkflowStatusFields
  }
}
    ${BulkPatronActionWorkflowStatusFieldsFragmentDoc}`;

/**
 * __useBulkDeletePatronAccountsSubscription__
 *
 * To run a query within a React component, call `useBulkDeletePatronAccountsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBulkDeletePatronAccountsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDeletePatronAccountsSubscription({
 *   variables: {
 *      patronIds: // value for 'patronIds'
 *      deleteReason: // value for 'deleteReason'
 *      emailBehavior: // value for 'emailBehavior'
 *   },
 * });
 */
export function useBulkDeletePatronAccountsSubscription(baseOptions: Apollo.SubscriptionHookOptions<BulkDeletePatronAccountsSubscription, BulkDeletePatronAccountsSubscriptionVariables> & ({ variables: BulkDeletePatronAccountsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<BulkDeletePatronAccountsSubscription, BulkDeletePatronAccountsSubscriptionVariables>(BulkDeletePatronAccountsDocument, options);
      }
export type BulkDeletePatronAccountsSubscriptionHookResult = ReturnType<typeof useBulkDeletePatronAccountsSubscription>;
export type BulkDeletePatronAccountsSubscriptionResult = Apollo.SubscriptionResult<BulkDeletePatronAccountsSubscription>;
export const RemoveTockGiftCardBalanceDocument = gql`
    mutation RemoveTockGiftCardBalance($patronId: Int!, $tockGiftCardBalance: Int!) {
  clearTockGiftCardBalanceV2(
    patronId: $patronId
    tockGiftCardBalance: $tockGiftCardBalance
  ) {
    id
    tockGiftCardBalanceCents
  }
}
    `;
export type RemoveTockGiftCardBalanceMutationFn = Apollo.MutationFunction<RemoveTockGiftCardBalanceMutation, RemoveTockGiftCardBalanceMutationVariables>;

/**
 * __useRemoveTockGiftCardBalanceMutation__
 *
 * To run a mutation, you first call `useRemoveTockGiftCardBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTockGiftCardBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTockGiftCardBalanceMutation, { data, loading, error }] = useRemoveTockGiftCardBalanceMutation({
 *   variables: {
 *      patronId: // value for 'patronId'
 *      tockGiftCardBalance: // value for 'tockGiftCardBalance'
 *   },
 * });
 */
export function useRemoveTockGiftCardBalanceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTockGiftCardBalanceMutation, RemoveTockGiftCardBalanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTockGiftCardBalanceMutation, RemoveTockGiftCardBalanceMutationVariables>(RemoveTockGiftCardBalanceDocument, options);
      }
export type RemoveTockGiftCardBalanceMutationHookResult = ReturnType<typeof useRemoveTockGiftCardBalanceMutation>;
export type RemoveTockGiftCardBalanceMutationResult = Apollo.MutationResult<RemoveTockGiftCardBalanceMutation>;
export type RemoveTockGiftCardBalanceMutationOptions = Apollo.BaseMutationOptions<RemoveTockGiftCardBalanceMutation, RemoveTockGiftCardBalanceMutationVariables>;
export const ResetCompromisedAccountDocument = gql`
    mutation ResetCompromisedAccount($patronId: Int!, $sendEmail: Boolean!) {
  resetCompromisedAccountV2(patronId: $patronId, sendEmail: $sendEmail) {
    errors {
      displayMessage
    }
    failedPatronIds
    successCount
  }
}
    `;
export type ResetCompromisedAccountMutationFn = Apollo.MutationFunction<ResetCompromisedAccountMutation, ResetCompromisedAccountMutationVariables>;

/**
 * __useResetCompromisedAccountMutation__
 *
 * To run a mutation, you first call `useResetCompromisedAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCompromisedAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCompromisedAccountMutation, { data, loading, error }] = useResetCompromisedAccountMutation({
 *   variables: {
 *      patronId: // value for 'patronId'
 *      sendEmail: // value for 'sendEmail'
 *   },
 * });
 */
export function useResetCompromisedAccountMutation(baseOptions?: Apollo.MutationHookOptions<ResetCompromisedAccountMutation, ResetCompromisedAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCompromisedAccountMutation, ResetCompromisedAccountMutationVariables>(ResetCompromisedAccountDocument, options);
      }
export type ResetCompromisedAccountMutationHookResult = ReturnType<typeof useResetCompromisedAccountMutation>;
export type ResetCompromisedAccountMutationResult = Apollo.MutationResult<ResetCompromisedAccountMutation>;
export type ResetCompromisedAccountMutationOptions = Apollo.BaseMutationOptions<ResetCompromisedAccountMutation, ResetCompromisedAccountMutationVariables>;
export const UpdatePatronSelfOnboardingEligibilityDocument = gql`
    mutation UpdatePatronSelfOnboardingEligibility($email: String!, $eligibilityStatus: Boolean!) {
  updatePatronSelfOnboardingEligibility(
    email: $email
    eligibilityStatus: $eligibilityStatus
  ) {
    id
    isEligibleForSelfOnboarding
  }
}
    `;
export type UpdatePatronSelfOnboardingEligibilityMutationFn = Apollo.MutationFunction<UpdatePatronSelfOnboardingEligibilityMutation, UpdatePatronSelfOnboardingEligibilityMutationVariables>;

/**
 * __useUpdatePatronSelfOnboardingEligibilityMutation__
 *
 * To run a mutation, you first call `useUpdatePatronSelfOnboardingEligibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatronSelfOnboardingEligibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatronSelfOnboardingEligibilityMutation, { data, loading, error }] = useUpdatePatronSelfOnboardingEligibilityMutation({
 *   variables: {
 *      email: // value for 'email'
 *      eligibilityStatus: // value for 'eligibilityStatus'
 *   },
 * });
 */
export function useUpdatePatronSelfOnboardingEligibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatronSelfOnboardingEligibilityMutation, UpdatePatronSelfOnboardingEligibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatronSelfOnboardingEligibilityMutation, UpdatePatronSelfOnboardingEligibilityMutationVariables>(UpdatePatronSelfOnboardingEligibilityDocument, options);
      }
export type UpdatePatronSelfOnboardingEligibilityMutationHookResult = ReturnType<typeof useUpdatePatronSelfOnboardingEligibilityMutation>;
export type UpdatePatronSelfOnboardingEligibilityMutationResult = Apollo.MutationResult<UpdatePatronSelfOnboardingEligibilityMutation>;
export type UpdatePatronSelfOnboardingEligibilityMutationOptions = Apollo.BaseMutationOptions<UpdatePatronSelfOnboardingEligibilityMutation, UpdatePatronSelfOnboardingEligibilityMutationVariables>;
export const CompareRebalancePlansDocument = gql`
    query CompareRebalancePlans($env: String!, $service: String!, $exportDate: LocalDate!, $serviceDate: LocalDate!, $exportType: TimelineExportType!, $filename: String!, $businessId: Int!, $timeLimitMillis: Int!) {
  business(id: $businessId) {
    id
    name
    compareRebalancePlans(
      env: $env
      filename: $filename
      service: $service
      exportDate: $exportDate
      serviceDate: $serviceDate
      exportType: $exportType
      timeLimitMillis: $timeLimitMillis
    ) {
      rebalancePlan {
        computationTimeMillis
        before {
          ...seatingPlanFields
        }
        after {
          ...seatingPlanFields
        }
      }
      difference {
        unassignedBookingsLeft
        unassignedBookingsRight
        unassignedCoversLeft
        unassignedCoversRight
        totalTableAssignmentsLeft
        totalTableAssignmentsRight
        differingTableAssignments
        bookingsOnTablesWithDifferingExperienceLeft
        bookingsOnTablesWithDifferingExperienceRight
        overbookedTablesLeft
        overbookedTablesRight
      }
      serviceFloorplan {
        serviceStartLocalTime
        serviceEndLocalTime
        bookableTables {
          name
          supportedExperiences {
            name
            shortCode
          }
          maxSize
          minSize
          offeredOnline
          blockedLocalTimes
        }
      }
    }
  }
}
    ${SeatingPlanFieldsFragmentDoc}`;

/**
 * __useCompareRebalancePlansQuery__
 *
 * To run a query within a React component, call `useCompareRebalancePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompareRebalancePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompareRebalancePlansQuery({
 *   variables: {
 *      env: // value for 'env'
 *      service: // value for 'service'
 *      exportDate: // value for 'exportDate'
 *      serviceDate: // value for 'serviceDate'
 *      exportType: // value for 'exportType'
 *      filename: // value for 'filename'
 *      businessId: // value for 'businessId'
 *      timeLimitMillis: // value for 'timeLimitMillis'
 *   },
 * });
 */
export function useCompareRebalancePlansQuery(baseOptions: Apollo.QueryHookOptions<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables> & ({ variables: CompareRebalancePlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>(CompareRebalancePlansDocument, options);
      }
export function useCompareRebalancePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>(CompareRebalancePlansDocument, options);
        }
export function useCompareRebalancePlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>(CompareRebalancePlansDocument, options);
        }
export type CompareRebalancePlansQueryHookResult = ReturnType<typeof useCompareRebalancePlansQuery>;
export type CompareRebalancePlansLazyQueryHookResult = ReturnType<typeof useCompareRebalancePlansLazyQuery>;
export type CompareRebalancePlansSuspenseQueryHookResult = ReturnType<typeof useCompareRebalancePlansSuspenseQuery>;
export type CompareRebalancePlansQueryResult = Apollo.QueryResult<CompareRebalancePlansQuery, CompareRebalancePlansQueryVariables>;
export const RestoreTableAssignmentsDocument = gql`
    mutation RestoreTableAssignments($historyId: Int!, $fromBefore: Boolean!, $restoreToday: Boolean!) {
  restoreTablesFromScheduleHistory(
    historyId: $historyId
    fromBefore: $fromBefore
    restoreToday: $restoreToday
  )
}
    `;
export type RestoreTableAssignmentsMutationFn = Apollo.MutationFunction<RestoreTableAssignmentsMutation, RestoreTableAssignmentsMutationVariables>;

/**
 * __useRestoreTableAssignmentsMutation__
 *
 * To run a mutation, you first call `useRestoreTableAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTableAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTableAssignmentsMutation, { data, loading, error }] = useRestoreTableAssignmentsMutation({
 *   variables: {
 *      historyId: // value for 'historyId'
 *      fromBefore: // value for 'fromBefore'
 *      restoreToday: // value for 'restoreToday'
 *   },
 * });
 */
export function useRestoreTableAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTableAssignmentsMutation, RestoreTableAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTableAssignmentsMutation, RestoreTableAssignmentsMutationVariables>(RestoreTableAssignmentsDocument, options);
      }
export type RestoreTableAssignmentsMutationHookResult = ReturnType<typeof useRestoreTableAssignmentsMutation>;
export type RestoreTableAssignmentsMutationResult = Apollo.MutationResult<RestoreTableAssignmentsMutation>;
export type RestoreTableAssignmentsMutationOptions = Apollo.BaseMutationOptions<RestoreTableAssignmentsMutation, RestoreTableAssignmentsMutationVariables>;
export const SsoLoginDomainsDocument = gql`
    query SsoLoginDomains($businessId: Int!) {
  loginDomainsForBusiness(businessId: $businessId) {
    id
    ...ssoLoginDomainFields
  }
}
    ${SsoLoginDomainFieldsFragmentDoc}`;

/**
 * __useSsoLoginDomainsQuery__
 *
 * To run a query within a React component, call `useSsoLoginDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoLoginDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoLoginDomainsQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useSsoLoginDomainsQuery(baseOptions: Apollo.QueryHookOptions<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables> & ({ variables: SsoLoginDomainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>(SsoLoginDomainsDocument, options);
      }
export function useSsoLoginDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>(SsoLoginDomainsDocument, options);
        }
export function useSsoLoginDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>(SsoLoginDomainsDocument, options);
        }
export type SsoLoginDomainsQueryHookResult = ReturnType<typeof useSsoLoginDomainsQuery>;
export type SsoLoginDomainsLazyQueryHookResult = ReturnType<typeof useSsoLoginDomainsLazyQuery>;
export type SsoLoginDomainsSuspenseQueryHookResult = ReturnType<typeof useSsoLoginDomainsSuspenseQuery>;
export type SsoLoginDomainsQueryResult = Apollo.QueryResult<SsoLoginDomainsQuery, SsoLoginDomainsQueryVariables>;
export const AddSsoLoginDomainsToBusinessDocument = gql`
    mutation AddSsoLoginDomainsToBusiness($businessId: Int!, $domains: [String!]!, $tenantId: String!) {
  addSsoLoginDomainsToBusiness(
    businessId: $businessId
    domains: $domains
    tenantId: $tenantId
  )
}
    `;
export type AddSsoLoginDomainsToBusinessMutationFn = Apollo.MutationFunction<AddSsoLoginDomainsToBusinessMutation, AddSsoLoginDomainsToBusinessMutationVariables>;

/**
 * __useAddSsoLoginDomainsToBusinessMutation__
 *
 * To run a mutation, you first call `useAddSsoLoginDomainsToBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSsoLoginDomainsToBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSsoLoginDomainsToBusinessMutation, { data, loading, error }] = useAddSsoLoginDomainsToBusinessMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      domains: // value for 'domains'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAddSsoLoginDomainsToBusinessMutation(baseOptions?: Apollo.MutationHookOptions<AddSsoLoginDomainsToBusinessMutation, AddSsoLoginDomainsToBusinessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSsoLoginDomainsToBusinessMutation, AddSsoLoginDomainsToBusinessMutationVariables>(AddSsoLoginDomainsToBusinessDocument, options);
      }
export type AddSsoLoginDomainsToBusinessMutationHookResult = ReturnType<typeof useAddSsoLoginDomainsToBusinessMutation>;
export type AddSsoLoginDomainsToBusinessMutationResult = Apollo.MutationResult<AddSsoLoginDomainsToBusinessMutation>;
export type AddSsoLoginDomainsToBusinessMutationOptions = Apollo.BaseMutationOptions<AddSsoLoginDomainsToBusinessMutation, AddSsoLoginDomainsToBusinessMutationVariables>;
export const EntitlementSetFormSelectFieldDocument = gql`
    query EntitlementSetFormSelectField {
  entitlementSets {
    id
    name
  }
}
    `;

/**
 * __useEntitlementSetFormSelectFieldQuery__
 *
 * To run a query within a React component, call `useEntitlementSetFormSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitlementSetFormSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitlementSetFormSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitlementSetFormSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>(EntitlementSetFormSelectFieldDocument, options);
      }
export function useEntitlementSetFormSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>(EntitlementSetFormSelectFieldDocument, options);
        }
export function useEntitlementSetFormSelectFieldSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>(EntitlementSetFormSelectFieldDocument, options);
        }
export type EntitlementSetFormSelectFieldQueryHookResult = ReturnType<typeof useEntitlementSetFormSelectFieldQuery>;
export type EntitlementSetFormSelectFieldLazyQueryHookResult = ReturnType<typeof useEntitlementSetFormSelectFieldLazyQuery>;
export type EntitlementSetFormSelectFieldSuspenseQueryHookResult = ReturnType<typeof useEntitlementSetFormSelectFieldSuspenseQuery>;
export type EntitlementSetFormSelectFieldQueryResult = Apollo.QueryResult<EntitlementSetFormSelectFieldQuery, EntitlementSetFormSelectFieldQueryVariables>;
export const CreateEntitlementSetDocument = gql`
    mutation CreateEntitlementSet($input: CreateEntitlementSetInput!) {
  createEntitlementSet(input: $input) {
    entitlementSet {
      id
      name
      description
      entitlementSetFeatures {
        id
        feature {
          name
        }
      }
    }
  }
}
    `;
export type CreateEntitlementSetMutationFn = Apollo.MutationFunction<CreateEntitlementSetMutation, CreateEntitlementSetMutationVariables>;

/**
 * __useCreateEntitlementSetMutation__
 *
 * To run a mutation, you first call `useCreateEntitlementSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntitlementSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntitlementSetMutation, { data, loading, error }] = useCreateEntitlementSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntitlementSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntitlementSetMutation, CreateEntitlementSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntitlementSetMutation, CreateEntitlementSetMutationVariables>(CreateEntitlementSetDocument, options);
      }
export type CreateEntitlementSetMutationHookResult = ReturnType<typeof useCreateEntitlementSetMutation>;
export type CreateEntitlementSetMutationResult = Apollo.MutationResult<CreateEntitlementSetMutation>;
export type CreateEntitlementSetMutationOptions = Apollo.BaseMutationOptions<CreateEntitlementSetMutation, CreateEntitlementSetMutationVariables>;
export const CreateEntitlementSetDialogDocument = gql`
    query CreateEntitlementSetDialog {
  features(type: ENTITLEMENT) {
    ...EntitlementSetFieldSet_features
  }
}
    ${EntitlementSetFieldSet_FeaturesFragmentDoc}`;

/**
 * __useCreateEntitlementSetDialogQuery__
 *
 * To run a query within a React component, call `useCreateEntitlementSetDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateEntitlementSetDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateEntitlementSetDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateEntitlementSetDialogQuery(baseOptions?: Apollo.QueryHookOptions<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>(CreateEntitlementSetDialogDocument, options);
      }
export function useCreateEntitlementSetDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>(CreateEntitlementSetDialogDocument, options);
        }
export function useCreateEntitlementSetDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>(CreateEntitlementSetDialogDocument, options);
        }
export type CreateEntitlementSetDialogQueryHookResult = ReturnType<typeof useCreateEntitlementSetDialogQuery>;
export type CreateEntitlementSetDialogLazyQueryHookResult = ReturnType<typeof useCreateEntitlementSetDialogLazyQuery>;
export type CreateEntitlementSetDialogSuspenseQueryHookResult = ReturnType<typeof useCreateEntitlementSetDialogSuspenseQuery>;
export type CreateEntitlementSetDialogQueryResult = Apollo.QueryResult<CreateEntitlementSetDialogQuery, CreateEntitlementSetDialogQueryVariables>;
export const UpdateEntitlementSetDocument = gql`
    mutation UpdateEntitlementSet($input: UpdateEntitlementSetInput!) {
  updateEntitlementSet(input: $input) {
    entitlementSet {
      id
      name
      description
      entitlementSetFeatures {
        id
        feature {
          name
        }
      }
    }
    error {
      displayMessage
    }
  }
}
    `;
export type UpdateEntitlementSetMutationFn = Apollo.MutationFunction<UpdateEntitlementSetMutation, UpdateEntitlementSetMutationVariables>;

/**
 * __useUpdateEntitlementSetMutation__
 *
 * To run a mutation, you first call `useUpdateEntitlementSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntitlementSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntitlementSetMutation, { data, loading, error }] = useUpdateEntitlementSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntitlementSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntitlementSetMutation, UpdateEntitlementSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntitlementSetMutation, UpdateEntitlementSetMutationVariables>(UpdateEntitlementSetDocument, options);
      }
export type UpdateEntitlementSetMutationHookResult = ReturnType<typeof useUpdateEntitlementSetMutation>;
export type UpdateEntitlementSetMutationResult = Apollo.MutationResult<UpdateEntitlementSetMutation>;
export type UpdateEntitlementSetMutationOptions = Apollo.BaseMutationOptions<UpdateEntitlementSetMutation, UpdateEntitlementSetMutationVariables>;
export const EditEntitlementSetDialogDocument = gql`
    query EditEntitlementSetDialog {
  features(type: ENTITLEMENT) {
    ...EntitlementSetFieldSet_features
  }
}
    ${EntitlementSetFieldSet_FeaturesFragmentDoc}`;

/**
 * __useEditEntitlementSetDialogQuery__
 *
 * To run a query within a React component, call `useEditEntitlementSetDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditEntitlementSetDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditEntitlementSetDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditEntitlementSetDialogQuery(baseOptions?: Apollo.QueryHookOptions<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>(EditEntitlementSetDialogDocument, options);
      }
export function useEditEntitlementSetDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>(EditEntitlementSetDialogDocument, options);
        }
export function useEditEntitlementSetDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>(EditEntitlementSetDialogDocument, options);
        }
export type EditEntitlementSetDialogQueryHookResult = ReturnType<typeof useEditEntitlementSetDialogQuery>;
export type EditEntitlementSetDialogLazyQueryHookResult = ReturnType<typeof useEditEntitlementSetDialogLazyQuery>;
export type EditEntitlementSetDialogSuspenseQueryHookResult = ReturnType<typeof useEditEntitlementSetDialogSuspenseQuery>;
export type EditEntitlementSetDialogQueryResult = Apollo.QueryResult<EditEntitlementSetDialogQuery, EditEntitlementSetDialogQueryVariables>;
export const EntitlementSetsPageDocument = gql`
    query EntitlementSetsPage {
  entitlementSets {
    ...EntitlementSetsPage_entitlementSets
    ...EditEntitlementSetDialog_entitlementSet
  }
}
    ${EntitlementSetsPage_EntitlementSetsFragmentDoc}
${EditEntitlementSetDialog_EntitlementSetFragmentDoc}`;

/**
 * __useEntitlementSetsPageQuery__
 *
 * To run a query within a React component, call `useEntitlementSetsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitlementSetsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitlementSetsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntitlementSetsPageQuery(baseOptions?: Apollo.QueryHookOptions<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>(EntitlementSetsPageDocument, options);
      }
export function useEntitlementSetsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>(EntitlementSetsPageDocument, options);
        }
export function useEntitlementSetsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>(EntitlementSetsPageDocument, options);
        }
export type EntitlementSetsPageQueryHookResult = ReturnType<typeof useEntitlementSetsPageQuery>;
export type EntitlementSetsPageLazyQueryHookResult = ReturnType<typeof useEntitlementSetsPageLazyQuery>;
export type EntitlementSetsPageSuspenseQueryHookResult = ReturnType<typeof useEntitlementSetsPageSuspenseQuery>;
export type EntitlementSetsPageQueryResult = Apollo.QueryResult<EntitlementSetsPageQuery, EntitlementSetsPageQueryVariables>;
export const CreatePaymentSubscriptionPlanDocument = gql`
    mutation CreatePaymentSubscriptionPlan($input: CreatePaymentSubscriptionPlanInput!) {
  createPaymentSubscriptionPlan(input: $input) {
    paymentSubscriptionPlan {
      ...PaymentSubscriptionPlansPage_subscription
    }
    error {
      displayMessage
    }
  }
}
    ${PaymentSubscriptionPlansPage_SubscriptionFragmentDoc}`;
export type CreatePaymentSubscriptionPlanMutationFn = Apollo.MutationFunction<CreatePaymentSubscriptionPlanMutation, CreatePaymentSubscriptionPlanMutationVariables>;

/**
 * __useCreatePaymentSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useCreatePaymentSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentSubscriptionPlanMutation, { data, loading, error }] = useCreatePaymentSubscriptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentSubscriptionPlanMutation, CreatePaymentSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentSubscriptionPlanMutation, CreatePaymentSubscriptionPlanMutationVariables>(CreatePaymentSubscriptionPlanDocument, options);
      }
export type CreatePaymentSubscriptionPlanMutationHookResult = ReturnType<typeof useCreatePaymentSubscriptionPlanMutation>;
export type CreatePaymentSubscriptionPlanMutationResult = Apollo.MutationResult<CreatePaymentSubscriptionPlanMutation>;
export type CreatePaymentSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<CreatePaymentSubscriptionPlanMutation, CreatePaymentSubscriptionPlanMutationVariables>;
export const UpdatePaymentSubscriptionPlanDocument = gql`
    mutation UpdatePaymentSubscriptionPlan($input: UpdatePaymentSubscriptionPlanInput!) {
  updatePaymentSubscriptionPlan(input: $input) {
    paymentSubscriptionPlan {
      id
      ...EditPaymentSubscriptionPlan_subscription
    }
    error {
      displayMessage
    }
  }
}
    ${EditPaymentSubscriptionPlan_SubscriptionFragmentDoc}`;
export type UpdatePaymentSubscriptionPlanMutationFn = Apollo.MutationFunction<UpdatePaymentSubscriptionPlanMutation, UpdatePaymentSubscriptionPlanMutationVariables>;

/**
 * __useUpdatePaymentSubscriptionPlanMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentSubscriptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentSubscriptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentSubscriptionPlanMutation, { data, loading, error }] = useUpdatePaymentSubscriptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentSubscriptionPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentSubscriptionPlanMutation, UpdatePaymentSubscriptionPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentSubscriptionPlanMutation, UpdatePaymentSubscriptionPlanMutationVariables>(UpdatePaymentSubscriptionPlanDocument, options);
      }
export type UpdatePaymentSubscriptionPlanMutationHookResult = ReturnType<typeof useUpdatePaymentSubscriptionPlanMutation>;
export type UpdatePaymentSubscriptionPlanMutationResult = Apollo.MutationResult<UpdatePaymentSubscriptionPlanMutation>;
export type UpdatePaymentSubscriptionPlanMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentSubscriptionPlanMutation, UpdatePaymentSubscriptionPlanMutationVariables>;
export const EditPaymentSubscriptionPlanDialogDocument = gql`
    query EditPaymentSubscriptionPlanDialog {
  entitlementSets {
    id
    name
  }
}
    `;

/**
 * __useEditPaymentSubscriptionPlanDialogQuery__
 *
 * To run a query within a React component, call `useEditPaymentSubscriptionPlanDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentSubscriptionPlanDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPaymentSubscriptionPlanDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditPaymentSubscriptionPlanDialogQuery(baseOptions?: Apollo.QueryHookOptions<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>(EditPaymentSubscriptionPlanDialogDocument, options);
      }
export function useEditPaymentSubscriptionPlanDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>(EditPaymentSubscriptionPlanDialogDocument, options);
        }
export function useEditPaymentSubscriptionPlanDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>(EditPaymentSubscriptionPlanDialogDocument, options);
        }
export type EditPaymentSubscriptionPlanDialogQueryHookResult = ReturnType<typeof useEditPaymentSubscriptionPlanDialogQuery>;
export type EditPaymentSubscriptionPlanDialogLazyQueryHookResult = ReturnType<typeof useEditPaymentSubscriptionPlanDialogLazyQuery>;
export type EditPaymentSubscriptionPlanDialogSuspenseQueryHookResult = ReturnType<typeof useEditPaymentSubscriptionPlanDialogSuspenseQuery>;
export type EditPaymentSubscriptionPlanDialogQueryResult = Apollo.QueryResult<EditPaymentSubscriptionPlanDialogQuery, EditPaymentSubscriptionPlanDialogQueryVariables>;
export const PaymentSubscriptionPlansPageDocument = gql`
    query PaymentSubscriptionPlansPage {
  paymentSubscriptionPlans {
    ...PaymentSubscriptionPlansPage_subscription
  }
}
    ${PaymentSubscriptionPlansPage_SubscriptionFragmentDoc}`;

/**
 * __usePaymentSubscriptionPlansPageQuery__
 *
 * To run a query within a React component, call `usePaymentSubscriptionPlansPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentSubscriptionPlansPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentSubscriptionPlansPageQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentSubscriptionPlansPageQuery(baseOptions?: Apollo.QueryHookOptions<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>(PaymentSubscriptionPlansPageDocument, options);
      }
export function usePaymentSubscriptionPlansPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>(PaymentSubscriptionPlansPageDocument, options);
        }
export function usePaymentSubscriptionPlansPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>(PaymentSubscriptionPlansPageDocument, options);
        }
export type PaymentSubscriptionPlansPageQueryHookResult = ReturnType<typeof usePaymentSubscriptionPlansPageQuery>;
export type PaymentSubscriptionPlansPageLazyQueryHookResult = ReturnType<typeof usePaymentSubscriptionPlansPageLazyQuery>;
export type PaymentSubscriptionPlansPageSuspenseQueryHookResult = ReturnType<typeof usePaymentSubscriptionPlansPageSuspenseQuery>;
export type PaymentSubscriptionPlansPageQueryResult = Apollo.QueryResult<PaymentSubscriptionPlansPageQuery, PaymentSubscriptionPlansPageQueryVariables>;
export const CreateSubscriptionAddonDocument = gql`
    mutation CreateSubscriptionAddon($input: CreatePaymentSubscriptionPlanAddonInput!) {
  createPaymentSubscriptionPlanAddon(input: $input) {
    paymentSubscriptionPlanAddon {
      ...Addons_paymentSubscriptionPlanAddons
    }
    error {
      displayMessage
    }
  }
}
    ${Addons_PaymentSubscriptionPlanAddonsFragmentDoc}`;
export type CreateSubscriptionAddonMutationFn = Apollo.MutationFunction<CreateSubscriptionAddonMutation, CreateSubscriptionAddonMutationVariables>;

/**
 * __useCreateSubscriptionAddonMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionAddonMutation, { data, loading, error }] = useCreateSubscriptionAddonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionAddonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionAddonMutation, CreateSubscriptionAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionAddonMutation, CreateSubscriptionAddonMutationVariables>(CreateSubscriptionAddonDocument, options);
      }
export type CreateSubscriptionAddonMutationHookResult = ReturnType<typeof useCreateSubscriptionAddonMutation>;
export type CreateSubscriptionAddonMutationResult = Apollo.MutationResult<CreateSubscriptionAddonMutation>;
export type CreateSubscriptionAddonMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionAddonMutation, CreateSubscriptionAddonMutationVariables>;
export const UpdateSubscriptionAddonDocument = gql`
    mutation UpdateSubscriptionAddon($input: UpdatePaymentSubscriptionPlanAddonInput!) {
  updatePaymentSubscriptionPlanAddon(input: $input) {
    paymentSubscriptionPlanAddon {
      ...Addons_paymentSubscriptionPlanAddons
    }
    error {
      displayMessage
    }
  }
}
    ${Addons_PaymentSubscriptionPlanAddonsFragmentDoc}`;
export type UpdateSubscriptionAddonMutationFn = Apollo.MutationFunction<UpdateSubscriptionAddonMutation, UpdateSubscriptionAddonMutationVariables>;

/**
 * __useUpdateSubscriptionAddonMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionAddonMutation, { data, loading, error }] = useUpdateSubscriptionAddonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionAddonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionAddonMutation, UpdateSubscriptionAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionAddonMutation, UpdateSubscriptionAddonMutationVariables>(UpdateSubscriptionAddonDocument, options);
      }
export type UpdateSubscriptionAddonMutationHookResult = ReturnType<typeof useUpdateSubscriptionAddonMutation>;
export type UpdateSubscriptionAddonMutationResult = Apollo.MutationResult<UpdateSubscriptionAddonMutation>;
export type UpdateSubscriptionAddonMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionAddonMutation, UpdateSubscriptionAddonMutationVariables>;
export const EditSubscriptionAddonDialogDocument = gql`
    query EditSubscriptionAddonDialog {
  entitlementSets {
    id
    name
  }
}
    `;

/**
 * __useEditSubscriptionAddonDialogQuery__
 *
 * To run a query within a React component, call `useEditSubscriptionAddonDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSubscriptionAddonDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSubscriptionAddonDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditSubscriptionAddonDialogQuery(baseOptions?: Apollo.QueryHookOptions<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>(EditSubscriptionAddonDialogDocument, options);
      }
export function useEditSubscriptionAddonDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>(EditSubscriptionAddonDialogDocument, options);
        }
export function useEditSubscriptionAddonDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>(EditSubscriptionAddonDialogDocument, options);
        }
export type EditSubscriptionAddonDialogQueryHookResult = ReturnType<typeof useEditSubscriptionAddonDialogQuery>;
export type EditSubscriptionAddonDialogLazyQueryHookResult = ReturnType<typeof useEditSubscriptionAddonDialogLazyQuery>;
export type EditSubscriptionAddonDialogSuspenseQueryHookResult = ReturnType<typeof useEditSubscriptionAddonDialogSuspenseQuery>;
export type EditSubscriptionAddonDialogQueryResult = Apollo.QueryResult<EditSubscriptionAddonDialogQuery, EditSubscriptionAddonDialogQueryVariables>;
export const AddonsPageDocument = gql`
    query AddonsPage {
  paymentSubscriptionPlanAddons {
    ...Addons_paymentSubscriptionPlanAddons
  }
}
    ${Addons_PaymentSubscriptionPlanAddonsFragmentDoc}`;

/**
 * __useAddonsPageQuery__
 *
 * To run a query within a React component, call `useAddonsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddonsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddonsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddonsPageQuery(baseOptions?: Apollo.QueryHookOptions<AddonsPageQuery, AddonsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddonsPageQuery, AddonsPageQueryVariables>(AddonsPageDocument, options);
      }
export function useAddonsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddonsPageQuery, AddonsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddonsPageQuery, AddonsPageQueryVariables>(AddonsPageDocument, options);
        }
export function useAddonsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddonsPageQuery, AddonsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddonsPageQuery, AddonsPageQueryVariables>(AddonsPageDocument, options);
        }
export type AddonsPageQueryHookResult = ReturnType<typeof useAddonsPageQuery>;
export type AddonsPageLazyQueryHookResult = ReturnType<typeof useAddonsPageLazyQuery>;
export type AddonsPageSuspenseQueryHookResult = ReturnType<typeof useAddonsPageSuspenseQuery>;
export type AddonsPageQueryResult = Apollo.QueryResult<AddonsPageQuery, AddonsPageQueryVariables>;
export const CreateFeatureDocument = gql`
    mutation CreateFeature($name: String!, $description: String!, $state: FeatureState!, $canonicalType: FeatureType) {
  createFeature(
    name: $name
    state: $state
    description: $description
    canonicalType: $canonicalType
  ) {
    id
    ...featureForList
  }
}
    ${FeatureForListFragmentDoc}`;
export type CreateFeatureMutationFn = Apollo.MutationFunction<CreateFeatureMutation, CreateFeatureMutationVariables>;

/**
 * __useCreateFeatureMutation__
 *
 * To run a mutation, you first call `useCreateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureMutation, { data, loading, error }] = useCreateFeatureMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      state: // value for 'state'
 *      canonicalType: // value for 'canonicalType'
 *   },
 * });
 */
export function useCreateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureMutation, CreateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureMutation, CreateFeatureMutationVariables>(CreateFeatureDocument, options);
      }
export type CreateFeatureMutationHookResult = ReturnType<typeof useCreateFeatureMutation>;
export type CreateFeatureMutationResult = Apollo.MutationResult<CreateFeatureMutation>;
export type CreateFeatureMutationOptions = Apollo.BaseMutationOptions<CreateFeatureMutation, CreateFeatureMutationVariables>;
export const UpdateBankVerificationStatusDocument = gql`
    mutation UpdateBankVerificationStatus($bankVerificationStatus: VerificationStatus, $businessId: Int!) {
  updateBankVerificationStatus(
    bankVerificationStatus: $bankVerificationStatus
    businessId: $businessId
  )
}
    `;
export type UpdateBankVerificationStatusMutationFn = Apollo.MutationFunction<UpdateBankVerificationStatusMutation, UpdateBankVerificationStatusMutationVariables>;

/**
 * __useUpdateBankVerificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBankVerificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankVerificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankVerificationStatusMutation, { data, loading, error }] = useUpdateBankVerificationStatusMutation({
 *   variables: {
 *      bankVerificationStatus: // value for 'bankVerificationStatus'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useUpdateBankVerificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankVerificationStatusMutation, UpdateBankVerificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankVerificationStatusMutation, UpdateBankVerificationStatusMutationVariables>(UpdateBankVerificationStatusDocument, options);
      }
export type UpdateBankVerificationStatusMutationHookResult = ReturnType<typeof useUpdateBankVerificationStatusMutation>;
export type UpdateBankVerificationStatusMutationResult = Apollo.MutationResult<UpdateBankVerificationStatusMutation>;
export type UpdateBankVerificationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBankVerificationStatusMutation, UpdateBankVerificationStatusMutationVariables>;
export const UpdateTosSignedDateDocument = gql`
    mutation UpdateTosSignedDate($tosSignedDate: LocalDate!, $businessId: Int!) {
  updateTosSignedDate(tosSignedDate: $tosSignedDate, businessId: $businessId)
}
    `;
export type UpdateTosSignedDateMutationFn = Apollo.MutationFunction<UpdateTosSignedDateMutation, UpdateTosSignedDateMutationVariables>;

/**
 * __useUpdateTosSignedDateMutation__
 *
 * To run a mutation, you first call `useUpdateTosSignedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTosSignedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTosSignedDateMutation, { data, loading, error }] = useUpdateTosSignedDateMutation({
 *   variables: {
 *      tosSignedDate: // value for 'tosSignedDate'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useUpdateTosSignedDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTosSignedDateMutation, UpdateTosSignedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTosSignedDateMutation, UpdateTosSignedDateMutationVariables>(UpdateTosSignedDateDocument, options);
      }
export type UpdateTosSignedDateMutationHookResult = ReturnType<typeof useUpdateTosSignedDateMutation>;
export type UpdateTosSignedDateMutationResult = Apollo.MutationResult<UpdateTosSignedDateMutation>;
export type UpdateTosSignedDateMutationOptions = Apollo.BaseMutationOptions<UpdateTosSignedDateMutation, UpdateTosSignedDateMutationVariables>;
export const UpdateLockDurationDocument = gql`
    mutation UpdateLockDuration($businessId: Int!, $lockDuration: Int!) {
  updateLockDuration(businessId: $businessId, lockDuration: $lockDuration) {
    id
  }
}
    `;
export type UpdateLockDurationMutationFn = Apollo.MutationFunction<UpdateLockDurationMutation, UpdateLockDurationMutationVariables>;

/**
 * __useUpdateLockDurationMutation__
 *
 * To run a mutation, you first call `useUpdateLockDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLockDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLockDurationMutation, { data, loading, error }] = useUpdateLockDurationMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      lockDuration: // value for 'lockDuration'
 *   },
 * });
 */
export function useUpdateLockDurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLockDurationMutation, UpdateLockDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLockDurationMutation, UpdateLockDurationMutationVariables>(UpdateLockDurationDocument, options);
      }
export type UpdateLockDurationMutationHookResult = ReturnType<typeof useUpdateLockDurationMutation>;
export type UpdateLockDurationMutationResult = Apollo.MutationResult<UpdateLockDurationMutation>;
export type UpdateLockDurationMutationOptions = Apollo.BaseMutationOptions<UpdateLockDurationMutation, UpdateLockDurationMutationVariables>;
export const UpdateCurrencyCodeDocument = gql`
    mutation UpdateCurrencyCode($businessId: Int!, $currencyCode: String!) {
  updateCurrencyCode(businessId: $businessId, currencyCode: $currencyCode) {
    id
  }
}
    `;
export type UpdateCurrencyCodeMutationFn = Apollo.MutationFunction<UpdateCurrencyCodeMutation, UpdateCurrencyCodeMutationVariables>;

/**
 * __useUpdateCurrencyCodeMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyCodeMutation, { data, loading, error }] = useUpdateCurrencyCodeMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useUpdateCurrencyCodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrencyCodeMutation, UpdateCurrencyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrencyCodeMutation, UpdateCurrencyCodeMutationVariables>(UpdateCurrencyCodeDocument, options);
      }
export type UpdateCurrencyCodeMutationHookResult = ReturnType<typeof useUpdateCurrencyCodeMutation>;
export type UpdateCurrencyCodeMutationResult = Apollo.MutationResult<UpdateCurrencyCodeMutation>;
export type UpdateCurrencyCodeMutationOptions = Apollo.BaseMutationOptions<UpdateCurrencyCodeMutation, UpdateCurrencyCodeMutationVariables>;
export const SetGiftCardProviderDocument = gql`
    mutation SetGiftCardProvider($businessId: Int!, $giftCardProvider: GiftCardProvider!) {
  updateGiftCardProvider(
    businessId: $businessId
    giftCardProvider: $giftCardProvider
  ) {
    id
  }
}
    `;
export type SetGiftCardProviderMutationFn = Apollo.MutationFunction<SetGiftCardProviderMutation, SetGiftCardProviderMutationVariables>;

/**
 * __useSetGiftCardProviderMutation__
 *
 * To run a mutation, you first call `useSetGiftCardProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGiftCardProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGiftCardProviderMutation, { data, loading, error }] = useSetGiftCardProviderMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      giftCardProvider: // value for 'giftCardProvider'
 *   },
 * });
 */
export function useSetGiftCardProviderMutation(baseOptions?: Apollo.MutationHookOptions<SetGiftCardProviderMutation, SetGiftCardProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGiftCardProviderMutation, SetGiftCardProviderMutationVariables>(SetGiftCardProviderDocument, options);
      }
export type SetGiftCardProviderMutationHookResult = ReturnType<typeof useSetGiftCardProviderMutation>;
export type SetGiftCardProviderMutationResult = Apollo.MutationResult<SetGiftCardProviderMutation>;
export type SetGiftCardProviderMutationOptions = Apollo.BaseMutationOptions<SetGiftCardProviderMutation, SetGiftCardProviderMutationVariables>;
export const PreviewEntitlementChangesDocument = gql`
    query PreviewEntitlementChanges($businessId: Int!, $paymentSubscriptionPlanId: Int, $paymentSubscriptionPlanAddonIds: [Int!]) {
  business(id: $businessId) {
    id
    previewEntitlementChanges(
      paymentSubscriptionPlanId: $paymentSubscriptionPlanId
      paymentSubscriptionPlanAddonIds: $paymentSubscriptionPlanAddonIds
    ) {
      ...PreviewEntitlementChanges
    }
  }
}
    ${PreviewEntitlementChangesFragmentDoc}`;

/**
 * __usePreviewEntitlementChangesQuery__
 *
 * To run a query within a React component, call `usePreviewEntitlementChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewEntitlementChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewEntitlementChangesQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      paymentSubscriptionPlanId: // value for 'paymentSubscriptionPlanId'
 *      paymentSubscriptionPlanAddonIds: // value for 'paymentSubscriptionPlanAddonIds'
 *   },
 * });
 */
export function usePreviewEntitlementChangesQuery(baseOptions: Apollo.QueryHookOptions<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables> & ({ variables: PreviewEntitlementChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>(PreviewEntitlementChangesDocument, options);
      }
export function usePreviewEntitlementChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>(PreviewEntitlementChangesDocument, options);
        }
export function usePreviewEntitlementChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>(PreviewEntitlementChangesDocument, options);
        }
export type PreviewEntitlementChangesQueryHookResult = ReturnType<typeof usePreviewEntitlementChangesQuery>;
export type PreviewEntitlementChangesLazyQueryHookResult = ReturnType<typeof usePreviewEntitlementChangesLazyQuery>;
export type PreviewEntitlementChangesSuspenseQueryHookResult = ReturnType<typeof usePreviewEntitlementChangesSuspenseQuery>;
export type PreviewEntitlementChangesQueryResult = Apollo.QueryResult<PreviewEntitlementChangesQuery, PreviewEntitlementChangesQueryVariables>;
export const BusinessesForRebalanceComparisonFormDocument = gql`
    query BusinessesForRebalanceComparisonForm {
  businesses {
    id
    name
    isAuthorizedByTock
    isDeleted
  }
}
    `;

/**
 * __useBusinessesForRebalanceComparisonFormQuery__
 *
 * To run a query within a React component, call `useBusinessesForRebalanceComparisonFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessesForRebalanceComparisonFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessesForRebalanceComparisonFormQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessesForRebalanceComparisonFormQuery(baseOptions?: Apollo.QueryHookOptions<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>(BusinessesForRebalanceComparisonFormDocument, options);
      }
export function useBusinessesForRebalanceComparisonFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>(BusinessesForRebalanceComparisonFormDocument, options);
        }
export function useBusinessesForRebalanceComparisonFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>(BusinessesForRebalanceComparisonFormDocument, options);
        }
export type BusinessesForRebalanceComparisonFormQueryHookResult = ReturnType<typeof useBusinessesForRebalanceComparisonFormQuery>;
export type BusinessesForRebalanceComparisonFormLazyQueryHookResult = ReturnType<typeof useBusinessesForRebalanceComparisonFormLazyQuery>;
export type BusinessesForRebalanceComparisonFormSuspenseQueryHookResult = ReturnType<typeof useBusinessesForRebalanceComparisonFormSuspenseQuery>;
export type BusinessesForRebalanceComparisonFormQueryResult = Apollo.QueryResult<BusinessesForRebalanceComparisonFormQuery, BusinessesForRebalanceComparisonFormQueryVariables>;
export const AvailableTimelineExportsDocument = gql`
    query AvailableTimelineExports($env: String!, $exportDate: LocalDate!, $exportType: TimelineExportType!, $businessId: Int!) {
  business(id: $businessId) {
    id
    name
    availableTimelineExports(
      env: $env
      exportDate: $exportDate
      exportType: $exportType
    ) {
      fileDescriptors {
        id
        label
      }
    }
  }
}
    `;

/**
 * __useAvailableTimelineExportsQuery__
 *
 * To run a query within a React component, call `useAvailableTimelineExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTimelineExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTimelineExportsQuery({
 *   variables: {
 *      env: // value for 'env'
 *      exportDate: // value for 'exportDate'
 *      exportType: // value for 'exportType'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useAvailableTimelineExportsQuery(baseOptions: Apollo.QueryHookOptions<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables> & ({ variables: AvailableTimelineExportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>(AvailableTimelineExportsDocument, options);
      }
export function useAvailableTimelineExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>(AvailableTimelineExportsDocument, options);
        }
export function useAvailableTimelineExportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>(AvailableTimelineExportsDocument, options);
        }
export type AvailableTimelineExportsQueryHookResult = ReturnType<typeof useAvailableTimelineExportsQuery>;
export type AvailableTimelineExportsLazyQueryHookResult = ReturnType<typeof useAvailableTimelineExportsLazyQuery>;
export type AvailableTimelineExportsSuspenseQueryHookResult = ReturnType<typeof useAvailableTimelineExportsSuspenseQuery>;
export type AvailableTimelineExportsQueryResult = Apollo.QueryResult<AvailableTimelineExportsQuery, AvailableTimelineExportsQueryVariables>;
export const BatchDeleteBusinessFeatureDocument = gql`
    mutation BatchDeleteBusinessFeature($featureId: Int!, $businessIds: [Int!]!) {
  batchDeleteBusinessFeature(featureId: $featureId, businessIds: $businessIds)
}
    `;
export type BatchDeleteBusinessFeatureMutationFn = Apollo.MutationFunction<BatchDeleteBusinessFeatureMutation, BatchDeleteBusinessFeatureMutationVariables>;

/**
 * __useBatchDeleteBusinessFeatureMutation__
 *
 * To run a mutation, you first call `useBatchDeleteBusinessFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteBusinessFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteBusinessFeatureMutation, { data, loading, error }] = useBatchDeleteBusinessFeatureMutation({
 *   variables: {
 *      featureId: // value for 'featureId'
 *      businessIds: // value for 'businessIds'
 *   },
 * });
 */
export function useBatchDeleteBusinessFeatureMutation(baseOptions?: Apollo.MutationHookOptions<BatchDeleteBusinessFeatureMutation, BatchDeleteBusinessFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchDeleteBusinessFeatureMutation, BatchDeleteBusinessFeatureMutationVariables>(BatchDeleteBusinessFeatureDocument, options);
      }
export type BatchDeleteBusinessFeatureMutationHookResult = ReturnType<typeof useBatchDeleteBusinessFeatureMutation>;
export type BatchDeleteBusinessFeatureMutationResult = Apollo.MutationResult<BatchDeleteBusinessFeatureMutation>;
export type BatchDeleteBusinessFeatureMutationOptions = Apollo.BaseMutationOptions<BatchDeleteBusinessFeatureMutation, BatchDeleteBusinessFeatureMutationVariables>;
export const UpdateExperimentIsActiveDocument = gql`
    mutation UpdateExperimentIsActive($id: Int!, $isActive: Boolean!) {
  updateExperimentIsActive(id: $id, isActive: $isActive) {
    id
    isActive
  }
}
    `;
export type UpdateExperimentIsActiveMutationFn = Apollo.MutationFunction<UpdateExperimentIsActiveMutation, UpdateExperimentIsActiveMutationVariables>;

/**
 * __useUpdateExperimentIsActiveMutation__
 *
 * To run a mutation, you first call `useUpdateExperimentIsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExperimentIsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExperimentIsActiveMutation, { data, loading, error }] = useUpdateExperimentIsActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateExperimentIsActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExperimentIsActiveMutation, UpdateExperimentIsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExperimentIsActiveMutation, UpdateExperimentIsActiveMutationVariables>(UpdateExperimentIsActiveDocument, options);
      }
export type UpdateExperimentIsActiveMutationHookResult = ReturnType<typeof useUpdateExperimentIsActiveMutation>;
export type UpdateExperimentIsActiveMutationResult = Apollo.MutationResult<UpdateExperimentIsActiveMutation>;
export type UpdateExperimentIsActiveMutationOptions = Apollo.BaseMutationOptions<UpdateExperimentIsActiveMutation, UpdateExperimentIsActiveMutationVariables>;
export const FetchAllAccoladeTypesDocument = gql`
    query FetchAllAccoladeTypes {
  accoladeTypesWithCounts {
    ...AccoladeTypeInfo
  }
}
    ${AccoladeTypeInfoFragmentDoc}`;

/**
 * __useFetchAllAccoladeTypesQuery__
 *
 * To run a query within a React component, call `useFetchAllAccoladeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAccoladeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAccoladeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllAccoladeTypesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
      }
export function useFetchAllAccoladeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
        }
export function useFetchAllAccoladeTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>(FetchAllAccoladeTypesDocument, options);
        }
export type FetchAllAccoladeTypesQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesQuery>;
export type FetchAllAccoladeTypesLazyQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesLazyQuery>;
export type FetchAllAccoladeTypesSuspenseQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypesSuspenseQuery>;
export type FetchAllAccoladeTypesQueryResult = Apollo.QueryResult<FetchAllAccoladeTypesQuery, FetchAllAccoladeTypesQueryVariables>;
export const DeleteAccoladeTypeDocument = gql`
    mutation DeleteAccoladeType($id: Int!) {
  deleteAccoladeType(id: $id)
}
    `;
export type DeleteAccoladeTypeMutationFn = Apollo.MutationFunction<DeleteAccoladeTypeMutation, DeleteAccoladeTypeMutationVariables>;

/**
 * __useDeleteAccoladeTypeMutation__
 *
 * To run a mutation, you first call `useDeleteAccoladeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccoladeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccoladeTypeMutation, { data, loading, error }] = useDeleteAccoladeTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccoladeTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccoladeTypeMutation, DeleteAccoladeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccoladeTypeMutation, DeleteAccoladeTypeMutationVariables>(DeleteAccoladeTypeDocument, options);
      }
export type DeleteAccoladeTypeMutationHookResult = ReturnType<typeof useDeleteAccoladeTypeMutation>;
export type DeleteAccoladeTypeMutationResult = Apollo.MutationResult<DeleteAccoladeTypeMutation>;
export type DeleteAccoladeTypeMutationOptions = Apollo.BaseMutationOptions<DeleteAccoladeTypeMutation, DeleteAccoladeTypeMutationVariables>;
export const CreateAccoladeTypeDocument = gql`
    mutation CreateAccoladeType($accoladeType: AccoladeTypeInput!) {
  createAccoladeType(accoladeType: $accoladeType) {
    __typename
    displayName
    hasAchievement
    hasCritic
    hasLink
    iconImgLink
    id
    isActive
    name
    orgLink
    accoladeTypeRating {
      id
    }
  }
}
    `;
export type CreateAccoladeTypeMutationFn = Apollo.MutationFunction<CreateAccoladeTypeMutation, CreateAccoladeTypeMutationVariables>;

/**
 * __useCreateAccoladeTypeMutation__
 *
 * To run a mutation, you first call `useCreateAccoladeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccoladeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccoladeTypeMutation, { data, loading, error }] = useCreateAccoladeTypeMutation({
 *   variables: {
 *      accoladeType: // value for 'accoladeType'
 *   },
 * });
 */
export function useCreateAccoladeTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccoladeTypeMutation, CreateAccoladeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccoladeTypeMutation, CreateAccoladeTypeMutationVariables>(CreateAccoladeTypeDocument, options);
      }
export type CreateAccoladeTypeMutationHookResult = ReturnType<typeof useCreateAccoladeTypeMutation>;
export type CreateAccoladeTypeMutationResult = Apollo.MutationResult<CreateAccoladeTypeMutation>;
export type CreateAccoladeTypeMutationOptions = Apollo.BaseMutationOptions<CreateAccoladeTypeMutation, CreateAccoladeTypeMutationVariables>;
export const UpdateAccoladeTypeDocument = gql`
    mutation UpdateAccoladeType($accoladeType: AccoladeTypeInput!) {
  updateAccoladeType(accoladeType: $accoladeType) {
    accoladeTypeRating {
      isHalfPoints
      id
      maxValue
      minValue
      name
      systemType
    }
    displayName
    hasAchievement
    hasCritic
    hasLink
    iconImgLink
    id
    isActive
    name
    orgLink
  }
}
    `;
export type UpdateAccoladeTypeMutationFn = Apollo.MutationFunction<UpdateAccoladeTypeMutation, UpdateAccoladeTypeMutationVariables>;

/**
 * __useUpdateAccoladeTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAccoladeTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccoladeTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccoladeTypeMutation, { data, loading, error }] = useUpdateAccoladeTypeMutation({
 *   variables: {
 *      accoladeType: // value for 'accoladeType'
 *   },
 * });
 */
export function useUpdateAccoladeTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccoladeTypeMutation, UpdateAccoladeTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccoladeTypeMutation, UpdateAccoladeTypeMutationVariables>(UpdateAccoladeTypeDocument, options);
      }
export type UpdateAccoladeTypeMutationHookResult = ReturnType<typeof useUpdateAccoladeTypeMutation>;
export type UpdateAccoladeTypeMutationResult = Apollo.MutationResult<UpdateAccoladeTypeMutation>;
export type UpdateAccoladeTypeMutationOptions = Apollo.BaseMutationOptions<UpdateAccoladeTypeMutation, UpdateAccoladeTypeMutationVariables>;
export const FetchAllAccoladeTypeRatingsDocument = gql`
    query FetchAllAccoladeTypeRatings {
  accoladeTypeRatingsWithCounts {
    ...AccoladeTypeRatingInfo
  }
}
    ${AccoladeTypeRatingInfoFragmentDoc}`;

/**
 * __useFetchAllAccoladeTypeRatingsQuery__
 *
 * To run a query within a React component, call `useFetchAllAccoladeTypeRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllAccoladeTypeRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllAccoladeTypeRatingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllAccoladeTypeRatingsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>(FetchAllAccoladeTypeRatingsDocument, options);
      }
export function useFetchAllAccoladeTypeRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>(FetchAllAccoladeTypeRatingsDocument, options);
        }
export function useFetchAllAccoladeTypeRatingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>(FetchAllAccoladeTypeRatingsDocument, options);
        }
export type FetchAllAccoladeTypeRatingsQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypeRatingsQuery>;
export type FetchAllAccoladeTypeRatingsLazyQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypeRatingsLazyQuery>;
export type FetchAllAccoladeTypeRatingsSuspenseQueryHookResult = ReturnType<typeof useFetchAllAccoladeTypeRatingsSuspenseQuery>;
export type FetchAllAccoladeTypeRatingsQueryResult = Apollo.QueryResult<FetchAllAccoladeTypeRatingsQuery, FetchAllAccoladeTypeRatingsQueryVariables>;
export const CreateAccoladeTypeRatingDocument = gql`
    mutation CreateAccoladeTypeRating($accoladeTypeRating: AccoladeTypeRatingInput!) {
  createAccoladeTypeRating(accoladeTypeRating: $accoladeTypeRating) {
    id
    isHalfPoints
    name
    minValue
    maxValue
    systemType
  }
}
    `;
export type CreateAccoladeTypeRatingMutationFn = Apollo.MutationFunction<CreateAccoladeTypeRatingMutation, CreateAccoladeTypeRatingMutationVariables>;

/**
 * __useCreateAccoladeTypeRatingMutation__
 *
 * To run a mutation, you first call `useCreateAccoladeTypeRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccoladeTypeRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccoladeTypeRatingMutation, { data, loading, error }] = useCreateAccoladeTypeRatingMutation({
 *   variables: {
 *      accoladeTypeRating: // value for 'accoladeTypeRating'
 *   },
 * });
 */
export function useCreateAccoladeTypeRatingMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccoladeTypeRatingMutation, CreateAccoladeTypeRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccoladeTypeRatingMutation, CreateAccoladeTypeRatingMutationVariables>(CreateAccoladeTypeRatingDocument, options);
      }
export type CreateAccoladeTypeRatingMutationHookResult = ReturnType<typeof useCreateAccoladeTypeRatingMutation>;
export type CreateAccoladeTypeRatingMutationResult = Apollo.MutationResult<CreateAccoladeTypeRatingMutation>;
export type CreateAccoladeTypeRatingMutationOptions = Apollo.BaseMutationOptions<CreateAccoladeTypeRatingMutation, CreateAccoladeTypeRatingMutationVariables>;
export const UpdateAccoladeTypeRatingDocument = gql`
    mutation UpdateAccoladeTypeRating($accoladeTypeRating: AccoladeTypeRatingInput!) {
  updateAccoladeTypeRating(accoladeTypeRating: $accoladeTypeRating) {
    id
    isHalfPoints
    name
    minValue
    maxValue
    systemType
  }
}
    `;
export type UpdateAccoladeTypeRatingMutationFn = Apollo.MutationFunction<UpdateAccoladeTypeRatingMutation, UpdateAccoladeTypeRatingMutationVariables>;

/**
 * __useUpdateAccoladeTypeRatingMutation__
 *
 * To run a mutation, you first call `useUpdateAccoladeTypeRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccoladeTypeRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccoladeTypeRatingMutation, { data, loading, error }] = useUpdateAccoladeTypeRatingMutation({
 *   variables: {
 *      accoladeTypeRating: // value for 'accoladeTypeRating'
 *   },
 * });
 */
export function useUpdateAccoladeTypeRatingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccoladeTypeRatingMutation, UpdateAccoladeTypeRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccoladeTypeRatingMutation, UpdateAccoladeTypeRatingMutationVariables>(UpdateAccoladeTypeRatingDocument, options);
      }
export type UpdateAccoladeTypeRatingMutationHookResult = ReturnType<typeof useUpdateAccoladeTypeRatingMutation>;
export type UpdateAccoladeTypeRatingMutationResult = Apollo.MutationResult<UpdateAccoladeTypeRatingMutation>;
export type UpdateAccoladeTypeRatingMutationOptions = Apollo.BaseMutationOptions<UpdateAccoladeTypeRatingMutation, UpdateAccoladeTypeRatingMutationVariables>;
export const DeleteAccoladeTypeRatingDocument = gql`
    mutation DeleteAccoladeTypeRating($id: Int!) {
  deleteAccoladeTypeRating(id: $id)
}
    `;
export type DeleteAccoladeTypeRatingMutationFn = Apollo.MutationFunction<DeleteAccoladeTypeRatingMutation, DeleteAccoladeTypeRatingMutationVariables>;

/**
 * __useDeleteAccoladeTypeRatingMutation__
 *
 * To run a mutation, you first call `useDeleteAccoladeTypeRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccoladeTypeRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccoladeTypeRatingMutation, { data, loading, error }] = useDeleteAccoladeTypeRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccoladeTypeRatingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccoladeTypeRatingMutation, DeleteAccoladeTypeRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccoladeTypeRatingMutation, DeleteAccoladeTypeRatingMutationVariables>(DeleteAccoladeTypeRatingDocument, options);
      }
export type DeleteAccoladeTypeRatingMutationHookResult = ReturnType<typeof useDeleteAccoladeTypeRatingMutation>;
export type DeleteAccoladeTypeRatingMutationResult = Apollo.MutationResult<DeleteAccoladeTypeRatingMutation>;
export type DeleteAccoladeTypeRatingMutationOptions = Apollo.BaseMutationOptions<DeleteAccoladeTypeRatingMutation, DeleteAccoladeTypeRatingMutationVariables>;
export const FetchBusinessGroupDocument = gql`
    query FetchBusinessGroup($businessGroupId: Int!) {
  businessGroup(id: $businessGroupId) {
    id
    ...BusinessGroup
  }
}
    ${BusinessGroupFragmentDoc}`;

/**
 * __useFetchBusinessGroupQuery__
 *
 * To run a query within a React component, call `useFetchBusinessGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBusinessGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBusinessGroupQuery({
 *   variables: {
 *      businessGroupId: // value for 'businessGroupId'
 *   },
 * });
 */
export function useFetchBusinessGroupQuery(baseOptions: Apollo.QueryHookOptions<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables> & ({ variables: FetchBusinessGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>(FetchBusinessGroupDocument, options);
      }
export function useFetchBusinessGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>(FetchBusinessGroupDocument, options);
        }
export function useFetchBusinessGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>(FetchBusinessGroupDocument, options);
        }
export type FetchBusinessGroupQueryHookResult = ReturnType<typeof useFetchBusinessGroupQuery>;
export type FetchBusinessGroupLazyQueryHookResult = ReturnType<typeof useFetchBusinessGroupLazyQuery>;
export type FetchBusinessGroupSuspenseQueryHookResult = ReturnType<typeof useFetchBusinessGroupSuspenseQuery>;
export type FetchBusinessGroupQueryResult = Apollo.QueryResult<FetchBusinessGroupQuery, FetchBusinessGroupQueryVariables>;
export const UpdateBusinessGroupDocument = gql`
    mutation UpdateBusinessGroup($businessGroup: BusinessGroupInput!) {
  updateBusinessGroup(businessGroup: $businessGroup) {
    id
    groupLevelTags
    groupUrlPageTitle
    name
    slug
  }
}
    `;
export type UpdateBusinessGroupMutationFn = Apollo.MutationFunction<UpdateBusinessGroupMutation, UpdateBusinessGroupMutationVariables>;

/**
 * __useUpdateBusinessGroupMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessGroupMutation, { data, loading, error }] = useUpdateBusinessGroupMutation({
 *   variables: {
 *      businessGroup: // value for 'businessGroup'
 *   },
 * });
 */
export function useUpdateBusinessGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessGroupMutation, UpdateBusinessGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessGroupMutation, UpdateBusinessGroupMutationVariables>(UpdateBusinessGroupDocument, options);
      }
export type UpdateBusinessGroupMutationHookResult = ReturnType<typeof useUpdateBusinessGroupMutation>;
export type UpdateBusinessGroupMutationResult = Apollo.MutationResult<UpdateBusinessGroupMutation>;
export type UpdateBusinessGroupMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessGroupMutation, UpdateBusinessGroupMutationVariables>;
export const CreateBusinessGroupDocument = gql`
    mutation CreateBusinessGroup($businessGroup: BusinessGroupInput!) {
  createBusinessGroup(businessGroup: $businessGroup) {
    __typename
    id
    name
    groupLevelTags
    slug
  }
}
    `;
export type CreateBusinessGroupMutationFn = Apollo.MutationFunction<CreateBusinessGroupMutation, CreateBusinessGroupMutationVariables>;

/**
 * __useCreateBusinessGroupMutation__
 *
 * To run a mutation, you first call `useCreateBusinessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessGroupMutation, { data, loading, error }] = useCreateBusinessGroupMutation({
 *   variables: {
 *      businessGroup: // value for 'businessGroup'
 *   },
 * });
 */
export function useCreateBusinessGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessGroupMutation, CreateBusinessGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessGroupMutation, CreateBusinessGroupMutationVariables>(CreateBusinessGroupDocument, options);
      }
export type CreateBusinessGroupMutationHookResult = ReturnType<typeof useCreateBusinessGroupMutation>;
export type CreateBusinessGroupMutationResult = Apollo.MutationResult<CreateBusinessGroupMutation>;
export type CreateBusinessGroupMutationOptions = Apollo.BaseMutationOptions<CreateBusinessGroupMutation, CreateBusinessGroupMutationVariables>;
export const BusinessPhotosDocument = gql`
    query BusinessPhotos($domainName: String!) {
  businessByDomainName(domainName: $domainName) {
    id
    name
    profileImages {
      id
      ...ImageInfo
    }
    ticketTypes(archived: false) {
      id
      name
      images {
        id
        ...ImageInfo
      }
    }
    images {
      id
      ...ImageInfo
    }
  }
}
    ${ImageInfoFragmentDoc}`;

/**
 * __useBusinessPhotosQuery__
 *
 * To run a query within a React component, call `useBusinessPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessPhotosQuery({
 *   variables: {
 *      domainName: // value for 'domainName'
 *   },
 * });
 */
export function useBusinessPhotosQuery(baseOptions: Apollo.QueryHookOptions<BusinessPhotosQuery, BusinessPhotosQueryVariables> & ({ variables: BusinessPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessPhotosQuery, BusinessPhotosQueryVariables>(BusinessPhotosDocument, options);
      }
export function useBusinessPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessPhotosQuery, BusinessPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessPhotosQuery, BusinessPhotosQueryVariables>(BusinessPhotosDocument, options);
        }
export function useBusinessPhotosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessPhotosQuery, BusinessPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessPhotosQuery, BusinessPhotosQueryVariables>(BusinessPhotosDocument, options);
        }
export type BusinessPhotosQueryHookResult = ReturnType<typeof useBusinessPhotosQuery>;
export type BusinessPhotosLazyQueryHookResult = ReturnType<typeof useBusinessPhotosLazyQuery>;
export type BusinessPhotosSuspenseQueryHookResult = ReturnType<typeof useBusinessPhotosSuspenseQuery>;
export type BusinessPhotosQueryResult = Apollo.QueryResult<BusinessPhotosQuery, BusinessPhotosQueryVariables>;
export const FetchBusinessDocument = gql`
    query FetchBusiness($businessId: Int!) {
  business(id: $businessId) {
    ...BusinessWithSearchAttributes
  }
}
    ${BusinessWithSearchAttributesFragmentDoc}`;

/**
 * __useFetchBusinessQuery__
 *
 * To run a query within a React component, call `useFetchBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBusinessQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useFetchBusinessQuery(baseOptions: Apollo.QueryHookOptions<FetchBusinessQuery, FetchBusinessQueryVariables> & ({ variables: FetchBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBusinessQuery, FetchBusinessQueryVariables>(FetchBusinessDocument, options);
      }
export function useFetchBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBusinessQuery, FetchBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBusinessQuery, FetchBusinessQueryVariables>(FetchBusinessDocument, options);
        }
export function useFetchBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBusinessQuery, FetchBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBusinessQuery, FetchBusinessQueryVariables>(FetchBusinessDocument, options);
        }
export type FetchBusinessQueryHookResult = ReturnType<typeof useFetchBusinessQuery>;
export type FetchBusinessLazyQueryHookResult = ReturnType<typeof useFetchBusinessLazyQuery>;
export type FetchBusinessSuspenseQueryHookResult = ReturnType<typeof useFetchBusinessSuspenseQuery>;
export type FetchBusinessQueryResult = Apollo.QueryResult<FetchBusinessQuery, FetchBusinessQueryVariables>;
export const FetchActiveMetroAreasDocument = gql`
    query FetchActiveMetroAreas($activeMode: ActiveMode) {
  metroAreas(activeMode: $activeMode) {
    ...ActiveMetroAreaNames
  }
}
    ${ActiveMetroAreaNamesFragmentDoc}`;

/**
 * __useFetchActiveMetroAreasQuery__
 *
 * To run a query within a React component, call `useFetchActiveMetroAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchActiveMetroAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchActiveMetroAreasQuery({
 *   variables: {
 *      activeMode: // value for 'activeMode'
 *   },
 * });
 */
export function useFetchActiveMetroAreasQuery(baseOptions?: Apollo.QueryHookOptions<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>(FetchActiveMetroAreasDocument, options);
      }
export function useFetchActiveMetroAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>(FetchActiveMetroAreasDocument, options);
        }
export function useFetchActiveMetroAreasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>(FetchActiveMetroAreasDocument, options);
        }
export type FetchActiveMetroAreasQueryHookResult = ReturnType<typeof useFetchActiveMetroAreasQuery>;
export type FetchActiveMetroAreasLazyQueryHookResult = ReturnType<typeof useFetchActiveMetroAreasLazyQuery>;
export type FetchActiveMetroAreasSuspenseQueryHookResult = ReturnType<typeof useFetchActiveMetroAreasSuspenseQuery>;
export type FetchActiveMetroAreasQueryResult = Apollo.QueryResult<FetchActiveMetroAreasQuery, FetchActiveMetroAreasQueryVariables>;
export const UpdateBusinessCityStateDocument = gql`
    mutation UpdateBusinessCityState($businessId: Int!, $input: UpdateBusinessLocationInput!) {
  updateBusinessCityState(businessId: $businessId, input: $input) {
    id
  }
}
    `;
export type UpdateBusinessCityStateMutationFn = Apollo.MutationFunction<UpdateBusinessCityStateMutation, UpdateBusinessCityStateMutationVariables>;

/**
 * __useUpdateBusinessCityStateMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessCityStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessCityStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessCityStateMutation, { data, loading, error }] = useUpdateBusinessCityStateMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessCityStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessCityStateMutation, UpdateBusinessCityStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessCityStateMutation, UpdateBusinessCityStateMutationVariables>(UpdateBusinessCityStateDocument, options);
      }
export type UpdateBusinessCityStateMutationHookResult = ReturnType<typeof useUpdateBusinessCityStateMutation>;
export type UpdateBusinessCityStateMutationResult = Apollo.MutationResult<UpdateBusinessCityStateMutation>;
export type UpdateBusinessCityStateMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessCityStateMutation, UpdateBusinessCityStateMutationVariables>;
export const UpdateSearchAttributeDocument = gql`
    mutation UpdateSearchAttribute($businessId: Int!, $searchAttribute: SearchAttributeInput!) {
  updateSearchAttribute(
    businessId: $businessId
    searchAttribute: $searchAttribute
  )
}
    `;
export type UpdateSearchAttributeMutationFn = Apollo.MutationFunction<UpdateSearchAttributeMutation, UpdateSearchAttributeMutationVariables>;

/**
 * __useUpdateSearchAttributeMutation__
 *
 * To run a mutation, you first call `useUpdateSearchAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchAttributeMutation, { data, loading, error }] = useUpdateSearchAttributeMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      searchAttribute: // value for 'searchAttribute'
 *   },
 * });
 */
export function useUpdateSearchAttributeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSearchAttributeMutation, UpdateSearchAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSearchAttributeMutation, UpdateSearchAttributeMutationVariables>(UpdateSearchAttributeDocument, options);
      }
export type UpdateSearchAttributeMutationHookResult = ReturnType<typeof useUpdateSearchAttributeMutation>;
export type UpdateSearchAttributeMutationResult = Apollo.MutationResult<UpdateSearchAttributeMutation>;
export type UpdateSearchAttributeMutationOptions = Apollo.BaseMutationOptions<UpdateSearchAttributeMutation, UpdateSearchAttributeMutationVariables>;
export const FetchBusinessesDocument = gql`
    query FetchBusinesses {
  businesses {
    bookingsDisabled
    id
    businessGroup {
      name
    }
    isAuthorizedByTock
    domainName
    isDeleted
    name
    webUrl
    ticketsAvailableUntil
    unlisted
  }
}
    `;

/**
 * __useFetchBusinessesQuery__
 *
 * To run a query within a React component, call `useFetchBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBusinessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBusinessesQuery(baseOptions?: Apollo.QueryHookOptions<FetchBusinessesQuery, FetchBusinessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBusinessesQuery, FetchBusinessesQueryVariables>(FetchBusinessesDocument, options);
      }
export function useFetchBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBusinessesQuery, FetchBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBusinessesQuery, FetchBusinessesQueryVariables>(FetchBusinessesDocument, options);
        }
export function useFetchBusinessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBusinessesQuery, FetchBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBusinessesQuery, FetchBusinessesQueryVariables>(FetchBusinessesDocument, options);
        }
export type FetchBusinessesQueryHookResult = ReturnType<typeof useFetchBusinessesQuery>;
export type FetchBusinessesLazyQueryHookResult = ReturnType<typeof useFetchBusinessesLazyQuery>;
export type FetchBusinessesSuspenseQueryHookResult = ReturnType<typeof useFetchBusinessesSuspenseQuery>;
export type FetchBusinessesQueryResult = Apollo.QueryResult<FetchBusinessesQuery, FetchBusinessesQueryVariables>;
export const FormikTaxCategoryBusinessOverridesDocument = gql`
    query FormikTaxCategoryBusinessOverrides($input: String) {
  businessesPaginated(first: 5, query: $input) {
    edges {
      node {
        id
        ...BusinessSearchField_Business
      }
    }
  }
}
    ${BusinessSearchField_BusinessFragmentDoc}`;

/**
 * __useFormikTaxCategoryBusinessOverridesQuery__
 *
 * To run a query within a React component, call `useFormikTaxCategoryBusinessOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormikTaxCategoryBusinessOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormikTaxCategoryBusinessOverridesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormikTaxCategoryBusinessOverridesQuery(baseOptions?: Apollo.QueryHookOptions<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>(FormikTaxCategoryBusinessOverridesDocument, options);
      }
export function useFormikTaxCategoryBusinessOverridesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>(FormikTaxCategoryBusinessOverridesDocument, options);
        }
export function useFormikTaxCategoryBusinessOverridesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>(FormikTaxCategoryBusinessOverridesDocument, options);
        }
export type FormikTaxCategoryBusinessOverridesQueryHookResult = ReturnType<typeof useFormikTaxCategoryBusinessOverridesQuery>;
export type FormikTaxCategoryBusinessOverridesLazyQueryHookResult = ReturnType<typeof useFormikTaxCategoryBusinessOverridesLazyQuery>;
export type FormikTaxCategoryBusinessOverridesSuspenseQueryHookResult = ReturnType<typeof useFormikTaxCategoryBusinessOverridesSuspenseQuery>;
export type FormikTaxCategoryBusinessOverridesQueryResult = Apollo.QueryResult<FormikTaxCategoryBusinessOverridesQuery, FormikTaxCategoryBusinessOverridesQueryVariables>;
export const SingleTaxBusinessesDocument = gql`
    query SingleTaxBusinesses($first: Int!, $after: String!, $query: String!, $unlisted: Boolean!) {
  singleTaxBusinessesForSwitcher(
    first: $first
    after: $after
    query: $query
    unlisted: $unlisted
  ) {
    emailLogoUrl
    id
    location {
      city
      state
    }
    name
  }
}
    `;

/**
 * __useSingleTaxBusinessesQuery__
 *
 * To run a query within a React component, call `useSingleTaxBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleTaxBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleTaxBusinessesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      unlisted: // value for 'unlisted'
 *   },
 * });
 */
export function useSingleTaxBusinessesQuery(baseOptions: Apollo.QueryHookOptions<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables> & ({ variables: SingleTaxBusinessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>(SingleTaxBusinessesDocument, options);
      }
export function useSingleTaxBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>(SingleTaxBusinessesDocument, options);
        }
export function useSingleTaxBusinessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>(SingleTaxBusinessesDocument, options);
        }
export type SingleTaxBusinessesQueryHookResult = ReturnType<typeof useSingleTaxBusinessesQuery>;
export type SingleTaxBusinessesLazyQueryHookResult = ReturnType<typeof useSingleTaxBusinessesLazyQuery>;
export type SingleTaxBusinessesSuspenseQueryHookResult = ReturnType<typeof useSingleTaxBusinessesSuspenseQuery>;
export type SingleTaxBusinessesQueryResult = Apollo.QueryResult<SingleTaxBusinessesQuery, SingleTaxBusinessesQueryVariables>;
export const BusinessTaxMigrationDocument = gql`
    query BusinessTaxMigration($businessId: Int!) {
  singleTaxBusiness(businessId: $businessId) {
    ...businessTaxMigratorFields
  }
}
    ${BusinessTaxMigratorFieldsFragmentDoc}`;

/**
 * __useBusinessTaxMigrationQuery__
 *
 * To run a query within a React component, call `useBusinessTaxMigrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTaxMigrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTaxMigrationQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useBusinessTaxMigrationQuery(baseOptions: Apollo.QueryHookOptions<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables> & ({ variables: BusinessTaxMigrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>(BusinessTaxMigrationDocument, options);
      }
export function useBusinessTaxMigrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>(BusinessTaxMigrationDocument, options);
        }
export function useBusinessTaxMigrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>(BusinessTaxMigrationDocument, options);
        }
export type BusinessTaxMigrationQueryHookResult = ReturnType<typeof useBusinessTaxMigrationQuery>;
export type BusinessTaxMigrationLazyQueryHookResult = ReturnType<typeof useBusinessTaxMigrationLazyQuery>;
export type BusinessTaxMigrationSuspenseQueryHookResult = ReturnType<typeof useBusinessTaxMigrationSuspenseQuery>;
export type BusinessTaxMigrationQueryResult = Apollo.QueryResult<BusinessTaxMigrationQuery, BusinessTaxMigrationQueryVariables>;
export const MigrateBusinessToTaxLibraryDocument = gql`
    mutation MigrateBusinessToTaxLibrary($businessId: Int!) {
  updateBusinessToTaxLibrary(businessId: $businessId) {
    error {
      displayMessage
    }
    success
  }
}
    `;
export type MigrateBusinessToTaxLibraryMutationFn = Apollo.MutationFunction<MigrateBusinessToTaxLibraryMutation, MigrateBusinessToTaxLibraryMutationVariables>;

/**
 * __useMigrateBusinessToTaxLibraryMutation__
 *
 * To run a mutation, you first call `useMigrateBusinessToTaxLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateBusinessToTaxLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateBusinessToTaxLibraryMutation, { data, loading, error }] = useMigrateBusinessToTaxLibraryMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useMigrateBusinessToTaxLibraryMutation(baseOptions?: Apollo.MutationHookOptions<MigrateBusinessToTaxLibraryMutation, MigrateBusinessToTaxLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateBusinessToTaxLibraryMutation, MigrateBusinessToTaxLibraryMutationVariables>(MigrateBusinessToTaxLibraryDocument, options);
      }
export type MigrateBusinessToTaxLibraryMutationHookResult = ReturnType<typeof useMigrateBusinessToTaxLibraryMutation>;
export type MigrateBusinessToTaxLibraryMutationResult = Apollo.MutationResult<MigrateBusinessToTaxLibraryMutation>;
export type MigrateBusinessToTaxLibraryMutationOptions = Apollo.BaseMutationOptions<MigrateBusinessToTaxLibraryMutation, MigrateBusinessToTaxLibraryMutationVariables>;
export const OpenRequestsDocument = gql`
    query OpenRequests($since: Instant!) {
  temporaryPermissions {
    pending: requestsWithFilter(filter: {since: $since, statuses: [PENDING]}) {
      id
      ...temporaryPermissionsRequest
    }
    active: requestsWithFilter(filter: {statuses: [ACTIVE]}) {
      id
      ...temporaryPermissionsRequest
    }
    history: requestsWithFilter(filter: {since: $since, statuses: []}) {
      ...temporaryPermissionsRequest
    }
  }
}
    ${TemporaryPermissionsRequestFragmentDoc}`;

/**
 * __useOpenRequestsQuery__
 *
 * To run a query within a React component, call `useOpenRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenRequestsQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useOpenRequestsQuery(baseOptions: Apollo.QueryHookOptions<OpenRequestsQuery, OpenRequestsQueryVariables> & ({ variables: OpenRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenRequestsQuery, OpenRequestsQueryVariables>(OpenRequestsDocument, options);
      }
export function useOpenRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenRequestsQuery, OpenRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenRequestsQuery, OpenRequestsQueryVariables>(OpenRequestsDocument, options);
        }
export function useOpenRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OpenRequestsQuery, OpenRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenRequestsQuery, OpenRequestsQueryVariables>(OpenRequestsDocument, options);
        }
export type OpenRequestsQueryHookResult = ReturnType<typeof useOpenRequestsQuery>;
export type OpenRequestsLazyQueryHookResult = ReturnType<typeof useOpenRequestsLazyQuery>;
export type OpenRequestsSuspenseQueryHookResult = ReturnType<typeof useOpenRequestsSuspenseQuery>;
export type OpenRequestsQueryResult = Apollo.QueryResult<OpenRequestsQuery, OpenRequestsQueryVariables>;
export const GrantAccessDocument = gql`
    mutation GrantAccess($requestId: String!, $approved: Boolean!) {
  approveBusinessAccess(approved: $approved, requestId: $requestId)
}
    `;
export type GrantAccessMutationFn = Apollo.MutationFunction<GrantAccessMutation, GrantAccessMutationVariables>;

/**
 * __useGrantAccessMutation__
 *
 * To run a mutation, you first call `useGrantAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAccessMutation, { data, loading, error }] = useGrantAccessMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useGrantAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantAccessMutation, GrantAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantAccessMutation, GrantAccessMutationVariables>(GrantAccessDocument, options);
      }
export type GrantAccessMutationHookResult = ReturnType<typeof useGrantAccessMutation>;
export type GrantAccessMutationResult = Apollo.MutationResult<GrantAccessMutation>;
export type GrantAccessMutationOptions = Apollo.BaseMutationOptions<GrantAccessMutation, GrantAccessMutationVariables>;
export const DashboardAccessRouteDocument = gql`
    query DashboardAccessRoute($workflowId: String!) {
  temporaryPermissions {
    requestWorkflow(workflowId: $workflowId) {
      ...TemporaryPermissionRequest
    }
  }
}
    ${TemporaryPermissionRequestFragmentDoc}`;

/**
 * __useDashboardAccessRouteQuery__
 *
 * To run a query within a React component, call `useDashboardAccessRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardAccessRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardAccessRouteQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useDashboardAccessRouteQuery(baseOptions: Apollo.QueryHookOptions<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables> & ({ variables: DashboardAccessRouteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>(DashboardAccessRouteDocument, options);
      }
export function useDashboardAccessRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>(DashboardAccessRouteDocument, options);
        }
export function useDashboardAccessRouteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>(DashboardAccessRouteDocument, options);
        }
export type DashboardAccessRouteQueryHookResult = ReturnType<typeof useDashboardAccessRouteQuery>;
export type DashboardAccessRouteLazyQueryHookResult = ReturnType<typeof useDashboardAccessRouteLazyQuery>;
export type DashboardAccessRouteSuspenseQueryHookResult = ReturnType<typeof useDashboardAccessRouteSuspenseQuery>;
export type DashboardAccessRouteQueryResult = Apollo.QueryResult<DashboardAccessRouteQuery, DashboardAccessRouteQueryVariables>;
export const FetchAllExperimentsDocument = gql`
    query FetchAllExperiments {
  experiments {
    id
    ...experimentForList
  }
}
    ${ExperimentForListFragmentDoc}`;

/**
 * __useFetchAllExperimentsQuery__
 *
 * To run a query within a React component, call `useFetchAllExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllExperimentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllExperimentsQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>(FetchAllExperimentsDocument, options);
      }
export function useFetchAllExperimentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>(FetchAllExperimentsDocument, options);
        }
export function useFetchAllExperimentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>(FetchAllExperimentsDocument, options);
        }
export type FetchAllExperimentsQueryHookResult = ReturnType<typeof useFetchAllExperimentsQuery>;
export type FetchAllExperimentsLazyQueryHookResult = ReturnType<typeof useFetchAllExperimentsLazyQuery>;
export type FetchAllExperimentsSuspenseQueryHookResult = ReturnType<typeof useFetchAllExperimentsSuspenseQuery>;
export type FetchAllExperimentsQueryResult = Apollo.QueryResult<FetchAllExperimentsQuery, FetchAllExperimentsQueryVariables>;
export const CreateExperimentDocument = gql`
    mutation CreateExperiment($name: String!, $description: String!) {
  createExperiment(name: $name, description: $description) {
    id
    ...experimentForList
  }
}
    ${ExperimentForListFragmentDoc}`;
export type CreateExperimentMutationFn = Apollo.MutationFunction<CreateExperimentMutation, CreateExperimentMutationVariables>;

/**
 * __useCreateExperimentMutation__
 *
 * To run a mutation, you first call `useCreateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExperimentMutation, { data, loading, error }] = useCreateExperimentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateExperimentMutation(baseOptions?: Apollo.MutationHookOptions<CreateExperimentMutation, CreateExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExperimentMutation, CreateExperimentMutationVariables>(CreateExperimentDocument, options);
      }
export type CreateExperimentMutationHookResult = ReturnType<typeof useCreateExperimentMutation>;
export type CreateExperimentMutationResult = Apollo.MutationResult<CreateExperimentMutation>;
export type CreateExperimentMutationOptions = Apollo.BaseMutationOptions<CreateExperimentMutation, CreateExperimentMutationVariables>;
export const DeleteExperimentDocument = gql`
    mutation DeleteExperiment($id: Int!) {
  deleteExperiment(id: $id)
}
    `;
export type DeleteExperimentMutationFn = Apollo.MutationFunction<DeleteExperimentMutation, DeleteExperimentMutationVariables>;

/**
 * __useDeleteExperimentMutation__
 *
 * To run a mutation, you first call `useDeleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExperimentMutation, { data, loading, error }] = useDeleteExperimentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExperimentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExperimentMutation, DeleteExperimentMutationVariables>(DeleteExperimentDocument, options);
      }
export type DeleteExperimentMutationHookResult = ReturnType<typeof useDeleteExperimentMutation>;
export type DeleteExperimentMutationResult = Apollo.MutationResult<DeleteExperimentMutation>;
export type DeleteExperimentMutationOptions = Apollo.BaseMutationOptions<DeleteExperimentMutation, DeleteExperimentMutationVariables>;
export const SingleFeatureHistoryDocument = gql`
    query SingleFeatureHistory($id: Int!) {
  feature(id: $id) {
    id
    name
    description
    overridesCount
    historys {
      id
      state
      updatedAt
      editedByPatron {
        id
        firstName
        lastName
        email
      }
    }
    businessFeatures(onlyOverrides: true) {
      id
      ...singleBusinessFeature
    }
  }
}
    ${SingleBusinessFeatureFragmentDoc}`;

/**
 * __useSingleFeatureHistoryQuery__
 *
 * To run a query within a React component, call `useSingleFeatureHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleFeatureHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleFeatureHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleFeatureHistoryQuery(baseOptions: Apollo.QueryHookOptions<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables> & ({ variables: SingleFeatureHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>(SingleFeatureHistoryDocument, options);
      }
export function useSingleFeatureHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>(SingleFeatureHistoryDocument, options);
        }
export function useSingleFeatureHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>(SingleFeatureHistoryDocument, options);
        }
export type SingleFeatureHistoryQueryHookResult = ReturnType<typeof useSingleFeatureHistoryQuery>;
export type SingleFeatureHistoryLazyQueryHookResult = ReturnType<typeof useSingleFeatureHistoryLazyQuery>;
export type SingleFeatureHistorySuspenseQueryHookResult = ReturnType<typeof useSingleFeatureHistorySuspenseQuery>;
export type SingleFeatureHistoryQueryResult = Apollo.QueryResult<SingleFeatureHistoryQuery, SingleFeatureHistoryQueryVariables>;
export const SingleFeatureDocument = gql`
    query SingleFeature($id: Int!) {
  feature(id: $id) {
    id
    name
    overridesCount
    businessFeatures(onlyOverrides: true) {
      id
      ...singleBusinessFeature
    }
  }
}
    ${SingleBusinessFeatureFragmentDoc}`;

/**
 * __useSingleFeatureQuery__
 *
 * To run a query within a React component, call `useSingleFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleFeatureQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleFeatureQuery(baseOptions: Apollo.QueryHookOptions<SingleFeatureQuery, SingleFeatureQueryVariables> & ({ variables: SingleFeatureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleFeatureQuery, SingleFeatureQueryVariables>(SingleFeatureDocument, options);
      }
export function useSingleFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleFeatureQuery, SingleFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleFeatureQuery, SingleFeatureQueryVariables>(SingleFeatureDocument, options);
        }
export function useSingleFeatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleFeatureQuery, SingleFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleFeatureQuery, SingleFeatureQueryVariables>(SingleFeatureDocument, options);
        }
export type SingleFeatureQueryHookResult = ReturnType<typeof useSingleFeatureQuery>;
export type SingleFeatureLazyQueryHookResult = ReturnType<typeof useSingleFeatureLazyQuery>;
export type SingleFeatureSuspenseQueryHookResult = ReturnType<typeof useSingleFeatureSuspenseQuery>;
export type SingleFeatureQueryResult = Apollo.QueryResult<SingleFeatureQuery, SingleFeatureQueryVariables>;
export const FetchAllFeaturesDocument = gql`
    query FetchAllFeatures {
  features {
    id
    ...featureForList
  }
}
    ${FeatureForListFragmentDoc}`;

/**
 * __useFetchAllFeaturesQuery__
 *
 * To run a query within a React component, call `useFetchAllFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchAllFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchAllFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchAllFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>(FetchAllFeaturesDocument, options);
      }
export function useFetchAllFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>(FetchAllFeaturesDocument, options);
        }
export function useFetchAllFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>(FetchAllFeaturesDocument, options);
        }
export type FetchAllFeaturesQueryHookResult = ReturnType<typeof useFetchAllFeaturesQuery>;
export type FetchAllFeaturesLazyQueryHookResult = ReturnType<typeof useFetchAllFeaturesLazyQuery>;
export type FetchAllFeaturesSuspenseQueryHookResult = ReturnType<typeof useFetchAllFeaturesSuspenseQuery>;
export type FetchAllFeaturesQueryResult = Apollo.QueryResult<FetchAllFeaturesQuery, FetchAllFeaturesQueryVariables>;
export const UpdateBusinessFeatureDocument = gql`
    mutation UpdateBusinessFeature($businessId: Int!, $featureId: Int!, $state: BusinessFeatureState!) {
  updateBusinessFeature(
    businessId: $businessId
    featureId: $featureId
    state: $state
  ) {
    id
    ...singleBusinessFeature
  }
}
    ${SingleBusinessFeatureFragmentDoc}`;
export type UpdateBusinessFeatureMutationFn = Apollo.MutationFunction<UpdateBusinessFeatureMutation, UpdateBusinessFeatureMutationVariables>;

/**
 * __useUpdateBusinessFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessFeatureMutation, { data, loading, error }] = useUpdateBusinessFeatureMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      featureId: // value for 'featureId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateBusinessFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessFeatureMutation, UpdateBusinessFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessFeatureMutation, UpdateBusinessFeatureMutationVariables>(UpdateBusinessFeatureDocument, options);
      }
export type UpdateBusinessFeatureMutationHookResult = ReturnType<typeof useUpdateBusinessFeatureMutation>;
export type UpdateBusinessFeatureMutationResult = Apollo.MutationResult<UpdateBusinessFeatureMutation>;
export type UpdateBusinessFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessFeatureMutation, UpdateBusinessFeatureMutationVariables>;
export const BatchUpdateBusinessFeatureDocument = gql`
    mutation BatchUpdateBusinessFeature($businessIds: [Int!]!, $featureId: Int!, $state: BusinessFeatureState!) {
  batchUpdateBusinessFeature(
    businessIds: $businessIds
    featureId: $featureId
    state: $state
  ) {
    id
    ...singleBusinessFeature
  }
}
    ${SingleBusinessFeatureFragmentDoc}`;
export type BatchUpdateBusinessFeatureMutationFn = Apollo.MutationFunction<BatchUpdateBusinessFeatureMutation, BatchUpdateBusinessFeatureMutationVariables>;

/**
 * __useBatchUpdateBusinessFeatureMutation__
 *
 * To run a mutation, you first call `useBatchUpdateBusinessFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateBusinessFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateBusinessFeatureMutation, { data, loading, error }] = useBatchUpdateBusinessFeatureMutation({
 *   variables: {
 *      businessIds: // value for 'businessIds'
 *      featureId: // value for 'featureId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useBatchUpdateBusinessFeatureMutation(baseOptions?: Apollo.MutationHookOptions<BatchUpdateBusinessFeatureMutation, BatchUpdateBusinessFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchUpdateBusinessFeatureMutation, BatchUpdateBusinessFeatureMutationVariables>(BatchUpdateBusinessFeatureDocument, options);
      }
export type BatchUpdateBusinessFeatureMutationHookResult = ReturnType<typeof useBatchUpdateBusinessFeatureMutation>;
export type BatchUpdateBusinessFeatureMutationResult = Apollo.MutationResult<BatchUpdateBusinessFeatureMutation>;
export type BatchUpdateBusinessFeatureMutationOptions = Apollo.BaseMutationOptions<BatchUpdateBusinessFeatureMutation, BatchUpdateBusinessFeatureMutationVariables>;
export const RandomUpdateBusinessFeatureDocument = gql`
    mutation RandomUpdateBusinessFeature($featureId: Int!, $count: Int!, $state: BusinessFeatureState!) {
  updateBusinessFeatureRandom(featureId: $featureId, count: $count, state: $state) {
    id
    ...singleBusinessFeature
  }
}
    ${SingleBusinessFeatureFragmentDoc}`;
export type RandomUpdateBusinessFeatureMutationFn = Apollo.MutationFunction<RandomUpdateBusinessFeatureMutation, RandomUpdateBusinessFeatureMutationVariables>;

/**
 * __useRandomUpdateBusinessFeatureMutation__
 *
 * To run a mutation, you first call `useRandomUpdateBusinessFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRandomUpdateBusinessFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [randomUpdateBusinessFeatureMutation, { data, loading, error }] = useRandomUpdateBusinessFeatureMutation({
 *   variables: {
 *      featureId: // value for 'featureId'
 *      count: // value for 'count'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useRandomUpdateBusinessFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RandomUpdateBusinessFeatureMutation, RandomUpdateBusinessFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RandomUpdateBusinessFeatureMutation, RandomUpdateBusinessFeatureMutationVariables>(RandomUpdateBusinessFeatureDocument, options);
      }
export type RandomUpdateBusinessFeatureMutationHookResult = ReturnType<typeof useRandomUpdateBusinessFeatureMutation>;
export type RandomUpdateBusinessFeatureMutationResult = Apollo.MutationResult<RandomUpdateBusinessFeatureMutation>;
export type RandomUpdateBusinessFeatureMutationOptions = Apollo.BaseMutationOptions<RandomUpdateBusinessFeatureMutation, RandomUpdateBusinessFeatureMutationVariables>;
export const BusinessesForSwitcherDocument = gql`
    query BusinessesForSwitcher {
  businesses {
    id
    name
    location {
      city
      state
    }
    emailLogoUrl
  }
}
    `;

/**
 * __useBusinessesForSwitcherQuery__
 *
 * To run a query within a React component, call `useBusinessesForSwitcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessesForSwitcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessesForSwitcherQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessesForSwitcherQuery(baseOptions?: Apollo.QueryHookOptions<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>(BusinessesForSwitcherDocument, options);
      }
export function useBusinessesForSwitcherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>(BusinessesForSwitcherDocument, options);
        }
export function useBusinessesForSwitcherSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>(BusinessesForSwitcherDocument, options);
        }
export type BusinessesForSwitcherQueryHookResult = ReturnType<typeof useBusinessesForSwitcherQuery>;
export type BusinessesForSwitcherLazyQueryHookResult = ReturnType<typeof useBusinessesForSwitcherLazyQuery>;
export type BusinessesForSwitcherSuspenseQueryHookResult = ReturnType<typeof useBusinessesForSwitcherSuspenseQuery>;
export type BusinessesForSwitcherQueryResult = Apollo.QueryResult<BusinessesForSwitcherQuery, BusinessesForSwitcherQueryVariables>;
export const GuestProfileTagsByBusinessDocument = gql`
    query GuestProfileTagsByBusiness($businessId: Int!) {
  tagCountsByBusiness(businessId: $businessId) {
    ...GuestProfileTag
  }
}
    ${GuestProfileTagFragmentDoc}`;

/**
 * __useGuestProfileTagsByBusinessQuery__
 *
 * To run a query within a React component, call `useGuestProfileTagsByBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestProfileTagsByBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestProfileTagsByBusinessQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useGuestProfileTagsByBusinessQuery(baseOptions: Apollo.QueryHookOptions<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables> & ({ variables: GuestProfileTagsByBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>(GuestProfileTagsByBusinessDocument, options);
      }
export function useGuestProfileTagsByBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>(GuestProfileTagsByBusinessDocument, options);
        }
export function useGuestProfileTagsByBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>(GuestProfileTagsByBusinessDocument, options);
        }
export type GuestProfileTagsByBusinessQueryHookResult = ReturnType<typeof useGuestProfileTagsByBusinessQuery>;
export type GuestProfileTagsByBusinessLazyQueryHookResult = ReturnType<typeof useGuestProfileTagsByBusinessLazyQuery>;
export type GuestProfileTagsByBusinessSuspenseQueryHookResult = ReturnType<typeof useGuestProfileTagsByBusinessSuspenseQuery>;
export type GuestProfileTagsByBusinessQueryResult = Apollo.QueryResult<GuestProfileTagsByBusinessQuery, GuestProfileTagsByBusinessQueryVariables>;
export const BulkUpdateGuestProfileTagsDocument = gql`
    mutation BulkUpdateGuestProfileTags($businessId: Int!, $state: Boolean!, $tagName: String!) {
  updateGuestProfileTags(
    businessId: $businessId
    state: $state
    tagName: $tagName
  )
}
    `;
export type BulkUpdateGuestProfileTagsMutationFn = Apollo.MutationFunction<BulkUpdateGuestProfileTagsMutation, BulkUpdateGuestProfileTagsMutationVariables>;

/**
 * __useBulkUpdateGuestProfileTagsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateGuestProfileTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateGuestProfileTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateGuestProfileTagsMutation, { data, loading, error }] = useBulkUpdateGuestProfileTagsMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      state: // value for 'state'
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useBulkUpdateGuestProfileTagsMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateGuestProfileTagsMutation, BulkUpdateGuestProfileTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateGuestProfileTagsMutation, BulkUpdateGuestProfileTagsMutationVariables>(BulkUpdateGuestProfileTagsDocument, options);
      }
export type BulkUpdateGuestProfileTagsMutationHookResult = ReturnType<typeof useBulkUpdateGuestProfileTagsMutation>;
export type BulkUpdateGuestProfileTagsMutationResult = Apollo.MutationResult<BulkUpdateGuestProfileTagsMutation>;
export type BulkUpdateGuestProfileTagsMutationOptions = Apollo.BaseMutationOptions<BulkUpdateGuestProfileTagsMutation, BulkUpdateGuestProfileTagsMutationVariables>;
export const GetHelpMenuEntryByIdDocument = gql`
    query GetHelpMenuEntryById($helpMenuEntryById: Int!) {
  helpMenuEntry(id: $helpMenuEntryById) {
    bodyText
    createdAt
    effectiveDate
    features {
      name
    }
    headline
    helpCenterUrl
    id
    image {
      id
      imageBackingUrl
    }
    publicationStatus
    relevantInventoryType
    updatedAt
  }
}
    `;

/**
 * __useGetHelpMenuEntryByIdQuery__
 *
 * To run a query within a React component, call `useGetHelpMenuEntryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpMenuEntryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpMenuEntryByIdQuery({
 *   variables: {
 *      helpMenuEntryById: // value for 'helpMenuEntryById'
 *   },
 * });
 */
export function useGetHelpMenuEntryByIdQuery(baseOptions: Apollo.QueryHookOptions<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables> & ({ variables: GetHelpMenuEntryByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>(GetHelpMenuEntryByIdDocument, options);
      }
export function useGetHelpMenuEntryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>(GetHelpMenuEntryByIdDocument, options);
        }
export function useGetHelpMenuEntryByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>(GetHelpMenuEntryByIdDocument, options);
        }
export type GetHelpMenuEntryByIdQueryHookResult = ReturnType<typeof useGetHelpMenuEntryByIdQuery>;
export type GetHelpMenuEntryByIdLazyQueryHookResult = ReturnType<typeof useGetHelpMenuEntryByIdLazyQuery>;
export type GetHelpMenuEntryByIdSuspenseQueryHookResult = ReturnType<typeof useGetHelpMenuEntryByIdSuspenseQuery>;
export type GetHelpMenuEntryByIdQueryResult = Apollo.QueryResult<GetHelpMenuEntryByIdQuery, GetHelpMenuEntryByIdQueryVariables>;
export const GetFeaturesDocument = gql`
    query GetFeatures {
  features {
    name
  }
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export function useGetFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturesSuspenseQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const TicketTypesForBusinessDocument = gql`
    query TicketTypesForBusiness($businessId: Int!) {
  business(id: $businessId) {
    id
    name
    ticketTypes(archived: false) {
      id
      ...TicketTypeForMigratorExport
    }
  }
}
    ${TicketTypeForMigratorExportFragmentDoc}`;

/**
 * __useTicketTypesForBusinessQuery__
 *
 * To run a query within a React component, call `useTicketTypesForBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketTypesForBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketTypesForBusinessQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useTicketTypesForBusinessQuery(baseOptions: Apollo.QueryHookOptions<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables> & ({ variables: TicketTypesForBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>(TicketTypesForBusinessDocument, options);
      }
export function useTicketTypesForBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>(TicketTypesForBusinessDocument, options);
        }
export function useTicketTypesForBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>(TicketTypesForBusinessDocument, options);
        }
export type TicketTypesForBusinessQueryHookResult = ReturnType<typeof useTicketTypesForBusinessQuery>;
export type TicketTypesForBusinessLazyQueryHookResult = ReturnType<typeof useTicketTypesForBusinessLazyQuery>;
export type TicketTypesForBusinessSuspenseQueryHookResult = ReturnType<typeof useTicketTypesForBusinessSuspenseQuery>;
export type TicketTypesForBusinessQueryResult = Apollo.QueryResult<TicketTypesForBusinessQuery, TicketTypesForBusinessQueryVariables>;
export const UpdateMetaTagDocument = gql`
    mutation UpdateMetaTag($id: Int!, $name: String!, $isActive: Boolean!, $isInternal: Boolean!, $newExperienceIds: [Int!]!, $removeExperienceIds: [Int!]!, $newBusinessIds: [Int!]!, $removeBusinessIds: [Int!]!) {
  updateMetaTag(
    id: $id
    name: $name
    isActive: $isActive
    isInternal: $isInternal
    tagExperiences: $newExperienceIds
    removeExperiences: $removeExperienceIds
    tagBusinesses: $newBusinessIds
    removeTagBusinesses: $removeBusinessIds
  ) {
    id
    ...listMetaTag
  }
}
    ${ListMetaTagFragmentDoc}`;
export type UpdateMetaTagMutationFn = Apollo.MutationFunction<UpdateMetaTagMutation, UpdateMetaTagMutationVariables>;

/**
 * __useUpdateMetaTagMutation__
 *
 * To run a mutation, you first call `useUpdateMetaTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetaTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetaTagMutation, { data, loading, error }] = useUpdateMetaTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      isActive: // value for 'isActive'
 *      isInternal: // value for 'isInternal'
 *      newExperienceIds: // value for 'newExperienceIds'
 *      removeExperienceIds: // value for 'removeExperienceIds'
 *      newBusinessIds: // value for 'newBusinessIds'
 *      removeBusinessIds: // value for 'removeBusinessIds'
 *   },
 * });
 */
export function useUpdateMetaTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetaTagMutation, UpdateMetaTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetaTagMutation, UpdateMetaTagMutationVariables>(UpdateMetaTagDocument, options);
      }
export type UpdateMetaTagMutationHookResult = ReturnType<typeof useUpdateMetaTagMutation>;
export type UpdateMetaTagMutationResult = Apollo.MutationResult<UpdateMetaTagMutation>;
export type UpdateMetaTagMutationOptions = Apollo.BaseMutationOptions<UpdateMetaTagMutation, UpdateMetaTagMutationVariables>;
export const CreateMetaTagDocument = gql`
    mutation CreateMetaTag($name: String!, $isActive: Boolean!, $isInternal: Boolean!, $type: TagType!, $newExperienceIds: [Int!]!, $newBusinessIds: [Int!]!) {
  createMetaTag(
    name: $name
    isActive: $isActive
    isInternal: $isInternal
    type: $type
    tagExperiences: $newExperienceIds
    tagBusinesses: $newBusinessIds
  ) {
    id
    ...listMetaTag
  }
}
    ${ListMetaTagFragmentDoc}`;
export type CreateMetaTagMutationFn = Apollo.MutationFunction<CreateMetaTagMutation, CreateMetaTagMutationVariables>;

/**
 * __useCreateMetaTagMutation__
 *
 * To run a mutation, you first call `useCreateMetaTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMetaTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMetaTagMutation, { data, loading, error }] = useCreateMetaTagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      isActive: // value for 'isActive'
 *      isInternal: // value for 'isInternal'
 *      type: // value for 'type'
 *      newExperienceIds: // value for 'newExperienceIds'
 *      newBusinessIds: // value for 'newBusinessIds'
 *   },
 * });
 */
export function useCreateMetaTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateMetaTagMutation, CreateMetaTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMetaTagMutation, CreateMetaTagMutationVariables>(CreateMetaTagDocument, options);
      }
export type CreateMetaTagMutationHookResult = ReturnType<typeof useCreateMetaTagMutation>;
export type CreateMetaTagMutationResult = Apollo.MutationResult<CreateMetaTagMutation>;
export type CreateMetaTagMutationOptions = Apollo.BaseMutationOptions<CreateMetaTagMutation, CreateMetaTagMutationVariables>;
export const MetaTagsByTagTypeInternalDocument = gql`
    query MetaTagsByTagTypeInternal($tagTypes: [TagType!]!) {
  metaTagsByTagTypeInternal(tagTypes: $tagTypes) {
    id
    ...listMetaTag
  }
}
    ${ListMetaTagFragmentDoc}`;

/**
 * __useMetaTagsByTagTypeInternalQuery__
 *
 * To run a query within a React component, call `useMetaTagsByTagTypeInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaTagsByTagTypeInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaTagsByTagTypeInternalQuery({
 *   variables: {
 *      tagTypes: // value for 'tagTypes'
 *   },
 * });
 */
export function useMetaTagsByTagTypeInternalQuery(baseOptions: Apollo.QueryHookOptions<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables> & ({ variables: MetaTagsByTagTypeInternalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>(MetaTagsByTagTypeInternalDocument, options);
      }
export function useMetaTagsByTagTypeInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>(MetaTagsByTagTypeInternalDocument, options);
        }
export function useMetaTagsByTagTypeInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>(MetaTagsByTagTypeInternalDocument, options);
        }
export type MetaTagsByTagTypeInternalQueryHookResult = ReturnType<typeof useMetaTagsByTagTypeInternalQuery>;
export type MetaTagsByTagTypeInternalLazyQueryHookResult = ReturnType<typeof useMetaTagsByTagTypeInternalLazyQuery>;
export type MetaTagsByTagTypeInternalSuspenseQueryHookResult = ReturnType<typeof useMetaTagsByTagTypeInternalSuspenseQuery>;
export type MetaTagsByTagTypeInternalQueryResult = Apollo.QueryResult<MetaTagsByTagTypeInternalQuery, MetaTagsByTagTypeInternalQueryVariables>;
export const TicketTypeMetaTagsInternalDocument = gql`
    query TicketTypeMetaTagsInternal {
  ticketTypeMetaTagsInternal {
    id
    ...listMetaTag
  }
}
    ${ListMetaTagFragmentDoc}`;

/**
 * __useTicketTypeMetaTagsInternalQuery__
 *
 * To run a query within a React component, call `useTicketTypeMetaTagsInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketTypeMetaTagsInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketTypeMetaTagsInternalQuery({
 *   variables: {
 *   },
 * });
 */
export function useTicketTypeMetaTagsInternalQuery(baseOptions?: Apollo.QueryHookOptions<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>(TicketTypeMetaTagsInternalDocument, options);
      }
export function useTicketTypeMetaTagsInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>(TicketTypeMetaTagsInternalDocument, options);
        }
export function useTicketTypeMetaTagsInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>(TicketTypeMetaTagsInternalDocument, options);
        }
export type TicketTypeMetaTagsInternalQueryHookResult = ReturnType<typeof useTicketTypeMetaTagsInternalQuery>;
export type TicketTypeMetaTagsInternalLazyQueryHookResult = ReturnType<typeof useTicketTypeMetaTagsInternalLazyQuery>;
export type TicketTypeMetaTagsInternalSuspenseQueryHookResult = ReturnType<typeof useTicketTypeMetaTagsInternalSuspenseQuery>;
export type TicketTypeMetaTagsInternalQueryResult = Apollo.QueryResult<TicketTypeMetaTagsInternalQuery, TicketTypeMetaTagsInternalQueryVariables>;
export const CreateTockApiKeyDocument = gql`
    mutation CreateTockApiKey($keyType: KeyType!, $patronId: Int!, $description: String!, $contactEmail: String!) {
  createTockApiKey(
    tockApiKeyGenerationRequest: {keyType: $keyType, requestingPatronId: $patronId, description: $description, contactEmail: $contactEmail}
  )
}
    `;
export type CreateTockApiKeyMutationFn = Apollo.MutationFunction<CreateTockApiKeyMutation, CreateTockApiKeyMutationVariables>;

/**
 * __useCreateTockApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateTockApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTockApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTockApiKeyMutation, { data, loading, error }] = useCreateTockApiKeyMutation({
 *   variables: {
 *      keyType: // value for 'keyType'
 *      patronId: // value for 'patronId'
 *      description: // value for 'description'
 *      contactEmail: // value for 'contactEmail'
 *   },
 * });
 */
export function useCreateTockApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateTockApiKeyMutation, CreateTockApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTockApiKeyMutation, CreateTockApiKeyMutationVariables>(CreateTockApiKeyDocument, options);
      }
export type CreateTockApiKeyMutationHookResult = ReturnType<typeof useCreateTockApiKeyMutation>;
export type CreateTockApiKeyMutationResult = Apollo.MutationResult<CreateTockApiKeyMutation>;
export type CreateTockApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateTockApiKeyMutation, CreateTockApiKeyMutationVariables>;
export const UpdateTockApiKeyStatusDocument = gql`
    mutation UpdateTockApiKeyStatus($uuid: String!, $isEnabled: Boolean!) {
  updateKeyStatus(keyUUID: $uuid, isEnabled: $isEnabled)
}
    `;
export type UpdateTockApiKeyStatusMutationFn = Apollo.MutationFunction<UpdateTockApiKeyStatusMutation, UpdateTockApiKeyStatusMutationVariables>;

/**
 * __useUpdateTockApiKeyStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTockApiKeyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTockApiKeyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTockApiKeyStatusMutation, { data, loading, error }] = useUpdateTockApiKeyStatusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdateTockApiKeyStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTockApiKeyStatusMutation, UpdateTockApiKeyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTockApiKeyStatusMutation, UpdateTockApiKeyStatusMutationVariables>(UpdateTockApiKeyStatusDocument, options);
      }
export type UpdateTockApiKeyStatusMutationHookResult = ReturnType<typeof useUpdateTockApiKeyStatusMutation>;
export type UpdateTockApiKeyStatusMutationResult = Apollo.MutationResult<UpdateTockApiKeyStatusMutation>;
export type UpdateTockApiKeyStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTockApiKeyStatusMutation, UpdateTockApiKeyStatusMutationVariables>;
export const GetAllTockApiKeyDocument = gql`
    query GetAllTockApiKey {
  allApiKeys {
    uuid
    keyType
    status
    createdAt
    createdByPatron {
      firstName
      lastName
    }
    description
    contactEmail
  }
}
    `;

/**
 * __useGetAllTockApiKeyQuery__
 *
 * To run a query within a React component, call `useGetAllTockApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTockApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTockApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTockApiKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>(GetAllTockApiKeyDocument, options);
      }
export function useGetAllTockApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>(GetAllTockApiKeyDocument, options);
        }
export function useGetAllTockApiKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>(GetAllTockApiKeyDocument, options);
        }
export type GetAllTockApiKeyQueryHookResult = ReturnType<typeof useGetAllTockApiKeyQuery>;
export type GetAllTockApiKeyLazyQueryHookResult = ReturnType<typeof useGetAllTockApiKeyLazyQuery>;
export type GetAllTockApiKeySuspenseQueryHookResult = ReturnType<typeof useGetAllTockApiKeySuspenseQuery>;
export type GetAllTockApiKeyQueryResult = Apollo.QueryResult<GetAllTockApiKeyQuery, GetAllTockApiKeyQueryVariables>;
export const GetTockTenConfigsDocument = gql`
    query GetTockTenConfigs {
  tockTenConfigs {
    id
    name
    description
    image {
      imageUrl
    }
    businesss {
      id
      name
    }
    marketingUrl
    isArchived
  }
}
    `;

/**
 * __useGetTockTenConfigsQuery__
 *
 * To run a query within a React component, call `useGetTockTenConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTockTenConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTockTenConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTockTenConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>(GetTockTenConfigsDocument, options);
      }
export function useGetTockTenConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>(GetTockTenConfigsDocument, options);
        }
export function useGetTockTenConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>(GetTockTenConfigsDocument, options);
        }
export type GetTockTenConfigsQueryHookResult = ReturnType<typeof useGetTockTenConfigsQuery>;
export type GetTockTenConfigsLazyQueryHookResult = ReturnType<typeof useGetTockTenConfigsLazyQuery>;
export type GetTockTenConfigsSuspenseQueryHookResult = ReturnType<typeof useGetTockTenConfigsSuspenseQuery>;
export type GetTockTenConfigsQueryResult = Apollo.QueryResult<GetTockTenConfigsQuery, GetTockTenConfigsQueryVariables>;
export const CreateTockTenListDocument = gql`
    mutation CreateTockTenList($name: String!, $description: String, $uploadedImageId: Int!, $businessIds: [Int!]!, $marketingUrl: String!) {
  createTockTenList(
    tockTen: {name: $name, description: $description, uploadedImageId: $uploadedImageId, businessIds: $businessIds, marketingUrl: $marketingUrl}
  )
}
    `;
export type CreateTockTenListMutationFn = Apollo.MutationFunction<CreateTockTenListMutation, CreateTockTenListMutationVariables>;

/**
 * __useCreateTockTenListMutation__
 *
 * To run a mutation, you first call `useCreateTockTenListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTockTenListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTockTenListMutation, { data, loading, error }] = useCreateTockTenListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      uploadedImageId: // value for 'uploadedImageId'
 *      businessIds: // value for 'businessIds'
 *      marketingUrl: // value for 'marketingUrl'
 *   },
 * });
 */
export function useCreateTockTenListMutation(baseOptions?: Apollo.MutationHookOptions<CreateTockTenListMutation, CreateTockTenListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTockTenListMutation, CreateTockTenListMutationVariables>(CreateTockTenListDocument, options);
      }
export type CreateTockTenListMutationHookResult = ReturnType<typeof useCreateTockTenListMutation>;
export type CreateTockTenListMutationResult = Apollo.MutationResult<CreateTockTenListMutation>;
export type CreateTockTenListMutationOptions = Apollo.BaseMutationOptions<CreateTockTenListMutation, CreateTockTenListMutationVariables>;
export const UpdateTockTenListDocument = gql`
    mutation UpdateTockTenList($id: Int!, $isArchived: Boolean!, $isDeleted: Boolean!) {
  updateTockTenList(id: $id, isArchived: $isArchived, isDeleted: $isDeleted)
}
    `;
export type UpdateTockTenListMutationFn = Apollo.MutationFunction<UpdateTockTenListMutation, UpdateTockTenListMutationVariables>;

/**
 * __useUpdateTockTenListMutation__
 *
 * To run a mutation, you first call `useUpdateTockTenListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTockTenListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTockTenListMutation, { data, loading, error }] = useUpdateTockTenListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useUpdateTockTenListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTockTenListMutation, UpdateTockTenListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTockTenListMutation, UpdateTockTenListMutationVariables>(UpdateTockTenListDocument, options);
      }
export type UpdateTockTenListMutationHookResult = ReturnType<typeof useUpdateTockTenListMutation>;
export type UpdateTockTenListMutationResult = Apollo.MutationResult<UpdateTockTenListMutation>;
export type UpdateTockTenListMutationOptions = Apollo.BaseMutationOptions<UpdateTockTenListMutation, UpdateTockTenListMutationVariables>;
export const MetaTagsByTaggableInternalDocument = gql`
    query MetaTagsByTaggableInternal {
  ticketTypeMetaTagsInternal {
    id
    ...simpleMetaTag
  }
  businessMetaTagsInternal {
    id
    ...simpleMetaTag
  }
}
    ${SimpleMetaTagFragmentDoc}`;

/**
 * __useMetaTagsByTaggableInternalQuery__
 *
 * To run a query within a React component, call `useMetaTagsByTaggableInternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaTagsByTaggableInternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaTagsByTaggableInternalQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetaTagsByTaggableInternalQuery(baseOptions?: Apollo.QueryHookOptions<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>(MetaTagsByTaggableInternalDocument, options);
      }
export function useMetaTagsByTaggableInternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>(MetaTagsByTaggableInternalDocument, options);
        }
export function useMetaTagsByTaggableInternalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>(MetaTagsByTaggableInternalDocument, options);
        }
export type MetaTagsByTaggableInternalQueryHookResult = ReturnType<typeof useMetaTagsByTaggableInternalQuery>;
export type MetaTagsByTaggableInternalLazyQueryHookResult = ReturnType<typeof useMetaTagsByTaggableInternalLazyQuery>;
export type MetaTagsByTaggableInternalSuspenseQueryHookResult = ReturnType<typeof useMetaTagsByTaggableInternalSuspenseQuery>;
export type MetaTagsByTaggableInternalQueryResult = Apollo.QueryResult<MetaTagsByTaggableInternalQuery, MetaTagsByTaggableInternalQueryVariables>;
export const ResendBankVerificationDepositsDocument = gql`
    mutation ResendBankVerificationDeposits($businessId: Int!) {
  resendBankVerificationDeposits(businessId: $businessId)
}
    `;
export type ResendBankVerificationDepositsMutationFn = Apollo.MutationFunction<ResendBankVerificationDepositsMutation, ResendBankVerificationDepositsMutationVariables>;

/**
 * __useResendBankVerificationDepositsMutation__
 *
 * To run a mutation, you first call `useResendBankVerificationDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBankVerificationDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBankVerificationDepositsMutation, { data, loading, error }] = useResendBankVerificationDepositsMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useResendBankVerificationDepositsMutation(baseOptions?: Apollo.MutationHookOptions<ResendBankVerificationDepositsMutation, ResendBankVerificationDepositsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendBankVerificationDepositsMutation, ResendBankVerificationDepositsMutationVariables>(ResendBankVerificationDepositsDocument, options);
      }
export type ResendBankVerificationDepositsMutationHookResult = ReturnType<typeof useResendBankVerificationDepositsMutation>;
export type ResendBankVerificationDepositsMutationResult = Apollo.MutationResult<ResendBankVerificationDepositsMutation>;
export type ResendBankVerificationDepositsMutationOptions = Apollo.BaseMutationOptions<ResendBankVerificationDepositsMutation, ResendBankVerificationDepositsMutationVariables>;
export const ReverseInvoiceDocument = gql`
    mutation ReverseInvoice($id: Int!, $forcePayoutRemoval: Boolean!) {
  reverseInvoice(forcePayoutRemoval: $forcePayoutRemoval, id: $id)
}
    `;
export type ReverseInvoiceMutationFn = Apollo.MutationFunction<ReverseInvoiceMutation, ReverseInvoiceMutationVariables>;

/**
 * __useReverseInvoiceMutation__
 *
 * To run a mutation, you first call `useReverseInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseInvoiceMutation, { data, loading, error }] = useReverseInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forcePayoutRemoval: // value for 'forcePayoutRemoval'
 *   },
 * });
 */
export function useReverseInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ReverseInvoiceMutation, ReverseInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseInvoiceMutation, ReverseInvoiceMutationVariables>(ReverseInvoiceDocument, options);
      }
export type ReverseInvoiceMutationHookResult = ReturnType<typeof useReverseInvoiceMutation>;
export type ReverseInvoiceMutationResult = Apollo.MutationResult<ReverseInvoiceMutation>;
export type ReverseInvoiceMutationOptions = Apollo.BaseMutationOptions<ReverseInvoiceMutation, ReverseInvoiceMutationVariables>;
export const MarkInvoiceAsPaidByCheckDocument = gql`
    mutation MarkInvoiceAsPaidByCheck($invoiceId: Int!) {
  markInvoiceAsPaidByCheck(invoiceId: $invoiceId)
}
    `;
export type MarkInvoiceAsPaidByCheckMutationFn = Apollo.MutationFunction<MarkInvoiceAsPaidByCheckMutation, MarkInvoiceAsPaidByCheckMutationVariables>;

/**
 * __useMarkInvoiceAsPaidByCheckMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidByCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidByCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidByCheckMutation, { data, loading, error }] = useMarkInvoiceAsPaidByCheckMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidByCheckMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidByCheckMutation, MarkInvoiceAsPaidByCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidByCheckMutation, MarkInvoiceAsPaidByCheckMutationVariables>(MarkInvoiceAsPaidByCheckDocument, options);
      }
export type MarkInvoiceAsPaidByCheckMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidByCheckMutation>;
export type MarkInvoiceAsPaidByCheckMutationResult = Apollo.MutationResult<MarkInvoiceAsPaidByCheckMutation>;
export type MarkInvoiceAsPaidByCheckMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsPaidByCheckMutation, MarkInvoiceAsPaidByCheckMutationVariables>;
export const SetSubscriptionToPaidByCheckDocument = gql`
    mutation SetSubscriptionToPaidByCheck($businessId: Int!) {
  setSubscriptionToPaidByCheck(businessId: $businessId)
}
    `;
export type SetSubscriptionToPaidByCheckMutationFn = Apollo.MutationFunction<SetSubscriptionToPaidByCheckMutation, SetSubscriptionToPaidByCheckMutationVariables>;

/**
 * __useSetSubscriptionToPaidByCheckMutation__
 *
 * To run a mutation, you first call `useSetSubscriptionToPaidByCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSubscriptionToPaidByCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSubscriptionToPaidByCheckMutation, { data, loading, error }] = useSetSubscriptionToPaidByCheckMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useSetSubscriptionToPaidByCheckMutation(baseOptions?: Apollo.MutationHookOptions<SetSubscriptionToPaidByCheckMutation, SetSubscriptionToPaidByCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSubscriptionToPaidByCheckMutation, SetSubscriptionToPaidByCheckMutationVariables>(SetSubscriptionToPaidByCheckDocument, options);
      }
export type SetSubscriptionToPaidByCheckMutationHookResult = ReturnType<typeof useSetSubscriptionToPaidByCheckMutation>;
export type SetSubscriptionToPaidByCheckMutationResult = Apollo.MutationResult<SetSubscriptionToPaidByCheckMutation>;
export type SetSubscriptionToPaidByCheckMutationOptions = Apollo.BaseMutationOptions<SetSubscriptionToPaidByCheckMutation, SetSubscriptionToPaidByCheckMutationVariables>;
export const UpdateBusinessPayoutConfigDocument = gql`
    mutation UpdateBusinessPayoutConfig($businessPayoutConfig: BusinessPayoutConfigInput!) {
  updateBusinessPayoutConfig(businessPayoutConfig: $businessPayoutConfig) {
    id
  }
}
    `;
export type UpdateBusinessPayoutConfigMutationFn = Apollo.MutationFunction<UpdateBusinessPayoutConfigMutation, UpdateBusinessPayoutConfigMutationVariables>;

/**
 * __useUpdateBusinessPayoutConfigMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessPayoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessPayoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessPayoutConfigMutation, { data, loading, error }] = useUpdateBusinessPayoutConfigMutation({
 *   variables: {
 *      businessPayoutConfig: // value for 'businessPayoutConfig'
 *   },
 * });
 */
export function useUpdateBusinessPayoutConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessPayoutConfigMutation, UpdateBusinessPayoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessPayoutConfigMutation, UpdateBusinessPayoutConfigMutationVariables>(UpdateBusinessPayoutConfigDocument, options);
      }
export type UpdateBusinessPayoutConfigMutationHookResult = ReturnType<typeof useUpdateBusinessPayoutConfigMutation>;
export type UpdateBusinessPayoutConfigMutationResult = Apollo.MutationResult<UpdateBusinessPayoutConfigMutation>;
export type UpdateBusinessPayoutConfigMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessPayoutConfigMutation, UpdateBusinessPayoutConfigMutationVariables>;
export const ReverseBusinessPayoutDocument = gql`
    mutation ReverseBusinessPayout($payoutId: Int!, $businessId: Int!) {
  reverseBusinessPayout(payoutId: $payoutId, businessId: $businessId)
}
    `;
export type ReverseBusinessPayoutMutationFn = Apollo.MutationFunction<ReverseBusinessPayoutMutation, ReverseBusinessPayoutMutationVariables>;

/**
 * __useReverseBusinessPayoutMutation__
 *
 * To run a mutation, you first call `useReverseBusinessPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseBusinessPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseBusinessPayoutMutation, { data, loading, error }] = useReverseBusinessPayoutMutation({
 *   variables: {
 *      payoutId: // value for 'payoutId'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useReverseBusinessPayoutMutation(baseOptions?: Apollo.MutationHookOptions<ReverseBusinessPayoutMutation, ReverseBusinessPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseBusinessPayoutMutation, ReverseBusinessPayoutMutationVariables>(ReverseBusinessPayoutDocument, options);
      }
export type ReverseBusinessPayoutMutationHookResult = ReturnType<typeof useReverseBusinessPayoutMutation>;
export type ReverseBusinessPayoutMutationResult = Apollo.MutationResult<ReverseBusinessPayoutMutation>;
export type ReverseBusinessPayoutMutationOptions = Apollo.BaseMutationOptions<ReverseBusinessPayoutMutation, ReverseBusinessPayoutMutationVariables>;
export const ReimburseBusinessThroughStripeDocument = gql`
    mutation ReimburseBusinessThroughStripe($businessId: Int!, $amountCents: Int!, $description: String!, $creditCardId: String!) {
  reimburseBusinessThroughStripe(
    businessId: $businessId
    amountCents: $amountCents
    description: $description
    creditCardId: $creditCardId
  )
}
    `;
export type ReimburseBusinessThroughStripeMutationFn = Apollo.MutationFunction<ReimburseBusinessThroughStripeMutation, ReimburseBusinessThroughStripeMutationVariables>;

/**
 * __useReimburseBusinessThroughStripeMutation__
 *
 * To run a mutation, you first call `useReimburseBusinessThroughStripeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReimburseBusinessThroughStripeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reimburseBusinessThroughStripeMutation, { data, loading, error }] = useReimburseBusinessThroughStripeMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      amountCents: // value for 'amountCents'
 *      description: // value for 'description'
 *      creditCardId: // value for 'creditCardId'
 *   },
 * });
 */
export function useReimburseBusinessThroughStripeMutation(baseOptions?: Apollo.MutationHookOptions<ReimburseBusinessThroughStripeMutation, ReimburseBusinessThroughStripeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReimburseBusinessThroughStripeMutation, ReimburseBusinessThroughStripeMutationVariables>(ReimburseBusinessThroughStripeDocument, options);
      }
export type ReimburseBusinessThroughStripeMutationHookResult = ReturnType<typeof useReimburseBusinessThroughStripeMutation>;
export type ReimburseBusinessThroughStripeMutationResult = Apollo.MutationResult<ReimburseBusinessThroughStripeMutation>;
export type ReimburseBusinessThroughStripeMutationOptions = Apollo.BaseMutationOptions<ReimburseBusinessThroughStripeMutation, ReimburseBusinessThroughStripeMutationVariables>;
export const FinanceBusinessDocument = gql`
    query FinanceBusiness($id: Int!) {
  business(id: $id) {
    id
    ...financeBusinessFields
    ...payoutConfigFields
  }
}
    ${FinanceBusinessFieldsFragmentDoc}
${PayoutConfigFieldsFragmentDoc}`;

/**
 * __useFinanceBusinessQuery__
 *
 * To run a query within a React component, call `useFinanceBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinanceBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinanceBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinanceBusinessQuery(baseOptions: Apollo.QueryHookOptions<FinanceBusinessQuery, FinanceBusinessQueryVariables> & ({ variables: FinanceBusinessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinanceBusinessQuery, FinanceBusinessQueryVariables>(FinanceBusinessDocument, options);
      }
export function useFinanceBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinanceBusinessQuery, FinanceBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinanceBusinessQuery, FinanceBusinessQueryVariables>(FinanceBusinessDocument, options);
        }
export function useFinanceBusinessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinanceBusinessQuery, FinanceBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinanceBusinessQuery, FinanceBusinessQueryVariables>(FinanceBusinessDocument, options);
        }
export type FinanceBusinessQueryHookResult = ReturnType<typeof useFinanceBusinessQuery>;
export type FinanceBusinessLazyQueryHookResult = ReturnType<typeof useFinanceBusinessLazyQuery>;
export type FinanceBusinessSuspenseQueryHookResult = ReturnType<typeof useFinanceBusinessSuspenseQuery>;
export type FinanceBusinessQueryResult = Apollo.QueryResult<FinanceBusinessQuery, FinanceBusinessQueryVariables>;
export const ImportStatusDocument = gql`
    subscription ImportStatus($businessId: Int!) {
  importStatus(businessId: $businessId) {
    ...importStatusFields
  }
}
    ${ImportStatusFieldsFragmentDoc}`;

/**
 * __useImportStatusSubscription__
 *
 * To run a query within a React component, call `useImportStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useImportStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportStatusSubscription({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useImportStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<ImportStatusSubscription, ImportStatusSubscriptionVariables> & ({ variables: ImportStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ImportStatusSubscription, ImportStatusSubscriptionVariables>(ImportStatusDocument, options);
      }
export type ImportStatusSubscriptionHookResult = ReturnType<typeof useImportStatusSubscription>;
export type ImportStatusSubscriptionResult = Apollo.SubscriptionResult<ImportStatusSubscription>;
export const StartUndoImportDocument = gql`
    mutation StartUndoImport($importUuid: UUID!, $businessId: Int!, $maxConcurrentTasks: Int!) {
  startImportUndo(
    importUuid: $importUuid
    businessId: $businessId
    maxConcurrentTasks: $maxConcurrentTasks
  ) {
    started
  }
}
    `;
export type StartUndoImportMutationFn = Apollo.MutationFunction<StartUndoImportMutation, StartUndoImportMutationVariables>;

/**
 * __useStartUndoImportMutation__
 *
 * To run a mutation, you first call `useStartUndoImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartUndoImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startUndoImportMutation, { data, loading, error }] = useStartUndoImportMutation({
 *   variables: {
 *      importUuid: // value for 'importUuid'
 *      businessId: // value for 'businessId'
 *      maxConcurrentTasks: // value for 'maxConcurrentTasks'
 *   },
 * });
 */
export function useStartUndoImportMutation(baseOptions?: Apollo.MutationHookOptions<StartUndoImportMutation, StartUndoImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartUndoImportMutation, StartUndoImportMutationVariables>(StartUndoImportDocument, options);
      }
export type StartUndoImportMutationHookResult = ReturnType<typeof useStartUndoImportMutation>;
export type StartUndoImportMutationResult = Apollo.MutationResult<StartUndoImportMutation>;
export type StartUndoImportMutationOptions = Apollo.BaseMutationOptions<StartUndoImportMutation, StartUndoImportMutationVariables>;
export const PauseOrContinueWorkflowDocument = gql`
    mutation PauseOrContinueWorkflow($businessId: Int!, $pause: Boolean!) {
  pauseOrContinueWorkflow(businessId: $businessId, pause: $pause) {
    ...importStatusFields
  }
}
    ${ImportStatusFieldsFragmentDoc}`;
export type PauseOrContinueWorkflowMutationFn = Apollo.MutationFunction<PauseOrContinueWorkflowMutation, PauseOrContinueWorkflowMutationVariables>;

/**
 * __usePauseOrContinueWorkflowMutation__
 *
 * To run a mutation, you first call `usePauseOrContinueWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseOrContinueWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseOrContinueWorkflowMutation, { data, loading, error }] = usePauseOrContinueWorkflowMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      pause: // value for 'pause'
 *   },
 * });
 */
export function usePauseOrContinueWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<PauseOrContinueWorkflowMutation, PauseOrContinueWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseOrContinueWorkflowMutation, PauseOrContinueWorkflowMutationVariables>(PauseOrContinueWorkflowDocument, options);
      }
export type PauseOrContinueWorkflowMutationHookResult = ReturnType<typeof usePauseOrContinueWorkflowMutation>;
export type PauseOrContinueWorkflowMutationResult = Apollo.MutationResult<PauseOrContinueWorkflowMutation>;
export type PauseOrContinueWorkflowMutationOptions = Apollo.BaseMutationOptions<PauseOrContinueWorkflowMutation, PauseOrContinueWorkflowMutationVariables>;
export const UndoImportDocument = gql`
    subscription UndoImport($businessId: Int!) {
  undoImport(businessId: $businessId) {
    ...importUndoResponseFields
  }
}
    ${ImportUndoResponseFieldsFragmentDoc}`;

/**
 * __useUndoImportSubscription__
 *
 * To run a query within a React component, call `useUndoImportSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUndoImportSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUndoImportSubscription({
 *   variables: {
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useUndoImportSubscription(baseOptions: Apollo.SubscriptionHookOptions<UndoImportSubscription, UndoImportSubscriptionVariables> & ({ variables: UndoImportSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UndoImportSubscription, UndoImportSubscriptionVariables>(UndoImportDocument, options);
      }
export type UndoImportSubscriptionHookResult = ReturnType<typeof useUndoImportSubscription>;
export type UndoImportSubscriptionResult = Apollo.SubscriptionResult<UndoImportSubscription>;
export const FetchBusinessGroupsDocument = gql`
    query FetchBusinessGroups {
  businessGroups {
    ...BusinessGroupInfo
  }
}
    ${BusinessGroupInfoFragmentDoc}`;

/**
 * __useFetchBusinessGroupsQuery__
 *
 * To run a query within a React component, call `useFetchBusinessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBusinessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBusinessGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBusinessGroupsQuery(baseOptions?: Apollo.QueryHookOptions<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>(FetchBusinessGroupsDocument, options);
      }
export function useFetchBusinessGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>(FetchBusinessGroupsDocument, options);
        }
export function useFetchBusinessGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>(FetchBusinessGroupsDocument, options);
        }
export type FetchBusinessGroupsQueryHookResult = ReturnType<typeof useFetchBusinessGroupsQuery>;
export type FetchBusinessGroupsLazyQueryHookResult = ReturnType<typeof useFetchBusinessGroupsLazyQuery>;
export type FetchBusinessGroupsSuspenseQueryHookResult = ReturnType<typeof useFetchBusinessGroupsSuspenseQuery>;
export type FetchBusinessGroupsQueryResult = Apollo.QueryResult<FetchBusinessGroupsQuery, FetchBusinessGroupsQueryVariables>;
export const CreateTaxCategoryEntitiesDocument = gql`
    mutation CreateTaxCategoryEntities($taxCategories: [TaxCategoryInput!]!) {
  createTaxCategoryEntities(taxCategories: $taxCategories) {
    __typename
    id
    displayName
    optionalId
    globalEnablementState
    updatedAt
    sources {
      id
      sourceIdentifier
      taxSource
    }
  }
}
    `;
export type CreateTaxCategoryEntitiesMutationFn = Apollo.MutationFunction<CreateTaxCategoryEntitiesMutation, CreateTaxCategoryEntitiesMutationVariables>;

/**
 * __useCreateTaxCategoryEntitiesMutation__
 *
 * To run a mutation, you first call `useCreateTaxCategoryEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxCategoryEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxCategoryEntitiesMutation, { data, loading, error }] = useCreateTaxCategoryEntitiesMutation({
 *   variables: {
 *      taxCategories: // value for 'taxCategories'
 *   },
 * });
 */
export function useCreateTaxCategoryEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxCategoryEntitiesMutation, CreateTaxCategoryEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxCategoryEntitiesMutation, CreateTaxCategoryEntitiesMutationVariables>(CreateTaxCategoryEntitiesDocument, options);
      }
export type CreateTaxCategoryEntitiesMutationHookResult = ReturnType<typeof useCreateTaxCategoryEntitiesMutation>;
export type CreateTaxCategoryEntitiesMutationResult = Apollo.MutationResult<CreateTaxCategoryEntitiesMutation>;
export type CreateTaxCategoryEntitiesMutationOptions = Apollo.BaseMutationOptions<CreateTaxCategoryEntitiesMutation, CreateTaxCategoryEntitiesMutationVariables>;
export const GetTaxCategoriesDocument = gql`
    query GetTaxCategories {
  taxCategoryEntitiesForConfiguration {
    id
    ...TaxCategories_taxCategoryEntities
  }
  allEnablementStates
}
    ${TaxCategories_TaxCategoryEntitiesFragmentDoc}`;

/**
 * __useGetTaxCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTaxCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTaxCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>(GetTaxCategoriesDocument, options);
      }
export function useGetTaxCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>(GetTaxCategoriesDocument, options);
        }
export function useGetTaxCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>(GetTaxCategoriesDocument, options);
        }
export type GetTaxCategoriesQueryHookResult = ReturnType<typeof useGetTaxCategoriesQuery>;
export type GetTaxCategoriesLazyQueryHookResult = ReturnType<typeof useGetTaxCategoriesLazyQuery>;
export type GetTaxCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTaxCategoriesSuspenseQuery>;
export type GetTaxCategoriesQueryResult = Apollo.QueryResult<GetTaxCategoriesQuery, GetTaxCategoriesQueryVariables>;
export const DeleteTaxCategoryEnablementDocument = gql`
    mutation DeleteTaxCategoryEnablement($taxCategories: [TaxCategoryInput!]!) {
  updateTaxCategoryEntities(taxCategories: $taxCategories) {
    id
    ...TaxCategoryDeletion
  }
}
    ${TaxCategoryDeletionFragmentDoc}`;
export type DeleteTaxCategoryEnablementMutationFn = Apollo.MutationFunction<DeleteTaxCategoryEnablementMutation, DeleteTaxCategoryEnablementMutationVariables>;

/**
 * __useDeleteTaxCategoryEnablementMutation__
 *
 * To run a mutation, you first call `useDeleteTaxCategoryEnablementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxCategoryEnablementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxCategoryEnablementMutation, { data, loading, error }] = useDeleteTaxCategoryEnablementMutation({
 *   variables: {
 *      taxCategories: // value for 'taxCategories'
 *   },
 * });
 */
export function useDeleteTaxCategoryEnablementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaxCategoryEnablementMutation, DeleteTaxCategoryEnablementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaxCategoryEnablementMutation, DeleteTaxCategoryEnablementMutationVariables>(DeleteTaxCategoryEnablementDocument, options);
      }
export type DeleteTaxCategoryEnablementMutationHookResult = ReturnType<typeof useDeleteTaxCategoryEnablementMutation>;
export type DeleteTaxCategoryEnablementMutationResult = Apollo.MutationResult<DeleteTaxCategoryEnablementMutation>;
export type DeleteTaxCategoryEnablementMutationOptions = Apollo.BaseMutationOptions<DeleteTaxCategoryEnablementMutation, DeleteTaxCategoryEnablementMutationVariables>;
export const GetTaxCategoryDocument = gql`
    query GetTaxCategory($id: Int!) {
  taxCategory(taxCategoryId: $id) {
    id
    ...TaxCategoryDetails
    ...TaxCategoryDetailForm
    ...TaxCategoryDeletion
    enablements {
      id
      ...BusinessTaxCategoryEnablement
      ...RegionalTaxCategoryEnablement
    }
  }
}
    ${TaxCategoryDetailsFragmentDoc}
${TaxCategoryDetailFormFragmentDoc}
${TaxCategoryDeletionFragmentDoc}
${BusinessTaxCategoryEnablementFragmentDoc}
${RegionalTaxCategoryEnablementFragmentDoc}`;

/**
 * __useGetTaxCategoryQuery__
 *
 * To run a query within a React component, call `useGetTaxCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTaxCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetTaxCategoryQuery, GetTaxCategoryQueryVariables> & ({ variables: GetTaxCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>(GetTaxCategoryDocument, options);
      }
export function useGetTaxCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>(GetTaxCategoryDocument, options);
        }
export function useGetTaxCategorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>(GetTaxCategoryDocument, options);
        }
export type GetTaxCategoryQueryHookResult = ReturnType<typeof useGetTaxCategoryQuery>;
export type GetTaxCategoryLazyQueryHookResult = ReturnType<typeof useGetTaxCategoryLazyQuery>;
export type GetTaxCategorySuspenseQueryHookResult = ReturnType<typeof useGetTaxCategorySuspenseQuery>;
export type GetTaxCategoryQueryResult = Apollo.QueryResult<GetTaxCategoryQuery, GetTaxCategoryQueryVariables>;
export const UpdateTaxCategoryEntitiesDocument = gql`
    mutation UpdateTaxCategoryEntities($taxCategories: [TaxCategoryInput!]!) {
  updateTaxCategoryEntities(taxCategories: $taxCategories) {
    id
    enablements {
      id
      business {
        id
        name
      }
      region
      enablementState
      enablementType
      isArchived
    }
  }
}
    `;
export type UpdateTaxCategoryEntitiesMutationFn = Apollo.MutationFunction<UpdateTaxCategoryEntitiesMutation, UpdateTaxCategoryEntitiesMutationVariables>;

/**
 * __useUpdateTaxCategoryEntitiesMutation__
 *
 * To run a mutation, you first call `useUpdateTaxCategoryEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxCategoryEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxCategoryEntitiesMutation, { data, loading, error }] = useUpdateTaxCategoryEntitiesMutation({
 *   variables: {
 *      taxCategories: // value for 'taxCategories'
 *   },
 * });
 */
export function useUpdateTaxCategoryEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxCategoryEntitiesMutation, UpdateTaxCategoryEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxCategoryEntitiesMutation, UpdateTaxCategoryEntitiesMutationVariables>(UpdateTaxCategoryEntitiesDocument, options);
      }
export type UpdateTaxCategoryEntitiesMutationHookResult = ReturnType<typeof useUpdateTaxCategoryEntitiesMutation>;
export type UpdateTaxCategoryEntitiesMutationResult = Apollo.MutationResult<UpdateTaxCategoryEntitiesMutation>;
export type UpdateTaxCategoryEntitiesMutationOptions = Apollo.BaseMutationOptions<UpdateTaxCategoryEntitiesMutation, UpdateTaxCategoryEntitiesMutationVariables>;
export const GetAddressTaxesDocument = gql`
    query GetAddressTaxes($address: String!, $city: String!, $state: String!, $zip: String!) {
  taxCategoryEntities {
    id
    displayName
    rates(street: $address, city: $city, stateOrRegion: $state, postalCode: $zip) {
      aggregateRate {
        asString
      }
      taxes {
        ...clowncarTaxResultAvalaraTax
      }
    }
  }
}
    ${ClowncarTaxResultAvalaraTaxFragmentDoc}`;

/**
 * __useGetAddressTaxesQuery__
 *
 * To run a query within a React component, call `useGetAddressTaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressTaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressTaxesQuery({
 *   variables: {
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useGetAddressTaxesQuery(baseOptions: Apollo.QueryHookOptions<GetAddressTaxesQuery, GetAddressTaxesQueryVariables> & ({ variables: GetAddressTaxesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>(GetAddressTaxesDocument, options);
      }
export function useGetAddressTaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>(GetAddressTaxesDocument, options);
        }
export function useGetAddressTaxesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>(GetAddressTaxesDocument, options);
        }
export type GetAddressTaxesQueryHookResult = ReturnType<typeof useGetAddressTaxesQuery>;
export type GetAddressTaxesLazyQueryHookResult = ReturnType<typeof useGetAddressTaxesLazyQuery>;
export type GetAddressTaxesSuspenseQueryHookResult = ReturnType<typeof useGetAddressTaxesSuspenseQuery>;
export type GetAddressTaxesQueryResult = Apollo.QueryResult<GetAddressTaxesQuery, GetAddressTaxesQueryVariables>;
export const GetBusinessTaxesDocument = gql`
    query GetBusinessTaxes($id: Int!) {
  business(id: $id) {
    id
    taxCategoryEntities {
      id
      ...clowncarTaxResult
    }
    location {
      address
      city
      state
      zipCode
    }
  }
}
    ${ClowncarTaxResultFragmentDoc}`;

/**
 * __useGetBusinessTaxesQuery__
 *
 * To run a query within a React component, call `useGetBusinessTaxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessTaxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessTaxesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBusinessTaxesQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables> & ({ variables: GetBusinessTaxesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>(GetBusinessTaxesDocument, options);
      }
export function useGetBusinessTaxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>(GetBusinessTaxesDocument, options);
        }
export function useGetBusinessTaxesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>(GetBusinessTaxesDocument, options);
        }
export type GetBusinessTaxesQueryHookResult = ReturnType<typeof useGetBusinessTaxesQuery>;
export type GetBusinessTaxesLazyQueryHookResult = ReturnType<typeof useGetBusinessTaxesLazyQuery>;
export type GetBusinessTaxesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessTaxesSuspenseQuery>;
export type GetBusinessTaxesQueryResult = Apollo.QueryResult<GetBusinessTaxesQuery, GetBusinessTaxesQueryVariables>;
export const CreateBusinessContentDocument = gql`
    mutation CreateBusinessContent($businessContent: UpdateBusinessContentInput!) {
  createBusinessContent(businessContent: $businessContent) {
    venueId
    businessId
    needToKnow
    whyWeLikeIt
  }
}
    `;
export type CreateBusinessContentMutationFn = Apollo.MutationFunction<CreateBusinessContentMutation, CreateBusinessContentMutationVariables>;

/**
 * __useCreateBusinessContentMutation__
 *
 * To run a mutation, you first call `useCreateBusinessContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessContentMutation, { data, loading, error }] = useCreateBusinessContentMutation({
 *   variables: {
 *      businessContent: // value for 'businessContent'
 *   },
 * });
 */
export function useCreateBusinessContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessContentMutation, CreateBusinessContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessContentMutation, CreateBusinessContentMutationVariables>(CreateBusinessContentDocument, options);
      }
export type CreateBusinessContentMutationHookResult = ReturnType<typeof useCreateBusinessContentMutation>;
export type CreateBusinessContentMutationResult = Apollo.MutationResult<CreateBusinessContentMutation>;
export type CreateBusinessContentMutationOptions = Apollo.BaseMutationOptions<CreateBusinessContentMutation, CreateBusinessContentMutationVariables>;
export const UpdateBusinessContentDocument = gql`
    mutation UpdateBusinessContent($businessContent: UpdateBusinessContentInput!) {
  updateBusinessContent(businessContent: $businessContent) {
    venueId
    businessId
    needToKnow
    whyWeLikeIt
  }
}
    `;
export type UpdateBusinessContentMutationFn = Apollo.MutationFunction<UpdateBusinessContentMutation, UpdateBusinessContentMutationVariables>;

/**
 * __useUpdateBusinessContentMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessContentMutation, { data, loading, error }] = useUpdateBusinessContentMutation({
 *   variables: {
 *      businessContent: // value for 'businessContent'
 *   },
 * });
 */
export function useUpdateBusinessContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessContentMutation, UpdateBusinessContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessContentMutation, UpdateBusinessContentMutationVariables>(UpdateBusinessContentDocument, options);
      }
export type UpdateBusinessContentMutationHookResult = ReturnType<typeof useUpdateBusinessContentMutation>;
export type UpdateBusinessContentMutationResult = Apollo.MutationResult<UpdateBusinessContentMutation>;
export type UpdateBusinessContentMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessContentMutation, UpdateBusinessContentMutationVariables>;
export const GetAllBusinessContentDocument = gql`
    query GetAllBusinessContent {
  allBusinessContent {
    businessId
    venueId
    needToKnow
    whyWeLikeIt
  }
}
    `;

/**
 * __useGetAllBusinessContentQuery__
 *
 * To run a query within a React component, call `useGetAllBusinessContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBusinessContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBusinessContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllBusinessContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>(GetAllBusinessContentDocument, options);
      }
export function useGetAllBusinessContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>(GetAllBusinessContentDocument, options);
        }
export function useGetAllBusinessContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>(GetAllBusinessContentDocument, options);
        }
export type GetAllBusinessContentQueryHookResult = ReturnType<typeof useGetAllBusinessContentQuery>;
export type GetAllBusinessContentLazyQueryHookResult = ReturnType<typeof useGetAllBusinessContentLazyQuery>;
export type GetAllBusinessContentSuspenseQueryHookResult = ReturnType<typeof useGetAllBusinessContentSuspenseQuery>;
export type GetAllBusinessContentQueryResult = Apollo.QueryResult<GetAllBusinessContentQuery, GetAllBusinessContentQueryVariables>;
export const CreateBusinessContentBulkDocument = gql`
    mutation CreateBusinessContentBulk($businessContents: [UpdateBusinessContentInput!]!) {
  createBusinessContentBulk(businessContents: $businessContents) {
    businessId
    venueId
    needToKnow
    whyWeLikeIt
  }
}
    `;
export type CreateBusinessContentBulkMutationFn = Apollo.MutationFunction<CreateBusinessContentBulkMutation, CreateBusinessContentBulkMutationVariables>;

/**
 * __useCreateBusinessContentBulkMutation__
 *
 * To run a mutation, you first call `useCreateBusinessContentBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessContentBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessContentBulkMutation, { data, loading, error }] = useCreateBusinessContentBulkMutation({
 *   variables: {
 *      businessContents: // value for 'businessContents'
 *   },
 * });
 */
export function useCreateBusinessContentBulkMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessContentBulkMutation, CreateBusinessContentBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessContentBulkMutation, CreateBusinessContentBulkMutationVariables>(CreateBusinessContentBulkDocument, options);
      }
export type CreateBusinessContentBulkMutationHookResult = ReturnType<typeof useCreateBusinessContentBulkMutation>;
export type CreateBusinessContentBulkMutationResult = Apollo.MutationResult<CreateBusinessContentBulkMutation>;
export type CreateBusinessContentBulkMutationOptions = Apollo.BaseMutationOptions<CreateBusinessContentBulkMutation, CreateBusinessContentBulkMutationVariables>;
export const CreateJceHomepageGeographyDocument = gql`
    mutation CreateJceHomepageGeography($geography: JceHomepageGeographyInput!) {
  createJceHomepageGeography(geography: $geography) {
    id
    name
    urlSlug
    resyBlogKey
    tier
    priorityWithinTier
  }
}
    `;
export type CreateJceHomepageGeographyMutationFn = Apollo.MutationFunction<CreateJceHomepageGeographyMutation, CreateJceHomepageGeographyMutationVariables>;

/**
 * __useCreateJceHomepageGeographyMutation__
 *
 * To run a mutation, you first call `useCreateJceHomepageGeographyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJceHomepageGeographyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJceHomepageGeographyMutation, { data, loading, error }] = useCreateJceHomepageGeographyMutation({
 *   variables: {
 *      geography: // value for 'geography'
 *   },
 * });
 */
export function useCreateJceHomepageGeographyMutation(baseOptions?: Apollo.MutationHookOptions<CreateJceHomepageGeographyMutation, CreateJceHomepageGeographyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJceHomepageGeographyMutation, CreateJceHomepageGeographyMutationVariables>(CreateJceHomepageGeographyDocument, options);
      }
export type CreateJceHomepageGeographyMutationHookResult = ReturnType<typeof useCreateJceHomepageGeographyMutation>;
export type CreateJceHomepageGeographyMutationResult = Apollo.MutationResult<CreateJceHomepageGeographyMutation>;
export type CreateJceHomepageGeographyMutationOptions = Apollo.BaseMutationOptions<CreateJceHomepageGeographyMutation, CreateJceHomepageGeographyMutationVariables>;
export const GetAllGeographiesDocument = gql`
    query GetAllGeographies {
  allGeographies {
    id
    name
    urlSlug
    resyBlogKey
    tier
    priorityWithinTier
  }
}
    `;

/**
 * __useGetAllGeographiesQuery__
 *
 * To run a query within a React component, call `useGetAllGeographiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGeographiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGeographiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllGeographiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>(GetAllGeographiesDocument, options);
      }
export function useGetAllGeographiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>(GetAllGeographiesDocument, options);
        }
export function useGetAllGeographiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>(GetAllGeographiesDocument, options);
        }
export type GetAllGeographiesQueryHookResult = ReturnType<typeof useGetAllGeographiesQuery>;
export type GetAllGeographiesLazyQueryHookResult = ReturnType<typeof useGetAllGeographiesLazyQuery>;
export type GetAllGeographiesSuspenseQueryHookResult = ReturnType<typeof useGetAllGeographiesSuspenseQuery>;
export type GetAllGeographiesQueryResult = Apollo.QueryResult<GetAllGeographiesQuery, GetAllGeographiesQueryVariables>;
export const CreateJceVenueCollectionDocument = gql`
    mutation CreateJceVenueCollection($collection: JceVenueCollectionInput!, $geographyId: Int!) {
  createJceVenueCollection(collection: $collection, geographyId: $geographyId) {
    id
    name
    description
    iconIndicator
    status
    urlSlug
  }
}
    `;
export type CreateJceVenueCollectionMutationFn = Apollo.MutationFunction<CreateJceVenueCollectionMutation, CreateJceVenueCollectionMutationVariables>;

/**
 * __useCreateJceVenueCollectionMutation__
 *
 * To run a mutation, you first call `useCreateJceVenueCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJceVenueCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJceVenueCollectionMutation, { data, loading, error }] = useCreateJceVenueCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *      geographyId: // value for 'geographyId'
 *   },
 * });
 */
export function useCreateJceVenueCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateJceVenueCollectionMutation, CreateJceVenueCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJceVenueCollectionMutation, CreateJceVenueCollectionMutationVariables>(CreateJceVenueCollectionDocument, options);
      }
export type CreateJceVenueCollectionMutationHookResult = ReturnType<typeof useCreateJceVenueCollectionMutation>;
export type CreateJceVenueCollectionMutationResult = Apollo.MutationResult<CreateJceVenueCollectionMutation>;
export type CreateJceVenueCollectionMutationOptions = Apollo.BaseMutationOptions<CreateJceVenueCollectionMutation, CreateJceVenueCollectionMutationVariables>;
export const UpdateJceVenueCollectionDocument = gql`
    mutation UpdateJceVenueCollection($collection: JceVenueCollectionInput!) {
  updateJceVenueCollection(collection: $collection) {
    id
    name
    description
    iconIndicator
    status
    urlSlug
  }
}
    `;
export type UpdateJceVenueCollectionMutationFn = Apollo.MutationFunction<UpdateJceVenueCollectionMutation, UpdateJceVenueCollectionMutationVariables>;

/**
 * __useUpdateJceVenueCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateJceVenueCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJceVenueCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJceVenueCollectionMutation, { data, loading, error }] = useUpdateJceVenueCollectionMutation({
 *   variables: {
 *      collection: // value for 'collection'
 *   },
 * });
 */
export function useUpdateJceVenueCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJceVenueCollectionMutation, UpdateJceVenueCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJceVenueCollectionMutation, UpdateJceVenueCollectionMutationVariables>(UpdateJceVenueCollectionDocument, options);
      }
export type UpdateJceVenueCollectionMutationHookResult = ReturnType<typeof useUpdateJceVenueCollectionMutation>;
export type UpdateJceVenueCollectionMutationResult = Apollo.MutationResult<UpdateJceVenueCollectionMutation>;
export type UpdateJceVenueCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateJceVenueCollectionMutation, UpdateJceVenueCollectionMutationVariables>;

      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AvailabilityAction": [
      "AvailabilityCriticalAction",
      "AvailabilityOffAction",
      "AvailabilityRecommendedAction",
      "AvailabilityWindowEndingAction",
      "AvailabilityWindowInPastAction",
      "HiddenExperienceAction",
      "NoOfferingsAction",
      "ScheduleEndingAction",
      "ScheduleInPastAction",
      "ToGoExperienceEndingAction",
      "ToGoExperienceInPastAction"
    ],
    "BookingBase": [
      "Purchase",
      "WalkIn"
    ],
    "DateTimeRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "IMetaTag": [
      "MetaTagEntity",
      "MetaTagWrapper"
    ],
    "Lock": [
      "GuestLock",
      "InviteLock"
    ],
    "MfaFactor": [
      "MfaEmailFactor",
      "MfaPhoneFactor"
    ],
    "Node": [
      "Available",
      "Block",
      "BusinessEntitlementSetEntity",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "Party",
      "PaymentSubscriptionAddonEntity",
      "PaymentSubscriptionPlanAddonEntity",
      "PaymentSubscriptionPlanEntity",
      "PreBookingBlock",
      "Purchase",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold",
      "WalkIn"
    ],
    "Purchasable": [
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "TicketOptionEntity",
      "TicketTypeEntity"
    ],
    "PurchasableTax": [
      "AvalaraTax",
      "BusinessTaxEntity"
    ],
    "ReservationQuestion": [
      "FreeFormQuestion",
      "OptionsQuestion"
    ],
    "ShopItem": [
      "ShopItemBasicType",
      "ShopItemWineType"
    ],
    "Slot": [
      "AvailableCommunalSlot",
      "AvailableSlot",
      "HeldCommunalSlot",
      "HeldSlot",
      "LockedSlot",
      "UnassignedBooking"
    ],
    "TableBooking": [
      "TableBookingPurchase",
      "TableBookingWalkIn"
    ],
    "TableStateRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "Tax": [
      "AvalaraTax",
      "BusinessTaxEntity",
      "Impl",
      "OrderItemTaxEntity",
      "OrderShipmentFeeTaxEntity",
      "OrderTaxEntity",
      "PaymentTaxEntity",
      "PurchasedTax",
      "PurchasedTaxImpl",
      "PurchasedTicketOptionTaxEntity",
      "PurchasedTicketTypeTaxEntity",
      "RefundTaxEntity",
      "TransactedTax"
    ],
    "Taxable": [
      "CompsAndDiscountsPurchasedTaxable",
      "CustomAndEventFeesPurchasedTaxable",
      "CustomChargeEntity",
      "DeliveryServiceFeePurchasedTaxable",
      "FeeEntity",
      "GratuityPurchasedTaxable",
      "InferredPurchasedTaxable",
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "MockTaxable",
      "OrderItemEntity",
      "OrderShipmentFeeEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "PurchasedCustomChargeEntity",
      "PurchasedFeeEntity",
      "PurchasedOptionEntity",
      "PurchasedTaxable",
      "ServiceChargePurchasedTaxable",
      "TicketOptionEntity",
      "TicketTypeEntity",
      "TicketTypePurchasedTaxable"
    ],
    "UploadedImageEntityInterface": [
      "BusinessImage",
      "UploadedImageEntity"
    ],
    "WaitlistEvent": [
      "WaitlistEventEntity",
      "WaitlistFulfilledEventEntity",
      "WaitlistJoinEventEntity",
      "WaitlistSentEmailNotificationEventEntity",
      "WaitlistSentPushNotificationEventEntity"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AvailabilityAction": [
      "AvailabilityCriticalAction",
      "AvailabilityOffAction",
      "AvailabilityRecommendedAction",
      "AvailabilityWindowEndingAction",
      "AvailabilityWindowInPastAction",
      "HiddenExperienceAction",
      "NoOfferingsAction",
      "ScheduleEndingAction",
      "ScheduleInPastAction",
      "ToGoExperienceEndingAction",
      "ToGoExperienceInPastAction"
    ],
    "BookingBase": [
      "Purchase",
      "WalkIn"
    ],
    "DateTimeRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "IMetaTag": [
      "MetaTagEntity",
      "MetaTagWrapper"
    ],
    "Lock": [
      "GuestLock",
      "InviteLock"
    ],
    "MfaFactor": [
      "MfaEmailFactor",
      "MfaPhoneFactor"
    ],
    "Node": [
      "Available",
      "Block",
      "BusinessEntitlementSetEntity",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "Party",
      "PaymentSubscriptionAddonEntity",
      "PaymentSubscriptionPlanAddonEntity",
      "PaymentSubscriptionPlanEntity",
      "PreBookingBlock",
      "Purchase",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold",
      "WalkIn"
    ],
    "Purchasable": [
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "TicketOptionEntity",
      "TicketTypeEntity"
    ],
    "PurchasableTax": [
      "AvalaraTax",
      "BusinessTaxEntity"
    ],
    "ReservationQuestion": [
      "FreeFormQuestion",
      "OptionsQuestion"
    ],
    "ShopItem": [
      "ShopItemBasicType",
      "ShopItemWineType"
    ],
    "Slot": [
      "AvailableCommunalSlot",
      "AvailableSlot",
      "HeldCommunalSlot",
      "HeldSlot",
      "LockedSlot",
      "UnassignedBooking"
    ],
    "TableBooking": [
      "TableBookingPurchase",
      "TableBookingWalkIn"
    ],
    "TableStateRange": [
      "Available",
      "Block",
      "DayTail",
      "GuestLock",
      "InactiveTimeBlock",
      "InviteLock",
      "PacingBlock",
      "PreBookingBlock",
      "TableBookingPurchase",
      "TableBookingWalkIn",
      "TableHold"
    ],
    "Tax": [
      "AvalaraTax",
      "BusinessTaxEntity",
      "Impl",
      "OrderItemTaxEntity",
      "OrderShipmentFeeTaxEntity",
      "OrderTaxEntity",
      "PaymentTaxEntity",
      "PurchasedTax",
      "PurchasedTaxImpl",
      "PurchasedTicketOptionTaxEntity",
      "PurchasedTicketTypeTaxEntity",
      "RefundTaxEntity",
      "TransactedTax"
    ],
    "Taxable": [
      "CompsAndDiscountsPurchasedTaxable",
      "CustomAndEventFeesPurchasedTaxable",
      "CustomChargeEntity",
      "DeliveryServiceFeePurchasedTaxable",
      "FeeEntity",
      "GratuityPurchasedTaxable",
      "InferredPurchasedTaxable",
      "ItemBasicTypeEntity",
      "ItemWineTypeEntity",
      "MenuItemEntity",
      "MenuModifierGroupOptionEntity",
      "MockTaxable",
      "OrderItemEntity",
      "OrderShipmentFeeEntity",
      "PurchasableItem",
      "PurchaseVerifyOptionEntity",
      "PurchasedCustomChargeEntity",
      "PurchasedFeeEntity",
      "PurchasedOptionEntity",
      "PurchasedTaxable",
      "ServiceChargePurchasedTaxable",
      "TicketOptionEntity",
      "TicketTypeEntity",
      "TicketTypePurchasedTaxable"
    ],
    "UploadedImageEntityInterface": [
      "BusinessImage",
      "UploadedImageEntity"
    ],
    "WaitlistEvent": [
      "WaitlistEventEntity",
      "WaitlistFulfilledEventEntity",
      "WaitlistJoinEventEntity",
      "WaitlistSentEmailNotificationEventEntity",
      "WaitlistSentPushNotificationEventEntity"
    ]
  }
};
      export default result;
    